(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("ca-ui-carbon-toolkit"), require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons"), require("react-dom"), require("jquery"), require("underscore"), require("ca-ui-carbon"), require("polyglot"), require("mobx-react"), require("doT"), require("hammerjs"), require("jquery.hammer"), require("baglass/core-client/js/core-client/ui/properties/PropertyUIControl"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "ca-ui-carbon-toolkit", "@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons", "react-dom", "jquery", "underscore", "ca-ui-carbon", "polyglot", "mobx-react", "doT", "hammerjs", "jquery.hammer", "baglass/core-client/js/core-client/ui/properties/PropertyUIControl"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("ca-ui-carbon-toolkit"), require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons"), require("react-dom"), require("jquery"), require("underscore"), require("ca-ui-carbon"), require("polyglot"), require("mobx-react"), require("doT"), require("hammerjs"), require("jquery.hammer"), require("baglass/core-client/js/core-client/ui/properties/PropertyUIControl")) : factory(root["react"], root["ca-ui-carbon-toolkit"], root["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons"], root["react-dom"], root["jquery"], root["underscore"], root["ca-ui-carbon"], root["polyglot"], root["mobx-react"], root["doT"], root["hammerjs"], root["jquery.hammer"], root["baglass/core-client/js/core-client/ui/properties/PropertyUIControl"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_14__, __WEBPACK_EXTERNAL_MODULE_19__, __WEBPACK_EXTERNAL_MODULE_22__, __WEBPACK_EXTERNAL_MODULE_56__, __WEBPACK_EXTERNAL_MODULE_61__, __WEBPACK_EXTERNAL_MODULE_62__, __WEBPACK_EXTERNAL_MODULE_63__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/bundles";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 39);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(40)(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(43)();
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AuthoringCommonResources = __webpack_require__(18);

var _AuthoringCommonResources2 = _interopRequireDefault(_AuthoringCommonResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * Licensed Materials - Property of IBM
                                                                                                                                                           * IBM Cognos Products: BI
                                                                                                                                                           * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           */

var Polyglot = __webpack_require__(19);

var StringResources = function () {
	function StringResources() {
		_classCallCheck(this, StringResources);

		/**
   * Module which provides simple access to string resources.
   */
		this.polyglot = new Polyglot({
			phrases: _AuthoringCommonResources2.default
		});
	}

	/**
  * Get the string resource for the given key and interpolation options
  *
  * @param key						The  key of the string to return
  * @param interpolationOptions		Optional interpolation options (see poly.t documentation for details)
  * @returns							The string to display
  */


	StringResources.prototype.get = function get(key, interpolationOptions) {
		return this.polyglot.t(key, interpolationOptions);
	};

	return StringResources;
}();

exports.default = new StringResources();

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(47);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(49)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js??ref--1-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--1-4!./all.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js??ref--1-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--1-4!./all.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ColorWheel = __webpack_require__(26);

var _ColorWheel2 = _interopRequireDefault(_ColorWheel);

var _ColorRgb = __webpack_require__(29);

var _ColorRgb2 = _interopRequireDefault(_ColorRgb);

var _ColorSliders = __webpack_require__(28);

var _ColorSliders2 = _interopRequireDefault(_ColorSliders);

var _ColorMode = __webpack_require__(27);

var _ColorMode2 = _interopRequireDefault(_ColorMode);

var _ColorGrid = __webpack_require__(30);

var _ColorGrid2 = _interopRequireDefault(_ColorGrid);

var _ColorConversion = __webpack_require__(11);

var _ColorConversion2 = _interopRequireDefault(_ColorConversion);

var _PaletteAlgorithms = __webpack_require__(51);

var _PaletteAlgorithms2 = _interopRequireDefault(_PaletteAlgorithms);

var _underscore = __webpack_require__(12);

var _underscore2 = _interopRequireDefault(_underscore);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _baUiCarbonToolkit = __webpack_require__(3);

__webpack_require__(4);

var _delete_ = __webpack_require__(31);

var _delete_2 = _interopRequireDefault(_delete_);

var _addNew_ = __webpack_require__(52);

var _addNew_2 = _interopRequireDefault(_addNew_);

var _repeat_ = __webpack_require__(53);

var _repeat_2 = _interopRequireDefault(_repeat_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2018, 2021
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var MIN_SWATCH_COUNT = 2;
var MAX_SWATCH_COUNT_CONTINUOUS = 9;
var MAX_SWATCH_COUNT_CATEGORICAL = 36;
// CustomPalette class

var CustomPalette = function (_Component) {
	_inherits(CustomPalette, _Component);

	// Constructor
	// State consists of property to define whether or not the dialog is open or closed, the selectedTab for the tab panel and the selected item in the select drop down list
	function CustomPalette(props) {
		_classCallCheck(this, CustomPalette);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.componentDidMount = function () {

			//Check to see if a palette definition exists (opening a palette for edit or duplicating)
			//If one exists set state and properties accordingly from the palette definition
			if (_this.props.paletteDef) {
				var paletteColors = void 0,
				    paletteType = void 0;
				if (_this.props.paletteDef.fillType === 'continuous') {
					paletteType = 'continuous';
					paletteColors = _underscore2.default.map(_this.props.paletteDef.fills, function (aFill) {
						return aFill.fill;
					});
				} else {
					paletteType = 'standard';
					paletteColors = _underscore2.default.map(_this.props.paletteDef.fills, function (aFill) {
						return aFill.toUpperCase();
					});
				}

				_this.setState({
					paletteColors: paletteColors,
					paletteType: paletteType,
					currentSelectIndex: 0,
					paletteNameValue: _this.props.paletteDef.label,
					swatchCount: paletteColors.length
				});
			}
		};

		_this.addSwatchEntry = function () {
			if (_this.state.swatchCount >= _this._getMaxSwatchCount()) {
				return;
			}
			if (_this.state.paletteType == 'continuous') {
				var newPaletteColors = [];
				for (var i = 0; i < _this.state.paletteColors.length; i++) {
					newPaletteColors.push(_this.state.paletteColors[i]);
				}
				newPaletteColors.push('#FFFFFF');
				_this.setState({
					swatchCount: newPaletteColors.length,
					currentSelectIndex: newPaletteColors.length - 1,
					paletteColors: newPaletteColors
				});
			} else {
				var count = _this.state.swatchCount + 1;
				_this.setState({
					swatchCount: count,
					currentSelectIndex: count - 1
				});
			}
		};

		_this.removeSwatchEntry = function () {
			if (_this.state.swatchCount <= MIN_SWATCH_COUNT) {
				return;
			}
			var newPaletteColors = [];
			for (var i = 0; i < _this.state.paletteColors.length; i++) {
				if (i != _this.state.currentSelectIndex) {
					newPaletteColors.push(_this.state.paletteColors[i]);
				}
			}

			var newCount = _this.state.swatchCount - 1;
			// if it was the last one, move the index, otherwise leave it alone
			var selectedIndex = _this.state.currentSelectIndex >= newCount ? newCount - 1 : _this.state.currentSelectIndex;

			_this.setState({
				paletteColors: newPaletteColors,
				currentSelectIndex: selectedIndex,
				swatchCount: newCount
			});
		};

		_this.reversePalette = function () {
			var newPaletteColors = [];
			if (_this.state.paletteType == 'standard') {
				// add any padded empty cells to the front
				for (var i = 0; i < _this.state.swatchCount - _this.state.paletteColors.length; i++) {
					newPaletteColors.push(null);
				}
			}

			for (var _i = _this.state.paletteColors.length - 1; _i >= 0; _i--) {
				newPaletteColors.push(_this.state.paletteColors[_i]);
			}
			var newSelectedIndex = _this.state.swatchCount - 1 - _this.state.currentSelectIndex;
			_this.setState({
				paletteColors: newPaletteColors,
				currentSelectIndex: newSelectedIndex
			});
		};

		_this.applyPaletteColor = function () {
			var namePresent = !!_this.state.paletteNameValue;
			var sufficientColors = false;

			var paletteFills = null;
			var currFillType = null;
			if (_this.state.paletteType == 'continuous') {
				paletteFills = _this.deriveContinuousFills();
				sufficientColors = paletteFills.length > 1;
				currFillType = 'continuous';
			} else {
				paletteFills = _this.state.paletteColors.filter(_this.removeEmptySwatches);
				currFillType = 'simple';
				sufficientColors = paletteFills.length > 1;
			}
			if (!namePresent || !sufficientColors) {
				_this.setState({
					noName: !namePresent,
					insufficientColors: !sufficientColors
				});
				return;
			}

			var palette = { label: _this.state.paletteNameValue, fillType: currFillType, fills: paletteFills };
			var isPublic = _this.props.type == 'global';
			var paletteServicePromise = _this.props.paletteService ? Promise.resolve(_this.props.paletteService) : _this.props.glassContext.getSvc('.Palette');

			if (_this.props.paletteDef && _this.props.paletteId) {
				var options = { id: _this.props.paletteId, palette: palette };
				paletteServicePromise.then(function (service) {
					service.updatePalette(options).then(function () {
						_this.closeDialog();
					}, function (error) {
						console.log(error);
					});
				});
			} else if (!isPublic) {
				paletteServicePromise.then(function (service) {
					service.createPalette({ palette: palette }).then(function (paletteId) {
						if (_this.props.onPaletteCreated) {
							_this.props.onPaletteCreated(paletteId);
						}
						_this.closeDialog();
					}, function (error) {
						console.log(error);
					});
				});
			} else if (isPublic) {
				paletteServicePromise.then(function (service) {
					service.createPalette({ palette: palette, public: isPublic }).then(function (paletteId) {
						if (_this.props.onPaletteCreated) {
							_this.props.onPaletteCreated(paletteId);
						}
						_this.closeDialog();
					}, function (error) {
						console.log(error);
					});
				});
			}
		};

		_this.openDialog = function () {
			_this.setState({ isDialogOpen: true });
		};

		_this.closeDialog = function () {
			_this.setState({ isDialogOpen: false });
			if (_this.props.removeDialog) {
				_this.props.removeDialog();
			}
			// In DialogWrapper, it uses onCloseDialog for closing so must handle it here.
			if (_this.props.onCloseDialog) {
				_this.props.onCloseDialog();
			}
		};

		_this.state = {
			isDialogOpen: props.isDialogOpen || false,
			selectedTab: 'idColorGrid',
			selectedColorType: 'RGB',
			paletteNameValue: '',
			radioGroupSelectedOption: 'custom',
			swatchCount: _this.props.paletteType == 'continuous' ? 2 : 10,
			paletteDirection: 'forward',
			paletteType: 'standard',
			currentSelectIndex: 0,
			insufficientColors: false,
			noName: false,
			paletteColors: _this.props.paletteType == 'continuous' ? ['#FFFFFF', '#FFFFFF'] : []
		};
		return _this;
	}

	/**
 * componentDidMount - Lifecycle method. Executes before first render. Executes when the element is inserted into the virtual DOM but before the HTML node itself can be manipulated.
 * Use this point to configure the element as required based on properties passed upon creation
 **/


	/**
 *	componentDidUpdate - Lifecycle method. Executes after first render and any time a render is executed. Use this opportunity to manipulate the HTML node as required.
 * @param {Object} prevProps - Object holding the key value pairs of the previous properties used to render this element
 * @param {Object} prevState - Object holding the key value pairs of the previous state used to render this element
 **/
	CustomPalette.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {

		if (this.props.paletteType && this.state.paletteType != prevProps.paletteType) {
			this.setState({ paletteType: this.props.paletteType });
		}

		if (this.state.paletteType == 'continuous') {
			if (this.state.paletteType != prevState.paletteType) {
				var colorGuide = this.state.paletteType == 'continuous' ? 'custom' : this.state.radioGroupSelectedOption;
				this.setState({
					radioGroupSelectedOption: colorGuide,
					insufficientColors: false
				});
			}
		}
	};

	/**
 * addSwatchEntry - Add a swatch to the end of the dialog
 **/


	/**
 * removeEntryAtIndex - Remove the color entry in paletteColors at the corresponding index
 **/


	/**
 * reversePalette - Change the order of the colors in the swatches as well as the corresponding palette array.
 * In the case of continuous palettes change the direction of the gradient preview
 **/


	CustomPalette.prototype.generateSwatches = function generateSwatches() {
		var className = 'clsSwatchContainer';
		var swatches = '';
		if (this.state.paletteType === 'standard') {
			swatches = this.generateCategoricalSwatches();
		} else if (this.props.continuousStepped) {
			className = 'clsSteppedSwatchContainer';
			swatches = this.generateSteppedContinuousSwatches();
		} else {
			swatches = this.generateGradientContinuousSwatches();
		}

		return _react2.default.createElement(
			'div',
			{ className: className, tabIndex: '0', onKeyDown: this.navigateSwatch.bind(this) },
			swatches
		);
	};

	CustomPalette.prototype.generateCategoricalSwatches = function generateCategoricalSwatches() {
		var swatches = [];
		for (var i = 0; i < this.state.swatchCount; i++) {
			var backgroundColor = i < this.state.paletteColors.length ? this.state.paletteColors[i] : '#FFFFFF';
			var hasPalette = i < this.state.paletteColors.length && this.state.paletteColors[i];
			var isSelected = i == this.state.currentSelectIndex;
			var className = 'clsSwatchStyle_empty';
			if (isSelected) {
				className = hasPalette ? 'clsSwatchStyle_filled_selected' : 'clsSwatchStyle_empty_selected';
			} else if (hasPalette) {
				var hsl = _ColorConversion2.default.convertRgbToHsl(this.state.paletteColors[i]);
				className = hsl.light > 0.67 ? 'clsSwatchStyle_filled_light' : 'clsSwatchStyle_filled';
			}
			swatches.push(_react2.default.createElement(_baUiCarbonToolkit.FlexItem, {
				className: className,
				key: 'swatch' + i,
				id: 'swatch' + i,
				style: { backgroundColor: backgroundColor },
				onClick: this.selectSwatch.bind(this, i) }));
		}
		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexLayout,
			{ wrap: 'wrap' },
			swatches
		);
	};

	CustomPalette.prototype.generateSteppedContinuousSwatches = function generateSteppedContinuousSwatches() {
		var _this2 = this;

		var swatches = this.state.paletteColors.map(function (color, idx) {
			var className = idx == _this2.state.currentSelectIndex ? 'clsSwatchStyle_continuous_selected' : 'clsSwatchStyle_continuous_unselected';
			return _react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				{ key: idx },
				_react2.default.createElement('div', { className: className, style: { backgroundColor: color }, onClick: _this2.selectSwatch.bind(_this2, idx) })
			);
		});
		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexLayout,
			{ className: 'clsSwatchOutline_continuous_stepped' },
			swatches
		);
	};

	CustomPalette.prototype.generateGradientContinuousSwatches = function generateGradientContinuousSwatches() {
		var fillsCopy = this.state.paletteColors.filter(this.removeEmptySwatches);
		var gradientColor = '#FFFFFF';
		if (fillsCopy.length > 1) {
			gradientColor = 'linear-gradient(to right, ' + fillsCopy.join(',') + ')';
		}
		var fillSelectors = [];
		if (this.state.swatchCount > 1) {
			for (var i = 0; i < this.state.swatchCount; i++) {
				var className = i == this.state.currentSelectIndex ? 'clsSelector' : 'clsContinuousIndicator';
				fillSelectors.push(_react2.default.createElement(
					'div',
					{ key: 'selector_' + i, className: 'clsContinuousIndicatorContainer' },
					_react2.default.createElement('div', { className: className, style: { backgroundColor: this.state.paletteColors[i] }, onClick: this.selectSwatch.bind(this, i) })
				));
			}
		}
		var roundedEdgeClass = '';
		if (this.state.currentSelectIndex == 0) {
			roundedEdgeClass = ' clsContinuousPreviewRoundLeft';
		} else if (this.state.swatchCount == this.state.currentSelectIndex + 1) {
			roundedEdgeClass = ' clsContinuousPreviewRoundRight';
		}
		return _react2.default.createElement(
			'div',
			{ style: { background: gradientColor }, id: 'idContinuousPreview', className: 'clsContinuousPreview' + roundedEdgeClass },
			fillSelectors
		);
	};

	CustomPalette.prototype.selectSwatch = function selectSwatch(swatchIndex) {
		if (swatchIndex != this.state.currentSelectIndex) {
			this.setState({ currentSelectIndex: swatchIndex });
		}
	};

	CustomPalette.prototype.onColorChange = function onColorChange(color, isGreyScale) {
		var newPaletteColors = [];
		var selectedIndex = this.state.currentSelectIndex || 0;
		for (var i = 0; i < this.state.paletteColors.length; i++) {
			newPaletteColors.push(this.state.paletteColors[i]);
		}

		if (this.state.radioGroupSelectedOption == 'custom') {
			newPaletteColors[selectedIndex] = color;
		} else if (this.state.radioGroupSelectedOption == 'auto') {
			var hslColor = _ColorConversion2.default.convertRgbToHsl(color);
			var swatchCount = this.state.swatchCount - this.state.currentSelectIndex;
			var hslColors = isGreyScale ? _PaletteAlgorithms2.default.createPaletteViaLight(swatchCount, hslColor, isGreyScale) : _PaletteAlgorithms2.default.createPaletteViaHue(swatchCount, hslColor, isGreyScale);
			newPaletteColors[selectedIndex] = color;
			// start from 1, leaving the current "seed" color unchanged to avoid roundoff in RGB->HSL->RGB
			for (var _i2 = 1; _i2 < hslColors.length; _i2++) {
				var rgbVal = _ColorConversion2.default.convertHslToRgb(hslColors[_i2]);
				var rgbHex = _ColorConversion2.default.convertRgbValToRgbHex(rgbVal);
				newPaletteColors[selectedIndex + _i2] = rgbHex;
			}
		}
		// we always set insufficient colors to false (even if there is not enough) on a color change to keep the error indicator from being noisy
		this.setState({
			paletteColors: newPaletteColors,
			insufficientColors: false
		});
	};

	CustomPalette.prototype.removeEmptySwatches = function removeEmptySwatches(currentSwatch) {
		return !!currentSwatch;
	};

	CustomPalette.prototype.deriveContinuousFills = function deriveContinuousFills() {
		var fillsCopy = this.state.paletteColors.filter(this.removeEmptySwatches);
		// this only supports 2 colors
		if (fillsCopy.length < 2) {
			return [];
		}
		var contFills = [];
		var step = 1 / (fillsCopy.length - 1);
		for (var i = 0; i < fillsCopy.length; i++) {
			var currFill = {
				fill: fillsCopy[i],
				at: step * i
			};
			contFills.push(currFill);
		}
		return contFills;
	};

	CustomPalette.prototype.changePaletteType = function changePaletteType(val) {
		if (this.state.paletteType == val) {
			return;
		}

		this.setState({
			paletteType: val,
			paletteColors: val == 'standard' ? [] : ['#FFFFFF', '#FFFFFF'],
			currentSelectIndex: 0,
			swatchCount: val == 'standard' ? 10 : 2
		});
	};

	CustomPalette.prototype.getAdminButtons = function getAdminButtons() {
		var _this3 = this;

		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexLayout,
			null,
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(
					'div',
					{ className: this.state.paletteType == 'standard' ? 'clsPaletteIcons_wrapper_selected' : 'clsPaletteIcons_wrapper' },
					_react2.default.createElement('div', {
						className: 'clsPaletteStandard',
						id: 'imgStandardPalette',
						value: 'standard',
						onClick: function onClick() {
							return _this3.changePaletteType('standard');
						},
						title: _StringResources2.default.get('standardPalette')
					})
				)
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(
					'div',
					{ className: this.state.paletteType == 'continuous' ? 'clsPaletteIcons_wrapper_selected' : 'clsPaletteIcons_wrapper' },
					_react2.default.createElement('div', {
						className: 'clsPaletteGradient',
						id: 'imgContinuousPalette',
						value: 'continuous',
						onClick: function onClick() {
							return _this3.changePaletteType('continuous');
						},
						title: _StringResources2.default.get('continuousPalette')
					})
				)
			)
		);
	};

	CustomPalette.prototype.navigateSwatch = function navigateSwatch(e) {
		var currentIndex = this.state.currentSelectIndex;
		var key = e.keyCode;
		switch (key) {
			case 37:
				//	left arrow
				if (currentIndex > 0) this.setState({ currentSelectIndex: currentIndex - 1 });
				break;
			case 39:
				// right arrow
				if (currentIndex != this.state.swatchCount - 1) this.setState({ currentSelectIndex: currentIndex + 1 });
				break;
		}
	};

	CustomPalette.prototype.navigatePaletteType = function navigatePaletteType(e) {
		var key = e.keyCode;
		switch (key) {
			case 37:
				//	left arrow
				if (this.state.paletteType == 'continuous') this.changePaletteType('standard');
				break;
			case 39:
				// right arrow
				if (this.state.paletteType == 'standard') this.changePaletteType('continuous');
				break;
		}
	};

	CustomPalette.prototype._getMaxSwatchCount = function _getMaxSwatchCount() {
		return this.state.paletteType == 'continuous' ? MAX_SWATCH_COUNT_CONTINUOUS : MAX_SWATCH_COUNT_CATEGORICAL;
	};

	// Function used to render the CustomPalette element (dialog)


	CustomPalette.prototype.render = function render() {
		var _this4 = this;

		var radioOptions = [{ label: _StringResources2.default.get('modeCustom'), value: 'custom', checked: true }, { label: _StringResources2.default.get('modeAutomatic'), value: 'auto' }];
		if (this.state.paletteType == 'continuous') {
			radioOptions[1].disabled = true;
		}
		var continuousStandardBtns = this.props.userClass && this.props.userClass == 'admin' ? this.getAdminButtons() : [];
		var swatches = this.generateSwatches();

		var colorWarningText = this.state.insufficientColors ? _StringResources2.default.get('errorInsufficientColors') : '';

		return this.state.isDialogOpen && _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				_baUiCarbonToolkit.Dialog,
				{ width: '640px', onClose: this.closeDialog, startingFocusIndex: 0 },
				_react2.default.createElement(
					_baUiCarbonToolkit.Dialog.Header,
					null,
					this.props.paletteDef ? _StringResources2.default.get('modifyPaletteHeader') : _StringResources2.default.get('createPaletteHeader')
				),
				_react2.default.createElement(
					_baUiCarbonToolkit.Dialog.Body,
					{ style: { height: '525px', overflow: 'hidden' } },
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_baUiCarbonToolkit.Label, { label: _StringResources2.default.get('paletteName'), id: 'idNameLabel', htmlFor: 'idPaletteName', type: 'caption' })
					),
					_react2.default.createElement(
						'div',
						{ style: { marginTop: '8px' } },
						_react2.default.createElement(
							_baUiCarbonToolkit.FlexLayout,
							{ justifyContent: 'space-between' },
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								{ style: { width: '288px', height: '60px' } },
								_react2.default.createElement(_baUiCarbonToolkit.TextInput, {
									light: true,
									placeholder: _StringResources2.default.get('paletteNamePlaceholder'),
									id: 'idPaletteName',
									value: this.state.paletteNameValue,
									onValueChange: function onValueChange(value) {
										return _this4.setState({ paletteNameValue: value, noName: !value });
									},
									style: { width: '100%' },
									label: _StringResources2.default.get('paletteName'),
									autoFocus: true,
									fullWidth: true,
									validationErrorText: _StringResources2.default.get('errorNoName'),
									hasValidationError: this.state.noName
								})
							),
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								null,
								_react2.default.createElement(
									'div',
									{ tabIndex: continuousStandardBtns ? '0' : '-1', onKeyDown: this.navigatePaletteType.bind(this) },
									continuousStandardBtns
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_baUiCarbonToolkit.FlexLayout,
							{ justifyContent: 'space-between' },
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								null,
								swatches,
								_react2.default.createElement(
									'span',
									{ className: 'clsErrorMessage' },
									colorWarningText,
									'\xA0'
								)
							),
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								null,
								_react2.default.createElement(
									_baUiCarbonToolkit.FlexLayout,
									null,
									_react2.default.createElement(
										_baUiCarbonToolkit.FlexItem,
										null,
										_react2.default.createElement(_baUiCarbonToolkit.Button, {
											id: 'idDelSwatch',
											intent: 'primary',
											icon: _delete_2.default.id,
											iconSize: 'small',
											variant: 'icon',
											onClick: this.removeSwatchEntry,
											iconDescription: _StringResources2.default.get('removeSwatch'),
											tabIndex: 0,
											disabled: this.state.swatchCount <= MIN_SWATCH_COUNT,
											tooltipAlignment: 'end'
										})
									),
									_react2.default.createElement(
										_baUiCarbonToolkit.FlexItem,
										null,
										_react2.default.createElement(_baUiCarbonToolkit.Separator, {
											orientation: 'vertical',
											style: { margin: '0px' },
											className: 'clsButtonSeparator'
										})
									),
									_react2.default.createElement(
										_baUiCarbonToolkit.FlexItem,
										null,
										_react2.default.createElement(_baUiCarbonToolkit.Button, {
											id: 'idAddSwatch',
											intent: 'primary',
											icon: _addNew_2.default.id,
											iconSize: 'small',
											variant: 'icon',
											onClick: this.addSwatchEntry,
											iconDescription: _StringResources2.default.get('addSwatch'),
											tabIndex: 0,
											disabled: this.state.swatchCount >= this._getMaxSwatchCount(),
											tooltipAlignment: 'end'
										})
									),
									_react2.default.createElement(
										_baUiCarbonToolkit.FlexItem,
										null,
										_react2.default.createElement(_baUiCarbonToolkit.Button, {
											id: 'idReverse',
											intent: 'primary',
											icon: _repeat_2.default.id,
											iconSize: 'small',
											variant: 'icon',
											onClick: this.reversePalette.bind(this),
											tabIndex: 0,
											iconDescription: _StringResources2.default.get('reversePalette'),
											tooltipAlignment: 'end'
										})
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_baUiCarbonToolkit.Tabs,
							{ selected: this.state.selectedTab, onChange: function onChange(tabId) {
									return _this4.setState({ selectedTab: tabId });
								} },
							_react2.default.createElement(
								_baUiCarbonToolkit.TabPanel,
								{ keepTabContent: true, id: 'idColorGrid', label: _StringResources2.default.get('grid') },
								_react2.default.createElement(
									_baUiCarbonToolkit.FlexLayout,
									{ justifyContent: 'space-between', style: { marginTop: '16px' } },
									_react2.default.createElement(
										_baUiCarbonToolkit.FlexItem,
										null,
										_react2.default.createElement(_baUiCarbonToolkit.Label, { id: 'idGridRadioGroupLabel', label: _StringResources2.default.get('colorGuide') }),
										_react2.default.createElement(_baUiCarbonToolkit.RadioGroup, {
											id: 'idGridRadioGroup',
											direction: 'vertical',
											options: radioOptions,
											onChange: function onChange(val) {
												return _this4.setState({ radioGroupSelectedOption: val });
											},
											checked: this.state.radioGroupSelectedOption,
											tabIndex: 0,
											'aria-labelledby': 'idGridRadioGroupLabel'
										})
									),
									_react2.default.createElement(
										_baUiCarbonToolkit.FlexItem,
										null,
										_react2.default.createElement(_ColorGrid2.default, {
											id: 'idColorGridComponent',
											onColorChange: this.onColorChange.bind(this),
											color: this.state.paletteColors[this.state.currentSelectIndex]
										})
									)
								)
							),
							_react2.default.createElement(
								_baUiCarbonToolkit.TabPanel,
								{ keepTabContent: true, id: 'idColorWheel', label: _StringResources2.default.get('wheel') },
								_react2.default.createElement(
									'div',
									{ style: { height: '320px' } },
									_react2.default.createElement(
										_baUiCarbonToolkit.FlexLayout,
										{ justifyContent: 'space-between', style: { marginTop: '16px' } },
										_react2.default.createElement(
											_baUiCarbonToolkit.FlexItem,
											null,
											_react2.default.createElement(_ColorMode2.default, {
												selectedColorType: this.state.selectedColorType,
												onChange: function onChange(value) {
													return _this4.setState({ selectedColorType: value });
												}
											}),
											_react2.default.createElement(_baUiCarbonToolkit.Label, {
												id: 'idWheelRadioGroupLabel',
												label: _StringResources2.default.get('colorGuide'),
												style: { paddingTop: '24px' }
											}),
											_react2.default.createElement(_baUiCarbonToolkit.RadioGroup, {
												id: 'idWheelRadioGroup',
												direction: 'vertical',
												options: radioOptions,
												onChange: function onChange(val) {
													return _this4.setState({ radioGroupSelectedOption: val });
												},
												checked: this.state.radioGroupSelectedOption,
												tabIndex: 0,
												'aria-labelledby': 'idWheelRadioGroupLabel'
											})
										),
										_react2.default.createElement(
											_baUiCarbonToolkit.FlexItem,
											{ style: { marginLeft: '16px' } },
											_react2.default.createElement(_ColorWheel2.default, {
												onColorChange: this.onColorChange.bind(this),
												color: this.state.paletteColors[this.state.currentSelectIndex]
											})
										),
										_react2.default.createElement(
											_baUiCarbonToolkit.FlexItem,
											{ style: { marginLeft: '16px' } },
											_react2.default.createElement(_ColorRgb2.default, {
												onChange: this.onColorChange.bind(this),
												color: this.state.paletteColors[this.state.currentSelectIndex]
											}),
											_react2.default.createElement(_ColorSliders2.default, {
												onColorChange: this.onColorChange.bind(this),
												selectedColorType: this.state.selectedColorType,
												color: this.state.paletteColors[this.state.currentSelectIndex],
												style: { marginTop: '16px' }
											})
										)
									)
								)
							)
						)
					)
				),
				_react2.default.createElement(
					_baUiCarbonToolkit.Dialog.Footer,
					null,
					_react2.default.createElement(_baUiCarbonToolkit.Dialog.Button, { id: 'idCancelBtn', label: _StringResources2.default.get('cancelDialog'), onClick: this.closeDialog, tabIndex: 0 }),
					_react2.default.createElement(_baUiCarbonToolkit.Dialog.Button, { id: 'idCreateBtn', label: this.props.paletteDef ? _StringResources2.default.get('saveDialog') : _StringResources2.default.get('createDialog'), onClick: this.applyPaletteColor, tabIndex: 0, primary: true })
				)
			)
		) || null;
	};

	return CustomPalette;
}(_react.Component);

CustomPalette.propTypes = {
	glassContext: _propTypes2.default.object,
	paletteDef: _propTypes2.default.object,
	paletteId: _propTypes2.default.string,
	onPaletteCreated: _propTypes2.default.func,
	removeDialog: _propTypes2.default.func,
	onCloseDialog: _propTypes2.default.func,
	type: _propTypes2.default.string,
	userClass: _propTypes2.default.string,
	paletteType: _propTypes2.default.string,
	isDialogOpen: _propTypes2.default.bool,
	paletteService: _propTypes2.default.object,
	continuousStepped: _propTypes2.default.bool // treat continuous palettes as stepped (impacts the swatch rendering)
};
CustomPalette.defaultProps = {
	isDialogOpen: false,
	continuousStepped: false,
	name: 'CustomPaletteDialog'
};
exports.default = CustomPalette;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_9__;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
var ColorConversion = function () {
	function ColorConversion() {
		_classCallCheck(this, ColorConversion);
	}

	ColorConversion.convertRgbHexToRgbVal = function convertRgbHexToRgbVal(rgbHex) {
		var rgbColor = {};
		if (rgbHex) {
			rgbColor.red = parseInt(rgbHex.substr(1, 2), 16) || 0;
			rgbColor.green = parseInt(rgbHex.substr(3, 2), 16) || 0;
			rgbColor.blue = parseInt(rgbHex.substr(5, 2), 16) || 0;
		}
		return rgbColor;
	};

	ColorConversion.convertRgbValToRgbHex = function convertRgbValToRgbHex(rgbVal) {
		var redCode = Math.round(rgbVal.red).toString(16);
		var greenCode = Math.round(rgbVal.green).toString(16);
		var blueCode = Math.round(rgbVal.blue).toString(16);

		while (redCode.length < 2) {
			redCode = '0' + redCode;
		}
		while (greenCode.length < 2) {
			greenCode = '0' + greenCode;
		}
		while (blueCode.length < 2) {
			blueCode = '0' + blueCode;
		}
		return ('#' + redCode + greenCode + blueCode).toUpperCase();
	};

	ColorConversion.convertRgbToHsl = function convertRgbToHsl(color) {
		if (!color) {
			return {};
		}
		var rgbVal = this.convertRgbHexToRgbVal(color);
		var hslVal = {};

		var redVal = rgbVal.red / 255;
		var greenVal = rgbVal.green / 255;
		var blueVal = rgbVal.blue / 255;

		var maxVal = Math.max(redVal, greenVal, blueVal);
		var minVal = Math.min(redVal, greenVal, blueVal);

		var chroma = maxVal - minVal;

		var lightnessVal = (maxVal + minVal) / 2;

		var hueVal = 0;

		if (chroma == 0) {
			hueVal = 0;
		} else {
			if (maxVal == redVal) {
				hueVal = (greenVal - blueVal) / chroma % 6;
			} else if (maxVal == greenVal) {
				hueVal = (blueVal - redVal) / chroma + 2;
			} else if (maxVal == blueVal) {
				hueVal = (redVal - greenVal) / chroma + 4;
			}
		}

		var satVal = chroma / (1 - Math.abs(2 * lightnessVal - 1));
		if (!satVal) {
			satVal = 0;
		}
		hslVal.hue = hueVal * 60;

		if (hslVal.hue < 0) {
			hslVal.hue += 360;
		} else if (hslVal.hue > 360) {
			hslVal.hue -= 360;
		}

		hslVal.sat = satVal;
		hslVal.light = lightnessVal;

		return hslVal;
	};

	ColorConversion.convertHslToRgb = function convertHslToRgb(hslColor) {
		var chroma = (1 - Math.abs(2 * hslColor.light - 1)) * hslColor.sat;
		var huePrime = hslColor.hue / 60;
		var rgbColor = {};
		var variance = 1 * (hslColor.light - chroma / 2);

		var colorShift = chroma * (1 - Math.abs(huePrime % 2 - 1));

		if (huePrime >= 0 && huePrime <= 1) {
			rgbColor.red = chroma;
			rgbColor.green = colorShift;
			rgbColor.blue = 0;
		} else if (huePrime >= 1 && huePrime <= 2) {
			rgbColor.red = colorShift;
			rgbColor.green = chroma;
			rgbColor.blue = 0;
		} else if (huePrime >= 2 && huePrime <= 3) {
			rgbColor.red = 0;
			rgbColor.green = chroma;
			rgbColor.blue = colorShift;
		} else if (huePrime >= 3 && huePrime <= 4) {
			rgbColor.red = 0;
			rgbColor.green = colorShift;
			rgbColor.blue = chroma;
		} else if (huePrime >= 4 && huePrime <= 5) {
			rgbColor.red = colorShift;
			rgbColor.green = 0;
			rgbColor.blue = chroma;
		} else if (huePrime >= 5 && huePrime <= 6) {
			rgbColor.red = chroma;
			rgbColor.green = 0;
			rgbColor.blue = colorShift;
		} else {
			rgbColor.red = 0;
			rgbColor.green = 0;
			rgbColor.blue = 0;
		}

		rgbColor.red = (rgbColor.red + variance) * 255;
		rgbColor.green = (rgbColor.green + variance) * 255;
		rgbColor.blue = (rgbColor.blue + variance) * 255;

		return rgbColor;
	};

	/**
  * Hex code with opacity: RRGGBBAA where AA is the alpha opacity value
  *
  * @param {string} hexColor - hex color code, e.g., #FFAABB
  * @param {number} opacity - fraction number represent the opacity. The value must be between 0 and 1
  *
  * @return {string} An 8 digit value represent the hex color with opacity
  */


	ColorConversion.convertHexColorToHexColorWithOpacity = function convertHexColorToHexColorWithOpacity(hexColor, opacity) {
		if (typeof hexColor !== 'string') {
			throw new Error('Invalid hexColor');
		}
		if (typeof opacity !== 'number') {
			throw new Error('Invalid opacity value');
		}
		if (opacity < 0 || opacity > 1) {
			throw new Error('The opacity value must be between 0.0 and 1.0');
		}
		var alpha = Math.round(opacity * 255);
		var hexAlpha = alpha.toString(16).toUpperCase();
		if (hexAlpha.length === 1) {
			hexAlpha = '0' + hexAlpha;
		}
		return '' + hexColor.toUpperCase() + hexAlpha;
	};

	return ColorConversion;
}();

exports.default = ColorConversion;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_12__;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

function _defineProperty(obj, key, value) {
	if (key in obj) {
		Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	} else {
		obj[key] = value;
	}return obj;
}

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2013, 2016
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
	'use strict';

	/**
  * The Class implements the root of class hierarchy implementing the mechanism for
  * creating new derived classes and calling inherited methods.
  */

	// @class
	// @abstract

	var Class = function Class() {};

	function createConstructor() {
		return function () {
			if (typeof this.init === 'function') {
				this.init.apply(this, arguments);
			}
		};
	}

	// Create new widget class derived from the Class
	// @static
	// @param mixins	[optional] An array of the mixin classes.
	// @param def		The definition of the derived class, methods, member variables. The
	//					special method 'init' is called at construction of the class instance.
	//
	Class.extend = function (mixins, def) {
		if (arguments.length === 1) {
			def = mixins;
			mixins = null;
		}

		var baseProto = this.prototype,
		    parentProto = baseProto,
		    proto = Object.create(parentProto);

		// create the constructor
		var ctor = createConstructor();

		// add the mixins
		if (mixins) {
			mixins.forEach(function (mixin) {
				var mixinProto = mixin.prototype;
				// ES6 class detected?! ES6 prototype functions are not enumerable
				if (Object.keys(mixinProto).length === 0) {
					Object.getOwnPropertyNames(mixinProto).filter(function (name) {
						return name !== 'constructor';
					}).forEach(function (prop) {
						proto = Object.assign(proto, _defineProperty({}, prop, mixinProto[prop]));
					});
				} else {
					proto = Object.assign(proto, mixinProto);
				}
			});
			parentProto = proto;
			proto = Object.create(proto);
			if (typeof def.init !== 'function') {
				// generate default init method for multi-class inheritance
				def.init = function () {
					ctor.inherited('init', this, arguments);
				};
			}
		}

		proto = Object.assign(proto, def);
		ctor.prototype = proto;

		// static method to allow for further extension
		ctor.extend = this.extend;

		// calling the inherited methods
		ctor.inherited = function (name, that, args) {
			if (name === 'init') {
				// the 'init' method has a special case of calling inherited implementation
				// it should call all the 'init' methods from the base class and mixins
				if (typeof baseProto[name] === 'function') {
					baseProto[name].apply(that, args);
				}
				if (mixins) {
					mixins.forEach(function (m) {
						if (typeof m.prototype[name] === 'function') {
							m.prototype[name].apply(that, args);
						}
					});
				}
			} else if (typeof parentProto[name] === 'function') {
				return parentProto[name].apply(that, args);
			}
		};

		return ctor;
	};

	return Class;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
//# sourceMappingURL=Class.js.map

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_14__;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (process.env.NODE_ENV !== 'production') {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 18 */
/***/ (function(module, exports) {

var amdi18n={"__root":{"errorCreatingPalette":"An error occurred while saving the palette.","paletteErrorTitle":"Palette Error","changePaletteLabel":"Change color palette","manageColorPalettes":"Manage color palettes","legacyPaletteLabel":"Legacy","systemPaletteLabel":"System","localPaletteLabel":"Local","customPaletteLabel":"Custom","globalPaletteLabel":"Global","mruPaletteLabel":"Recently used","mruPalettes":"Recently used palettes","allPalettes":"All palettes","okDialog":"OK","back":"Back","deleteDialogTitle":"Delete","applyDialog":"Apply","cancelDialog":"Cancel","saveDialog":"Save","createDialog":"Create","deleteMessage":"Are you sure you want to delete the palette \"%{name}\"?","deleteToast":"\"%{name}\" was deleted","favoritesLabel":"Favorites","setAsFavorite":"Set as favorite","createdToastMessage":"\"%{name}\" was successfully created.","createPalette":"Create a custom palette","colorPicker":"Color picker","errorNoName":"Enter a name for your palette","errorInsufficientColors":"Choose at least two colors","paletteAppliedToastMessage":"Palette \"%{name}\", was applied to the report.","createPaletteHeader":"Create color palette","modifyPaletteHeader":"Edit color palette","paletteNamePlaceholder":"Type palette name here","paletteName":"Palette name","standardPalette":"Categorical palette","continuousPalette":"Continuous palette","removeSwatch":"Remove swatch","addSwatch":"Add swatch","reversePalette":"Reverse palette","colorGuide":"Color guide","modeAutomatic":"Automatic","modeCustom":"Custom","colorModel":"Color model","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Grid","wheel":"Wheel","hexCode":"Hex code","colorRed":"Red","colorGreen":"Green","colorBlue":"Blue","colorHue":"Hue","colorSaturation":"Saturation","colorBrightness":"Brightness","colorCyan":"Cyan","colorMagenta":"Magenta","colorYellow":"Yellow","colorBlack":"Black","codeRed":"Red","codeGreen":"Green","codeBlue":"Blue","codeHue":"Hue","codeSaturation":"Saturation","codeBrightness":"Brightness","close":"Close","duplicate":"Duplicate","edit":"Edit","delete":"Delete","restoreDefault":"Restore default","editSchematic":"Edit package","searchSchematic":"Search","nameLabelSchematic":"Name","captionLabelSchematic":"Caption","keyLabelSchematic":"Key","addSchematic":"Upload file","schematicsInvalidSvg":"Invalid or unsupported SVG","schematicsInvalidSvgData":"Could not obtain file data","schematicsInvalidType":"Unsupported file type: %{type}","schematicsInvalidSize":"File %{file}, size %{size} exceeds limit.","schematicsContextMenuReplace":"Replace","schematicsContextMenuDelete":"Delete","schematicsEmptySearchResults":"Search results are empty","schematicsNoSelection":"No items selected","schematicsMultipleSelection":"%{count} items selected","schematicsSingleDeletionSuccessed":"Your schematic was successfully deleted.","schematicsMultipleDeletionSuccessed":"%{count} schematics were successfully deleted.","schematicsSingleAddSuccessed":"Your schematic was successfully added.","schematicsMultipleAddSuccessed":"%{count} schematics were successfully added.","schematicsAddFailed":"Failed adding your schematic.","schematicsReplaceDlgTitle":"Confirm replacement of existing file","schematicsReplaceDlgContent":"The file '%{sourceName}' already exists. Do you want to replace it with the new file?","schematicsReplaceDlgApplyToAllFiles":"Apply to all files","schematicsPackageTab":"Package","schematicsContentTab":"Content","schematicsDescriptionLabel":"Description","schematicsIconLabel":"Icon","schematicsChooseFile":"Add file","schematicsDeleteIcon":"Remove the icon","schematicsIconAdded":"The icon \"%{file}\" has been successfully added.","schematicsIconRemove":"The icon has been successully removed.","schematicsIconDropFiles":"Drag and drop file here or upload","schematicsIconOr":"or","schematicsIconFileTypes":"Only .jpg, .png, and .svg files.","schematicsIconFileSize":"%{size}MB max file size.","legacySectionExtraMessage":"Warning: Legacy palettes are from an earlier version before you upgraded. Changes to these palettes will cause them to no longer appear for this visualization.","favorite":"Favorites","colorPaletteLabel":"Color palette"},"__cy":{"errorCreatingPalette":"An error occurred while saving the palette.~DB1","paletteErrorTitle":"Palette Error~DB2","changePaletteLabel":"Change color palette~DB3","myPaletteLabel":"Custom~DB4","systemPaletteLabel":"System~DB5","publicPaletteLabel":"Global~DB6","localPaletteLabel":"Local~DB7","mruPaletteLabel":"Recently used~DB8","okDialog":"OK~DB9","deleteDialogTitle":"Delete~DB10","applyDialog":"Apply~DB11","cancelDialog":"Cancel~DB12","saveDialog":"Save~DB13","deleteMessage":"Are you sure you want to delete the palette \"[%{name}]\"?~DB14","deleteToast":"\"[%{name}]\" was deleted~DB15","favoritesLabel":"Favorites~DB16","setAsFavorite":"Set as favorite~DB17","createdToastMessage":"\"[%{name}]\" was successfully created.~DB18","createPalette":"Create a custom palette~DB19","colorPicker":"Color picker~DB20","errorNoName":"Enter a name for your palette~DB21","errorInsufficientColors":"Choose at least two colors~DB22","paletteAppliedToastMessage":"Palette \"[%{name}]\", was applied to the report.~DB23","createContinuousPalette":"Create continuous color palette~DB24","createStandardPalette":"Create categorical color palette~DB25","paletteNamePlaceholder":"Type palette name here~DB26","paletteName":"Palette name~DB27","standardPalette":"Categorical palette~DB28","continuousPalette":"Continuous palette~DB29","removeSwatch":"Remove swatch~DB30","addSwatch":"Add swatch~DB31","reversePalette":"Reverse palette~DB32","colorGuide":"Color guide~DB33","modeAutomatic":"Automatic~DB34","modeCustom":"Custom~DB35","colorModel":"Color model~DB36","modelRGB":"RGB~DB37","modelHSB":"HSB~DB38","modelCMYK":"CMYK~DB39","grid":"Grid~DB40","wheel":"Wheel~DB41","hexCode":"Hex code~DB42","colorRed":"Red~DB43","colorGreen":"Green~DB44","colorBlue":"Blue~DB45","colorHue":"Hue~DB46","colorSaturation":"Saturation~DB47","colorBrightness":"Brightness~DB48","colorCyan":"Cyan~DB49","colorMagenta":"Magenta~DB50","colorYellow":"Yellow~DB51","colorBlack":"Black~DB52","codeRed":"R~DB53","codeGreen":"G~DB54","codeBlue":"B~DB55","codeHue":"H~DB56","codeSaturation":"S~DB57","codeBrightness":"B~DB58","codeCyan":"C~DB59","codeMagenta":"M~DB60","codeYellow":"Y~DB61","codeBlack":"K~DB62","close":"Close~DB63","editSchematic":"Edit package~DB64","searchSchematic":"Search~DB65","nameLabelSchematic":"Name~DB66","captionLabelSchematic":"Caption~DB67","keyLabelSchematic":"Key~DB68","addSchematic":"Upload File~DB69","schematicsInvalidSvg":"Invalid or unsupported SVG~DB70","schematicsInvalidSvgData":"Could not obtain file data~DB71","schematicsInvalidType":"Unsupported file type: [%{type}]~DB72","schematicsInvalidSize":"File [%{file}], size [%{size}] exceeds limit.~DB73","schematicsContextMenuReplace":"Replace~DB74","schematicsContextMenuDelete":"Delete~DB75","schematicsEmptySearchResults":"Search results are empty~DB76","schematicsNoSelection":"No items selected~DB77","schematicsMultipleSelection":"[%{count}] items selected~DB78","schematicsSingleDeletionSuccessed":"Your schematic was successfully deleted.~DB79","schematicsMultipleDeletionSuccessed":"[%{count}] schematics were successfully deleted.~DB80","schematicsSingleAddSuccessed":"Your schematic was successfully added.~DB81","schematicsMultipleAddSuccessed":"[%{count}] schematics were successfully added.~DB82","schematicsAddFailed":"Failed adding your schematic.~DB83","schematicsReplaceDlgTitle":"Confirm replacement of existing file~DB84","schematicsReplaceDlgContent":"The file '[%{sourceName}]' already exists. Do you want to replace it with the new file?~DB85","schematicsReplaceDlgApplyToAllFiles":"Apply to all files~DB86","schematicsPackageTab":"Package~DB87","schematicsContentTab":"Content~DB88","schematicsDescriptionLabel":"Description~DB89","schematicsIconLabel":"Icon~DB90","schematicsChooseFile":"Choose a file~DB91","schematicsDeleteIcon":"Remove the icon~DB92","schematicsIconAdded":"The icon \"[%{file}]\" has been successfully added.~DB93","schematicsIconRemove":"The icon has been successully removed.~DB94","schematicsIconDropFiles":"Drop files here~DB95","schematicsIconOr":"or~DB96","schematicsIconFileTypes":"Only .jpg, .png, and .svg files.~DB97","schematicsIconFileSize":"[%{size}]MB max file size.~DB98"},"__gl":{"errorCreatingPalette":"«头'ทั้ดูΣ＿Ａｎ error occurred while saving the palette.＿Э İı｜尾»","paletteErrorTitle":"«头'ทั้ดูΣ＿Palette Error＿Э İı｜尾»","changePaletteLabel":"«头'ทั้ดูΣ＿Change color palette＿Э İı｜尾»","myPaletteLabel":"«头'ทั้ดูΣ＿Custom＿Э İı｜尾»","systemPaletteLabel":"«头'ทั้ดูΣ＿System＿Э İı｜尾»","publicPaletteLabel":"«头'ทั้ดูΣ＿Global＿Э İı｜尾»","localPaletteLabel":"«头'ทั้ดูΣ＿Local＿Э İı｜尾»","mruPaletteLabel":"«头'ทั้ดูΣ＿Recently used＿Э İı｜尾»","okDialog":"«头'ทั้ดูΣ＿OK＿Э İı｜尾»","deleteDialogTitle":"«头'ทั้ดูΣ＿Delete＿Э İı｜尾»","applyDialog":"«头'ทั้ดูΣ＿Apply＿Э İı｜尾»","cancelDialog":"«头'ทั้ดูΣ＿Cancel＿Э İı｜尾»","saveDialog":"«头'ทั้ดูΣ＿Save＿Э İı｜尾»","deleteMessage":"«头'ทั้ดูΣ＿Ａｒe you sure you want to delete the palette \"[%{name}]\"?＿Э İı｜尾»","deleteToast":"«头'ทั้ดูΣ＿\"[%{name}]\" was deleted＿Э İı｜尾»","favoritesLabel":"«头'ทั้ดูΣ＿Favorites＿Э İı｜尾»","setAsFavorite":"«头'ทั้ดูΣ＿Set as favorite＿Э İı｜尾»","createdToastMessage":"«头'ทั้ดูΣ＿\"[%{name}]\" was successfully created.＿Э İı｜尾»","createPalette":"«头'ทั้ดูΣ＿Create a custom palette＿Э İı｜尾»","colorPicker":"«头'ทั้ดูΣ＿Color picker＿Э İı｜尾»","errorNoName":"«头'ทั้ดูΣ＿Enter a name for your palette＿Э İı｜尾»","errorInsufficientColors":"«头'ทั้ดูΣ＿Choose at least two colors＿Э İı｜尾»","paletteAppliedToastMessage":"«头'ทั้ดูΣ＿Ｐａlette \"[%{name}]\", was applied to the report.＿Э İı｜尾»","createContinuousPalette":"«头'ทั้ดูΣ＿Create continuous color palette＿Э İı｜尾»","createStandardPalette":"«头'ทั้ดูΣ＿Create categorical color palette＿Э İı｜尾»","paletteNamePlaceholder":"«头'ทั้ดูΣ＿Type palette name here＿Э İı｜尾»","paletteName":"«头'ทั้ดูΣ＿Palette name＿Э İı｜尾»","standardPalette":"«头'ทั้ดูΣ＿Categorical palette＿Э İı｜尾»","continuousPalette":"«头'ทั้ดูΣ＿Continuous palette＿Э İı｜尾»","removeSwatch":"«头'ทั้ดูΣ＿Remove swatch＿Э İı｜尾»","addSwatch":"«头'ทั้ดูΣ＿Add swatch＿Э İı｜尾»","reversePalette":"«头'ทั้ดูΣ＿Reverse palette＿Э İı｜尾»","colorGuide":"«头'ทั้ดูΣ＿Color guide＿Э İı｜尾»","modeAutomatic":"«头'ทั้ดูΣ＿Automatic＿Э İı｜尾»","modeCustom":"«头'ทั้ดูΣ＿Custom＿Э İı｜尾»","colorModel":"«头'ทั้ดูΣ＿Color model＿Э İı｜尾»","modelRGB":"«头'ทั้ดูΣ＿RGB＿Э İı｜尾»","modelHSB":"«头'ทั้ดูΣ＿HSB＿Э İı｜尾»","modelCMYK":"«头'ทั้ดูΣ＿CMYK＿Э İı｜尾»","grid":"«头'ทั้ดูΣ＿Grid＿Э İı｜尾»","wheel":"«头'ทั้ดูΣ＿Wheel＿Э İı｜尾»","hexCode":"«头'ทั้ดูΣ＿Hex code＿Э İı｜尾»","colorRed":"«头'ทั้ดูΣ＿Red＿Э İı｜尾»","colorGreen":"«头'ทั้ดูΣ＿Green＿Э İı｜尾»","colorBlue":"«头'ทั้ดูΣ＿Blue＿Э İı｜尾»","colorHue":"«头'ทั้ดูΣ＿Hue＿Э İı｜尾»","colorSaturation":"«头'ทั้ดูΣ＿Saturation＿Э İı｜尾»","colorBrightness":"«头'ทั้ดูΣ＿Brightness＿Э İı｜尾»","colorCyan":"«头'ทั้ดูΣ＿Cyan＿Э İı｜尾»","colorMagenta":"«头'ทั้ดูΣ＿Magenta＿Э İı｜尾»","colorYellow":"«头'ทั้ดูΣ＿Yellow＿Э İı｜尾»","colorBlack":"«头'ทั้ดูΣ＿Black＿Э İı｜尾»","codeRed":"«头'ทั้ดูΣ＿R＿Э İı｜尾»","codeGreen":"«头'ทั้ดูΣ＿G＿Э İı｜尾»","codeBlue":"«头'ทั้ดูΣ＿B＿Э İı｜尾»","codeHue":"«头'ทั้ดูΣ＿H＿Э İı｜尾»","codeSaturation":"«头'ทั้ดูΣ＿S＿Э İı｜尾»","codeBrightness":"«头'ทั้ดูΣ＿B＿Э İı｜尾»","codeCyan":"«头'ทั้ดูΣ＿C＿Э İı｜尾»","codeMagenta":"«头'ทั้ดูΣ＿M＿Э İı｜尾»","codeYellow":"«头'ทั้ดูΣ＿Y＿Э İı｜尾»","codeBlack":"«头'ทั้ดูΣ＿K＿Э İı｜尾»","close":"«头'ทั้ดูΣ＿Close＿Э İı｜尾»","editSchematic":"«头'ทั้ดูΣ＿Edit package＿Э İı｜尾»","searchSchematic":"«头'ทั้ดูΣ＿Search＿Э İı｜尾»","nameLabelSchematic":"«头'ทั้ดูΣ＿Name＿Э İı｜尾»","captionLabelSchematic":"«头'ทั้ดูΣ＿Caption＿Э İı｜尾»","keyLabelSchematic":"«头'ทั้ดูΣ＿Key＿Э İı｜尾»","addSchematic":"«头'ทั้ดูΣ＿Upload File＿Э İı｜尾»","schematicsInvalidSvg":"«头'ทั้ดูΣ＿Invalid or unsupported SVG＿Э İı｜尾»","schematicsInvalidSvgData":"«头'ทั้ดูΣ＿Could not obtain file data＿Э İı｜尾»","schematicsInvalidType":"«头'ทั้ดูΣ＿Unsupported file type: [%{type}]＿Э İı｜尾»","schematicsInvalidSize":"«头'ทั้ดูΣ＿File [%{file}], size [%{size}] exceeds limit.＿Э İı｜尾»","schematicsContextMenuReplace":"«头'ทั้ดูΣ＿Replace＿Э İı｜尾»","schematicsContextMenuDelete":"«头'ทั้ดูΣ＿Delete＿Э İı｜尾»","schematicsEmptySearchResults":"«头'ทั้ดูΣ＿Search results are empty＿Э İı｜尾»","schematicsNoSelection":"«头'ทั้ดูΣ＿No items selected＿Э İı｜尾»","schematicsMultipleSelection":"«头'ทั้ดูΣ＿[%{count}] items selected＿Э İı｜尾»","schematicsSingleDeletionSuccessed":"«头'ทั้ดูΣ＿Ｙｏur schematic was successfully deleted.＿Э İı｜尾»","schematicsMultipleDeletionSuccessed":"«头'ทั้ดูΣ＿[%{count}] ｓｃhematics were successfully deleted.＿Э İı｜尾»","schematicsSingleAddSuccessed":"«头'ทั้ดูΣ＿Ｙｏur schematic was successfully added.＿Э İı｜尾»","schematicsMultipleAddSuccessed":"«头'ทั้ดูΣ＿[%{count}] ｓchematics were successfully added.＿Э İı｜尾»","schematicsAddFailed":"«头'ทั้ดูΣ＿Failed adding your schematic.＿Э İı｜尾»","schematicsReplaceDlgTitle":"«头'ทั้ดูΣ＿Ｃonfirm replacement of existing file＿Э İı｜尾»","schematicsReplaceDlgContent":"«头'ทั้ดูΣ＿Ｔｈｅ ｆile '[%{sourceName}]' already exists. Do you want to replace it with the new file?＿Э İı｜尾»","schematicsReplaceDlgApplyToAllFiles":"«头'ทั้ดูΣ＿Apply to all files＿Э İı｜尾»","schematicsPackageTab":"«头'ทั้ดูΣ＿Package＿Э İı｜尾»","schematicsContentTab":"«头'ทั้ดูΣ＿Content＿Э İı｜尾»","schematicsDescriptionLabel":"«头'ทั้ดูΣ＿Description＿Э İı｜尾»","schematicsIconLabel":"«头'ทั้ดูΣ＿Icon＿Э İı｜尾»","schematicsChooseFile":"«头'ทั้ดูΣ＿Choose a file＿Э İı｜尾»","schematicsDeleteIcon":"«头'ทั้ดูΣ＿Remove the icon＿Э İı｜尾»","schematicsIconAdded":"«头'ทั้ดูΣ＿Ｔｈe icon \"[%{file}]\" has been successfully added.＿Э İı｜尾»","schematicsIconRemove":"«头'ทั้ดูΣ＿Ｔｈe icon has been successully removed.＿Э İı｜尾»","schematicsIconDropFiles":"«头'ทั้ดูΣ＿Drop files here＿Э İı｜尾»","schematicsIconOr":"«头'ทั้ดูΣ＿or＿Э İı｜尾»","schematicsIconFileTypes":"«头'ทั้ดูΣ＿Only .jpg, .png, and .svg files.＿Э İı｜尾»","schematicsIconFileSize":"«头'ทั้ดูΣ＿[%{size}]MB max file size.＿Э İı｜尾»"},"__cs":{"errorCreatingPalette":"Došlo k chybě při ukládání palety.","paletteErrorTitle":"Chyba palety","changePaletteLabel":"Změnit paletu barev","manageColorPalettes":"Spravovat palety barev","legacyPaletteLabel":"Starší","systemPaletteLabel":"Systém","localPaletteLabel":"Lokální","customPaletteLabel":"vlastní","globalPaletteLabel":"Globální","mruPaletteLabel":"Nedávno použité","mruPalettes":"Nedávno použité palety","allPalettes":"Všechny palety","okDialog":"OK","back":"Zpět","deleteDialogTitle":"Odstranit","applyDialog":"Použít","cancelDialog":"Storno","saveDialog":"Uložit","createDialog":"Vytvořit","deleteMessage":"Opravdu chcete odstranit paletu \"%{name}\"?","deleteToast":"Odstraněno: \"%{name}\"","favoritesLabel":"Oblíbené položky","setAsFavorite":"Nastavit jako oblíbené","createdToastMessage":"Úspěšně vytvořeno: \"%{name}\"","createPalette":"Vytvořit vlastní paletu","colorPicker":"Výběr barvy","errorNoName":"Zadejte název palety.","errorInsufficientColors":"Vyberte alespoň dvě barvy.","paletteAppliedToastMessage":"Na sestavu byla použit a paleta \"%{name}\".","createPaletteHeader":"Vytvořit paletu barev","modifyPaletteHeader":"Upravit paletu barev","paletteNamePlaceholder":"Zde zadejte název palety.","paletteName":"Název palety","standardPalette":"Kategorická paleta","continuousPalette":"Spojitá paleta","removeSwatch":"Odebrat paletu","addSwatch":"Přidat paletu","reversePalette":"Obrátit paletu","colorGuide":"Průvodce barvami","modeAutomatic":"Automaticky","modeCustom":"Vlastní","colorModel":"Barevný model","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Mřížka","wheel":"Kolo","hexCode":"Hexadecimální kód","colorRed":"Červená","colorGreen":"Zelená","colorBlue":"Modrá","colorHue":"Odstín","colorSaturation":"Sytost","colorBrightness":"Jas","colorCyan":"Azurová","colorMagenta":"Purpurová","colorYellow":"Žlutá","colorBlack":"Černá","codeRed":"Červená","codeGreen":"Zelená","codeBlue":"Modrá","codeHue":"Odstín","codeSaturation":"Sytost","codeBrightness":"Jas","close":"Zavřít","duplicate":"Duplikovat","edit":"Upravit","delete":"Odstranit","restoreDefault":"Obnovit výchozí nastavení","editSchematic":"Upravit balík","searchSchematic":"Hledat","nameLabelSchematic":"Název","captionLabelSchematic":"Titulek","keyLabelSchematic":"Klíč","addSchematic":"Odeslat soubor","schematicsInvalidSvg":"Neplatný nebo nepodporovaný formát SVG","schematicsInvalidSvgData":"Nelze získat data souboru","schematicsInvalidType":"Nepodporovaný typ souboru: %{type}","schematicsInvalidSize":"Soubor %{file} s velikostí %{size} překračuje limit.","schematicsContextMenuReplace":"Nahradit","schematicsContextMenuDelete":"Odstranit","schematicsEmptySearchResults":"Výsledky hledání jsou prázdné.","schematicsNoSelection":"Nejsou vybrány žádné prvky.","schematicsMultipleSelection":"Počet vybraných položek: %{count}","schematicsSingleDeletionSuccessed":"Vaše schéma bylo úspěšně odstraněno.","schematicsMultipleDeletionSuccessed":"Počet úspěšně odstraněných schémat: %{count}.","schematicsSingleAddSuccessed":"Vaše schéma bylo úspěšně přidáno.","schematicsMultipleAddSuccessed":"Počet úspěšně přidaných schémat: %{count}.","schematicsAddFailed":"Neúspěšné přidání nového schématu","schematicsReplaceDlgTitle":"Potvrdit nahrazení existujícího souboru","schematicsReplaceDlgContent":"Soubor '%{sourceName}' již existuje. Chcete ho nahradit tímto novým souborem?","schematicsReplaceDlgApplyToAllFiles":"Použít na všechny soubory","schematicsPackageTab":"Balík","schematicsContentTab":"Obsah","schematicsDescriptionLabel":"Popis","schematicsIconLabel":"Ikona","schematicsChooseFile":"Přidat soubor","schematicsDeleteIcon":"Odebrat ikonu","schematicsIconAdded":"Ikona \"%{file}\" byla úspěšně přidána.","schematicsIconRemove":"Ikona byla úspěšně odebrána.","schematicsIconDropFiles":"Přetáhněte soubor sem nebo jej odešlete","schematicsIconOr":"nebo","schematicsIconFileTypes":"Pouze soubory .jpg, .png a .svg.","schematicsIconFileSize":"Maximální velikost souboru %{size} MB.","legacySectionExtraMessage":"Varování: Starší palety pocházejí z dřívější verze před upgradem. Změny těchto palet způsobí, že se již nezobrazí v této vizualizaci.","favorite":"Oblíbené položky","colorPaletteLabel":"Paleta barev"},"__da":{"errorCreatingPalette":"Der er opstået en fejl i forbindelse med at gemme paletten.","paletteErrorTitle":"Paletfejl","changePaletteLabel":"Skift farvepalet","manageColorPalettes":"Administrér farvepaletter","legacyPaletteLabel":"Ældre","systemPaletteLabel":"System","localPaletteLabel":"Lokal","customPaletteLabel":"Tilpasset","globalPaletteLabel":"Global","mruPaletteLabel":"Anvendt for nylig","mruPalettes":"Nyligt anvendte paletter","allPalettes":"Alle paletter","okDialog":"OK","back":"Tilbage","deleteDialogTitle":"Slet","applyDialog":"Anvend","cancelDialog":"Annullér","saveDialog":"Gem","createDialog":"Opret","deleteMessage":"Er du sikker på, at du vil slette paletten \"%{name}\"?","deleteToast":"\"%{name}\" blev slettet","favoritesLabel":"Favoritter","setAsFavorite":"Angiv som favorit","createdToastMessage":"\"%{name}\" blev oprettet.","createPalette":"Opret en tilpasset palet","colorPicker":"Farvevælger","errorNoName":"Angiv et navn på din palet","errorInsufficientColors":"Vælg mindst to farver","paletteAppliedToastMessage":"Palet \"%{name}\" er anvendt til rapporten.","createPaletteHeader":"Opret farvepalet","modifyPaletteHeader":"Redigér farvepalet","paletteNamePlaceholder":"Angiv paletnavn her","paletteName":"Paletnavn","standardPalette":"Kategorisk palet","continuousPalette":"Fortløbende palet","removeSwatch":"Fjern prøve","addSwatch":"Tilføj prøve","reversePalette":"Omvendt palet","colorGuide":"Farvevejledning","modeAutomatic":"Automatisk","modeCustom":"Tilpasset","colorModel":"Farvemodel","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Gitter","wheel":"Hjul","hexCode":"Hex-kode","colorRed":"Rød","colorGreen":"Grøn","colorBlue":"Blå","colorHue":"Hue","colorSaturation":"Mætning","colorBrightness":"Lysstyrke","colorCyan":"Turkis","colorMagenta":"Magenta","colorYellow":"Gul","colorBlack":"Sort","codeRed":"Rød","codeGreen":"Grøn","codeBlue":"Blå","codeHue":"Hue","codeSaturation":"Mætning","codeBrightness":"Lysstyrke","close":"Luk","duplicate":"Duplikér","edit":"Redigér","delete":"Slet","restoreDefault":"Gendan standard","editSchematic":"Redigér pakke","searchSchematic":"Søg","nameLabelSchematic":"Navn","captionLabelSchematic":"Overskrift","keyLabelSchematic":"Nøgle","addSchematic":"Upload fil","schematicsInvalidSvg":"Ugyldig eller ikke-understøttet SVG","schematicsInvalidSvgData":"Kan ikke hente fildata","schematicsInvalidType":"Ikke-understøttet filtype: %{type}","schematicsInvalidSize":"Filen %{file}, størrelse %{size} overskrider grænsen.","schematicsContextMenuReplace":"Erstat","schematicsContextMenuDelete":"Slet","schematicsEmptySearchResults":"Søgeresultater er tom","schematicsNoSelection":"Ingen elementer valgt","schematicsMultipleSelection":"%{count} elementer valgt","schematicsSingleDeletionSuccessed":"Skemaet er slettet.","schematicsMultipleDeletionSuccessed":"%{count} skemaer blev slettet.","schematicsSingleAddSuccessed":"dit skema er tilføjet.","schematicsMultipleAddSuccessed":"%{count} skemaer blev tilføjet.","schematicsAddFailed":"Fejl under tilføjelse af dit skema","schematicsReplaceDlgTitle":"Bekræft erstatning af eksisterende file","schematicsReplaceDlgContent":"Filen '%{sourceName}' findes allerede. Vil du overskrive den med den nye fil?","schematicsReplaceDlgApplyToAllFiles":"Anvend på alle filer","schematicsPackageTab":"Pakke","schematicsContentTab":"Indhold","schematicsDescriptionLabel":"Beskrivelse","schematicsIconLabel":"Ikon","schematicsChooseFile":"Tilføj fil","schematicsDeleteIcon":"Fjern ikonen","schematicsIconAdded":"Ikonen \"%{file}\" er tilføjet.","schematicsIconRemove":"Ikonen er fjernet.","schematicsIconDropFiles":"Træk og placér fil her, eller upload","schematicsIconOr":"eller","schematicsIconFileTypes":"Kun filer af typen .jpg, .png og .svg.","schematicsIconFileSize":"%{size}MB maks. filstørrelse.","legacySectionExtraMessage":"Advarsel: Paletterne er fra en tidligere version, før du opgraderede. Ændringer af disse paletter medfører, at de ikke længere vil blive vist for denne visualisering.","favorite":"Favoritter","colorPaletteLabel":"Farvepalet"},"__de":{"errorCreatingPalette":"Beim Speichern der Palette ist ein Fehler aufgetreten.","paletteErrorTitle":"Palette - Fehler","changePaletteLabel":"Farbpalette ändern","manageColorPalettes":"Farbpaletten verwalten","legacyPaletteLabel":"Vorgängerdiagramm","systemPaletteLabel":"System","localPaletteLabel":"Lokal","customPaletteLabel":"angepasst","globalPaletteLabel":"Global","mruPaletteLabel":"Zuletzt verwendet","mruPalettes":"Zuletzt verwendete Paletten","allPalettes":"Alle Paletten","okDialog":"OK","back":"Zurück","deleteDialogTitle":"Löschen","applyDialog":"Anwenden","cancelDialog":"Abbrechen","saveDialog":"Speichern","createDialog":"Erstellen","deleteMessage":"Soll die Palette \"%{name}\" tatsächlich gelöscht werden?","deleteToast":"\"%{name}\" wurde gelöscht","favoritesLabel":"Favoriten","setAsFavorite":"Als Favorit festlegen","createdToastMessage":"\"%{name}\" wurde erfolgreich erstellt.","createPalette":"Benutzerdefinierte Palette erstellen","colorPicker":"Farbauswahl","errorNoName":"Namen für die Palette eingeben","errorInsufficientColors":"Mindestens zwei Farben auswählen","paletteAppliedToastMessage":"Die Palette \"%{name}\" wurde auf den Bericht angewendet.","createPaletteHeader":"Farbpalette erstellen","modifyPaletteHeader":"Farbpalette bearbeiten","paletteNamePlaceholder":"Palettennamen hier eingeben","paletteName":"Palettenname","standardPalette":"Kategoriale Palette","continuousPalette":"Fortlaufende Palette","removeSwatch":"Muster entfernen","addSwatch":"Muster hinzufügen","reversePalette":"Umgekehrte Palette","colorGuide":"Richtlinien für Farben","modeAutomatic":"Automatisch","modeCustom":"Benutzerdefiniert","colorModel":"Farbmodell","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Raster","wheel":"Rad","hexCode":"Hexadezimalcode","colorRed":"Rot","colorGreen":"Grün","colorBlue":"Blau","colorHue":"Farbton","colorSaturation":"Sättigung","colorBrightness":"Helligkeit","colorCyan":"Zyan","colorMagenta":"Magenta","colorYellow":"Gelb","colorBlack":"Schwarz","codeRed":"Rot","codeGreen":"Grün","codeBlue":"Blau","codeHue":"Farbton","codeSaturation":"Sättigung","codeBrightness":"Helligkeit","close":"Schließen","duplicate":"Duplizieren","edit":"Bearbeiten","delete":"Löschen","restoreDefault":"Standard wiederherstellen","editSchematic":"Package bearbeiten","searchSchematic":"Suchen","nameLabelSchematic":"Name","captionLabelSchematic":"Titelzeile","keyLabelSchematic":"Schlüssel","addSchematic":"Datei hochladen","schematicsInvalidSvg":"Ungültige oder nicht unterstützte SVG","schematicsInvalidSvgData":"Abrufen der Dateidaten nicht möglich","schematicsInvalidType":"Nicht unterstützter Dateityp: %{type}","schematicsInvalidSize":"Die Größe %{size} der Datei %{file} überschreitet den Grenzwert.","schematicsContextMenuReplace":"Ersetzen","schematicsContextMenuDelete":"Löschen","schematicsEmptySearchResults":"Suchergebnisse sind leer","schematicsNoSelection":"Keine Elemente ausgewählt","schematicsMultipleSelection":"%{count} Elemente ausgewählt","schematicsSingleDeletionSuccessed":"Das Schema wurde erfolgreich gelöscht.","schematicsMultipleDeletionSuccessed":"%{count} Schemas wurden erfolgreich gelöscht.","schematicsSingleAddSuccessed":"Das Schema wurde erfolgreich hinzugefügt.","schematicsMultipleAddSuccessed":"%{count} Schemas wurden erfolgreich hinzugefügt.","schematicsAddFailed":"Hinzufügen des Schemas fehlgeschlagen.","schematicsReplaceDlgTitle":"Ersetzen vorhandener Datei bestätigen","schematicsReplaceDlgContent":"Die Datei '%{sourceName}' ist bereits vorhanden. Soll sie durch die neue Datei ersetzt werden?","schematicsReplaceDlgApplyToAllFiles":"Für alle Dateien anwenden","schematicsPackageTab":"Package","schematicsContentTab":"Inhalt","schematicsDescriptionLabel":"Beschreibung","schematicsIconLabel":"Symbol","schematicsChooseFile":"Datei hinzufügen","schematicsDeleteIcon":"Symbol entfernen","schematicsIconAdded":"Das Symbol \"%{file}\" wurde erfolgreich hinzugefügt.","schematicsIconRemove":"Das Symbol wurde erfolgreich entfernt.","schematicsIconDropFiles":"Datei hierher ziehen und ablegen oder hochladen","schematicsIconOr":"oder","schematicsIconFileTypes":"Nur .jpg-, .png- und .svg-Dateien. ","schematicsIconFileSize":"Maximale Dateigröße %{size} MB. ","legacySectionExtraMessage":"Warnung: Vorgängerpaletten stammen aus einer früheren Version vor dem Upgrade. Wenn an diesen Paletten Änderungen vorgenommen werden, werden sie für diese Visualisierung nicht mehr angezeigt. ","favorite":"Favoriten","colorPaletteLabel":"Farbpalette"},"__es":{"errorCreatingPalette":"Se ha producido un error al guardar la paleta.","paletteErrorTitle":"Error de paleta","changePaletteLabel":"Cambiar paleta de colores","manageColorPalettes":"Gestionar paletas de colores","legacyPaletteLabel":"Heredada","systemPaletteLabel":"Sistema","localPaletteLabel":"Local","customPaletteLabel":"Personalizado","globalPaletteLabel":"Global","mruPaletteLabel":"Utilizados recientemente","mruPalettes":"Paletas utilizadas recientemente","allPalettes":"Todas las paletas","okDialog":"Aceptar","back":"Atrás","deleteDialogTitle":"Suprimir","applyDialog":"Aplicar","cancelDialog":"Cancelar","saveDialog":"Guardar","createDialog":"Crear","deleteMessage":"¿Está seguro de que desea suprimir la paleta \"%{name}\"?","deleteToast":"Se ha suprimido \"%{name}\"","favoritesLabel":"Favoritos","setAsFavorite":"Establecer como favorito","createdToastMessage":"Se ha creado correctamente \"%{name}\".","createPalette":"Crear una paleta personalizada","colorPicker":"Selector de color","errorNoName":"Escriba un nombre para la paleta.","errorInsufficientColors":"Seleccione al menos dos colores","paletteAppliedToastMessage":"Se ha aplicado la paleta \"%{name}\" al informe.","createPaletteHeader":"Crear paleta de colores","modifyPaletteHeader":"Editar paleta de colores","paletteNamePlaceholder":"Escriba aquí un nombre de paleta","paletteName":"Nombre de paleta","standardPalette":"Paleta de categorías","continuousPalette":"Paleta continua","removeSwatch":"Eliminar reloj","addSwatch":"Añadir reloj","reversePalette":"Invertir paleta","colorGuide":"Guía de colores","modeAutomatic":"Automático","modeCustom":"Personalizado","colorModel":"Modelo de color","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Cuadrícula","wheel":"Rueda","hexCode":"Código hexadecimal","colorRed":"Rojo","colorGreen":"Verde","colorBlue":"Azul","colorHue":"Tono","colorSaturation":"Saturación","colorBrightness":"Luminosidad","colorCyan":"Cian","colorMagenta":"Magenta","colorYellow":"Amarillo","colorBlack":"Negro","codeRed":"Rojo","codeGreen":"Verde","codeBlue":"Azul","codeHue":"Tono","codeSaturation":"Saturación","codeBrightness":"Luminosidad","close":"Cerrar","duplicate":"Duplicar","edit":"Editar","delete":"Suprimir","restoreDefault":"Restaurar valor predeterminado","editSchematic":"Editar paquete","searchSchematic":"Buscar","nameLabelSchematic":"Nombre","captionLabelSchematic":"Título","keyLabelSchematic":"Clave","addSchematic":"Cargar archivo","schematicsInvalidSvg":"SVG no válido o no soportado","schematicsInvalidSvgData":"No se han podido obtener los datos del archivo:","schematicsInvalidType":"Tipo de archivo no soportado: %{type}","schematicsInvalidSize":"El archivo %{file}, tamaño %{size} supera el límite.","schematicsContextMenuReplace":"Sustituir","schematicsContextMenuDelete":"Suprimir","schematicsEmptySearchResults":"El resultado de la búsqueda está vacío","schematicsNoSelection":"No se ha seleccionado ningún elemento","schematicsMultipleSelection":"%{count} elementos seleccionados","schematicsSingleDeletionSuccessed":"Su esquemático se ha suprimido correctamente.","schematicsMultipleDeletionSuccessed":"Se han suprimido %{count} esquemáticos correctamente.","schematicsSingleAddSuccessed":"Su esquemático se ha añadido correctamente.","schematicsMultipleAddSuccessed":"Se han añadido %{count} esquemáticos correctamente.","schematicsAddFailed":"Error al añadir su esquemático.","schematicsReplaceDlgTitle":"Confirmar sustitución del archivo existente","schematicsReplaceDlgContent":"El archivo '%{sourceName}' ya existe. ¿Desea reemplazarlo por este nuevo archivo?","schematicsReplaceDlgApplyToAllFiles":"Aplicar a todos los filtros","schematicsPackageTab":"Paquete","schematicsContentTab":"Contenido","schematicsDescriptionLabel":"Descripción","schematicsIconLabel":"Icono","schematicsChooseFile":"Añadir archivo","schematicsDeleteIcon":"Suprimir el icono","schematicsIconAdded":"El icono \"%{file}\" se ha añadido correctamente.","schematicsIconRemove":"El icono se ha eliminado correctamente.","schematicsIconDropFiles":"Arrastre y suelte o cargue el archivo aquí","schematicsIconOr":"o bien","schematicsIconFileTypes":"Solo archivos .jpg, .png y .svg.","schematicsIconFileSize":"%{size}MB de tamaño máximo de archivo. ","legacySectionExtraMessage":"Aviso: Las paletas de herencia pertenecen a una versión anterior a la actualización. Los cambios realizados en estas paletas harán que ya no se muestren en esta visualización. ","favorite":"Favoritos","colorPaletteLabel":"Paleta de colores"},"__fi":{"errorCreatingPalette":"Virhe tallennettaessa palettia.","paletteErrorTitle":"Palettivirhe","changePaletteLabel":"Vaihda väripaletti","manageColorPalettes":"Väripalettien hallinta","legacyPaletteLabel":"Vanha","systemPaletteLabel":"Järjestelmä","localPaletteLabel":"Paikallinen","customPaletteLabel":"mukautettu","globalPaletteLabel":"Yleiset","mruPaletteLabel":"Viimeksi käytetyt","mruPalettes":"Viimeksi käytetyt paletit","allPalettes":"Kaikki paletit","okDialog":"OK","back":"Edellinen","deleteDialogTitle":"Poista","applyDialog":"Käytä","cancelDialog":"Peruuta","saveDialog":"Tallenna","createDialog":"Luo","deleteMessage":"Haluatko varmasti poistaa paletin %{name}?","deleteToast":"%{name} on poistettu","favoritesLabel":"Suosikit","setAsFavorite":"Aseta suosikiksi","createdToastMessage":"%{name} on luotu.","createPalette":"Luo mukautettu paletti","colorPicker":"Värinvalitsin","errorNoName":"Anna paletille nimi:","errorInsufficientColors":"Valitse vähintään kaksi väriä","paletteAppliedToastMessage":"Raporttiin on käytetty palettia %{name}.","createPaletteHeader":"Luo väripaletti","modifyPaletteHeader":"Muokkaa väripalettia","paletteNamePlaceholder":"Kirjoita paletin nimi tähän","paletteName":"Paletin nimi","standardPalette":"Kategorinen paletti","continuousPalette":"Yhtenäinen paletti","removeSwatch":"Poista värivalikoima","addSwatch":"Lisää värivalikoima","reversePalette":"Käänteinen paletti","colorGuide":"Väriopas","modeAutomatic":"Automaattinen","modeCustom":"Mukautettu","colorModel":"Värimalli","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Ruudukko","wheel":"Pyörä","hexCode":"Heksadesimaalikoodi","colorRed":"Punainen","colorGreen":"Vihreä","colorBlue":"Sininen","colorHue":"Sävy","colorSaturation":"Kylläisyys","colorBrightness":"Kirkkaus","colorCyan":"Syaani","colorMagenta":"Magenta","colorYellow":"Keltainen","colorBlack":"Musta","codeRed":"Punainen","codeGreen":"Vihreä","codeBlue":"Sininen","codeHue":"Sävy","codeSaturation":"Kylläisyys","codeBrightness":"Kirkkaus","close":"Sulje","duplicate":"Kaksoiskappale","edit":"Muokkaa","delete":"Poista","restoreDefault":"Palauta oletusarvo","editSchematic":"Muokkaa pakettia","searchSchematic":"Hae","nameLabelSchematic":"Nimi","captionLabelSchematic":"Kuvateksti","keyLabelSchematic":"Avain","addSchematic":"Siirrä tiedosto palvelimeen","schematicsInvalidSvg":"SVG on virheellinen tai sitä ei tueta","schematicsInvalidSvgData":"Tiedostotietojen nouto ei onnistunut","schematicsInvalidType":"Tiedoston laji ei ole tuettu: %{type}","schematicsInvalidSize":"Tiedoston %{file} koko %{size} ylittää enimmäiskoon.","schematicsContextMenuReplace":"Korvaa","schematicsContextMenuDelete":"Poista","schematicsEmptySearchResults":"Hakutulos on tyhjä","schematicsNoSelection":"Kohteita ei ole valittu","schematicsMultipleSelection":"%{count} kohdetta on valittu","schematicsSingleDeletionSuccessed":"Skematiikka on poistettu.","schematicsMultipleDeletionSuccessed":"%{count} skematiikkaa on poistettu.","schematicsSingleAddSuccessed":"Skematiikka on lisätty.","schematicsMultipleAddSuccessed":"%{count} skematiikkaa on lisätty.","schematicsAddFailed":"Skematiikan lisäys epäonnistui.","schematicsReplaceDlgTitle":"Vahvista aiemmin luodun tiedoston korvaus","schematicsReplaceDlgContent":"Järjestelmässä on jo tiedosto %{sourceName}. Haluatko korvata sen uudella tiedostolla?","schematicsReplaceDlgApplyToAllFiles":"Käytä kaikissa tiedostoissa","schematicsPackageTab":"Paketti","schematicsContentTab":"Sisältö","schematicsDescriptionLabel":"Kuvaus","schematicsIconLabel":"Kuvake","schematicsChooseFile":"Lisää tiedosto","schematicsDeleteIcon":"Poista kuvake","schematicsIconAdded":"Kuvake %{file} on lisätty.","schematicsIconRemove":"Kuvake on poistettu.","schematicsIconDropFiles":"Vedä ja pudota tiedosto tähän tai siirrä se","schematicsIconOr":"tai","schematicsIconFileTypes":"Vain .jpg-, .png- ja .svg-tiedostoja.","schematicsIconFileSize":"Tiedoston enimmäiskoko %{size} Mt.","legacySectionExtraMessage":"Varoitus: Vanhat paletit ovat peräisin päivitystä edeltävästä aiemmasta versiosta. Jos näihin paletteihin tehdään muutoksia, ne eivät enää tule näkyviin tätä visualisointia varten.","favorite":"Suosikit","colorPaletteLabel":"Väripaletti"},"__fr":{"errorCreatingPalette":"Une erreur est survenue lors de la sauvegarde de la palette.","paletteErrorTitle":"Erreur liée à la palette","changePaletteLabel":"Modifier la palette de couleurs","manageColorPalettes":"Gérer les palettes de couleurs","legacyPaletteLabel":"Existant","systemPaletteLabel":"Système","localPaletteLabel":"Local","customPaletteLabel":"Personnalisé","globalPaletteLabel":"Global","mruPaletteLabel":"Utilisée récemment","mruPalettes":"Palettes utilisées récemment","allPalettes":"Toutes les palettes","okDialog":"OK","back":"Précédent","deleteDialogTitle":"Supprimer","applyDialog":"Appliquer","cancelDialog":"Annuler","saveDialog":"Enregistrer","createDialog":"Créer","deleteMessage":"Voulez-vous vraiment supprimer la palette \"%{name}\" ?","deleteToast":"\"%{name}\" a été supprimée","favoritesLabel":"Favoris","setAsFavorite":"Définir en tant que favori","createdToastMessage":"\"%{name}\" a été créé(e) avec succès.","createPalette":"Créer une palette personnalisée","colorPicker":"Sélecteur de couleur","errorNoName":"Entrez un nom pour votre palette","errorInsufficientColors":"Choisissez au moins deux couleurs","paletteAppliedToastMessage":"La palette \"%{name}\" a été appliquée au rapport.","createPaletteHeader":"Créer une palette de couleurs","modifyPaletteHeader":"Editer la palette de couleurs","paletteNamePlaceholder":"Entrez le nom de la palette ici","paletteName":"Nom de la palette","standardPalette":"Palette catégorielle","continuousPalette":"Palette continue","removeSwatch":"Supprimer l'échantillon témoin","addSwatch":"Ajouter un échantillon témoin","reversePalette":"Annuler la palette","colorGuide":"Guide de couleur","modeAutomatic":"Automatique","modeCustom":"Personnalisé","colorModel":"Modèle de couleur","modelRGB":"RVB","modelHSB":"TSI","modelCMYK":"CMJK","grid":"Grille","wheel":"Roue","hexCode":"Code hexadécimal","colorRed":"Rouge","colorGreen":"Vert","colorBlue":"Bleu","colorHue":"Teinte","colorSaturation":"Saturation","colorBrightness":"Intensité","colorCyan":"Cyan","colorMagenta":"Magenta","colorYellow":"Jaune","colorBlack":"Noir","codeRed":"Rouge","codeGreen":"Vert","codeBlue":"Bleu","codeHue":"Teinte","codeSaturation":"Saturation","codeBrightness":"Intensité","close":"Fermer","duplicate":"Dupliquer","edit":"Editer","delete":"Supprimer","restoreDefault":"Restaurer la valeur par défaut","editSchematic":"Editer le pack","searchSchematic":"Rechercher","nameLabelSchematic":"Nom","captionLabelSchematic":"Légende","keyLabelSchematic":"Clé","addSchematic":"Transférer le fichier","schematicsInvalidSvg":"Fichier SVG non valide ou non pris en charge","schematicsInvalidSvgData":"Impossible d'obtenir les données du fichier","schematicsInvalidType":"Type de fichier non pris en charge : %{type}","schematicsInvalidSize":"La taille %{size} du fichier %{file} dépasse la limite admise.","schematicsContextMenuReplace":"Remplacer","schematicsContextMenuDelete":"Supprimer","schematicsEmptySearchResults":"Les résultats de la recherche sont vides","schematicsNoSelection":"Aucun élément sélectionné","schematicsMultipleSelection":"%{count} éléments sélectionnés","schematicsSingleDeletionSuccessed":"Votre schéma a été supprimé.","schematicsMultipleDeletionSuccessed":"%{count} schémas ont été supprimés.","schematicsSingleAddSuccessed":"Votre schéma a été ajouté.","schematicsMultipleAddSuccessed":"%{count} schémas ont été ajoutés.","schematicsAddFailed":"Echec de l'ajout de votre schéma.","schematicsReplaceDlgTitle":"Confirmer le remplacement du fichier existant","schematicsReplaceDlgContent":"Le fichier '%{sourceName}' existe déjà. Voulez-vous le remplacer par le nouveau fichier ?","schematicsReplaceDlgApplyToAllFiles":"Appliquer à tous les fichiers","schematicsPackageTab":"Pack","schematicsContentTab":"Contenu","schematicsDescriptionLabel":"Description","schematicsIconLabel":"Icône","schematicsChooseFile":"Ajouter un fichier","schematicsDeleteIcon":"Retirer l'icône","schematicsIconAdded":"L'icône \"%{file}\" a été ajoutée.","schematicsIconRemove":"L'icône a été retirée.","schematicsIconDropFiles":"Transférez ou glissez-déposez le fichier ici","schematicsIconOr":"ou","schematicsIconFileTypes":"Uniquement les fichiers .jpg, .png et .svg.","schematicsIconFileSize":"Taille maximale du fichier : %{size} Mo.","legacySectionExtraMessage":"Avertissement : les palettes existantes proviennent d'une version antérieure à la mise à niveau. Si vous modifiez ces palettes, elles n'apparaîtront plus pour cette visualisation.","favorite":"Favoris","colorPaletteLabel":"Palette de couleurs"},"__hr":{"errorCreatingPalette":"Pojavila se greška tijekom spremanja ove palete.","paletteErrorTitle":"Greška palete","changePaletteLabel":"Promijeni paletu boja","manageColorPalettes":"Upravljanje paletama boja","legacyPaletteLabel":"Naslijeđeno","systemPaletteLabel":"Sistem","localPaletteLabel":"Lokalno","customPaletteLabel":"Prilagođeno","globalPaletteLabel":"Globalna","mruPaletteLabel":"Nedavno korišteno","mruPalettes":"Nedavno korištene palete","allPalettes":"Sve palete","okDialog":"OK","back":"Natrag","deleteDialogTitle":"Izbriši","applyDialog":"Primijeni","cancelDialog":"Opoziv","saveDialog":"Spremi","createDialog":"Kreiraj","deleteMessage":"Jeste li sigurni da želite izbrisati paletu \"%{name}\"?","deleteToast":"\"%{name}\" je izbrisana","favoritesLabel":"Favoriti","setAsFavorite":"Postavi za favorit","createdToastMessage":"\"%{name}\" je uspješno kreirana.","createPalette":"Kreiraj prilagođenu paletu","colorPicker":"Izbornik boja","errorNoName":"Unesite naziv vaše palete","errorInsufficientColors":"Izaberi barem dvije boje","paletteAppliedToastMessage":"Paleta \"%{name}\" je primijenjena na izvještaj.","createPaletteHeader":"Kreiraj paletu boja","modifyPaletteHeader":"Uredi paletu boja","paletteNamePlaceholder":"Ovdje upišite naziv palete","paletteName":"Naziv palete","standardPalette":"Kategorijska paleta","continuousPalette":"Kontinuirana paleta","removeSwatch":"Ukloni uzorak","addSwatch":"Dodaj uzorak","reversePalette":"Obrni paletu","colorGuide":"Vodič za boje","modeAutomatic":"Automatski","modeCustom":"Prilagođeno","colorModel":"Model boje","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Mreža","wheel":"Kotač","hexCode":"Heksadecimalan kod","colorRed":"Crvena","colorGreen":"Zelena","colorBlue":"Plava","colorHue":"Nijansa","colorSaturation":"Zasićenost","colorBrightness":"Svjetlost","colorCyan":"Cijan","colorMagenta":"Grimizna","colorYellow":"Žuta","colorBlack":"Crna","codeRed":"Crvena","codeGreen":"Zelena","codeBlue":"Plava","codeHue":"Nijansa","codeSaturation":"Zasićenost","codeBrightness":"Svjetlost","close":"Zatvori","duplicate":"Dupliciraj","edit":"Uredi","delete":"Izbriši","restoreDefault":"Vrati zadane postavke","editSchematic":"Uredi paket","searchSchematic":"Traži","nameLabelSchematic":"Naziv","captionLabelSchematic":"Zaglavlje","keyLabelSchematic":"Ključ","addSchematic":"Upload datoteke","schematicsInvalidSvg":"Pogrešan ili nepodržani SVG","schematicsInvalidSvgData":"Nisu se mogli dobiti podaci datoteke","schematicsInvalidType":"Nepodržani tip datoteke: %{type}","schematicsInvalidSize":"Datoteka %{file}, veličina %{size} premašuje ograničenje.","schematicsContextMenuReplace":"Zamijeni","schematicsContextMenuDelete":"Izbriši","schematicsEmptySearchResults":"Rezultati pretraživanja su prazni","schematicsNoSelection":"Nema izabranih stavki","schematicsMultipleSelection":"%{count} stavki je izabrano","schematicsSingleDeletionSuccessed":"Vaša shema je uspješno izbrisana.","schematicsMultipleDeletionSuccessed":"%{count} shema je uspješno izbrisano.","schematicsSingleAddSuccessed":"Vaša shema je uspješno dodana.","schematicsMultipleAddSuccessed":"%{count} shema je uspješno dodano.","schematicsAddFailed":"Neuspješno dodavanje sheme.","schematicsReplaceDlgTitle":"Potvrdite zamjenu postojeće datoteke","schematicsReplaceDlgContent":"Datoteka '%{sourceName}' već postoji. Želite li ju zamijeniti s novom datotekom?","schematicsReplaceDlgApplyToAllFiles":"Primijeni na sve datoteke","schematicsPackageTab":"Paket","schematicsContentTab":"Sadržaj","schematicsDescriptionLabel":"Opis","schematicsIconLabel":"Ikona","schematicsChooseFile":"Dodaj datoteku","schematicsDeleteIcon":"Ukloni ikonu","schematicsIconAdded":"Ikona \"%{file}\" je uspješno dodana.","schematicsIconRemove":"Ikona je uspješno uklonjena.","schematicsIconDropFiles":"povucite i ispustite datoteke ovdje ili ih uploadajte","schematicsIconOr":"ili","schematicsIconFileTypes":"Samo .jpg, .png i .svg datoteke","schematicsIconFileSize":"%{size}MB je maksimalna veličina datoteke.","legacySectionExtraMessage":"Upozorenje: Naslijeđene palete su iz ranije verzije prije nadogradnje. Promjene na ovim paletama uzrokovat će da se više ne pojavljuju kod ove vizualizacije.","favorite":"Favoriti","colorPaletteLabel":"Paleta boja"},"__hu":{"errorCreatingPalette":"Hiba történt a paletta mentése közben.","paletteErrorTitle":"Paletta hiba","changePaletteLabel":"Színpaletta módosítása","manageColorPalettes":"Színpaletták kezelése","legacyPaletteLabel":"Örökölt","systemPaletteLabel":"Rendszer","localPaletteLabel":"Helyi","customPaletteLabel":"Egyéni","globalPaletteLabel":"Globális","mruPaletteLabel":"Nemrégiben használt","mruPalettes":"Nemrég használt paletták","allPalettes":"Összes paletta","okDialog":"OK","back":"Vissza","deleteDialogTitle":"Törlés","applyDialog":"Alkalmaz","cancelDialog":"Mégse","saveDialog":"Mentés","createDialog":"Létrehozás","deleteMessage":"Valóban törölni kívánja a(z) \"%{name}\" palettát?","deleteToast":"A(z) \"%{name}\" törlésre került","favoritesLabel":"Kedvencek","setAsFavorite":"Beállítás kedvencként","createdToastMessage":"A(z) \"%{name}\" sikeresen létrehozásra került","createPalette":"Egyéni paletta létrehozása","colorPicker":"Színválasztó","errorNoName":"Adja meg a paletta nevét","errorInsufficientColors":"Válasszon legalább két színt","paletteAppliedToastMessage":"A(z) \"%{name}\" paletta került alkalmazásra a jelentéshez.","createPaletteHeader":"Színpaletta létrehozása","modifyPaletteHeader":"Színpaletta szerkesztése","paletteNamePlaceholder":"Itt adja meg a paletta nevét","paletteName":"Paletta neve","standardPalette":"Kategorikus paletta","continuousPalette":"Folytonos paletta","removeSwatch":"Minta eltávolítása","addSwatch":"Minta hozzáadása","reversePalette":"Fordított paletta","colorGuide":"Szín útmutató","modeAutomatic":"Automatikus","modeCustom":"Egyéni","colorModel":"Színmodell","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Rács","wheel":"Kerék","hexCode":"Hexa kód","colorRed":"Piros","colorGreen":"Zöld","colorBlue":"Kék","colorHue":"Árnyalat","colorSaturation":"Telítettség","colorBrightness":"Fényerő","colorCyan":"Cián","colorMagenta":"Bíbor","colorYellow":"Sárga","colorBlack":"Fekete","codeRed":"Piros","codeGreen":"Zöld","codeBlue":"Kék","codeHue":"Árnyalat","codeSaturation":"Telítettség","codeBrightness":"Fényerő","close":"Bezárás","duplicate":"Többszörözés","edit":"Szerkesztés","delete":"Törlés","restoreDefault":"Alapértelmezés visszaállítása","editSchematic":"Csomagok szerkesztése","searchSchematic":"Keresés","nameLabelSchematic":"Név","captionLabelSchematic":"Felirat","keyLabelSchematic":"Kulcs","addSchematic":"Fájl feltöltése","schematicsInvalidSvg":"Érvénytelen vagy nem támogatott SVG","schematicsInvalidSvgData":"A fájl adatait nem lehet lekérdezni","schematicsInvalidType":"Nem támogatott fájltípus: %{type}","schematicsInvalidSize":"A(z) %{file} fájl %{size} mérete meghaladja a korlátot.","schematicsContextMenuReplace":"Csere","schematicsContextMenuDelete":"Törlés","schematicsEmptySearchResults":"A keresési eredmény üres","schematicsNoSelection":"Nincs kijelölt elem","schematicsMultipleSelection":"%{count} elem kijelölve","schematicsSingleDeletionSuccessed":"Tervrajza sikeresen törlésre került.","schematicsMultipleDeletionSuccessed":"%{count} tervrajz sikeresen törlésre került.","schematicsSingleAddSuccessed":"Tervrajza sikeresen hozzáadásra került.","schematicsMultipleAddSuccessed":"%{count} tervrajz sikeresen hozzáadásra került.","schematicsAddFailed":"A tervrajz hozzáadása nem sikerült.","schematicsReplaceDlgTitle":"A meglévő fájl cseréjének jóváhagyása","schematicsReplaceDlgContent":"A(z) '%{sourceName}' fájl már létezik. Kívánja felülírni az új fájllal?","schematicsReplaceDlgApplyToAllFiles":"Minden fájlra vonatkozik","schematicsPackageTab":"Csomag","schematicsContentTab":"Tartalom","schematicsDescriptionLabel":"Leírás","schematicsIconLabel":"Ikon","schematicsChooseFile":"Fájl hozzáadása","schematicsDeleteIcon":"Az ikon eltávolítása","schematicsIconAdded":"A(z) \"%{file}\" ikon sikeresen hozzáadásra került.","schematicsIconRemove":"Az ikon sikeresen eltávolításra került.","schematicsIconDropFiles":"Húzza ide a fájlt vagy töltse fel","schematicsIconOr":"vagy","schematicsIconFileTypes":"Csak .jpg, .png és .svg fájlok.","schematicsIconFileSize":"%{size}MB maximális fájlméret.","legacySectionExtraMessage":"Figyelem: Az örökölt paletták egy frissítés előtti korábbi változatból származnak. Ha a palettákat módosítja, akkor azok többé nem jelennek meg az adott megjelenítésben. ","favorite":"Kedvencek","colorPaletteLabel":"Színpaletta"},"__it":{"errorCreatingPalette":"Si è verificato un errore durante il salvataggio della tavolozza.","paletteErrorTitle":"Errore della tavolozza","changePaletteLabel":"Modifica tavolozza colori","manageColorPalettes":"Gestisci le tavolozze dei colori","legacyPaletteLabel":"Legacy","systemPaletteLabel":"Sistema","localPaletteLabel":"Locale","customPaletteLabel":"Personalizzato","globalPaletteLabel":"Globale","mruPaletteLabel":"Utilizzato di recente","mruPalettes":"Tavolozze utilizzate di recente","allPalettes":"Tutte le tavolozze","okDialog":"OK","back":"Indietro","deleteDialogTitle":"Elimina","applyDialog":"Applica","cancelDialog":"Annulla","saveDialog":"Salva","createDialog":"Crea","deleteMessage":"Si è sicuri di voler eliminare la tavolozza \"%{name}\"?","deleteToast":"\"%{name}\" è stato eliminato","favoritesLabel":"Preferiti","setAsFavorite":"Imposta come Preferiti","createdToastMessage":"\"%{name}\" creato correttamente.","createPalette":"Creazione di una tavolozza personalizzata","colorPicker":"Selettore colori","errorNoName":"Immettere un nome per la tavolozza","errorInsufficientColors":"Scegli almeno due colori","paletteAppliedToastMessage":"La tavolozza  \"%{name}\", è stata applicata al report.","createPaletteHeader":"Crea tavolozza colori","modifyPaletteHeader":"Modifica tavolozza colori","paletteNamePlaceholder":"Immetti qui il nome tavolozza","paletteName":"Nome tavolozza","standardPalette":"Tavolozza categoriale","continuousPalette":"Tavolozza continua","removeSwatch":"Rimuovi campionario","addSwatch":"Aggiungi campionario","reversePalette":"Inverti tavolozza","colorGuide":"Guida a colori","modeAutomatic":"Automatico","modeCustom":"Personalizzato","colorModel":"Modello di colore","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Griglia","wheel":"Cerchio","hexCode":"Codice esadecimale","colorRed":"Rosso","colorGreen":"Verde","colorBlue":"Blu","colorHue":"Tonalità","colorSaturation":"Saturazione","colorBrightness":"Brillantezza","colorCyan":"Ciano","colorMagenta":"Magenta","colorYellow":"Giallo","colorBlack":"Nero","codeRed":"Rosso","codeGreen":"Verde","codeBlue":"Blu","codeHue":"Tonalità","codeSaturation":"Saturazione","codeBrightness":"Brillantezza","close":"Chiudi","duplicate":"Duplica","edit":"Modifica","delete":"Elimina","restoreDefault":"Ripristina impostazioni predefinite","editSchematic":"Modifica package","searchSchematic":"Ricerca","nameLabelSchematic":"Nome","captionLabelSchematic":"Didascalia","keyLabelSchematic":"Chiave","addSchematic":"Carica file","schematicsInvalidSvg":"SVG non valido o non supportato","schematicsInvalidSvgData":"Impossibile ottenere i dati del file","schematicsInvalidType":"Tipo file non supportato: %{type}","schematicsInvalidSize":"File %{file}, dimensione %{size} supera il limite.","schematicsContextMenuReplace":"Sostituisci","schematicsContextMenuDelete":"Elimina","schematicsEmptySearchResults":"I risultati della ricerca sono vuoti.","schematicsNoSelection":"Nessun elemento selezionato","schematicsMultipleSelection":"%{count} elementi selezionato","schematicsSingleDeletionSuccessed":"La schematica è stata correttamente eliminata.","schematicsMultipleDeletionSuccessed":"%{count} schematiche sono state correttamente eliminate.","schematicsSingleAddSuccessed":"Le schematiche sono state correttamente aggiunte.","schematicsMultipleAddSuccessed":"%{count} schematiche sono state correttamente aggiunte.","schematicsAddFailed":"Aggiunta schematica non riuscita.","schematicsReplaceDlgTitle":"Conferma sostituzione del file esistente","schematicsReplaceDlgContent":"Il file '%{sourceName}' esiste già. Si desidera sostituirlo con il nuovo file?","schematicsReplaceDlgApplyToAllFiles":"Applica a tutti i file","schematicsPackageTab":"Package","schematicsContentTab":"Contenuto","schematicsDescriptionLabel":"Descrizione","schematicsIconLabel":"Icona","schematicsChooseFile":"Aggiungi file","schematicsDeleteIcon":"Rimuovi l'icona","schematicsIconAdded":"L'icona \"%{file}\" è stata correttamente aggiunta.","schematicsIconRemove":"L'icona è stata correttamente rimossa.","schematicsIconDropFiles":"Trascinare e rilasciare il file qui o caricare","schematicsIconOr":"o ","schematicsIconFileTypes":"Solo file .jpg, .png e .svg ","schematicsIconFileSize":"Dimensione file massima %{size} MB ","legacySectionExtraMessage":"Avvertenza: le tavolozze legacy provengono da una versione precedente prima dell'aggiornamento. Modificando queste tavolozze, non saranno più visualizzate per questa visualizzazione. ","favorite":"Preferiti","colorPaletteLabel":"Tavolozza colori"},"__ja":{"errorCreatingPalette":"パレットの保存中にエラーが発生しました。","paletteErrorTitle":"パレット・エラー","changePaletteLabel":"カラー・パレットの変更","manageColorPalettes":"色パレットの管理","legacyPaletteLabel":"レガシー","systemPaletteLabel":"システム","localPaletteLabel":"ローカル","customPaletteLabel":"カスタム","globalPaletteLabel":"グローバル","mruPaletteLabel":"最近使用された","mruPalettes":"最近使用したパレット","allPalettes":"すべてのパレット","okDialog":"OK","back":"戻る","deleteDialogTitle":"削除","applyDialog":"適用","cancelDialog":"キャンセル","saveDialog":"保存","createDialog":"作成","deleteMessage":"パレット \"%{name}\" を削除しますか?","deleteToast":"\"%{name}\" が削除されました","favoritesLabel":"お気に入り","setAsFavorite":"お気に入りとして設定","createdToastMessage":"\"%{name}\" が正常に作成されました。","createPalette":"カスタム・パレットの作成","colorPicker":"カラー・ピッカー","errorNoName":"パレットの名前を入力してください","errorInsufficientColors":"少なくとも 2 つの色を選択してください","paletteAppliedToastMessage":"パレット \"%{name}\" がレポートに適用されました。","createPaletteHeader":"カラー・パレットの作成","modifyPaletteHeader":"カラー・パレットの編集","paletteNamePlaceholder":"ここにパレット名を入力","paletteName":"パレット名","standardPalette":"カテゴリー型パレット","continuousPalette":"連続型パレット","removeSwatch":"スウォッチを削除","addSwatch":"スウォッチを追加","reversePalette":"パレットを反転","colorGuide":"カラー・ガイド","modeAutomatic":"自動","modeCustom":"カスタム","colorModel":"カラー型","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"グリッド","wheel":"ホイール","hexCode":"16 進コード","colorRed":"赤","colorGreen":"緑","colorBlue":"青","colorHue":"色調","colorSaturation":"彩度","colorBrightness":"輝度","colorCyan":"シアン","colorMagenta":"マゼンタ","colorYellow":"黄","colorBlack":"黒","codeRed":"赤","codeGreen":"緑","codeBlue":"青","codeHue":"色調","codeSaturation":"彩度","codeBrightness":"輝度","close":"閉じる","duplicate":"複製","edit":"編集","delete":"削除","restoreDefault":"デフォルトを復元する","editSchematic":"パッケージの編集","searchSchematic":"検索","nameLabelSchematic":"名前","captionLabelSchematic":"キャプション","keyLabelSchematic":"キー","addSchematic":"ファイルのアップロード","schematicsInvalidSvg":"正しくない、またはサポートされていない SVG です","schematicsInvalidSvgData":"ファイル・データを取得できませんでした","schematicsInvalidType":"サポートされないファイル・タイプ: %{type}","schematicsInvalidSize":"ファイル %{file}、サイズ %{size} が制限を超えています。","schematicsContextMenuReplace":"置換","schematicsContextMenuDelete":"削除","schematicsEmptySearchResults":"検索結果が空です","schematicsNoSelection":"アイテムが選択されていません","schematicsMultipleSelection":"%{count} 個のアイテムを選択","schematicsSingleDeletionSuccessed":"図式が正常に削除されました。","schematicsMultipleDeletionSuccessed":"%{count} 個の図式が正常に削除されました。","schematicsSingleAddSuccessed":"図式が正常に追加されました。","schematicsMultipleAddSuccessed":"%{count} 個の図式が正常に追加されました。","schematicsAddFailed":"図式を追加できませんでした。","schematicsReplaceDlgTitle":"既存ファイルの置換の確認","schematicsReplaceDlgContent":"ファイル '%{sourceName}' は既に存在しています。 新しいファイルに置き換えますか?","schematicsReplaceDlgApplyToAllFiles":"すべてのファイルに適用","schematicsPackageTab":"パッケージ","schematicsContentTab":"コンテンツ","schematicsDescriptionLabel":"説明","schematicsIconLabel":"アイコン","schematicsChooseFile":"ファイルの追加","schematicsDeleteIcon":"アイコンの削除","schematicsIconAdded":"アイコン \"%{file}\" が正常に追加されました。","schematicsIconRemove":"アイコンが正常に削除されました。","schematicsIconDropFiles":"ファイルをここにドラッグ・アンド・ドロップするかアップロードしてください","schematicsIconOr":"または","schematicsIconFileTypes":".jpg、.png、および .svg ファイルのみ。","schematicsIconFileSize":"ファイル・サイズは最大 %{size}MB。","legacySectionExtraMessage":"警告: レガシー・パレットは、アップグレードする前のバージョンのものです。これらのパレットに変更を加えると、この視覚化には表示されなくなります。","favorite":"お気に入り","colorPaletteLabel":"カラー・パレット"},"__kk":{"errorCreatingPalette":"Бояғышты сақтау кезінде қате пайда болды.","paletteErrorTitle":"Бояғыш қатесі","changePaletteLabel":"Түсті бояғыштарды өзгерту","manageColorPalettes":"Түс палитраларын басқару","legacyPaletteLabel":"Бұрынғы","systemPaletteLabel":"Жүйе","localPaletteLabel":"Жергілікті","customPaletteLabel":"Теңшелетін","globalPaletteLabel":"Ғаламдық","mruPaletteLabel":"Жақында қолданылған","mruPalettes":"Соңғы қолданылған палитралар","allPalettes":"Барлық палитралар","okDialog":"OK","back":"Артқа","deleteDialogTitle":"Жою","applyDialog":"Қолдану","cancelDialog":"Болдырмау","saveDialog":"Сақтау","createDialog":"Жасау","deleteMessage":"\"%{name}\" бояғышын жойғыңыз келетініне сенімдісіз бе?","deleteToast":"\"%{name}\" жойылған","favoritesLabel":"Таңдаулылар","setAsFavorite":"Таңдаулы ретінде орнату","createdToastMessage":"\"%{name}\"  сәтті жасалды.","createPalette":"Пайдаланушы бояғышты жасау","colorPicker":"Түс таңдағыш","errorNoName":"Бояғыштың атын енгізіңіз","errorInsufficientColors":"Кемінде екі түсті таңдаңыз","paletteAppliedToastMessage":"Есепке \"%{name}\" бояғышы қолданылды.","createPaletteHeader":"Түстер бояғышын жасаңыз","modifyPaletteHeader":"Түстер бояғышын өңдеу","paletteNamePlaceholder":"Бояғыштың атауын мына жерде теріңіз","paletteName":"Бояғыш атауы","standardPalette":"Категориялы бояғыш","continuousPalette":"Үздіксіз бояғыш","removeSwatch":"Таңбаны алып тастау","addSwatch":"Таңба қосу","reversePalette":"Кері бояғышы","colorGuide":"Түс бағыттаушы","modeAutomatic":"Автоматты","modeCustom":"Теңшелім","colorModel":"Түс үлгісі","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Жоғарғы","wheel":"Шеңбері","hexCode":"Hex код","colorRed":"Қызыл","colorGreen":"Жасыл","colorBlue":"Көк","colorHue":"Реңк","colorSaturation":"Қанықтық","colorBrightness":"Жарықтық","colorCyan":"Көкшіл","colorMagenta":"Күлгін","colorYellow":"Сары","colorBlack":"Қара","codeRed":"Қызыл","codeGreen":"Жасыл","codeBlue":"Көк","codeHue":"Реңк","codeSaturation":"Қанықтық","codeBrightness":"Жарықтық","close":"Жабу","duplicate":"Көшірмелеу","edit":"Өңдеу","delete":"Жою","restoreDefault":"Әдепкі мәндерге қайтару","editSchematic":"Буманы өңдеу","searchSchematic":"Іздеу","nameLabelSchematic":"Аты","captionLabelSchematic":"Тақырып","keyLabelSchematic":"Кілт","addSchematic":"Файлды жүктеп алу","schematicsInvalidSvg":"Жарамсыз немесе қолдау көрсетілмейтін SVG","schematicsInvalidSvgData":"Файл деректерін алу мүмкін болмады","schematicsInvalidType":"Қолдау көрсетілмейтін файл түрі: %{type}","schematicsInvalidSize":"%{file} файлы, %{size} мөлшері шектен асады.","schematicsContextMenuReplace":"Ауыстыру","schematicsContextMenuDelete":"Жою","schematicsEmptySearchResults":"Іздеу нәтижелері бос","schematicsNoSelection":"Ешбір элемент таңдалмады","schematicsMultipleSelection":"%{count} элемент таңдалды","schematicsSingleDeletionSuccessed":"Сіздің схемаңыз сәтті жойылды.","schematicsMultipleDeletionSuccessed":"%{count} схемасы сәтті жойылды.","schematicsSingleAddSuccessed":"Сіздің схемаңыз сәтті қосылды.","schematicsMultipleAddSuccessed":"%{count} схемасы сәтті қосылды.","schematicsAddFailed":"Схемаңызды қосу сәтсіз аяқталды.","schematicsReplaceDlgTitle":"Бар файлды ауыстыруды растаңыз","schematicsReplaceDlgContent":"'%{sourceName}' файлы бұрыннан бар. Оны жаңа файлмен алмастырғыңыз келе ме?","schematicsReplaceDlgApplyToAllFiles":"Барлық файлдарға қолданыңыз","schematicsPackageTab":"Бума","schematicsContentTab":"Мазмұн","schematicsDescriptionLabel":"Сипаттама","schematicsIconLabel":"Белгіше","schematicsChooseFile":"Файлды қосу","schematicsDeleteIcon":"Белгішені жоюңыз","schematicsIconAdded":"\"%{file}\" белгішесі сәтті қосылды.","schematicsIconRemove":"Белгіше сәтті алынып тасталды.","schematicsIconDropFiles":"Файлды сүйреп апарыңыз немесе жүктеңіз","schematicsIconOr":"or","schematicsIconFileTypes":"Тек .jpg, .png және .svg файлдары.","schematicsIconFileSize":"%{size} МБ максималды файл өлшемі.","legacySectionExtraMessage":"Ескерту: бұрынғы палитралар сіз жаңартқанға дейінгі алдыңғы нұсқадан алынған. Бұл палитраларға енгізілген өзгертулер олардың көрнекілендіру үшін пайда болмауына әкеледі.","favorite":"Таңдаулылар","colorPaletteLabel":"Түсті бояғыш"},"__ko":{"errorCreatingPalette":"색상표를 저장하는 중에 오류가 발생했습니다.","paletteErrorTitle":"색상표 오류","changePaletteLabel":"색상표 변경","manageColorPalettes":"색상표 관리","legacyPaletteLabel":"레거시","systemPaletteLabel":"시스템","localPaletteLabel":"로컬","customPaletteLabel":"사용자 정의","globalPaletteLabel":"글로벌","mruPaletteLabel":"최근 사용됨","mruPalettes":"최근에 사용한 팔레트","allPalettes":"모든 팔레트","okDialog":"확인","back":"뒤로","deleteDialogTitle":"삭제","applyDialog":"적용","cancelDialog":"취소","saveDialog":"저장","createDialog":"작성","deleteMessage":"\"%{name}\" 색상표를 삭제하시겠습니까?","deleteToast":"\"%{name}\"이(가) 삭제됨","favoritesLabel":"즐겨찾기","setAsFavorite":"즐겨찾기로 설정","createdToastMessage":"\"%{name}\"이(가) 작성되었습니다.","createPalette":"사용자 정의 색상표 작성","colorPicker":"색상 선택도구","errorNoName":"색상표 이름 입력","errorInsufficientColors":"둘 이상의 색상 선택","paletteAppliedToastMessage":"\"%{name}\" 색상표가 보고서에 적용되었습니다.","createPaletteHeader":"색상표 작성","modifyPaletteHeader":"색상표 편집","paletteNamePlaceholder":"여기에 색상표 이름 입력","paletteName":"색상표 이름","standardPalette":"카테고리형 색상표","continuousPalette":"연속 색상표","removeSwatch":"견본 제거","addSwatch":"견본 추가","reversePalette":"색상표 반전","colorGuide":"색상 안내서","modeAutomatic":"자동","modeCustom":"사용자 정의","colorModel":"색상 모델","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"눈금","wheel":"휠","hexCode":"16진 코드","colorRed":"빨간색","colorGreen":"녹색","colorBlue":"파란색","colorHue":"색상","colorSaturation":"채도","colorBrightness":"밝기","colorCyan":"청록색","colorMagenta":"진홍색","colorYellow":"노란색","colorBlack":"검은색","codeRed":"빨간색","codeGreen":"녹색","codeBlue":"파란색","codeHue":"색상","codeSaturation":"채도","codeBrightness":"밝기","close":"닫기","duplicate":"복제","edit":"편집","delete":"삭제","restoreDefault":"기본값 복원","editSchematic":"패키지 편집","searchSchematic":"검색","nameLabelSchematic":"이름","captionLabelSchematic":"캡션","keyLabelSchematic":"키","addSchematic":"파일 업로드","schematicsInvalidSvg":"올바르지 않거나 지원되지 않는 SVG","schematicsInvalidSvgData":"파일 데이터를 확보할 수 없음","schematicsInvalidType":"지원되지 않는 파일 유형: %{type}","schematicsInvalidSize":"%{file} 파일, %{size} 크기가 한계를 초과했습니다.","schematicsContextMenuReplace":"대체","schematicsContextMenuDelete":"삭제","schematicsEmptySearchResults":"검색 결과가 비어 있음","schematicsNoSelection":"항목을 선택하지 않음","schematicsMultipleSelection":"%{count}개의 항목이 선택됨","schematicsSingleDeletionSuccessed":"도식이 삭제되었습니다.","schematicsMultipleDeletionSuccessed":"%{count} 도식이 삭제되었습니다.","schematicsSingleAddSuccessed":"도식이 추가되었습니다.","schematicsMultipleAddSuccessed":"%{count} 도식이 추가되었습니다.","schematicsAddFailed":"도식 추가에 실패했습니다.","schematicsReplaceDlgTitle":"기존 파일의 대체 확인","schematicsReplaceDlgContent":"'%{sourceName}' 파일이 이미 있습니다. 새 파일로 이를 대체하시겠습니까?","schematicsReplaceDlgApplyToAllFiles":"모든 파일에 적용","schematicsPackageTab":"패키지","schematicsContentTab":"컨텐츠","schematicsDescriptionLabel":"설명","schematicsIconLabel":"아이콘","schematicsChooseFile":"파일 추가","schematicsDeleteIcon":"아이콘 제거","schematicsIconAdded":"\"%{file}\" 아이콘이 추가되었습니다.","schematicsIconRemove":"아이콘이 제거되었습니다.","schematicsIconDropFiles":"여기에 파일을 끌어서 놓거나 업로드","schematicsIconOr":"또는","schematicsIconFileTypes":".jpg, .png 및 .svg 파일만.","schematicsIconFileSize":"%{size}MB의 최대 파일 크기.","legacySectionExtraMessage":"경고: 레거시 팔레트는 업그레이드하기 전에 이전 버전에서 가져온 것입니다. 이러한 팔레트를 변경하면 이 시각화에 더 이상 표시되지 않습니다. ","favorite":"즐겨찾기","colorPaletteLabel":"색상표"},"__no":{"errorCreatingPalette":"Det oppstod en feil under lagring av paletten.","paletteErrorTitle":"Palettfeil","changePaletteLabel":"Endre fargepalett","manageColorPalettes":"Administrer fargepaletter","legacyPaletteLabel":"Gammel (legacy)","systemPaletteLabel":"System","localPaletteLabel":"Lokal","customPaletteLabel":"Tilpasset","globalPaletteLabel":"Global","mruPaletteLabel":"Nylig brukt","mruPalettes":"Nylig brukte paletter","allPalettes":"Alle paletter","okDialog":"OK","back":"Tilbake","deleteDialogTitle":"Slett","applyDialog":"Bruk","cancelDialog":"Avbryt","saveDialog":"Lagre","createDialog":"Opprett","deleteMessage":"Er du sikker på at du vil slette paletten \"%{name}\"?","deleteToast":"\"%{name}\" ble slettet","favoritesLabel":"Favoritter","setAsFavorite":"Definer som favoritt","createdToastMessage":"\"%{name}\" ble opprettet.","createPalette":"Opprett en tilpasset palett","colorPicker":"Fargevelger","errorNoName":"Oppgi et navn på paletten.","errorInsufficientColors":"Velg minst to farger","paletteAppliedToastMessage":"Palett \"%{name}\" ble brukt på rapporten.","createPaletteHeader":"Opprett fargepalett","modifyPaletteHeader":"Rediger fargepalett","paletteNamePlaceholder":"Skriv palettnavn her","paletteName":"Palettnavn","standardPalette":"Kategorisk palett","continuousPalette":"Kontinuerlig palett","removeSwatch":"Fjern prøve","addSwatch":"Legg til prøve","reversePalette":"Omvendt palett","colorGuide":"Fargeveiledning","modeAutomatic":"Automatisk","modeCustom":"Tilpasset","colorModel":"Fargemodell","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Rutenett","wheel":"Hjul","hexCode":"Heksadesimal kode","colorRed":"Rød","colorGreen":"Grønn","colorBlue":"Blå","colorHue":"Nyanse","colorSaturation":"Metning","colorBrightness":"Lysstyrke","colorCyan":"Cyan","colorMagenta":"Magenta","colorYellow":"Gul","colorBlack":"Svart","codeRed":"Rød","codeGreen":"Grønn","codeBlue":"Blå","codeHue":"Nyanse","codeSaturation":"Metning","codeBrightness":"Lysstyrke","close":"Lukk","duplicate":"Dupliser","edit":"Rediger","delete":"Slett","restoreDefault":"Gjenopprett standard","editSchematic":"Rediger pakke","searchSchematic":"Søk","nameLabelSchematic":"Navn","captionLabelSchematic":"Tittel","keyLabelSchematic":"Nøkkel","addSchematic":"Last opp fil","schematicsInvalidSvg":"Ugyldig eller ikke støttet SVG","schematicsInvalidSvgData":"Kunne ikke hente fildata","schematicsInvalidType":"Ikke-støttet filtype: %{type}","schematicsInvalidSize":"Fil %{file}, størrelse %{size} overskrider grense.","schematicsContextMenuReplace":"Erstatt","schematicsContextMenuDelete":"Slett","schematicsEmptySearchResults":"Søkeresultatet er tomt","schematicsNoSelection":"Ingen elementer valgt","schematicsMultipleSelection":"%{count} elementer valgt","schematicsSingleDeletionSuccessed":"Skjemaet ble slettet.","schematicsMultipleDeletionSuccessed":"%{count} skjemaer ble slettet.","schematicsSingleAddSuccessed":"Skjemaet ble lagt til.","schematicsMultipleAddSuccessed":"%{count} skjemaer ble lagt til.","schematicsAddFailed":"Kunne ikke legge til skjema.","schematicsReplaceDlgTitle":"Bekreft erstatning av eksisterende fil","schematicsReplaceDlgContent":"Filen '%{sourceName}' finnes allerede. Vil du erstatte den med den nye filen?","schematicsReplaceDlgApplyToAllFiles":"Bruk på alle filer","schematicsPackageTab":"Pakke","schematicsContentTab":"Innhold","schematicsDescriptionLabel":"Beskrivelse","schematicsIconLabel":"Ikon","schematicsChooseFile":"Legg til fil","schematicsDeleteIcon":"Fjern ikonet","schematicsIconAdded":"Ikonet \"%{file}\" ble lagt til.","schematicsIconRemove":"Ikonet ble fjernet.","schematicsIconDropFiles":"Dra og slipp fil her eller last opp","schematicsIconOr":"eller","schematicsIconFileTypes":"Bare filer av typen .jpg, .png og .svg.","schematicsIconFileSize":"%{size} MB maks filstørrelse.","legacySectionExtraMessage":"Advarsel: Eldre paletter er fra en tidligere versjon før du oppgraderte. Endringer i disse palettene vil gjøre at de ikke lenger blir vist for denne visualiseringen.","favorite":"Favoritter","colorPaletteLabel":"Fargepalett"},"__nb":{"errorCreatingPalette":"Det oppstod en feil under lagring av paletten.","paletteErrorTitle":"Palettfeil","changePaletteLabel":"Endre fargepalett","manageColorPalettes":"Administrer fargepaletter","legacyPaletteLabel":"Gammel (legacy)","systemPaletteLabel":"System","localPaletteLabel":"Lokal","customPaletteLabel":"Tilpasset","globalPaletteLabel":"Global","mruPaletteLabel":"Nylig brukt","mruPalettes":"Nylig brukte paletter","allPalettes":"Alle paletter","okDialog":"OK","back":"Tilbake","deleteDialogTitle":"Slett","applyDialog":"Bruk","cancelDialog":"Avbryt","saveDialog":"Lagre","createDialog":"Opprett","deleteMessage":"Er du sikker på at du vil slette paletten \"%{name}\"?","deleteToast":"\"%{name}\" ble slettet","favoritesLabel":"Favoritter","setAsFavorite":"Definer som favoritt","createdToastMessage":"\"%{name}\" ble opprettet.","createPalette":"Opprett en tilpasset palett","colorPicker":"Fargevelger","errorNoName":"Oppgi et navn på paletten.","errorInsufficientColors":"Velg minst to farger","paletteAppliedToastMessage":"Palett \"%{name}\" ble brukt på rapporten.","createPaletteHeader":"Opprett fargepalett","modifyPaletteHeader":"Rediger fargepalett","paletteNamePlaceholder":"Skriv palettnavn her","paletteName":"Palettnavn","standardPalette":"Kategorisk palett","continuousPalette":"Kontinuerlig palett","removeSwatch":"Fjern prøve","addSwatch":"Legg til prøve","reversePalette":"Omvendt palett","colorGuide":"Fargeveiledning","modeAutomatic":"Automatisk","modeCustom":"Tilpasset","colorModel":"Fargemodell","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Rutenett","wheel":"Hjul","hexCode":"Heksadesimal kode","colorRed":"Rød","colorGreen":"Grønn","colorBlue":"Blå","colorHue":"Nyanse","colorSaturation":"Metning","colorBrightness":"Lysstyrke","colorCyan":"Cyan","colorMagenta":"Magenta","colorYellow":"Gul","colorBlack":"Svart","codeRed":"Rød","codeGreen":"Grønn","codeBlue":"Blå","codeHue":"Nyanse","codeSaturation":"Metning","codeBrightness":"Lysstyrke","close":"Lukk","duplicate":"Dupliser","edit":"Rediger","delete":"Slett","restoreDefault":"Gjenopprett standard","editSchematic":"Rediger pakke","searchSchematic":"Søk","nameLabelSchematic":"Navn","captionLabelSchematic":"Tittel","keyLabelSchematic":"Nøkkel","addSchematic":"Last opp fil","schematicsInvalidSvg":"Ugyldig eller ikke støttet SVG","schematicsInvalidSvgData":"Kunne ikke hente fildata","schematicsInvalidType":"Ikke-støttet filtype: %{type}","schematicsInvalidSize":"Fil %{file}, størrelse %{size} overskrider grense.","schematicsContextMenuReplace":"Erstatt","schematicsContextMenuDelete":"Slett","schematicsEmptySearchResults":"Søkeresultatet er tomt","schematicsNoSelection":"Ingen elementer valgt","schematicsMultipleSelection":"%{count} elementer valgt","schematicsSingleDeletionSuccessed":"Skjemaet ble slettet.","schematicsMultipleDeletionSuccessed":"%{count} skjemaer ble slettet.","schematicsSingleAddSuccessed":"Skjemaet ble lagt til.","schematicsMultipleAddSuccessed":"%{count} skjemaer ble lagt til.","schematicsAddFailed":"Kunne ikke legge til skjema.","schematicsReplaceDlgTitle":"Bekreft erstatning av eksisterende fil","schematicsReplaceDlgContent":"Filen '%{sourceName}' finnes allerede. Vil du erstatte den med den nye filen?","schematicsReplaceDlgApplyToAllFiles":"Bruk på alle filer","schematicsPackageTab":"Pakke","schematicsContentTab":"Innhold","schematicsDescriptionLabel":"Beskrivelse","schematicsIconLabel":"Ikon","schematicsChooseFile":"Legg til fil","schematicsDeleteIcon":"Fjern ikonet","schematicsIconAdded":"Ikonet \"%{file}\" ble lagt til.","schematicsIconRemove":"Ikonet ble fjernet.","schematicsIconDropFiles":"Dra og slipp fil her eller last opp","schematicsIconOr":"eller","schematicsIconFileTypes":"Bare filer av typen .jpg, .png og .svg.","schematicsIconFileSize":"%{size} MB maks filstørrelse.","legacySectionExtraMessage":"Advarsel: Eldre paletter er fra en tidligere versjon før du oppgraderte. Endringer i disse palettene vil gjøre at de ikke lenger blir vist for denne visualiseringen.","favorite":"Favoritter","colorPaletteLabel":"Fargepalett"},"__nl":{"errorCreatingPalette":"Fout opgetreden bij het opslaan van het palet.","paletteErrorTitle":"Paletfout","changePaletteLabel":"Kleurenpalet wijzigen","manageColorPalettes":"Kleurpaletten beheren","legacyPaletteLabel":"Legacy","systemPaletteLabel":"Systeem","localPaletteLabel":"Lokaal","customPaletteLabel":"aangepast","globalPaletteLabel":"Algemeen","mruPaletteLabel":"Kortgeleden gebruikt","mruPalettes":"Recent gebruikte paletten","allPalettes":"Alle paletten","okDialog":"OK","back":"Terug","deleteDialogTitle":"Verwijderen","applyDialog":"Toepassen","cancelDialog":"Annuleren","saveDialog":"Opslaan","createDialog":"Maken","deleteMessage":"Weet u zeker dat u het palet \"%{name}\" wilt wissen?","deleteToast":"\"%{name}\" is gewist","favoritesLabel":"Favorieten","setAsFavorite":"Instellen als favoriet","createdToastMessage":"\"%{name}\" is gemaakt.","createPalette":"Aangepast palet maken","colorPicker":"Kleurenselector","errorNoName":"Geef een naam voor uw palet op","errorInsufficientColors":"Kies minimaal twee kleuren","paletteAppliedToastMessage":"Palet \"%{name}\" is toegepast op het rapport.","createPaletteHeader":"Kleurenpalet maken","modifyPaletteHeader":"Kleurenpalet bewerken","paletteNamePlaceholder":"Typ hier de naam van het palet","paletteName":"Naam van palet","standardPalette":"Categorisch palet","continuousPalette":"Doorlopend palet","removeSwatch":"Staal verwijderen","addSwatch":"Staal toevoegen","reversePalette":"Palet negatief maken","colorGuide":"Kleurengids","modeAutomatic":"Automatisch","modeCustom":"Aangepast","colorModel":"Kleurmodel","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Raster","wheel":"Cirkel","hexCode":"Hexcode","colorRed":"Rood","colorGreen":"Groen","colorBlue":"Blauw","colorHue":"Tint","colorSaturation":"Verzadiging","colorBrightness":"Helderheid","colorCyan":"Cyaan","colorMagenta":"Magenta","colorYellow":"Geel","colorBlack":"Zwart","codeRed":"Rood","codeGreen":"Groen","codeBlue":"Blauw","codeHue":"Tint","codeSaturation":"Verzadiging","codeBrightness":"Helderheid","close":"Sluiten","duplicate":"Dupliceren","edit":"Bewerken","delete":"Verwijderen","restoreDefault":"Standaardwaarde herstellen","editSchematic":"Pakket bewerken","searchSchematic":"Zoeken","nameLabelSchematic":"Naam","captionLabelSchematic":"Bijschrift","keyLabelSchematic":"Sleutel","addSchematic":"Bestand uploaden","schematicsInvalidSvg":"Ongeldige of niet-ondersteunde SVG","schematicsInvalidSvgData":"Bestandsgegevens kunnen niet worden opgehaald","schematicsInvalidType":"Niet-ondersteund bestandstype: %{type}","schematicsInvalidSize":"Bestand %{file}, grootte %{size} overschrijdt de limiet.","schematicsContextMenuReplace":"Vervangen","schematicsContextMenuDelete":"Verwijderen","schematicsEmptySearchResults":"Het zoekresultaat is leeg","schematicsNoSelection":"Geen items geselecteerd","schematicsMultipleSelection":"%{count} items geselecteerd","schematicsSingleDeletionSuccessed":"Uw schema is gewist.","schematicsMultipleDeletionSuccessed":"%{count} schema's gewist.","schematicsSingleAddSuccessed":"Uw schema is toegevoegd.","schematicsMultipleAddSuccessed":"%{count} schema's zijn toegevoegd.","schematicsAddFailed":"Toevoegen van uw schema is mislukt.","schematicsReplaceDlgTitle":"Vervanging van bestaand bestand bevestigen","schematicsReplaceDlgContent":"Het bestand '%{sourceName}' bestaat al. Wilt u het vervangen door het nieuwe bestand?","schematicsReplaceDlgApplyToAllFiles":"Toepassen op alle bestanden","schematicsPackageTab":"Pakket","schematicsContentTab":"Inhoud","schematicsDescriptionLabel":"Naam","schematicsIconLabel":"Pictogram","schematicsChooseFile":"Bestand toevoegen","schematicsDeleteIcon":"Het pictogram verwijderen","schematicsIconAdded":"Het pictogram \"%{file}\" is toegevoegd.","schematicsIconRemove":"Het pictogram is verwijderd.","schematicsIconDropFiles":"Versleep een bestand hiernaartoe of upload het","schematicsIconOr":"of","schematicsIconFileTypes":"Alleen .jpg, .png en .svg-bestanden.","schematicsIconFileSize":"%{size} MB max bestandsgrootte.","legacySectionExtraMessage":"Waarschuwing: Legacypaletten zijn van een eerdere versie voordat een upgrade uitvoerde. Wijzigingen in deze paletten leiden ertoe dat ze niet meer in deze visualisatie zichtbaar zijn. ","favorite":"Favorieten","colorPaletteLabel":"Kleurenpalet"},"__pl":{"errorCreatingPalette":"Wystąpił błąd podczas zapisywania palety.","paletteErrorTitle":"Błąd palety","changePaletteLabel":"Zmień paletę kolorów","manageColorPalettes":"Zarządzaj paletami kolorów","legacyPaletteLabel":"Poprzednia wersja","systemPaletteLabel":"System","localPaletteLabel":"Lokalne","customPaletteLabel":"Niestandardowa","globalPaletteLabel":"Globalne","mruPaletteLabel":"Ostatnio używane","mruPalettes":"Ostatnio używane palety","allPalettes":"Wszystkie palety","okDialog":"OK","back":"Wstecz","deleteDialogTitle":"Usuń","applyDialog":"Zastosuj","cancelDialog":"Anuluj","saveDialog":"Zapisz","createDialog":"Utwórz","deleteMessage":"Czy na pewno chcesz usunąć paletę \"%{name}\"?","deleteToast":"Usunięto \"%{name}\"","favoritesLabel":"Ulubione","setAsFavorite":"Ustaw jako ulubione","createdToastMessage":"Pomyślnie utworzono \"%{name}\".","createPalette":"Utwórz paletę niestandardową","colorPicker":"Selektor kolorów","errorNoName":"Wprowadź nazwę palety","errorInsufficientColors":"Wybierz co najmniej dwa kolory","paletteAppliedToastMessage":"Paleta o nazwie \"%{name}\" została zastosowana w raporcie.","createPaletteHeader":"Utwórz paletę kolorów","modifyPaletteHeader":"Edytuj paletę kolorów","paletteNamePlaceholder":"Tutaj wpisz nazwę palety","paletteName":"Nazwa palety","standardPalette":"Paleta kategorialna","continuousPalette":"Paleta ciągła","removeSwatch":"Usuń próbkę","addSwatch":"Dodaj próbkę","reversePalette":"Odwróć paletę","colorGuide":"Przewodnik po kolorach","modeAutomatic":"Automatycznie","modeCustom":"Niestandardowa","colorModel":"Model kolorów","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Siatka","wheel":"Koło","hexCode":"Kod szesnastkowy","colorRed":"Czerwony","colorGreen":"Zielony","colorBlue":"Niebieski","colorHue":"Barwa","colorSaturation":"Nasycenie","colorBrightness":"Jasność","colorCyan":"Niebieskozielony","colorMagenta":"Amarantowy","colorYellow":"Żółty","colorBlack":"Czarny","codeRed":"Czerwony","codeGreen":"Zielony","codeBlue":"Niebieski","codeHue":"Barwa","codeSaturation":"Nasycenie","codeBrightness":"Jasność","close":"Zamknij","duplicate":"Duplikuj","edit":"Edytuj","delete":"Usuń","restoreDefault":"Przywróć wartość domyślną","editSchematic":"Edytuj pakiet","searchSchematic":"Szukaj","nameLabelSchematic":"Nazwa","captionLabelSchematic":"Podpis","keyLabelSchematic":"Klucz","addSchematic":"Prześlij plik","schematicsInvalidSvg":"Niepoprawny lub nieobsługiwany plik SVG","schematicsInvalidSvgData":"Nie można uzyskać danych pliku","schematicsInvalidType":"Nieobsługiwany typ pliku: %{type}","schematicsInvalidSize":"Rozmiar %{size} pliku %{file} przekracza limit.","schematicsContextMenuReplace":"Zastąp","schematicsContextMenuDelete":"Usuń","schematicsEmptySearchResults":"Wyniki wyszukiwania są puste","schematicsNoSelection":"Nie wybrano żadnego elementu","schematicsMultipleSelection":"Wybrano elementów: %{count}","schematicsSingleDeletionSuccessed":"Schemat został pomyślnie usunięty.","schematicsMultipleDeletionSuccessed":"Pomyślnie usunięto następującą liczbę schematów: %{count}","schematicsSingleAddSuccessed":"Schemat został pomyślnie dodany.","schematicsMultipleAddSuccessed":"Pomyślnie dodano następującą liczbę schematów: %{count}","schematicsAddFailed":"Nie powiodło się dodanie schematu.","schematicsReplaceDlgTitle":"Potwierdź zastąpienie istniejącego pliku","schematicsReplaceDlgContent":"Plik '%{sourceName}' już istnieje. Czy zastąpić go nowym plikiem?","schematicsReplaceDlgApplyToAllFiles":"Zastosuj do wszystkich plików","schematicsPackageTab":"Pakiet","schematicsContentTab":"Treść","schematicsDescriptionLabel":"Opis","schematicsIconLabel":"Ikona","schematicsChooseFile":"Dodaj plik","schematicsDeleteIcon":"Usuń ikonę","schematicsIconAdded":"Ikona \"%{file}\" została pomyślnie dodana.","schematicsIconRemove":"Ikona została pomyślnie usunięta.","schematicsIconDropFiles":"Przeciągnij i upuść plik w tym miejscu lub go prześlij","schematicsIconOr":"lub","schematicsIconFileTypes":"Tylko pliki .jpg, .png i .svg.","schematicsIconFileSize":"Maks. wielkość pliku: %{size}MB.","legacySectionExtraMessage":"Ostrzeżenie: Starsze palety pochodzą z wersji wcześniejszej, sprzed aktualizacji. Wprowadzenie zmian w tych paletach spowoduje, że nie będą już widoczne w tej wizualizacji.","favorite":"Ulubione","colorPaletteLabel":"Paleta kolorów"},"__pt":{"errorCreatingPalette":"Ocorreu um erro ao salvar a paleta.","paletteErrorTitle":"Erro da Paleta","changePaletteLabel":"Alterar paleta de cores","manageColorPalettes":"Gerenciar paletas de cores","legacyPaletteLabel":"Preexistente","systemPaletteLabel":"Sistema","localPaletteLabel":"Local","customPaletteLabel":"Customizado","globalPaletteLabel":"Global","mruPaletteLabel":"Recentemente usado","mruPalettes":"Paletas usadas recentemente","allPalettes":"Todas as paletas","okDialog":"OK","back":"Voltar","deleteDialogTitle":"Excluir","applyDialog":"Aplicar","cancelDialog":"Cancelar","saveDialog":"Salvar","createDialog":"Criar","deleteMessage":"Tem certeza de que deseja excluir a paleta \"%{name}\"?","deleteToast":"\"%{name}\" foi excluído","favoritesLabel":"Destaques","setAsFavorite":"Configurar como favorito","createdToastMessage":"\"%{name}\" foi criado com êxito.","createPalette":"Criar uma Paleta Customizada","colorPicker":"Selecionador de Cores","errorNoName":"Digite um nome para a paleta","errorInsufficientColors":"Escolha pelo menos duas cores","paletteAppliedToastMessage":"A paleta \"%{name}\" foi aplicada no relatório.","createPaletteHeader":"Criar paleta de cores","modifyPaletteHeader":"Editar paleta de cores","paletteNamePlaceholder":"Digite o nome da paleta aqui","paletteName":"Nome da paleta","standardPalette":"Paleta categórica","continuousPalette":"Paleta Contínua","removeSwatch":"Remover swatch","addSwatch":"Incluir swatch","reversePalette":"Reverter Paleta","colorGuide":"Guia de Cores","modeAutomatic":"Automática","modeCustom":"Personalização","colorModel":"Modelo de Cor","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Grade","wheel":"Roda","hexCode":"Código Hex","colorRed":"Vermelho","colorGreen":"Verde","colorBlue":"Azul","colorHue":"Hue","colorSaturation":"Saturação","colorBrightness":"Brilho","colorCyan":"Ciano","colorMagenta":"Magenta","colorYellow":"Amarelo","colorBlack":"Preto","codeRed":"Vermelho","codeGreen":"Verde","codeBlue":"Azul","codeHue":"Hue","codeSaturation":"Saturação","codeBrightness":"Brilho","close":"Fechar","duplicate":"Duplicado","edit":"Editar","delete":"Excluir","restoreDefault":"Restaurar padrão","editSchematic":"Editar pacote","searchSchematic":"Procurar","nameLabelSchematic":"Nome","captionLabelSchematic":"Texto Explicativo","keyLabelSchematic":"Chave","addSchematic":"Fazer upload do arquivo","schematicsInvalidSvg":"SVG inválido ou não suportado","schematicsInvalidSvgData":"Não foi possível obter os dados do arquivo","schematicsInvalidType":"Tipo de arquivo não suportado: %{type}","schematicsInvalidSize":"O arquivo %{file}, tamanho %{size}, excede o limite.","schematicsContextMenuReplace":"Substituir","schematicsContextMenuDelete":"Excluir","schematicsEmptySearchResults":"Os resultados da procura estão vazios","schematicsNoSelection":"Nenhum Item Selecionado","schematicsMultipleSelection":"%{count} itens selecionados","schematicsSingleDeletionSuccessed":"Seu esquema foi excluído com sucesso.","schematicsMultipleDeletionSuccessed":"%{count} esquemas foram excluídos com sucesso.","schematicsSingleAddSuccessed":"Seu esquema foi incluído com sucesso.","schematicsMultipleAddSuccessed":"%{count} esquemas foram incluídos com sucesso.","schematicsAddFailed":"Falha ao incluir seu esquema.","schematicsReplaceDlgTitle":"Confirmar substituição do arquivo existente","schematicsReplaceDlgContent":"O arquivo '%{sourceName}' já existe. Deseja substituí-lo pelo novo arquivo?","schematicsReplaceDlgApplyToAllFiles":"Aplicar a todos os arquivos","schematicsPackageTab":"Pacote","schematicsContentTab":"Conteúdo","schematicsDescriptionLabel":"Descrição","schematicsIconLabel":"Ícone","schematicsChooseFile":"Incluir arquivo","schematicsDeleteIcon":"Remover o ícone","schematicsIconAdded":"O ícone \"%{file}\" foi incluído com sucesso.","schematicsIconRemove":"O ícone foi removido com sucesso.","schematicsIconDropFiles":"Arraste e solte o arquivo aqui ou faça upload dele","schematicsIconOr":"ou","schematicsIconFileTypes":"Somente arquivos .jpg, .png, and .svg.","schematicsIconFileSize":"Tamanho máximo do arquivo: %{size}MB.","legacySectionExtraMessage":"Aviso: as paletas anteriores são de uma versão anterior ao upgrade. As mudanças nessas paletas farão com que elas não apareçam mais nesta visualização. ","favorite":"Destaques","colorPaletteLabel":"Paleta de cores"},"__pt-br":{"errorCreatingPalette":"Ocorreu um erro ao salvar a paleta.","paletteErrorTitle":"Erro da Paleta","changePaletteLabel":"Alterar paleta de cores","manageColorPalettes":"Gerenciar paletas de cores","legacyPaletteLabel":"Preexistente","systemPaletteLabel":"Sistema","localPaletteLabel":"Local","customPaletteLabel":"Customizado","globalPaletteLabel":"Global","mruPaletteLabel":"Recentemente usado","mruPalettes":"Paletas usadas recentemente","allPalettes":"Todas as paletas","okDialog":"OK","back":"Voltar","deleteDialogTitle":"Excluir","applyDialog":"Aplicar","cancelDialog":"Cancelar","saveDialog":"Salvar","createDialog":"Criar","deleteMessage":"Tem certeza de que deseja excluir a paleta \"%{name}\"?","deleteToast":"\"%{name}\" foi excluído","favoritesLabel":"Destaques","setAsFavorite":"Configurar como favorito","createdToastMessage":"\"%{name}\" foi criado com êxito.","createPalette":"Criar uma Paleta Customizada","colorPicker":"Selecionador de Cores","errorNoName":"Digite um nome para a paleta","errorInsufficientColors":"Escolha pelo menos duas cores","paletteAppliedToastMessage":"A paleta \"%{name}\" foi aplicada no relatório.","createPaletteHeader":"Criar paleta de cores","modifyPaletteHeader":"Editar paleta de cores","paletteNamePlaceholder":"Digite o nome da paleta aqui","paletteName":"Nome da paleta","standardPalette":"Paleta categórica","continuousPalette":"Paleta Contínua","removeSwatch":"Remover swatch","addSwatch":"Incluir swatch","reversePalette":"Reverter Paleta","colorGuide":"Guia de Cores","modeAutomatic":"Automática","modeCustom":"Personalização","colorModel":"Modelo de Cor","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Grade","wheel":"Roda","hexCode":"Código Hex","colorRed":"Vermelho","colorGreen":"Verde","colorBlue":"Azul","colorHue":"Hue","colorSaturation":"Saturação","colorBrightness":"Brilho","colorCyan":"Ciano","colorMagenta":"Magenta","colorYellow":"Amarelo","colorBlack":"Preto","codeRed":"Vermelho","codeGreen":"Verde","codeBlue":"Azul","codeHue":"Hue","codeSaturation":"Saturação","codeBrightness":"Brilho","close":"Fechar","duplicate":"Duplicado","edit":"Editar","delete":"Excluir","restoreDefault":"Restaurar padrão","editSchematic":"Editar pacote","searchSchematic":"Procurar","nameLabelSchematic":"Nome","captionLabelSchematic":"Texto Explicativo","keyLabelSchematic":"Chave","addSchematic":"Fazer upload do arquivo","schematicsInvalidSvg":"SVG inválido ou não suportado","schematicsInvalidSvgData":"Não foi possível obter os dados do arquivo","schematicsInvalidType":"Tipo de arquivo não suportado: %{type}","schematicsInvalidSize":"O arquivo %{file}, tamanho %{size}, excede o limite.","schematicsContextMenuReplace":"Substituir","schematicsContextMenuDelete":"Excluir","schematicsEmptySearchResults":"Os resultados da procura estão vazios","schematicsNoSelection":"Nenhum Item Selecionado","schematicsMultipleSelection":"%{count} itens selecionados","schematicsSingleDeletionSuccessed":"Seu esquema foi excluído com sucesso.","schematicsMultipleDeletionSuccessed":"%{count} esquemas foram excluídos com sucesso.","schematicsSingleAddSuccessed":"Seu esquema foi incluído com sucesso.","schematicsMultipleAddSuccessed":"%{count} esquemas foram incluídos com sucesso.","schematicsAddFailed":"Falha ao incluir seu esquema.","schematicsReplaceDlgTitle":"Confirmar substituição do arquivo existente","schematicsReplaceDlgContent":"O arquivo '%{sourceName}' já existe. Deseja substituí-lo pelo novo arquivo?","schematicsReplaceDlgApplyToAllFiles":"Aplicar a todos os arquivos","schematicsPackageTab":"Pacote","schematicsContentTab":"Conteúdo","schematicsDescriptionLabel":"Descrição","schematicsIconLabel":"Ícone","schematicsChooseFile":"Incluir arquivo","schematicsDeleteIcon":"Remover o ícone","schematicsIconAdded":"O ícone \"%{file}\" foi incluído com sucesso.","schematicsIconRemove":"O ícone foi removido com sucesso.","schematicsIconDropFiles":"Arraste e solte o arquivo aqui ou faça upload dele","schematicsIconOr":"ou","schematicsIconFileTypes":"Somente arquivos .jpg, .png, and .svg.","schematicsIconFileSize":"Tamanho máximo do arquivo: %{size}MB.","legacySectionExtraMessage":"Aviso: as paletas anteriores são de uma versão anterior ao upgrade. As mudanças nessas paletas farão com que elas não apareçam mais nesta visualização. ","favorite":"Destaques","colorPaletteLabel":"Paleta de cores"},"__ro":{"errorCreatingPalette":"A apărut o eroare la salvarea paletei.","paletteErrorTitle":"Eroare paletă","changePaletteLabel":"Modificare paletă de culori","manageColorPalettes":"Gestionare palete de culori","legacyPaletteLabel":"Moştenită","systemPaletteLabel":"Sistem","localPaletteLabel":"Locală","customPaletteLabel":"Personalizat","globalPaletteLabel":"Globală","mruPaletteLabel":"Utilizată recent","mruPalettes":"Palete folosite recent","allPalettes":"Toate paletele","okDialog":"OK","back":"Înapoi","deleteDialogTitle":"Ştergere","applyDialog":"Aplicare","cancelDialog":"Renunţare","saveDialog":"Salvare","createDialog":"Creare","deleteMessage":"Sunteţi sigur că vreţi să ştergeţi paleta \"%{name}\"?","deleteToast":"\"%{name}\" a fost ştearsă","favoritesLabel":"Favorite","setAsFavorite":"Setare ca favorit","createdToastMessage":"\"%{name}\" a fost creat cu succes.","createPalette":"Creare paletă personalizată","colorPicker":"Selector de culoare","errorNoName":"Introduceţi un nume paleta dumneavoastră","errorInsufficientColors":"Alegeţi cel puţin două culori","paletteAppliedToastMessage":"Paleta \"%{name}\", a fost aplicată la raport.","createPaletteHeader":"Creare paletă de culori","modifyPaletteHeader":"Editare paletă de culori","paletteNamePlaceholder":"Tastaţi numele de paletă aici","paletteName":"Nume paletă","standardPalette":"Paletă categorială","continuousPalette":"Paletă continuă","removeSwatch":"Înlăturare mostră","addSwatch":"Adăugare mostră","reversePalette":"Paletă inversă","colorGuide":"Ghid de culoare","modeAutomatic":"Automat","modeCustom":"Personalizată","colorModel":"Model de culoare","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Grilă","wheel":"Roată","hexCode":"Cod hex","colorRed":"Roşu","colorGreen":"Verde","colorBlue":"Albastru","colorHue":"Nuanţă","colorSaturation":"Saturaţie","colorBrightness":"Luminozitate","colorCyan":"Cyan","colorMagenta":"Magenta","colorYellow":"Galben","colorBlack":"Negru","codeRed":"Roşu","codeGreen":"Verde","codeBlue":"Albastru","codeHue":"Nuanţă","codeSaturation":"Saturaţie","codeBrightness":"Luminozitate","close":"Închidere","duplicate":"Duplicare","edit":"Editare","delete":"Ştergere","restoreDefault":"Restaurare implicită","editSchematic":"Editare pachet","searchSchematic":"Căutare","nameLabelSchematic":"Nume","captionLabelSchematic":"Subtitlu","keyLabelSchematic":"Cheie","addSchematic":"Încărcare fişier","schematicsInvalidSvg":"SVG invalid sau nesuportat","schematicsInvalidSvgData":"Nu s-au putut obţine datele fişierului","schematicsInvalidType":"Tip de fişier nesuportat: %{type}","schematicsInvalidSize":"Fişierul %{file}, dimensiunea %{size} depăşeşte limita.","schematicsContextMenuReplace":"Înlocuire","schematicsContextMenuDelete":"Ştergere","schematicsEmptySearchResults":"Rezultatele căutării sunt goale","schematicsNoSelection":"Niciun articol selectat","schematicsMultipleSelection":"%{count} articole selectate","schematicsSingleDeletionSuccessed":"Schematicul a fost şters cu succes.","schematicsMultipleDeletionSuccessed":"%{count} schematice au fost şterse cu succes.","schematicsSingleAddSuccessed":"Schematicul a fost adăugat cu succes.","schematicsMultipleAddSuccessed":"%{count} schematice au fost adăugate cu succes.","schematicsAddFailed":"A eşuat adăugarea schematicului.","schematicsReplaceDlgTitle":"Confirmare înlocuire fişier existent","schematicsReplaceDlgContent":"Fişierul '%{sourceName}' există deja. Doriţi să-l înlocuiţi cu noul fişier?","schematicsReplaceDlgApplyToAllFiles":"Aplicare pentru toate fişierele","schematicsPackageTab":"Pachet","schematicsContentTab":"Conţinut","schematicsDescriptionLabel":"Descriere","schematicsIconLabel":"Pictogramă","schematicsChooseFile":"Adăugare fişier","schematicsDeleteIcon":"Înlăturaţi pictograma","schematicsIconAdded":"Pictograma \"%{file}\" a fost adăugată cu succes.","schematicsIconRemove":"Pictograma a fost înlăturată cu succes.","schematicsIconDropFiles":"Trageţi şi plasaţi fişierul aici sau încărcaţi","schematicsIconOr":"sau","schematicsIconFileTypes":"Doar fişiere .jpg, .png, and .svg.","schematicsIconFileSize":"Dim. max. fişier %{size} MB.","legacySectionExtraMessage":"Avertisment: Paletele moştenite sunt de la o versiune anterioară înainte de a fi făcut modernizarea. Modificările la aceste palete vor face să nu mai apară pentru această vizualizare. ","favorite":"Favorite","colorPaletteLabel":"Paletă de culori"},"__ru":{"errorCreatingPalette":"При сохранении палитры произошла ошибка.","paletteErrorTitle":"Ошибка палитры","changePaletteLabel":"Изменить цветовую палитру","manageColorPalettes":"Управление цветовыми палитрами","legacyPaletteLabel":"Прежняя версия","systemPaletteLabel":"Система","localPaletteLabel":"Локальный","customPaletteLabel":"Пользовательское:","globalPaletteLabel":"Глобальная","mruPaletteLabel":"Недавно использованные","mruPalettes":"Недавно использованные палитры","allPalettes":"Все палитры","okDialog":"ОК","back":"Назад","deleteDialogTitle":"Удалить","applyDialog":"Применить","cancelDialog":"Отмена","saveDialog":"Сохранить","createDialog":"Создать","deleteMessage":"Вы уверены, что хотите удалить палитру \"%{name}\"?","deleteToast":"\"%{name}\" удалено","favoritesLabel":"Избранное","setAsFavorite":"Задать как избранное","createdToastMessage":"\"%{name}\" успешно создано.","createPalette":"Создать пользовательскую палитру","colorPicker":"Выбор цвета","errorNoName":"Введите имя для своей палитры","errorInsufficientColors":"Выберите хотя бы два цвета","paletteAppliedToastMessage":"Палитра \"%{name}\" применена к отчету.","createPaletteHeader":"Создать цветовую палитру","modifyPaletteHeader":"Изменить цветовую палитру","paletteNamePlaceholder":"Введите здесь имя палитры","paletteName":"Имя палитры","standardPalette":"Категориальная палитра","continuousPalette":"Непрерывная палитра","removeSwatch":"Удалить палитру","addSwatch":"Добавить палитру","reversePalette":"Обратить палитру","colorGuide":"Руководство по цветам","modeAutomatic":"Автоматически","modeCustom":"Настроить","colorModel":"Цветовая модель","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Таблица","wheel":"Часовая стрелка","hexCode":"Шестнадцатеричный код","colorRed":"Красный","colorGreen":"Зеленый","colorBlue":"Синий","colorHue":"Оттенок","colorSaturation":"Насыщенность","colorBrightness":"Яркость","colorCyan":"Cyan","colorMagenta":"Magenta","colorYellow":"Желтый","colorBlack":"Черный","codeRed":"Красный","codeGreen":"Зеленый","codeBlue":"Синий","codeHue":"Оттенок","codeSaturation":"Насыщенность","codeBrightness":"Яркость","close":"Закрыть","duplicate":"Дублировать","edit":"Изменить","delete":"Удалить","restoreDefault":"Восстановить значения по умолчанию","editSchematic":"Изменить пакет","searchSchematic":"Поиск","nameLabelSchematic":"Имя","captionLabelSchematic":"Заголовок","keyLabelSchematic":"Ключ","addSchematic":"Закачать файл","schematicsInvalidSvg":"Недопустимый или неподдерживаемый SVG","schematicsInvalidSvgData":"Не удалось получить данные файла","schematicsInvalidType":"Неподдерживаемый тип файла: %{type}","schematicsInvalidSize":"Файл %{file}, размер %{size} превышает предел.","schematicsContextMenuReplace":"Заменить","schematicsContextMenuDelete":"Удалить","schematicsEmptySearchResults":"Результаты поиска - пустые","schematicsNoSelection":"Элементы не выбраны","schematicsMultipleSelection":"%{count} элементов выбрано","schematicsSingleDeletionSuccessed":"Ваше схематическое представление успешно удалено.","schematicsMultipleDeletionSuccessed":"%{count} схематических представлений успешно удалены.","schematicsSingleAddSuccessed":"Ваше схематическое представление успешно добавлено.","schematicsMultipleAddSuccessed":"%{count} схематических представлений успешно добавлены.","schematicsAddFailed":"Не удалось добавить ваше схематическое представление.","schematicsReplaceDlgTitle":"Подтвердить замену существующего файла","schematicsReplaceDlgContent":"Файл '%{sourceName}' уже существует. Хотите заменить его новым файлом?","schematicsReplaceDlgApplyToAllFiles":"Применить ко всем файлам","schematicsPackageTab":"Пакет","schematicsContentTab":"Содержимое","schematicsDescriptionLabel":"Описание","schematicsIconLabel":"Значок","schematicsChooseFile":"Добавить файл","schematicsDeleteIcon":"Удалить значок","schematicsIconAdded":"Значок \"%{file}\" успешно добавлен.","schematicsIconRemove":"Значок успешно удален.","schematicsIconDropFiles":"Перетащите файл сюда или закачайте его","schematicsIconOr":"или","schematicsIconFileTypes":"Только файлы .jpg, .png и .svg.","schematicsIconFileSize":"Максимальный размер файла %{size} МБ.","legacySectionExtraMessage":"Предупреждение: Палитры до обновления происходят из предыдущей версии. Изменения в этих палитрах приведут к их исчезновению из этой визуализации.","favorite":"Избранное","colorPaletteLabel":"Цветовая палитра"},"__sl":{"errorCreatingPalette":"Med shranjevanjem palete je prišlo do napake.","paletteErrorTitle":"Napaka palete","changePaletteLabel":"Spremeni barvno paleto","manageColorPalettes":"Upravljanje barvnih palet","legacyPaletteLabel":"Starejša različica","systemPaletteLabel":"Sistem","localPaletteLabel":"Lokalno","customPaletteLabel":"Po meri","globalPaletteLabel":"Globalno","mruPaletteLabel":"Nedavno uporabljeno","mruPalettes":"Nedavno uporabljene palete","allPalettes":"Vse palete","okDialog":"V redu","back":"Nazaj","deleteDialogTitle":"Izbriši","applyDialog":"Uveljavi","cancelDialog":"Prekliči","saveDialog":"Shrani","createDialog":"Ustvari","deleteMessage":"Ali ste prepričani, da želite izbrisati paleto \"%{name}\"?","deleteToast":"\"%{name}\" je bil izbrisan","favoritesLabel":"Priljubljene","setAsFavorite":"Nastavi kot priljubljeno","createdToastMessage":"\"%{name}\" je bil uspešno ustvarjen.","createPalette":"Ustvari paleto po meri","colorPicker":"Izbirnik barv","errorNoName":"Vnesite ime svoje palete","errorInsufficientColors":"Izberite vsaj dve barvi","paletteAppliedToastMessage":"Paleta \"%{name}\" je bila uveljavljena za poročilo.","createPaletteHeader":"Ustvari barvno paleto","modifyPaletteHeader":"Urejanje barvne palete","paletteNamePlaceholder":"Na to mesto vpišite ime palete","paletteName":"Ime palete","standardPalette":"Kategorična paleta","continuousPalette":"Neprekinjena paleta","removeSwatch":"Odstrani paleto","addSwatch":"Dodaj paleto","reversePalette":"Obrni paleto","colorGuide":"Vodič za barve","modeAutomatic":"Samodejno","modeCustom":"Po meri","colorModel":"Barvni model","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Mreža","wheel":"Kolo","hexCode":"Šestnajstiška koda","colorRed":"Rdeča","colorGreen":"Zelena","colorBlue":"Modra","colorHue":"Odtenek","colorSaturation":"Nasičenost","colorBrightness":"Svetlost","colorCyan":"Cian","colorMagenta":"Magenta","colorYellow":"Rumena","colorBlack":"Črna","codeRed":"Rdeča","codeGreen":"Zelena","codeBlue":"Modra","codeHue":"Odtenek","codeSaturation":"Nasičenost","codeBrightness":"Svetlost","close":"Zapri","duplicate":"Podvoji","edit":"Urejanje","delete":"Izbriši","restoreDefault":"Obnovi privzeto","editSchematic":"Urejanje paketa","searchSchematic":"Iskanje","nameLabelSchematic":"Ime","captionLabelSchematic":"Napis","keyLabelSchematic":"Ključ","addSchematic":"Naloži datoteko","schematicsInvalidSvg":"Neveljavna ali nepodprta datoteka SVG","schematicsInvalidSvgData":"Podatkov datoteke ni bilo mogoče pridobiti","schematicsInvalidType":"Nepodprta vrsta datoteke: %{type}","schematicsInvalidSize":"Datoteka %{file}, velikost %{size} presega omejitev.","schematicsContextMenuReplace":"Zamenjaj","schematicsContextMenuDelete":"Izbriši","schematicsEmptySearchResults":"Rezultati iskanja so prazni","schematicsNoSelection":"Noben element ni izbran","schematicsMultipleSelection":"%{count} elementov je izbranih","schematicsSingleDeletionSuccessed":"Vaša shema je bila uspešno izbrisana.","schematicsMultipleDeletionSuccessed":"%{count} shem je bilo uspešno izbrisanih.","schematicsSingleAddSuccessed":"Vaša shema je bila uspešno dodana.","schematicsMultipleAddSuccessed":"%{count} shem je bilo uspešno dodanih.","schematicsAddFailed":"Dodajanje sheme ni bilo uspešno.","schematicsReplaceDlgTitle":"Potrdi zamenjavo obstoječe datoteke","schematicsReplaceDlgContent":"Datoteka '%{sourceName}' že obstaja. Ali jo želite zamenjati z novo datoteko?","schematicsReplaceDlgApplyToAllFiles":"Uveljavi za vse datoteke","schematicsPackageTab":"Paket","schematicsContentTab":"Vsebina","schematicsDescriptionLabel":"Opis","schematicsIconLabel":"Ikona","schematicsChooseFile":"Dodaj datoteko","schematicsDeleteIcon":"Odstrani ikono","schematicsIconAdded":"Ikona \"%{file}\" je bila uspešno dodana.","schematicsIconRemove":"Ikona je bila uspešno odstranjena.","schematicsIconDropFiles":"Datoteko povlecite in spustite na to mesto ali naložite","schematicsIconOr":"ali","schematicsIconFileTypes":"Samo datoteke .jpg, .png in .svg.","schematicsIconFileSize":"Največja velikost datoteke je %{size} MB.","legacySectionExtraMessage":"Opozorilo: palete starejših različic so iz starejše različice pred nadgradnjo. Spremembe palet bodo povzročite, da palete ne bodo več prikazane za to vizualizacijo. ","favorite":"Priljubljene","colorPaletteLabel":"Barvna paleta"},"__sv":{"errorCreatingPalette":"Ett fel uppstod när paletten skulle sparas.","paletteErrorTitle":"Palettfel","changePaletteLabel":"Ändra färgpalett","manageColorPalettes":"Hantera färgpaletter","legacyPaletteLabel":"Äldre","systemPaletteLabel":"System","localPaletteLabel":"Lokal","customPaletteLabel":"Anpassat","globalPaletteLabel":"Globalt","mruPaletteLabel":"Senast använda","mruPalettes":"Nyligen använda paletter","allPalettes":"Alla paletter","okDialog":"OK","back":"Tillbaka","deleteDialogTitle":"Ta bort","applyDialog":"Tillämpa","cancelDialog":"Avbryt","saveDialog":"Spara","createDialog":"Skapa","deleteMessage":"Vill du ta bort paletten %{name}?","deleteToast":"%{name} togs bort","favoritesLabel":"Favoriter","setAsFavorite":"Ange som favorit","createdToastMessage":"%{name} har skapats.","createPalette":"Skapa en anpassad palett","colorPicker":"Färgväljare","errorNoName":"Ange ett namn för paletten","errorInsufficientColors":"Välj minst två färger","paletteAppliedToastMessage":"Paletten %{name} tillämpades på rapporten.","createPaletteHeader":"Skapa färgpalett","modifyPaletteHeader":"Redigera färgpalett","paletteNamePlaceholder":"Skriv palettnamn här","paletteName":"Palettnamn","standardPalette":"Kategorisk palett","continuousPalette":"Kontinuerlig palett","removeSwatch":"Ta bort färgrutor","addSwatch":"Lägg till färgrutor","reversePalette":"Omvänd palett","colorGuide":"Färgguide","modeAutomatic":"Automatisk","modeCustom":"Anpassad","colorModel":"Färgmodell","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Rutnät","wheel":"Hjul","hexCode":"Hexkod","colorRed":"Röd","colorGreen":"Grön","colorBlue":"Blå","colorHue":"Nyans","colorSaturation":"Mättnad","colorBrightness":"Ljusstyrka","colorCyan":"Cyan","colorMagenta":"Magenta","colorYellow":"Gul","colorBlack":"Svart","codeRed":"Röd","codeGreen":"Grön","codeBlue":"Blå","codeHue":"Nyans","codeSaturation":"Mättnad","codeBrightness":"Ljusstyrka","close":"Stäng","duplicate":"Kopiera","edit":"Redigera","delete":"Ta bort","restoreDefault":"Återställ standard","editSchematic":"Redigera paket","searchSchematic":"Sök","nameLabelSchematic":"Namn","captionLabelSchematic":"Objekttext","keyLabelSchematic":"Nyckel","addSchematic":"Överför fil","schematicsInvalidSvg":"Ogiltig eller ohanterad SVG","schematicsInvalidSvgData":"Det gick inte att hämta fildata","schematicsInvalidType":"Otillåten filtyp: %{type}","schematicsInvalidSize":"Filen %{file}, storlek %{size} överskrider gränsen.","schematicsContextMenuReplace":"Ersätt","schematicsContextMenuDelete":"Ta bort","schematicsEmptySearchResults":"Sökresultatet är tomt","schematicsNoSelection":"Inga objekt har valts","schematicsMultipleSelection":"%{count} objekt har valts","schematicsSingleDeletionSuccessed":"Din schematik togs bort.","schematicsMultipleDeletionSuccessed":"%{count} schematiker togs bort.","schematicsSingleAddSuccessed":"Din schematik lades till.","schematicsMultipleAddSuccessed":"%{count} schematiker lades till.","schematicsAddFailed":"Det gick inte att lägga till din schematik","schematicsReplaceDlgTitle":"Bekräfta ersättning av befintlig fil","schematicsReplaceDlgContent":"Filen '%{sourceName}' finns redan. Vill du ersätta den med den nya filen?","schematicsReplaceDlgApplyToAllFiles":"Tillämpa på alla filer","schematicsPackageTab":"Paket","schematicsContentTab":"Innehåll","schematicsDescriptionLabel":"Beskrivning","schematicsIconLabel":"Ikon","schematicsChooseFile":"Lägg till fil","schematicsDeleteIcon":"Ta bort ikonen","schematicsIconAdded":"Ikonen \"%{file}\" lades till.","schematicsIconRemove":"Ikonen togs bort.","schematicsIconDropFiles":"Dra och släpp fil här eller överför","schematicsIconOr":"eller","schematicsIconFileTypes":"Endast .jpg-, .png- och .svg-filer.","schematicsIconFileSize":"%{size} MB max filstorlek.","legacySectionExtraMessage":"Varning: Paletter är från en tidigare version innan du uppgraderade. Ändringar av dessa paletter kommer att orsaka att de inte längre visas för den här visualiseringen.","favorite":"Favoriter","colorPaletteLabel":"Färgpalett"},"__th":{"errorCreatingPalette":"เกิดข้อผิดพลาดขณะบันทึกพาเล็ต","paletteErrorTitle":"ข้อผิดพลาดพาเล็ต","changePaletteLabel":"เปลี่ยนพาเล็ตสี","manageColorPalettes":"จัดการถาดสี","legacyPaletteLabel":"ดั้งเดิม","systemPaletteLabel":"ระบบ","localPaletteLabel":"โลคัล","customPaletteLabel":"กำหนดเอง","globalPaletteLabel":"โกลบอล","mruPaletteLabel":"ใช้ล่าสุด","mruPalettes":"ถาดที่ใช้ล่าสุด","allPalettes":"ถาดทั้งหมด","okDialog":"ตกลง","back":"ย้อนกลับ","deleteDialogTitle":"ลบ","applyDialog":"ใช้","cancelDialog":"ยกเลิก","saveDialog":"บันทึก","createDialog":"สร้าง","deleteMessage":"คุณแน่ใจหรือว่าต้องการลบพาเล็ต \"%{name}\"?","deleteToast":"ลบ \"%{name}\" ออกแล้ว","favoritesLabel":"รายการโปรด","setAsFavorite":"ตั้งค่าเป็นรายการโปรด","createdToastMessage":"สร้าง \"%{name}\" เรียบร้อยแล้ว","createPalette":"สร้างพาเล็ตแบบกำหนดเอง","colorPicker":"ตัวเลือกสี","errorNoName":"ป้อนชื่อสำหรับพาเล็ตของคุณ","errorInsufficientColors":"เลือกสีสองสีขึ้นไป","paletteAppliedToastMessage":"พาเล็ต \"%{name}\" ถูกนำไปใช้กับรายงาน","createPaletteHeader":"สร้างพาเล็ตสี","modifyPaletteHeader":"แก้ไขพาเล็ตสี","paletteNamePlaceholder":"พิมพ์ชื่อพาเล็ตที่นี่","paletteName":"ชื่อพาเล็ต","standardPalette":"พาเล็ตแบบเป็นหมวดหมู่","continuousPalette":"พาเล็ตแบบต่อเนื่องกัน","removeSwatch":"ลบ swatch","addSwatch":"เพิ่ม swatch","reversePalette":"กลับพาเล็ต","colorGuide":"ตารางสี","modeAutomatic":"อัตโนมัติ","modeCustom":"กำหนดเอง","colorModel":"โมเดลสี","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"กริด","wheel":"วงล้อ","hexCode":"รหัสเลขฐานสิบหก","colorRed":"สีแดง","colorGreen":"สีเขียว","colorBlue":"สีน้ำเงิน","colorHue":"สี","colorSaturation":"ความสดของสี","colorBrightness":"ความสว่าง","colorCyan":"สีฟ้า","colorMagenta":"สีม่วงแดง","colorYellow":"สีเหลือง","colorBlack":"สีดำ","codeRed":"สีแดง","codeGreen":"สีเขียว","codeBlue":"สีน้ำเงิน","codeHue":"สี","codeSaturation":"ความสดของสี","codeBrightness":"ความสว่าง","close":"ปิด","duplicate":"ทำซ้ำ","edit":"แก้ไข","delete":"ลบ","restoreDefault":"เรียกคืนค่าเริ่มต้น","editSchematic":"แก้ไขแพ็กเกจ","searchSchematic":"ค้นหา","nameLabelSchematic":"ชื่อ","captionLabelSchematic":"คำบรรยาย","keyLabelSchematic":"คีย์","addSchematic":"อัพโหลดไฟล์","schematicsInvalidSvg":"SVG ไม่ถูกต้องหรือไม่สนับสนุน","schematicsInvalidSvgData":"ไม่สามารถขอรับข้อมูลไฟล์","schematicsInvalidType":"ชนิดไฟล์ที่ไม่สนับสนุน: %{type}","schematicsInvalidSize":"ไฟล์ %{file} ขนาด %{size} เกินขนาดที่จำกัดไว้","schematicsContextMenuReplace":"แทนที่","schematicsContextMenuDelete":"ลบ","schematicsEmptySearchResults":"ผลลัพธ์การค้นหาว่างเปล่า","schematicsNoSelection":"ไม่มีไอเท็มที่เลือกไว้","schematicsMultipleSelection":"%{count} ไอเท็มที่เลือกไว้","schematicsSingleDeletionSuccessed":"แบบแผนของคุณถูกลบทิ้งเป็นผลสำเร็จแล้ว","schematicsMultipleDeletionSuccessed":"%{count} แบบแผนถูกลบทิ้งเป็นผลสำเร็จแล้ว","schematicsSingleAddSuccessed":"แบบแผนของคุณถูกเพิ่มเป็นผลสำเร็จแล้ว","schematicsMultipleAddSuccessed":"%{count} แบบแผนถูกเพิ่มเป็นผลสำเร็จแล้ว","schematicsAddFailed":"ล้มเหลวในการเพิ่มแบบแผนของคุณ","schematicsReplaceDlgTitle":"ยืนยันการแทนที่ไฟล์ที่มีอยู่","schematicsReplaceDlgContent":"ไฟล์ '%{sourceName}' มีอยู่ก่อนแล้ว คุณต้องการแทนที่ด้วยไฟล์ใหม่หรือไม่?","schematicsReplaceDlgApplyToAllFiles":"ใช้กับไฟล์ทั้งหมด","schematicsPackageTab":"แพ็กเกจ","schematicsContentTab":"เนื้อหา","schematicsDescriptionLabel":"คำอธิบาย","schematicsIconLabel":"ไอคอน","schematicsChooseFile":"เพิ่มไฟล์","schematicsDeleteIcon":"ลบไอคอนออก","schematicsIconAdded":"ไอคอน \"%{file}\" ถูกเพิ่มเป็นผลสำเร็จแล้ว","schematicsIconRemove":"ไอคอนถูกลบออกเป็นผลสำเร็จแล้ว","schematicsIconDropFiles":"ลากและปล่อยไฟล์ที่นี่หรืออัพโหลด","schematicsIconOr":"หรือ","schematicsIconFileTypes":"เฉพาะไฟล์ .jpg, .png, และ .svg","schematicsIconFileSize":"ขนาดไฟล์สูงสุด %{size}MB","legacySectionExtraMessage":"คำเตือน: พาเล็ตเดิมมาจากเวอร์ชันก่อนหน้าก่อนที่คุณจะอัพเกรด การเปลี่ยนแปลงพาเล็ตเหล่านี้จะทำให้ไม่ปรากฏวิชวลไลเซชันนี้อีกต่อไป","favorite":"รายการโปรด","colorPaletteLabel":"พาเล็ตสี"},"__tr":{"errorCreatingPalette":"Palet kaydedilirken bir hata oluştu.","paletteErrorTitle":"Palet Hatası","changePaletteLabel":"Renk paletini değiştir","manageColorPalettes":"Renk paletlerini yönet","legacyPaletteLabel":"Eski","systemPaletteLabel":"Sistem","localPaletteLabel":"Yerel","customPaletteLabel":"Özel","globalPaletteLabel":"Genel","mruPaletteLabel":"Son kullanılan","mruPalettes":"Son kullanılan paletler","allPalettes":"Tüm paletler","okDialog":"Tamam","back":"Geri","deleteDialogTitle":"Sil","applyDialog":"Uygula","cancelDialog":"İptal","saveDialog":"Kaydet","createDialog":"Oluştur","deleteMessage":"\"%{name}\" paletini silmek istediğinizden emin misiniz?","deleteToast":"\"%{name}\" silindi","favoritesLabel":"Sık Kullanılanlar","setAsFavorite":"Sık kullanılan olarak ayarla","createdToastMessage":"\"%{name}\" başarıyla oluşturuldu.","createPalette":"Özel palet oluştur","colorPicker":"Renk seçici","errorNoName":"Paletiniz için bir ad girin","errorInsufficientColors":"En az iki renk seçin","paletteAppliedToastMessage":"\"%{name}\" paleti, rapora uygulandı.","createPaletteHeader":"Renk paleti yarat","modifyPaletteHeader":"Renk paletini düzenle","paletteNamePlaceholder":"Buraya palet adını yazın","paletteName":"Palet adı","standardPalette":"Kategorik palet","continuousPalette":"Sürekli palet","removeSwatch":"Renk örneğini kaldır","addSwatch":"Renk örneği ekle","reversePalette":"Renk örneğini ters çevir","colorGuide":"Renk kılavuzu","modeAutomatic":"Otomatik","modeCustom":"Özel","colorModel":"Renk modeli","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Kılavuz","wheel":"Tekerlek","hexCode":"Onaltılı kod","colorRed":"Kırmızı","colorGreen":"Yeşil","colorBlue":"Mavi","colorHue":"Renk Tonu","colorSaturation":"Doygunluk","colorBrightness":"Parlaklık","colorCyan":"Cam Göbeği","colorMagenta":"Macenta","colorYellow":"Sarı","colorBlack":"Siyah","codeRed":"Kırmızı","codeGreen":"Yeşil","codeBlue":"Mavi","codeHue":"Renk Tonu","codeSaturation":"Doygunluk","codeBrightness":"Parlaklık","close":"Kapat","duplicate":"Yinele","edit":"Düzenle","delete":"Sil","restoreDefault":"Varsayılanı geri yükle","editSchematic":"Paketi düzenle","searchSchematic":"Ara","nameLabelSchematic":"Ad","captionLabelSchematic":"Başlık","keyLabelSchematic":"Tuş","addSchematic":"Dosyayı karşıya yükle","schematicsInvalidSvg":"SVG geçersiz veya desteklenmiyor","schematicsInvalidSvgData":"Dosya verileri alınamadı","schematicsInvalidType":"Desteklenmeyen dosya tipi: %{type}","schematicsInvalidSize":"%{file} dosyası, %{size} boyutu sınırı aşıyor.","schematicsContextMenuReplace":"Değiştir","schematicsContextMenuDelete":"Sil","schematicsEmptySearchResults":"Arama sonuçları boş","schematicsNoSelection":"Bir öğe seçilmedi","schematicsMultipleSelection":"%{count} öğe seçildi","schematicsSingleDeletionSuccessed":"Şemanız başarıyla silindi.","schematicsMultipleDeletionSuccessed":"%{count} şema başarıyla silindi.","schematicsSingleAddSuccessed":"Şemanız başarıyla eklendi.","schematicsMultipleAddSuccessed":"%{count} şema başarıyla eklendi.","schematicsAddFailed":"Şemanız eklenemedi.","schematicsReplaceDlgTitle":"Var olan dosyanın değiştirilmesini onayla","schematicsReplaceDlgContent":"'%{sourceName}' dosyası zaten var. Bu dosyayı yeni dosyayla değiştirmek istiyor musunuz?","schematicsReplaceDlgApplyToAllFiles":"Tüm dosyalara uygula","schematicsPackageTab":"Paket","schematicsContentTab":"İçerik","schematicsDescriptionLabel":"Tanım","schematicsIconLabel":"Simge","schematicsChooseFile":"Dosya ekle","schematicsDeleteIcon":"Simgeyi kaldır","schematicsIconAdded":"\"%{file}\" simgesi başarıyla eklendi.","schematicsIconRemove":"Simge başarıyla kaldırıldı.","schematicsIconDropFiles":"Dosyayı sürükleyip buraya bırakın ya da karşıya yükleyin","schematicsIconOr":"ya da","schematicsIconFileTypes":"Yalnızca .jpg, .png ve .svg dosyaları.","schematicsIconFileSize":"Maksimum dosya boyutu: %{size}.","legacySectionExtraMessage":"Uyarı: Eski paletler siz büyütme yapmadan önceki bir sürümden geliyor. Bu paletlerdeki değişiklikler, paletlerin bu görselleştirmede artık görünmemesine neden olacak. ","favorite":"Sık kullanılanlar","colorPaletteLabel":"Renk paleti"},"__zh":{"errorCreatingPalette":"保存调色板时发生错误。","paletteErrorTitle":"调色板错误","changePaletteLabel":"更改调色板","manageColorPalettes":"管理调色板","legacyPaletteLabel":"原始","systemPaletteLabel":"系统","localPaletteLabel":"本地","customPaletteLabel":"定制","globalPaletteLabel":"全局","mruPaletteLabel":"最近使用的","mruPalettes":"最近使用的调色板","allPalettes":"所有调色板","okDialog":"确定","back":"后退","deleteDialogTitle":"删除","applyDialog":"应用","cancelDialog":"取消","saveDialog":"保存","createDialog":"创建","deleteMessage":"确定要删除调色板“%{name}”吗？","deleteToast":"“%{name}”已删除","favoritesLabel":"收藏夹","setAsFavorite":"设置为收藏项","createdToastMessage":"“%{name}”已成功创建。","createPalette":"创建自定义调色板","colorPicker":"颜色选取器","errorNoName":"请为调色板输入名称","errorInsufficientColors":"至少选择两种颜色","paletteAppliedToastMessage":"调色板“%{name}”已应用于报表。","createPaletteHeader":"创建调色板","modifyPaletteHeader":"编辑调色板","paletteNamePlaceholder":"在此输入调色板名称","paletteName":"调色板名称","standardPalette":"分类调色板","continuousPalette":"连续调色板","removeSwatch":"移除图样","addSwatch":"添加图样","reversePalette":"反转调色板","colorGuide":"颜色指南","modeAutomatic":"自动","modeCustom":"自定义","colorModel":"颜色模型","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"网格","wheel":"色轮","hexCode":"十六进制代码","colorRed":"红色","colorGreen":"绿色","colorBlue":"蓝色","colorHue":"色调","colorSaturation":"饱和度","colorBrightness":"亮度","colorCyan":"蓝绿色","colorMagenta":"品红色","colorYellow":"黄色","colorBlack":"黑色","codeRed":"红色","codeGreen":"绿色","codeBlue":"蓝色","codeHue":"色调","codeSaturation":"饱和度","codeBrightness":"亮度","close":"关闭","duplicate":"重复","edit":"编辑","delete":"删除","restoreDefault":"恢复缺省值","editSchematic":"编辑数据包","searchSchematic":"搜索","nameLabelSchematic":"名称","captionLabelSchematic":"标题","keyLabelSchematic":"密钥","addSchematic":"上载文件","schematicsInvalidSvg":"SVG 无效或不受支持","schematicsInvalidSvgData":"无法获取文件数据","schematicsInvalidType":"不支持的文件类型：%{type}","schematicsInvalidSize":"文件 %{file} 的大小 %{size} 超过限制。","schematicsContextMenuReplace":"替换","schematicsContextMenuDelete":"删除","schematicsEmptySearchResults":"搜索结果为空","schematicsNoSelection":"未选择任何项","schematicsMultipleSelection":"已选择 %{count} 项","schematicsSingleDeletionSuccessed":"示意图已成功删除。","schematicsMultipleDeletionSuccessed":"%{count} 个示意图已成功删除。","schematicsSingleAddSuccessed":"示意图已成功添加。","schematicsMultipleAddSuccessed":"%{count} 个示意图已成功添加。","schematicsAddFailed":"未能添加示意图。","schematicsReplaceDlgTitle":"确认替换现有文件","schematicsReplaceDlgContent":"文件“%{sourceName}”已存在。是否要将其替换为新文件？","schematicsReplaceDlgApplyToAllFiles":"应用于所有文件","schematicsPackageTab":"数据包","schematicsContentTab":"内容","schematicsDescriptionLabel":"说明","schematicsIconLabel":"图标","schematicsChooseFile":"添加文件","schematicsDeleteIcon":"移除图标","schematicsIconAdded":"图标“%{file}”已成功添加。","schematicsIconRemove":"图标已成功移除。","schematicsIconDropFiles":"将文件拖放到此处或上载文件","schematicsIconOr":"或","schematicsIconFileTypes":"仅限 .jpg、.png 和 .svg 文件。","schematicsIconFileSize":"%{size}MB 最大文件大小。","legacySectionExtraMessage":"警告：原始调色板来自升级前的较低版本。对这些调色板进行更改将导致其不再对此可视化显示。","favorite":"收藏夹","colorPaletteLabel":"调色板"},"__zh-cn":{"errorCreatingPalette":"保存调色板时发生错误。","paletteErrorTitle":"调色板错误","changePaletteLabel":"更改调色板","manageColorPalettes":"管理调色板","legacyPaletteLabel":"原始","systemPaletteLabel":"系统","localPaletteLabel":"本地","customPaletteLabel":"定制","globalPaletteLabel":"全局","mruPaletteLabel":"最近使用的","mruPalettes":"最近使用的调色板","allPalettes":"所有调色板","okDialog":"确定","back":"后退","deleteDialogTitle":"删除","applyDialog":"应用","cancelDialog":"取消","saveDialog":"保存","createDialog":"创建","deleteMessage":"确定要删除调色板“%{name}”吗？","deleteToast":"“%{name}”已删除","favoritesLabel":"收藏夹","setAsFavorite":"设置为收藏项","createdToastMessage":"“%{name}”已成功创建。","createPalette":"创建自定义调色板","colorPicker":"颜色选取器","errorNoName":"请为调色板输入名称","errorInsufficientColors":"至少选择两种颜色","paletteAppliedToastMessage":"调色板“%{name}”已应用于报表。","createPaletteHeader":"创建调色板","modifyPaletteHeader":"编辑调色板","paletteNamePlaceholder":"在此输入调色板名称","paletteName":"调色板名称","standardPalette":"分类调色板","continuousPalette":"连续调色板","removeSwatch":"移除图样","addSwatch":"添加图样","reversePalette":"反转调色板","colorGuide":"颜色指南","modeAutomatic":"自动","modeCustom":"自定义","colorModel":"颜色模型","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"网格","wheel":"色轮","hexCode":"十六进制代码","colorRed":"红色","colorGreen":"绿色","colorBlue":"蓝色","colorHue":"色调","colorSaturation":"饱和度","colorBrightness":"亮度","colorCyan":"蓝绿色","colorMagenta":"品红色","colorYellow":"黄色","colorBlack":"黑色","codeRed":"红色","codeGreen":"绿色","codeBlue":"蓝色","codeHue":"色调","codeSaturation":"饱和度","codeBrightness":"亮度","close":"关闭","duplicate":"重复","edit":"编辑","delete":"删除","restoreDefault":"恢复缺省值","editSchematic":"编辑数据包","searchSchematic":"搜索","nameLabelSchematic":"名称","captionLabelSchematic":"标题","keyLabelSchematic":"密钥","addSchematic":"上载文件","schematicsInvalidSvg":"SVG 无效或不受支持","schematicsInvalidSvgData":"无法获取文件数据","schematicsInvalidType":"不支持的文件类型：%{type}","schematicsInvalidSize":"文件 %{file} 的大小 %{size} 超过限制。","schematicsContextMenuReplace":"替换","schematicsContextMenuDelete":"删除","schematicsEmptySearchResults":"搜索结果为空","schematicsNoSelection":"未选择任何项","schematicsMultipleSelection":"已选择 %{count} 项","schematicsSingleDeletionSuccessed":"示意图已成功删除。","schematicsMultipleDeletionSuccessed":"%{count} 个示意图已成功删除。","schematicsSingleAddSuccessed":"示意图已成功添加。","schematicsMultipleAddSuccessed":"%{count} 个示意图已成功添加。","schematicsAddFailed":"未能添加示意图。","schematicsReplaceDlgTitle":"确认替换现有文件","schematicsReplaceDlgContent":"文件“%{sourceName}”已存在。是否要将其替换为新文件？","schematicsReplaceDlgApplyToAllFiles":"应用于所有文件","schematicsPackageTab":"数据包","schematicsContentTab":"内容","schematicsDescriptionLabel":"说明","schematicsIconLabel":"图标","schematicsChooseFile":"添加文件","schematicsDeleteIcon":"移除图标","schematicsIconAdded":"图标“%{file}”已成功添加。","schematicsIconRemove":"图标已成功移除。","schematicsIconDropFiles":"将文件拖放到此处或上载文件","schematicsIconOr":"或","schematicsIconFileTypes":"仅限 .jpg、.png 和 .svg 文件。","schematicsIconFileSize":"%{size}MB 最大文件大小。","legacySectionExtraMessage":"警告：原始调色板来自升级前的较低版本。对这些调色板进行更改将导致其不再对此可视化显示。","favorite":"收藏夹","colorPaletteLabel":"调色板"},"__zh-tw":{"errorCreatingPalette":"儲存選用區時發生錯誤。","paletteErrorTitle":"選用區錯誤","changePaletteLabel":"變更調色盤","manageColorPalettes":"管理顏色選用區","legacyPaletteLabel":"舊式","systemPaletteLabel":"系統","localPaletteLabel":"本端","customPaletteLabel":"自訂","globalPaletteLabel":"廣域","mruPaletteLabel":"最近已使用","mruPalettes":"最近使用過的選用區","allPalettes":"所有選用區","okDialog":"確定","back":"上一步","deleteDialogTitle":"刪除","applyDialog":"套用","cancelDialog":"取消","saveDialog":"儲存","createDialog":"建立","deleteMessage":"您確定要刪除選用區 \"%{name}\" 嗎？","deleteToast":"\"%{name}\" 已刪除","favoritesLabel":"我的最愛","setAsFavorite":"設為我的最愛","createdToastMessage":"\"%{name}\" 已順利建立。","createPalette":"建立自訂選用區","colorPicker":"顏色選取器","errorNoName":"輸入選用區的名稱","errorInsufficientColors":"至少選擇兩種顏色","paletteAppliedToastMessage":"選用區 \"%{name}\" 已套用至報告。","createPaletteHeader":"建立 color 選用區","modifyPaletteHeader":"編輯 color 選用區","paletteNamePlaceholder":"在這裡鍵入選用區名稱","paletteName":"選用區名稱","standardPalette":"種類選用區","continuousPalette":"連續選用區","removeSwatch":"移除色樣","addSwatch":"新增色樣","reversePalette":"反轉選用區","colorGuide":"顏色指南","modeAutomatic":"自動","modeCustom":"自訂","colorModel":"色彩模式","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"網格","wheel":"輪子","hexCode":"十六進位碼","colorRed":"紅色","colorGreen":"綠色","colorBlue":"藍色","colorHue":"色調","colorSaturation":"飽和度","colorBrightness":"亮度","colorCyan":"青藍色","colorMagenta":"紫紅色","colorYellow":"黃色","colorBlack":"黑色","codeRed":"紅色","codeGreen":"綠色","codeBlue":"藍色","codeHue":"色調","codeSaturation":"飽和度","codeBrightness":"亮度","close":"關閉","duplicate":"複製","edit":"編輯","delete":"刪除","restoreDefault":"還原預設值","editSchematic":"編輯套件","searchSchematic":"搜尋","nameLabelSchematic":"名稱","captionLabelSchematic":"標題","keyLabelSchematic":"索引鍵","addSchematic":"上傳檔案","schematicsInvalidSvg":"無效或不受支援的 SVG","schematicsInvalidSvgData":"無法取得檔案資料","schematicsInvalidType":"不受支援的檔案類型：%{type}","schematicsInvalidSize":"檔案 %{file}（大小 %{size}）超出限制。","schematicsContextMenuReplace":"取代","schematicsContextMenuDelete":"刪除","schematicsEmptySearchResults":"搜尋結果是空的","schematicsNoSelection":"未選取項目","schematicsMultipleSelection":"%{count} 個項目已選取","schematicsSingleDeletionSuccessed":"您的示意圖已順利刪除。","schematicsMultipleDeletionSuccessed":"%{count} 個示意圖已順利刪除。","schematicsSingleAddSuccessed":"您的示意圖已順利新增。","schematicsMultipleAddSuccessed":"%{count} 個示意圖已順利新增。","schematicsAddFailed":"無法新增您的示意圖。","schematicsReplaceDlgTitle":"確認取代現有檔案","schematicsReplaceDlgContent":"檔案 '%{sourceName}' 已存在。您要使用這個新檔案來進行取代嗎？","schematicsReplaceDlgApplyToAllFiles":"套用至所有檔案","schematicsPackageTab":"套件","schematicsContentTab":"內容","schematicsDescriptionLabel":"說明","schematicsIconLabel":"圖示","schematicsChooseFile":"新增檔案","schematicsDeleteIcon":"請移除圖示","schematicsIconAdded":"圖示 \"%{file}\" 已順利新增。","schematicsIconRemove":"圖示已順利移除。","schematicsIconDropFiles":"在這裡拖放檔案或上傳","schematicsIconOr":"或","schematicsIconFileTypes":"僅限 .jpg、.png 和 .svg 檔案","schematicsIconFileSize":"%{size}MB 檔案大小上限。","legacySectionExtraMessage":"警告：舊式選用區是來自您升級之前的較舊版本。這些選用區的變更將會造成它們不再會為此視覺化而出現。","favorite":"我的最愛","colorPaletteLabel":"調色盤"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_19__;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(55)(module)))

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2013, 2016
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 * @module /dashboard/data/Events
 * @see Events
 */

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(13)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Class) {
	'use strict';

	/**
  * Events implements the Backbone-style eventing model objects
  *
  * @class Events
  */

	var Events = Class.extend({
		init: function init() {
			this._events = {};
		},

		/**
   * The 'on' method registers the handler and return DOJO-style event registration object with 'remove' method, which unregisters the handler.
   *
   * This implementation supports composite event names, such as 'eventBaseName:eventSecondaryName', for example: 'change:name'. Triggering 'change:name' event would invoke handlers registered to
   * listen 'change' event as well as the handlers registered to listen the 'change:name' event. The special event name 'all' can be used to listen to all event types.
   */
		on: function on(eventName, handler, context) {
			if (typeof handler !== 'function') {
				console.log('ERROR in Events.on: Invalid event handler');
			}
			if (!this._events[eventName]) {
				this._events[eventName] = [];
			}
			this._events[eventName].push({
				handler: handler,
				context: context
			});

			var that = this;
			return {
				remove: function remove() {
					that.off(eventName, handler, context);
				}
			};
		},

		/**
   * Removes the specified handler from the listening to the events on this object. If eventName is not specified then unregister handler and context for all event types. If handler is not specified
   * then unregister all event handlers for the specified context and event name. If context is not specified then unregister all event handlers for the specified handler and event name.
   *
   * Examples: obj.off('change:name', handler, context); // unregister handler in context from listening 'change:name' event obj.off(null, null, context); // unregister all event handlers for the
   * specified context obj.off(); // unregister all event handlers
   */
		off: function off(eventName, handler, context) {
			var getEvents = function getEvents(evName, self) {
				var events = self._events;
				if (!evName) {
					return events;
				}
				var parts = evName.split(':');
				events = {};
				events[parts[0]] = self._events[parts[0]];
				if (parts.length > 1 && parts[1] !== '*') {
					events[evName] = self._events[evName];
				} else if (parts.length > 1 && parts[1] === '*') {
					for (var name in self._events) {
						if (name.indexOf(parts[0] + ':') === 0) {
							events[name] = self._events[name];
						}
					}
				}
				return events;
			};
			var events = getEvents(eventName, this);

			for (var name in events) {
				var i = 0,
				    handlers = events[name];
				if (!handlers) {
					continue;
				}
				while (i < handlers.length) {
					if ((handlers[i].handler === handler || !handler) && (handlers[i].context === context || !context)) {
						handlers.splice(i, 1);
					} else {
						i++;
					}
				}
			}
		},

		/**
   * Triggers an event
   */
		trigger: function trigger(eventName, event) {
			var parts = eventName.split(':');
			var handlers = [].concat(this._events['all'] || []).concat(this._events[parts[0]] || []);
			if (parts.length > 1) {
				handlers = handlers.concat(this._events[eventName] || []);
			}
			for (var i = 0; i < handlers.length; i++) {
				if (typeof handlers[i].handler === 'function') {
					handlers[i].handler.call(handlers[i].context, event, eventName);
				}
			}
		}
	});

	// alias
	Events.prototype.emit = Events.prototype.trigger;

	//
	return Events;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
//# sourceMappingURL=Events.js.map

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_22__;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var PALETTE_FILL_TYPE = {
	ColorPalette: 'simple',
	HeatPalette: 'continuous',
	ConditionalPalette: 'simple'
};

var PREFIX_CM_ID = '__CM__';

var PALETTE_SECTION_ORDER = ['mru', 'local', 'custom', 'global', 'system', 'legacy'];

/**
 * This class help UI Components render palettes group by sections
 */

var PaletteHelper = function () {
	function PaletteHelper(_ref) {
		var paletteService = _ref.paletteService,
		    getPalettesFn = _ref.getPalettesFn,
		    _ref$paletteName = _ref.paletteName,
		    paletteName = _ref$paletteName === undefined ? null : _ref$paletteName,
		    _ref$maxMostRecentUse = _ref.maxMostRecentUseSize,
		    maxMostRecentUseSize = _ref$maxMostRecentUse === undefined ? 3 : _ref$maxMostRecentUse;

		_classCallCheck(this, PaletteHelper);

		if (!paletteService) {
			throw new Error('Invalid paletteService');
		}
		this.paletteService = paletteService;
		this.paletteName = paletteName || 'ColorPalette';
		this.getPalettesFn = getPalettesFn;
		this.maxMostRecentUseSize = maxMostRecentUseSize;
		this.palettes = null;
	}

	/**
  * Retrieve palettes return from palette service, create appropriate sections for the palette to be render in the UI
  *
  * @returns {promise} resolved with a palette object key by sub sections of palettes
  */


	PaletteHelper.prototype.getPaletteGroupBySections = function getPaletteGroupBySections() {
		var _this = this;

		return this.getPalettesFn().then(function (palettes) {
			// Clone the palette to make it local to this instance to avoid modifying its content by reference
			_this.palettes = JSON.parse(JSON.stringify(palettes));
			_this._creastePaletteSections();
			return _this._getMostRecentlyUsed().then(function (mru) {
				_this.palettes.mru = mru || [];
				return _this.palettes;
			});
		});
	};

	/**
  * Return the order of sections to be render in the UI
  *
  * @returns {array} Array of section names
  */


	PaletteHelper.prototype.getPaletteSectionOrder = function getPaletteSectionOrder() {
		// Return a clone to avoid changing the original global definition
		return JSON.parse(JSON.stringify(PALETTE_SECTION_ORDER));
	};

	PaletteHelper.prototype.refreshPalette = function refreshPalette() {
		return this.getPaletteGroupBySections();
	};

	PaletteHelper.prototype.getPalette = function getPalette(paletteId) {
		var foundPalette = [];
		var sectionNameList = this.getPaletteSectionOrder();
		this._findMostRecentPaletteFromIds([paletteId], foundPalette, sectionNameList, 0);
		return foundPalette.length ? foundPalette[0] : null;
	};

	PaletteHelper.prototype.isSamePaletteId = function isSamePaletteId() {
		var idToVerify = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
		var idToVerifyAgainst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

		return idToVerifyAgainst.indexOf(idToVerify) !== -1;
	};

	PaletteHelper.getCustomPaletteId = function getCustomPaletteId(paletteId) {
		return paletteId.indexOf(PREFIX_CM_ID) !== -1 ? paletteId : '' + PREFIX_CM_ID + paletteId;
	};

	PaletteHelper.isCustomPalette = function isCustomPalette(paletteId) {
		return paletteId.indexOf(PREFIX_CM_ID) !== -1;
	};

	/**
  * Return a list of most recently used palettes
  *
  * @returns {promise} resolved with a list of most recently used palettes
  */


	PaletteHelper.prototype._getMostRecentlyUsed = function _getMostRecentlyUsed() {
		var _this2 = this;

		var fillType = PALETTE_FILL_TYPE[this.paletteName] || 'simple';
		var mruPalettes = [];

		return this.paletteService.getRecentlyUsedPaletteInfo(fillType).then(function (mostRecentlyUsed) {
			var mruIds = mostRecentlyUsed.map(function (mru) {
				return mru.id;
			});
			var sectionNameList = _this2.getPaletteSectionOrder();
			var startingIndex = 1; // Skip over the mru since it is the one we want to create
			_this2._findMostRecentPaletteFromIds(mruIds, mruPalettes, sectionNameList, startingIndex);
			mruPalettes.length = mruPalettes.length <= _this2.maxMostRecentUseSize ? mruPalettes.length : _this2.maxMostRecentUseSize;
			return mruPalettes;
		});
	};

	/**
  * Retrieve the most recent used palettes base on MRU palette ids
  *
  * @param {String[]} mruIds  Array of MRU ids to search for their corresponding palettes
  * @param {Object[]} foundPaletteList  Array found palettes
  * @param {String[]} sectionNameList - Array of palette section names
  */


	PaletteHelper.prototype._findMostRecentPaletteFromIds = function _findMostRecentPaletteFromIds(mruIds, foundPaletteList, sectionNameList) {
		var _this3 = this;

		var outerIndex = 0;
		var innerIndex = void 0;

		var _loop = function _loop() {
			var idToSearch = mruIds[outerIndex];
			for (innerIndex = 0; innerIndex < sectionNameList.length; innerIndex++) {
				var sectionName = sectionNameList[innerIndex];
				var palette = _this3.palettes[sectionName];
				var matchedPalette = palette && palette.find(function (candidatePalette) {
					return candidatePalette.id == idToSearch || candidatePalette.id.indexOf(idToSearch) !== -1;
				});
				if (matchedPalette) {
					foundPaletteList.push(matchedPalette);
					break;
				}
			}
		};

		for (outerIndex; outerIndex < mruIds.length; outerIndex++) {
			_loop();
		}
	};

	/**
  * Creates a palette sections as defined by PALETTE_SECTION_ORDER
  */


	PaletteHelper.prototype._creastePaletteSections = function _creastePaletteSections() {
		// Make sure these array exists
		this.palettes.my = this.palettes.my || [];
		this.palettes.public = this.palettes.public || [];
		this.palettes.system = this.palettes.system || [];
		this.palettes.local = this.palettes.local || [];
		this.palettes.legacy = this.palettes.legacy || [];

		this.palettes.global = [].concat(this.palettes.public);
		this.palettes.custom = [].concat(this.palettes.my.filter(function (palette) {
			return !palette.public;
		}));
		delete this.palettes.my;
		delete this.palettes.public;
	};

	return PaletteHelper;
}();

exports.default = PaletteHelper;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(7);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ColorWheel = __webpack_require__(26);

var _ColorWheel2 = _interopRequireDefault(_ColorWheel);

var _ColorMode = __webpack_require__(27);

var _ColorMode2 = _interopRequireDefault(_ColorMode);

var _ColorSliders = __webpack_require__(28);

var _ColorSliders2 = _interopRequireDefault(_ColorSliders);

var _ColorRgb = __webpack_require__(29);

var _ColorRgb2 = _interopRequireDefault(_ColorRgb);

var _ColorGrid = __webpack_require__(30);

var _ColorGrid2 = _interopRequireDefault(_ColorGrid);

var _Favorites = __webpack_require__(46);

var _Favorites2 = _interopRequireDefault(_Favorites);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _baUiCarbonToolkit = __webpack_require__(3);

__webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2018, 2021
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var MAX_FAVORITES = 12;

// CustomPalette class

var CustomColorDialog = function (_Component) {
	_inherits(CustomColorDialog, _Component);

	// Constructor
	// State consists of property to define whether or not the dialog is open or closed, the selectedTab for the tab panel and the selected item in the select drop down list
	function CustomColorDialog(props) {
		_classCallCheck(this, CustomColorDialog);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.applyPaletteColor = function () {
			var paletteServicePromise = _this.props.paletteService ? Promise.resolve(_this.props.paletteService) : _this.props.glassContext.getSvc('.Palette');
			paletteServicePromise.then(function (service) {
				service.setFavoriteColors(_this.favoritesView.getFavoriteColors()).then(function () {
					_this.props.onChange(_this.state.currentColor);
					_this.closeDialog();
				}, function (error) {
					console.log(error);
				});
			});
		};

		_this.closeDialog = function () {
			_this.setState({ isDialogOpen: false });
			if (_this.props.onCloseDialog) {
				_this.props.onCloseDialog();
			}
		};

		_this.openDialog = function () {
			_this.setState({ isDialogOpen: true });
		};

		_this.favoritesView = null;
		_this.state = {
			currentColor: _this._getCurrentColor(),
			isDialogOpen: props.isDialogOpen || false,
			selectedTab: 'idColorGrid',
			selectedColorType: 'RGB'
		};
		return _this;
	}

	CustomColorDialog.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		var paletteServicePromise = this.props.paletteService ? Promise.resolve(this.props.paletteService) : this.props.glassContext.getSvc('.Palette');
		paletteServicePromise.then(function (service) {
			service.getFavoriteColors().then(function (cmFavoriteColors) {
				_this2.favoritesView.setState({
					favoriteColors: cmFavoriteColors
				});
			});
		});
	};

	CustomColorDialog.prototype.updateSelectedColor = function updateSelectedColor(color) {
		this.setState({
			currentColor: color
		});
	};

	CustomColorDialog.prototype.setColor = function setColor(color) {
		this.updateSelectedColor(color);
		if (this.favoritesView.isFavoriteSelected()) {
			this.favoritesView.updateSelectedColor(color);
			this.favoritesView.deselectCurrentFavorite();
		}
	};

	CustomColorDialog.prototype.addFavorite = function addFavorite() {
		if (this.state.currentColor && this.favoritesView.state.favoriteColors.length < MAX_FAVORITES) {
			var colors = this.favoritesView.state.favoriteColors;
			colors.push(this.state.currentColor);
			this.favoritesView.setState({
				favoriteColors: colors
			});
		}
	};

	CustomColorDialog.prototype.render = function render() {
		var _this3 = this;

		return this.state.isDialogOpen && _react2.default.createElement(
			_baUiCarbonToolkit.Dialog,
			{ width: '481px', onClose: this.closeDialog, className: 'customColorDialog' },
			_react2.default.createElement(
				_baUiCarbonToolkit.Dialog.Header,
				null,
				_StringResources2.default.get('colorPicker')
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.Dialog.Body,
				null,
				_react2.default.createElement(
					_baUiCarbonToolkit.Tabs,
					{ selected: this.state.selectedTab, onChange: function onChange(tabId) {
							return _this3.setState({ selectedTab: tabId });
						}, style: { height: '375px' } },
					_react2.default.createElement(
						_baUiCarbonToolkit.TabPanel,
						{ keepTabContent: true, id: 'idColorGrid', label: _StringResources2.default.get('grid') },
						_react2.default.createElement(
							'div',
							{ style: { marginTop: '16px' } },
							_react2.default.createElement(_ColorGrid2.default, {
								id: 'idColorGridComponent',
								onColorChange: this.setColor.bind(this)
							})
						)
					),
					_react2.default.createElement(
						_baUiCarbonToolkit.TabPanel,
						{ keepTabContent: true, id: 'idColorWheel', label: _StringResources2.default.get('wheel') },
						_react2.default.createElement(
							_baUiCarbonToolkit.FlexLayout,
							{ style: { marginTop: '16px' } },
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								null,
								_react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(_ColorWheel2.default, {
										id: 'idColorWheelComponent',
										onColorChange: this.setColor.bind(this),
										color: this.state.currentColor
									})
								),
								_react2.default.createElement(
									'div',
									{ style: { marginTop: '16px', width: '160px' } },
									_react2.default.createElement(_ColorMode2.default, {
										selectedColorType: this.state.selectedColorType,
										onChange: function onChange(value) {
											return _this3.setState({ selectedColorType: value });
										}
									})
								)
							),
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								{ style: { marginLeft: '16px' } },
								_react2.default.createElement(_ColorRgb2.default, {
									onChange: this.setColor.bind(this),
									color: this.state.currentColor
								}),
								_react2.default.createElement(_ColorSliders2.default, {
									onColorChange: this.setColor.bind(this),
									selectedColorType: this.state.selectedColorType,
									color: this.state.currentColor,
									style: { marginTop: '16px' }
								})
							)
						)
					)
				),
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexLayout,
					{ direction: 'column' },
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexLayout,
						{ justifyContent: 'flex-end' },
						_react2.default.createElement(
							_baUiCarbonToolkit.Link,
							{ className: 'addFavorite', style: { zIndex: 3000 }, onClick: this.addFavorite.bind(this) },
							_StringResources2.default.get('setAsFavorite')
						)
					),
					_react2.default.createElement(_Favorites2.default, {
						favoriteColors: [],
						updateColor: this.updateSelectedColor.bind(this),
						ref: function ref(element) {
							_this3.favoritesView = element;
						},
						numberOfFavorites: MAX_FAVORITES })
				)
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.Dialog.Footer,
				null,
				_react2.default.createElement(_baUiCarbonToolkit.Dialog.Button, { label: _StringResources2.default.get('cancelDialog'), onClick: this.closeDialog }),
				_react2.default.createElement(_baUiCarbonToolkit.Dialog.Button, { label: _StringResources2.default.get('applyDialog'), onClick: this.applyPaletteColor, disabled: !this.state.currentColor, primary: true })
			)
		) || null;
	};

	CustomColorDialog.prototype._getCurrentColor = function _getCurrentColor() {
		var selectedColor = this.props.selectedColor;
		// transparent is not a color in the color wheel so return undefined, ie, not provided by client

		return selectedColor && selectedColor.toLowerCase() === 'transparent' ? undefined : selectedColor;
	};

	return CustomColorDialog;
}(_react.Component);

CustomColorDialog.propTypes = {
	isDialogOpen: _propTypes2.default.bool,
	glassContext: _propTypes2.default.object,
	paletteService: _propTypes2.default.object,
	selectedColor: _propTypes2.default.string,
	onChange: _propTypes2.default.func,
	onCloseDialog: _propTypes2.default.func
};
CustomColorDialog.defaultProps = {
	isDialogOpen: false
};
exports.default = CustomColorDialog;


CustomColorDialog.defaultProps = {
	name: 'CustomColorDialog'
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(15);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (process.env.NODE_ENV !== 'production') {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ColorConversion = __webpack_require__(11);

var _ColorConversion2 = _interopRequireDefault(_ColorConversion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var WHEEL_PIXEL_SIZE = 225;
var WHEEL_ORIGIN_OFFSET = WHEEL_PIXEL_SIZE / 2;

var ColorWheel = function (_Component) {
	_inherits(ColorWheel, _Component);

	function ColorWheel(props) {
		_classCallCheck(this, ColorWheel);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this._drawCanvas = function () {
			var canvasContext = _this.colorWheel.getContext('2d');
			// Center coordinates of the color wheel
			var xCoordinate = WHEEL_ORIGIN_OFFSET;
			var yCoordinate = WHEEL_ORIGIN_OFFSET;
			//Radius of the color wheel
			var iRadius = WHEEL_ORIGIN_OFFSET;
			var bCounterClockwise = false;

			//For loop used to draw the color wheel pixel by pixel on the canvas
			for (var angle = 0; angle <= 360; angle++) {
				var v_iStartAngle = (angle - 2) * Math.PI / 180;
				var v_iEndAngle = angle * Math.PI / 180;
				canvasContext.beginPath();
				canvasContext.moveTo(xCoordinate, yCoordinate);
				canvasContext.arc(xCoordinate, yCoordinate, iRadius, v_iStartAngle, v_iEndAngle, bCounterClockwise);
				canvasContext.closePath();
				var v_iGradient = canvasContext.createRadialGradient(xCoordinate, yCoordinate, 0, xCoordinate, yCoordinate, iRadius);
				v_iGradient.addColorStop(0, 'hsl(' + angle + ', 10%, 100%)');
				v_iGradient.addColorStop(1, 'hsl(' + angle + ', 100%, 50%)');
				canvasContext.fillStyle = v_iGradient;
				canvasContext.fill();
			}
		};

		_this._clickOnPalette = function (event) {
			var eventX = null;
			var eventY = null;

			if (event.type == 'touchmove') {
				eventX = event.targetTouches[0].clientX;
				eventY = event.targetTouches[0].clientY;
			} else {
				eventX = event.clientX;
				eventY = event.clientY;
			}

			var elementRelativePosition = _this._getRelativeOffset();
			var x = eventX - elementRelativePosition.left;
			var y = eventY - elementRelativePosition.top;

			var pickerOffsetWidth = _this.colorPicker.offsetWidth / 2 + 1;
			var pickerOffsetHeight = _this.colorPicker.offsetHeight / 2;

			// if clicking outside the radius of the circle, move it to the outside edge of the circle
			var circleX = x - WHEEL_ORIGIN_OFFSET;
			var circleY = WHEEL_ORIGIN_OFFSET - y;
			var radius = Math.sqrt(Math.pow(circleX, 2) + Math.pow(circleY, 2));
			if (radius > WHEEL_ORIGIN_OFFSET) {
				var fixedCircleX = WHEEL_ORIGIN_OFFSET * Math.cos(Math.acos(circleX / radius));
				var fixedCircleY = WHEEL_ORIGIN_OFFSET * Math.sin(Math.asin(circleY / radius));
				x = fixedCircleX + WHEEL_ORIGIN_OFFSET;
				y = WHEEL_ORIGIN_OFFSET - fixedCircleY;
			}

			var rgbHex = _ColorConversion2.default.convertRgbValToRgbHex(_this._getCanvasColor(x, y));
			if (rgbHex === '#000000') {
				// this is an error state in IE, where a color could not be retrieved from the canvas (our canvas has no black)
				// return and let the user try to click again
				return;
			}
			_this.setState({ pickerColor: rgbHex });
			_this.colorPicker.style.left = x - pickerOffsetWidth + 'px';
			_this.colorPicker.style.top = y - (_this.colorWheel.height + pickerOffsetHeight) + 'px';
			_this.props.onColorChange(rgbHex, false);
		};

		_this.colorWheel = null;
		_this.colorPicker = null;
		_this.state = {
			pickerColor: null
		};
		return _this;
	}

	ColorWheel.prototype.componentDidMount = function componentDidMount() {
		this._drawCanvas();
		this.colorWheel.onclick = this.colorPicker.onclick = this._clickOnPalette.bind(this);
	};

	ColorWheel.prototype._getRelativeOffset = function _getRelativeOffset() {
		var clientRect = this.colorWheel.getBoundingClientRect();
		var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

		var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		var position = { top: clientRect.top + scrollTop, left: clientRect.left + scrollLeft };

		return position;
	};

	ColorWheel.prototype._getCanvasColor = function _getCanvasColor(left, top) {
		var dataArray = this.colorWheel.getContext('2d').getImageData(left, top, 1, 1).data;
		return {
			red: dataArray[0],
			green: dataArray[1],
			blue: dataArray[2]
		};
	};

	ColorWheel.prototype.render = function render() {
		var _this2 = this;

		return _react2.default.createElement(
			'div',
			{ style: { height: WHEEL_PIXEL_SIZE + 'px', width: WHEEL_PIXEL_SIZE + 'px' } },
			_react2.default.createElement('canvas', {
				width: WHEEL_PIXEL_SIZE,
				height: WHEEL_PIXEL_SIZE,
				id: 'colorWheel',
				ref: function ref(element) {
					_this2.colorWheel = element;
				}
			}),
			_react2.default.createElement('div', {
				id: 'colorPicker',
				style: { backgroundColor: this.state.pickerColor, visibility: this.state.pickerColor && this.state.pickerColor === this.props.color ? '' : 'hidden' },
				className: 'clsWheelSelector clsWheelSelectorEmpty clsPickerWrapper',
				ref: function ref(element) {
					_this2.colorPicker = element;
				} })
		);
	};

	return ColorWheel;
}(_react.Component);

ColorWheel.propTypes = {
	onColorChange: _propTypes2.default.func,
	color: _propTypes2.default.string
};
ColorWheel.defaultProps = {
	color: '#FFFFFF'
};
exports.default = ColorWheel;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _baUiCarbonToolkit = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var ColorMode = function (_PureComponent) {
	_inherits(ColorMode, _PureComponent);

	function ColorMode() {
		_classCallCheck(this, ColorMode);

		return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	}

	ColorMode.prototype.render = function render() {
		var myList = [{ value: 'RGB', label: _StringResources2.default.get('modelRGB') },
		// { value: 'CMYK', label: StringResources.get('modelCMYK') },
		{ value: 'HSB', label: _StringResources2.default.get('modelHSB') }];
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(_baUiCarbonToolkit.Label, { id: 'idSelectColorModeLabel', label: _StringResources2.default.get('colorModel') }),
			_react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(_baUiCarbonToolkit.Select, {
					light: true,
					selected: this.props.selectedColorType,
					options: myList,
					onChange: this.props.onChange,
					'aria-labelledby': 'idSelectColorModeLabel'
				})
			)
		);
	};

	return ColorMode;
}(_react.PureComponent);

ColorMode.propTypes = {
	selectedColorType: _propTypes2.default.string,
	onChange: _propTypes2.default.func
};
ColorMode.defaultProps = {
	selectedColorType: 'RGB'
};
exports.default = ColorMode;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RgbSlider = __webpack_require__(44);

var _RgbSlider2 = _interopRequireDefault(_RgbSlider);

var _ColorConversion = __webpack_require__(11);

var _ColorConversion2 = _interopRequireDefault(_ColorConversion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var ColorSliders = function (_Component) {
	_inherits(ColorSliders, _Component);

	function ColorSliders(props) {
		_classCallCheck(this, ColorSliders);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.onRGBChange = function (value, color) {
			if (isNaN(value)) {
				return;
			}
			var rgbColor = _ColorConversion2.default.convertRgbHexToRgbVal(_this.props.color);
			rgbColor[color.toLowerCase()] = parseInt(value);
			var rgbHex = _ColorConversion2.default.convertRgbValToRgbHex(rgbColor);
			if (rgbHex != _this.props.color) {
				_this.props.onColorChange(rgbHex, false);
			}
		};

		_this.onHSLChange = function (value, color) {
			if (isNaN(value)) {
				return;
			}
			var hslColor = _extends({}, _this.state.hslColor);
			switch (color) {
				case 'Hue':
					if (Math.round(hslColor.hue) === value) {
						return;
					}
					hslColor.hue = value;
					break;
				case 'Saturation':
					if (Math.round(hslColor.sat * 100) === value) {
						return;
					}
					hslColor.sat = value / 100;
					break;
				case 'Brightness':
					if (Math.round(hslColor.light * 100) === value) {
						return;
					}
					hslColor.light = value / 100;
					break;
			}
			_this.setState({ hslColor: hslColor });
			var rgbHex = _ColorConversion2.default.convertRgbValToRgbHex(_ColorConversion2.default.convertHslToRgb(hslColor));
			if (rgbHex != _this.props.color) {
				_this.props.onColorChange(rgbHex);
			}
		};

		_this.state = {
			hslColor: _ColorConversion2.default.convertRgbToHsl(props.color)
		};
		return _this;
	}

	ColorSliders.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
		if (this.props.color != prevProps.color) {
			var newColor = this.props.color;
			// if the current HSL doesn't map to the RGB then we reset it
			if (newColor != _ColorConversion2.default.convertRgbValToRgbHex(_ColorConversion2.default.convertHslToRgb(this.state.hslColor))) {
				this.setState({ hslColor: _ColorConversion2.default.convertRgbToHsl(newColor) });
			}
		}
	};

	ColorSliders.prototype._getSliders = function _getSliders() {
		switch (this.props.selectedColorType) {
			case 'RGB':
				{
					var rgbVal = _ColorConversion2.default.convertRgbHexToRgbVal(this.props.color);
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_RgbSlider2.default, {
							key: 'red',
							color: 'Red',
							onChange: this.onRGBChange.bind(this),
							selectedColorType: this.props.selectedColorType,
							value: rgbVal.red
						}),
						_react2.default.createElement(_RgbSlider2.default, {
							key: 'green',
							color: 'Green',
							onChange: this.onRGBChange.bind(this),
							selectedColorType: this.props.selectedColorType,
							value: rgbVal.green
						}),
						_react2.default.createElement(_RgbSlider2.default, {
							key: 'blue',
							color: 'Blue',
							onChange: this.onRGBChange.bind(this),
							selectedColorType: this.props.selectedColorType,
							value: rgbVal.blue
						})
					);
				}
			case 'HSB':
				{
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_RgbSlider2.default, {
							key: 'hue',
							color: 'Hue',
							onChange: this.onHSLChange.bind(this),
							selectedColorType: this.props.selectedColorType,
							value: Math.round(this.state.hslColor.hue)
						}),
						_react2.default.createElement(_RgbSlider2.default, {
							key: 'sat',
							color: 'Saturation',
							onChange: this.onHSLChange.bind(this),
							selectedColorType: this.props.selectedColorType,
							value: Math.round(this.state.hslColor.sat * 100)
						}),
						_react2.default.createElement(_RgbSlider2.default, {
							key: 'light',
							color: 'Brightness',
							onChange: this.onHSLChange.bind(this),
							selectedColorType: this.props.selectedColorType,
							value: Math.round(this.state.hslColor.light * 100)
						})
					);
				}
		}
	};

	ColorSliders.prototype.render = function render() {
		return _react2.default.createElement(
			'div',
			{ id: 'idRGBWrapper' },
			this._getSliders()
		);
	};

	return ColorSliders;
}(_react.Component);

ColorSliders.propTypes = {
	onColorChange: _propTypes2.default.func,
	selectedColorType: _propTypes2.default.string,
	color: _propTypes2.default.string
};
ColorSliders.defaultProps = {
	color: '#FFFFFF',
	selectedColorType: 'RGB'
};
exports.default = ColorSliders;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _baUiCarbonToolkit = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var ColorRgb = function (_PureComponent) {
	_inherits(ColorRgb, _PureComponent);

	function ColorRgb() {
		var _temp, _this, _ret;

		_classCallCheck(this, ColorRgb);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this._validator = function (regex, color) {
			var matches = color.match(regex);
			return matches && matches.length == 1 && matches[0] === color;
		}, _this.validateHexInput = function (value) {
			// inject the hex string identifier if not present
			if (value.length == 0 || value[0] != '#') {
				value = '#' + value;
			}

			// if any pair is not hex digits, return before updating state to prevent the input
			var regex = /[0-9A-Fa-f]{1,2}/;
			if (value.length > 1 && !_this._validator(regex, value.substr(1, 2))) {
				return;
			}
			if (value.length > 3 && !_this._validator(regex, value.substr(3, 2))) {
				return;
			}
			if (value.length > 5 && !_this._validator(regex, value.substr(5, 2))) {
				return;
			}

			// only "process" the input if it's a full hex string
			if (value.length == 7) {
				_this.props.onChange(value.toUpperCase(), false);
			}
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	ColorRgb.prototype.render = function render() {
		var _this2 = this;

		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(_baUiCarbonToolkit.Label, {
				id: 'idHexCodeLabel',
				type: 'caption',
				label: _StringResources2.default.get('hexCode'),
				htmlFor: 'idTextRgbCode',
				title: _StringResources2.default.get('hexCode'),
				alt: _StringResources2.default.get('hexCode')
			}),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexLayout,
				null,
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					{ style: { width: '160px' } },
					_react2.default.createElement(_baUiCarbonToolkit.TextInput, {
						id: 'idTextRgbCode',
						light: true,
						value: this.props.color,
						onValueChange: function onValueChange(value) {
							return _this2.validateHexInput(value);
						},
						fullWidth: true,
						maxLength: '7',
						tabIndex: 0
					})
				),
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					null,
					_react2.default.createElement('div', {
						id: 'divPreview',
						className: 'clsPreviewBox',
						style: { backgroundColor: this.props.color }
					})
				)
			)
		);
	};

	return ColorRgb;
}(_react.PureComponent);

ColorRgb.propTypes = {
	color: _propTypes2.default.string,
	onChange: _propTypes2.default.func
};
ColorRgb.defaultProps = {
	color: '#FFFFFF'
};
exports.default = ColorRgb;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _IBMColors = __webpack_require__(45);

var IBMColors = _interopRequireWildcard(_IBMColors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var ColorGrid = function (_Component) {
	_inherits(ColorGrid, _Component);

	function ColorGrid(props) {
		_classCallCheck(this, ColorGrid);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {
			activeSelector: null
		};

		_this.colorNodes = _this.generateColorGrid();
		_this.blackAndWhite = [_this.getColorGrid({ backgroundColor: '#000000' }, 'black', true, false), _this.getColorGrid({ backgroundColor: '#FFFFFF' }, 'white', true, true)];
		return _this;
	}

	ColorGrid.prototype.generateColorGrid = function generateColorGrid() {
		var colorsArray = [IBMColors['Yellow 10'], IBMColors['Orange 10'], IBMColors['Red 10'], IBMColors['Magenta 10'], IBMColors['Purple 10'], IBMColors['Blue 10'], IBMColors['Cyan 10'], IBMColors['Teal 10'], IBMColors['Green 10'], IBMColors['Cool Gray 10'], IBMColors['Gray 10'], IBMColors['Warm Gray 10'], IBMColors['Yellow 20'], IBMColors['Orange 20'], IBMColors['Red 20'], IBMColors['Magenta 20'], IBMColors['Purple 20'], IBMColors['Blue 20'], IBMColors['Cyan 20'], IBMColors['Teal 20'], IBMColors['Green 20'], IBMColors['Cool Gray 20'], IBMColors['Gray 20'], IBMColors['Warm Gray 20'], IBMColors['Yellow 30'], IBMColors['Orange 30'], IBMColors['Red 30'], IBMColors['Magenta 30'], IBMColors['Purple 30'], IBMColors['Blue 30'], IBMColors['Cyan 30'], IBMColors['Teal 30'], IBMColors['Green 30'], IBMColors['Cool Gray 30'], IBMColors['Gray 30'], IBMColors['Warm Gray 30'], IBMColors['Yellow 40'], IBMColors['Orange 40'], IBMColors['Red 40'], IBMColors['Magenta 40'], IBMColors['Purple 40'], IBMColors['Blue 40'], IBMColors['Cyan 40'], IBMColors['Teal 40'], IBMColors['Green 40'], IBMColors['Cool Gray 40'], IBMColors['Gray 40'], IBMColors['Warm Gray 40'], IBMColors['Yellow 50'], IBMColors['Orange 50'], IBMColors['Red 50'], IBMColors['Magenta 50'], IBMColors['Purple 50'], IBMColors['Blue 50'], IBMColors['Cyan 50'], IBMColors['Teal 50'], IBMColors['Green 50'], IBMColors['Cool Gray 50'], IBMColors['Gray 50'], IBMColors['Warm Gray 50'], IBMColors['Yellow 60'], IBMColors['Orange 60'], IBMColors['Red 60'], IBMColors['Magenta 60'], IBMColors['Purple 60'], IBMColors['Blue 60'], IBMColors['Cyan 60'], IBMColors['Teal 60'], IBMColors['Green 60'], IBMColors['Cool Gray 60'], IBMColors['Gray 60'], IBMColors['Warm Gray 60'], IBMColors['Yellow 70'], IBMColors['Orange 70'], IBMColors['Red 70'], IBMColors['Magenta 70'], IBMColors['Purple 70'], IBMColors['Blue 70'], IBMColors['Cyan 70'], IBMColors['Teal 70'], IBMColors['Green 70'], IBMColors['Cool Gray 70'], IBMColors['Gray 70'], IBMColors['Warm Gray 70'], IBMColors['Yellow 80'], IBMColors['Orange 80'], IBMColors['Red 80'], IBMColors['Magenta 80'], IBMColors['Purple 80'], IBMColors['Blue 80'], IBMColors['Cyan 80'], IBMColors['Teal 80'], IBMColors['Green 80'], IBMColors['Cool Gray 80'], IBMColors['Gray 80'], IBMColors['Warm Gray 80'], IBMColors['Yellow 90'], IBMColors['Orange 90'], IBMColors['Red 90'], IBMColors['Magenta 90'], IBMColors['Purple 90'], IBMColors['Blue 90'], IBMColors['Cyan 90'], IBMColors['Teal 90'], IBMColors['Green 90'], IBMColors['Cool Gray 90'], IBMColors['Gray 90'], IBMColors['Warm Gray 90'], IBMColors['Yellow 100'], IBMColors['Orange 100'], IBMColors['Red 100'], IBMColors['Magenta 100'], IBMColors['Purple 100'], IBMColors['Blue 100'], IBMColors['Cyan 100'], IBMColors['Teal 100'], IBMColors['Green 100'], IBMColors['Cool Gray 100'], IBMColors['Gray 100'], IBMColors['Warm Gray 100']];

		var colors = [];
		for (var i = 0; i < colorsArray.length; i++) {
			var RgbColor = '#' + colorsArray[i];
			var colorStyle = {
				backgroundColor: RgbColor
			};
			colors.push(this.getIndexedColorGrid(colorStyle, i));
		}
		return colors;
	};

	ColorGrid.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
		return false;
	};

	ColorGrid.prototype.setColor = function setColor(e, color, isGreyScale) {
		var newSelector = e.target.firstChild || e.target;
		if (this.state.activeSelector) {
			var oldSelector = this.state.activeSelector;
			if (oldSelector != newSelector) {
				oldSelector.style.display = 'none';
				oldSelector.parentNode.style.borderWidth = '1px';
				oldSelector.parentNode.style.backgroundColor = oldSelector.style.backgroundColor;
			}
		}
		newSelector.style.display = 'block';
		newSelector.parentNode.style.borderWidth = '0px';
		newSelector.parentNode.style.backgroundColor = '#FFFFFF';
		this.setState({ activeSelector: newSelector });
		this.props.onColorChange(color.toUpperCase(), isGreyScale);
	};

	ColorGrid.prototype.getIndexedColorGrid = function getIndexedColorGrid(colorStyle, i) {
		var isGreyScale = i % 12 >= 9; // column 10 is true grey, 9 and 11 are warm/cool grey, which could work without setting greyscale, but give better results treated as grey
		var needsOutline = i < 36; // somewhat random assertion that the first 3 rows are light enough to warrant an outline
		return this.getColorGrid(colorStyle, i, isGreyScale, needsOutline);
	};

	ColorGrid.prototype.getColorGrid = function getColorGrid(colorStyle, identifier, isGreyScale, needsOutline) {
		var _this2 = this;

		var gridSquareClass = needsOutline ? 'clsColorBoxStyle_white' : 'clsColorBoxStyle';
		return _react2.default.createElement(
			'div',
			{ id: 'gridIndex' + identifier, key: identifier, style: colorStyle, className: gridSquareClass, onClick: function onClick(element) {
					return _this2.setColor(element, colorStyle.backgroundColor, isGreyScale);
				} },
			_react2.default.createElement('div', { id: 'gridSelector' + identifier, className: 'clsSelector', style: { display: 'none', backgroundColor: colorStyle.backgroundColor } })
		);
	};

	ColorGrid.prototype.render = function render() {
		return _react2.default.createElement(
			'div',
			{ style: { display: 'flex', width: '448px' } },
			_react2.default.createElement(
				'div',
				{ style: { display: 'flex', width: '64px' } },
				this.blackAndWhite
			),
			_react2.default.createElement(
				'div',
				{ style: { display: 'flex', flexWrap: 'wrap', width: '384px' } },
				this.colorNodes
			)
		);
	};

	return ColorGrid;
}(_react.Component);

ColorGrid.propTypes = {
	onColorChange: _propTypes2.default.func,
	color: _propTypes2.default.string
};
exports.default = ColorGrid;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,s){if(true)module.exports=s(__webpack_require__(5));else if("function"==typeof define&&define.amd)define(["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"],s);else{var a=s("object"==typeof exports?require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"):e["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for(var o in a)("object"==typeof exports?exports:e)[o]=a[o]}}("undefined"!=typeof self?self:this,function(e){return webpackJsonPBaGraphics([1370],{"139ff196022a7a1221df":function(e,s,a){"use strict";var o=a("9689a9c94ae38b47fa2c"),c=a.n(o),i=a("9ce58a7deea14f49ef01"),t=a.n(i),n=new c.a({id:"delete_32_v7",use:"delete_32_v7-usage",viewBox:"0 0 32 32",content:'<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="delete_32_v7"><path d="M12 12H14V24H12zM18 12H20V24H18z" /><path d="M4 6V8H6V28a2 2 0 002 2H24a2 2 0 002-2V8h2V6zM8 28V8H24V28zM12 2H20V4H12z" /></symbol>'});t.a.add(n);s.a=n},"421c5ca19058cc77b189":function(e,s,a){"use strict";Object.defineProperty(s,"__esModule",{value:!0});var o=a("6873601dfe1d9459c1a9"),c=(a.n(o),a("139ff196022a7a1221df"));s.default=c.a},"6873601dfe1d9459c1a9":function(s,a){s.exports=e}},["421c5ca19058cc77b189"])});

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2016
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(9), __webpack_require__(20), __webpack_require__(56), __webpack_require__(21), __webpack_require__(57)], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, _, dot, Events) {
	'use strict';

	var View = null;
	var eventsRegex = /^(\S+)\s*(.*)$/;

	// View related attributes that are supported
	var viewAttributes = ['el', 'id', 'className', 'tagName', 'events'];

	/**
  * A Backbone style base View Class. UI Views should extend this class.
  *
  */
	View = Events.extend({
		templateString: null,
		id: null,

		init: function init(attributes) {
			View.inherited('init', this, arguments);
			this.viewId = _.uniqueId('view');
			this.dotTemplate = dot.template(this.templateString || '');

			_.extend(this, _.pick(attributes || {}, viewAttributes));
			this._initDomElement();
			this._attachEvents();
		},

		/**
   * The tag name given to the view's DOM element. By default it's a DIV.
   */
		tagName: 'div',

		/**
   * Initialize the DOM element for this view
   */
		_initDomElement: function _initDomElement() {
			if (!this.el) {
				var attrs = {};
				if (this.id) {
					attrs.id = _.result(this, 'id');
				}
				if (this.className) {
					attrs['class'] = _.result(this, 'className');
				}
				this.setElement(document.createElement(this.tagName));
				this.$el.attr(attrs);
			} else {
				this.setElement(_.result(this, 'el'));
			}
		},

		/**
   * Convenience function to use jQuery to find a DOM element within this view. This is
   * faster then doing a global lockup.
   */
		$: function $(selector) {
			return this.$el.find(selector);
		},

		/**
   * Hide the view
   */
		hide: function hide() {
			this.$el.hide();
		},

		/**
   * Show the view if hidden
   */
		show: function show() {
			this.$el.show();
		},

		/**
   * Make sure the target is the intended dom node, using CSS class to validate.
   * If not the right node, check out the parents.
   */
		getTarget: function getTarget(target, sClass) {
			var $t = $(target);
			if (!$t.hasClass(sClass)) {
				var parents = $t.parents('.' + sClass);
				if (parents.length > 0) {
					target = parents[0];
				}
			}
			return target;
		},

		/**
   * Render is the main function of the View. Views should implement (override) the render
   * method to populate this.el with the appropriate HTML. Render should always return this
   * to allow chaining of calls.
   */
		render: function render() {
			return this;
		},

		/**
   * Remove this view:
   *		-Remove the element from the DOM
   *		-Remove the event listeners
   */
		remove: function remove() {
			if (this.$el) {
				this.$el.remove();
			}
			if (this.off) {
				this.off();
			}
			return this;
		},

		/**
   * Set the view element to a new DOM element
   */
		setElement: function setElement(el) {
			this._detachEvents();
			this.$el = el instanceof $ ? el : $(el);
			this.el = this.$el[0];
			this._attachEvents();
			return this;
		},

		/**
   * Attaches the events in this.events to this.el for this view
   */
		_attachEvents: function _attachEvents() {
			var events = this.events;

			this._detachEvents();
			for (var key in events) {
				var callback = events[key];
				if (!_.isFunction(callback)) {
					callback = this[events[key]];
				}
				if (!callback) {
					continue;
				}
				var match = key.match(eventsRegex);
				var eventName = match[1];
				var selector = match[2];
				// add the event to the element, with a namespace 'privateViewEvents'
				this.$el.on(eventName + '.privateViewEvents' + this.viewId, selector, callback.bind(this));
			}
			return this;
		},

		/**
   * Detaches all the events from the element
   */
		_detachEvents: function _detachEvents() {
			if (this.$el) {
				this.$el.off('.privateViewEvents' + this.viewId);
			}
			return this;
		}

	});

	return View;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
//# sourceMappingURL=View.js.map

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
var ToastEnum = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error'
};
Object.freeze(ToastEnum);
module.exports = ToastEnum;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _jszip = __webpack_require__(73);

var _jszip2 = _interopRequireDefault(_jszip);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } // Licensed Materials - Property of IBM
//
// IBM Watson Analytics
//
// (C) Copyright IBM Corp. 2019
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with IBM Corp.

var MB = 1000000;

/**
 * Utility class to load an SVG which can either be a single SVG or a zipped file containing one or more SVG's
 */

var FileLoader = function FileLoader(_reader, _zipMaxSize, _imgMaxSize, _allowedFileExtensions) {
	var _this = this;

	_classCallCheck(this, FileLoader);

	this.load = function (_files, _callback, _reject) {
		try {
			var results = [];

			// Define the file info if not created
			if (!_this._files) _this._files = {};

			// Load each file returning a promise for each one
			for (var i = 0; i < _files.length; i++) {
				results.push(_this._loadFile(_files[i]));
			}

			// Process all the promises and when all have finished fire the callback
			// function returning the list of svg names that have been loaded
			Promise.all(results).then(function (_dataArray) {
				// The result of the load will always return an array for each file
				// even if one file is selected.
				// Merge all arrays into one
				var mergedArrays = [].concat.apply([], _dataArray);
				return _callback(mergedArrays);
			}.bind(_this), _reject);
		} catch (_error) {
			_reject(_error);
		}
	};

	this.getFileAsBlob = function (_fileName) {
		return new Promise(function (_resolve, _reject) {
			var _fileData = this._getFileInfo(_fileName);
			if (_fileData) {
				if (_fileData.type === 'zip') {
					try {
						var file = {
							name: _fileData.data[_fileName].name,
							size: _fileData.data[_fileName]._data.uncompressedSize
						};
						this._verifyImgFileSize(file);
						_fileData.data[_fileName].async('blob').catch(function (_error) {
							_reject(_error);
						}).then(function (_content) {
							_resolve(_content);
						});
					} catch (_error) {
						_reject(_error);
					}
				} else _resolve(_fileData.data);
			} else _reject({ message: _StringResources2.default.get('schematicsInvalidSvgData') });
		}.bind(_this));
	};

	this._listZip = function (_zip) {
		var files = [];

		Object.keys(_zip).forEach(function (_fileName) {
			files.push(_fileName);
		});

		return files.filter(_this._isSVG);
	};

	this._loadFile = function (_file) {
		var results = [];
		var fileReader = !_this._reader ? new window.FileReader() : _this._reader;
		var fileType = _file.name.toLowerCase().substr(-3);

		if (_this._isSVG(_file.name) || _this._isAllowedFile(_file.name)) {
			var data = _file;
			_this._verifyImgFileSize(_file);
			_this._files[_file.name] = _this._fileData(_file.name, fileType, data, _file.size);
			results.push(_file.name);
			return Promise.resolve(results);
		} else if (!_this._allowedFileExtensions && _this._isZip(_file)) {
			return new Promise(function (_resolve, _reject) {
				fileReader.onload = function (e) {
					// Zipped svgs
					if (this._isZip(_file)) {
						// Load asynchronously
						_jszip2.default.loadAsync(e.target.result).then(function (jsZip) {
							this._files[_file.name] = this._fileData(_file.name, 'zip', jsZip.files, _file.size);
							// Get all SVG files in the zip
							var files = this._listZip(jsZip.files);
							for (var i = 0; i < files.length; i++) {
								results.push(files[i]);
							}
							_resolve(results);
						}.bind(this), function (error) {
							_reject(error);
						});
					} else {
						var data = _file;
						this._files[_file.name] = this._fileData(_file.name, 'svg', data, _file.size);
						results.push(_file.name);
						_resolve(results);
					}
				}.bind(this);

				try {
					this._readFile(_file, fileReader);
				} catch (e) {
					_reject(e);
				}
			}.bind(_this));
		} else {
			throw new Error(_StringResources2.default.get('schematicsInvalidType', { type: _file.name }));
		}
	};

	this._isZip = function (_file) {
		return _file && _file.name && _file.name.toLowerCase().substr(-4) === '.zip' && (_file.type === 'application/x-zip-compressed' || _file.type === 'application/zip' || _file.type === 'application/x-compressed');
	};

	this._isSVG = function (_fileName) {
		return _fileName.toLowerCase().substr(-4) === '.svg';
	};

	this._isAllowedFile = function (_fileName) {
		return _this._allowedFileExtensions && _this._allowedFileExtensions.indexOf(_fileName.toLowerCase().substr(-4)) >= 0;
	};

	this._readFile = function (_file, _fileReader) {
		if (_this._isZip(_file)) {
			_this._verifyZipFileSize(_file);
			_fileReader.readAsArrayBuffer(_file);
		} else if (_this._isSVG(_file)) {
			_this._verifyImgFileSize(_file);
			_fileReader.readAsDataURL(_file);
		} else {
			throw Error(_StringResources2.default.get('schematicsInvalidType', { type: _file.name }));
		}
	};

	this._verifyZipFileSize = function (_file) {
		if (_file.size > _this._zipMaxSize * MB) {
			throw Error(_StringResources2.default.get('schematicsInvalidSize', { file: _file.name, size: _file.size }));
		}
	};

	this._verifyImgFileSize = function (_file) {
		if (_file.size > _this._imgMaxSize * MB) {
			throw Error(_StringResources2.default.get('schematicsInvalidSize', { file: _file.name, size: _file.size }));
		}
	};

	this._fileData = function (_name, _type, _data) {
		return {
			'name': _name,
			'type': _type,
			'data': _data
		};
	};

	this._arrayFind = function (_arr, _obj) {
		for (var idx = 0; idx < _arr.length; ++idx) {
			if (_arr[idx] === _obj) return _obj;
		}
		return null;
	};

	this._getFileInfo = function (_fileName) {
		var keys = Object.keys(_this._files);
		var result;

		// Check first if the file is in the list
		var file = _this._arrayFind(keys, _fileName);

		if (file) {
			result = _this._files[file];
		} else {
			for (var i = 0; i < keys.length; i++) {
				var key = keys[i];
				var fileData = _this._files[key];
				if (fileData.type === 'zip') {
					file = _this._arrayFind(Object.keys(fileData.data), _fileName);
					if (file) {
						result = fileData;
						break;
					}
				}
			}
		}
		return result;
	};

	this._files = null;
	if (_reader) this._reader = _reader;

	if (_zipMaxSize) this._zipMaxSize = _zipMaxSize;

	if (_imgMaxSize) this._imgMaxSize = _imgMaxSize;

	this._allowedFileExtensions = _allowedFileExtensions;
}

/**
 * Load one or more files or a single zip file
 * @param {Array} _files Array of file names
 * @param {Function} _callback The function to be called with the SVG file list
 */


/**
 * Get the svg contents
 * @param {String} _fileName The file name
 * @returns {Promise} Return a promise
 */


/**
 * List =the SVGs found in a zip file
 * @param {String} _zip The filename
 * @returns {Array} List of file names
 */


/**
 * Load a file
 * @param {Object} _file The file object
 * @param {FileReader} _fileReader A file reader object
 * @returns {Promise} A promise that loads the file
 */


/**
 * Determine if the file is a zip file
 * @param {File} _file A file object
 * @returns {Boolean} true is the file is a zip
 */


/**
 * Read the file contents
 * @param {File} _file A file object
 * @param {FileReader} The file reader
 */


/**
 * Creates a file data object
 * @param {String} _name
 * @param {String} _type zip|svg
 * @param {Object} _data Depending on the type this will be a map of ZipObjects or for single files, the svg text
 * @returns {Object} The file data object
 */


// IE do not support array.find()


/**
 * Get file metadata
 * @param {String} _fileName The file name
 * @returns {Object} Return the file metadata. See _fileData()
 */
;

exports.default = FileLoader;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
                                                                                                                                                                                                                                                                   *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                   *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                   *| IBM Cognos Products: BI
                                                                                                                                                                                                                                                                   *| (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                   *|
                                                                                                                                                                                                                                                                   *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                   *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                   *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                   */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(7);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DialogWrapper = {
	show: function show(dialogClass, options) {
		var container = document.querySelector('.dialogWrapper');
		if (!container) {
			container = document.body.appendChild(document.createElement('DIV'));
			container.className = 'dialogWrapper';
		}
		var externalCloseCallback = options.onCloseDialog;
		var props = _extends({}, options, {
			ref: function ref(instance) {
				if (instance) instance.openDialog();
			},
			onCloseDialog: function onCloseDialog() {
				_reactDom2.default.unmountComponentAtNode(container);
				if (externalCloseCallback) {
					externalCloseCallback();
				}
			}
		});

		_reactDom2.default.render(_react2.default.createElement(dialogClass, props), container);
	}
};
exports.default = DialogWrapper;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2015, 2016
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {

	return {
		NUM0: 48,
		NUM1: 49,
		NUM2: 50,
		NUM3: 51,
		NUM4: 52,
		NUM5: 53,
		NUM6: 54,
		NUM7: 55,
		NUM8: 56,
		NUM9: 57,

		// Letters: Upper and Lower Case share the same code, i.e. the code for "a" is 65, too.
		A: 65,
		B: 66,
		C: 67,
		D: 68,
		E: 69,
		F: 70,
		G: 71,
		H: 72,
		I: 73,
		J: 74,
		K: 75,
		L: 76,
		M: 77,
		N: 78,
		O: 79,
		P: 80,
		Q: 81,
		R: 82,
		S: 83,
		T: 84,
		U: 85,
		V: 86,
		W: 87,
		X: 88,
		Y: 89,
		Z: 90,

		NUMPAD0: 96,
		NUMPAD1: 97,
		NUMPAD2: 98,
		NUMPAD3: 99,
		NUMPAD4: 100,
		NUMPAD5: 101,
		NUMPAD6: 102,
		NUMPAD7: 103,
		NUMPAD8: 104,
		NUMPAD9: 105,

		F1: 112,
		F2: 113,
		F3: 114,
		F4: 115,
		F5: 116,
		F6: 117,
		F7: 118,
		F8: 119,
		F9: 120,
		F10: 121,
		F11: 122,
		F12: 123,

		// Note: some keys have the same shape but different number, like DIVIDE and FORWARDSLASH.
		// Make sure you're using the right key.
		BACKSPACE: 8,
		TAB: 9,
		ENTER: 13,
		SHIFT: 16,
		CTRL: 17,
		ALT: 18,
		PAUSEBREAK: 19,
		CAPSLOCK: 20,
		ESCAPE: 27,
		SPACE: 32,
		PAGEUP: 33,
		PAGEDOWN: 34,
		END: 35,
		HOME: 36,
		LEFT_ARROW: 37,
		UP_ARROW: 38,
		RIGHT_ARROW: 39,
		DOWN_ARROW: 40,
		INSERT: 45,
		DELETE: 46,
		SECOND: 50, // the same with NUM2. Keep it for history reason.
		LEFT_WINDOW_KEY: 91, // Left Command on Mac
		RIGHT_WINDOW_KEY: 92, // Right Command on Mac
		SELECT_KEY: 93,
		MULTIPLY: 106,
		ADD: 107,
		SUBTRACT: 109,
		DECIMAL_POINT: 110,
		DIVIDE: 111,
		NUM_LOCK: 144,
		SCROLL_LOCK: 145,
		SEMI_COLON: 186,
		EQUAL: 187,
		COMMA: 188,
		DASH: 189,
		PERIOD: 190,
		FORWARDSLASH: 191,
		GRAVE_ACCENT: 192,
		OPEN_BRACKET: 219,
		BACKSLASH: 220,
		CLOSE_BRACKET: 221,
		SINGLE_QUOTE: 222
	};
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
//# sourceMappingURL=KeyCodes.js.map

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(22);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _baUiCarbon = __webpack_require__(14);

var _baUiCarbonToolkit = __webpack_require__(3);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _CustomPalette = __webpack_require__(8);

var _CustomPalette2 = _interopRequireDefault(_CustomPalette);

var _DialogWrapper = __webpack_require__(35);

var _DialogWrapper2 = _interopRequireDefault(_DialogWrapper);

var _PaletteHelper = __webpack_require__(23);

var _PaletteHelper2 = _interopRequireDefault(_PaletteHelper);

var _arrowLeft_ = __webpack_require__(85);

var _arrowLeft_2 = _interopRequireDefault(_arrowLeft_);

var _add_ = __webpack_require__(86);

var _add_2 = _interopRequireDefault(_add_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* IBM Confidential
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OCO Source Materials
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: authoring-common
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2020, 2021
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * The source code for this program is not published or otherwise
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * divested of its trade secrets, irrespective of what has been
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * deposited with the U.S. Copyright Office.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * NLS_ENCODING=UTF-8
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * NLS_MESSAGEFORMAT_NONE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var PaletteListing = function (_Component) {
	_inherits(PaletteListing, _Component);

	// these are the anticipated props based on the ChangePaletteView options
	function PaletteListing(props) {
		_classCallCheck(this, PaletteListing);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		var selectedId = _this.props.selectedId;

		_this.state = {
			palettes: null,
			selectedId: selectedId
		};
		var _this$props = _this.props,
		    getPalettes = _this$props.getPalettes,
		    paletteService = _this$props.paletteService;

		_this.paletteHelper = new _PaletteHelper2.default({ paletteService: paletteService, getPalettesFn: getPalettes });
		return _this;
	}

	PaletteListing.prototype.componentDidUpdate = function componentDidUpdate() {
		var propSelectedId = this.props.selectedId;
		var stateSelectedId = this.state.selectedId;

		if (propSelectedId != stateSelectedId) {
			this.setState({ selectedId: propSelectedId });
		}
	};

	PaletteListing.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		this._registerPaletteServiceEvents();
		this.paletteHelper.getPaletteGroupBySections().then(function (palettes) {
			_this2.setState({
				palettes: palettes
			});
		});
	};

	PaletteListing.prototype.componentWillUnmount = function componentWillUnmount() {
		this._unregisterPaletteServiceEvents();
	};

	PaletteListing.prototype.render = function render() {
		var _this3 = this;

		if (!this.state.palettes) return null;
		var sections = [];
		var sectionOrder = this.paletteHelper.getPaletteSectionOrder();
		sectionOrder.forEach(function (section) {
			var open = false;
			var palettes = _this3.state.palettes[section].map(function (palette) {
				var fills = palette.content.fills.map(function (fill) {
					if (_this3.props.createPaletteType === 'continuous') {
						fill = fill.fill;
					}
					return _react2.default.createElement(_baUiCarbonToolkit.FlexItem, { className: 'clsPaletteListingBoxStyle', style: { backgroundColor: fill }, key: fill });
				});
				var className = 'clsPaletteListingPalette';
				if (palette.id === _this3.state.selectedId) {
					className += '_selected';
					open = true;
				}
				var menuItems = _this3.props.sectionMenuItems[section];
				var overFlow = null;
				if (menuItems && menuItems.length) {
					overFlow = _react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						null,
						_react2.default.createElement(
							_baUiCarbon.OverflowMenu,
							{ flipped: true, onClick: function onClick(event) {
									return event.stopPropagation();
								} },
							menuItems.map(function (menuItem) {
								return _react2.default.createElement(_baUiCarbon.OverflowMenuItem, {
									key: menuItem,
									itemText: _StringResources2.default.get(menuItem),
									onClick: function onClick(event) {
										return _this3._performPaletteAction(event, palette, menuItem);
									}
								});
							})
						)
					);
				}
				return _react2.default.createElement(
					'div',
					{ key: palette, className: className, onClick: _this3._selectPalette.bind(_this3, palette) },
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexLayout,
						{ justifyContent: 'space-between', alignItems: 'center' },
						_react2.default.createElement(
							_baUiCarbonToolkit.FlexItem,
							null,
							_react2.default.createElement(_baUiCarbonToolkit.Label, { label: palette.content.label, className: 'clsPaletteListingPalette_paletteLabel' })
						),
						overFlow
					),
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexLayout,
						{ wrap: 'wrap' },
						fills
					)
				);
			});
			if (palettes.length) {
				sections.push(_react2.default.createElement(
					_baUiCarbon.AccordionItem,
					{ open: open, title: _StringResources2.default.get(section + 'PaletteLabel'), className: 'clsPaletteListingAccordianItem' },
					palettes
				));
			}
		});
		var close = null;
		if (this.props.onClose) {
			close = _react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(_baUiCarbon.Button, {
					renderIcon: function renderIcon() {
						return _react2.default.createElement(_baUiCarbonToolkit.SVGIcon, {
							icon: _arrowLeft_2.default,
							className: 'clsPaletteListing_buttonSvg',
							height: 16,
							width: 16
						});
					},
					onClick: this.props.onClose,
					iconDescription: _StringResources2.default.get('back'),
					hasIconOnly: true,
					kind: 'ghost',
					size: 'small',
					style: { marginLeft: '12px' }
				})
			);
		}
		var createPalette = null;
		if (this.props.createPalette) {
			createPalette = _react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(_baUiCarbon.Button, {
					renderIcon: function renderIcon() {
						return _react2.default.createElement(_baUiCarbonToolkit.SVGIcon, {
							icon: _add_2.default,
							className: 'clsPaletteListing_buttonSvg',
							height: 16,
							width: 16
						});
					},
					onClick: this.props.createPalette,
					iconDescription: _StringResources2.default.get('createPalette'),
					hasIconOnly: true,
					kind: 'ghost',
					size: 'small',
					tooltipAlignment: 'end',
					style: { marginRight: '8px' }
				})
			);
		}
		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexLayout,
			{ direction: 'column', width: '100%' },
			close,
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexLayout,
					{ justifyContent: 'space-between' },
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						null,
						_react2.default.createElement(_baUiCarbonToolkit.Label, { label: this.props.headerText, className: 'clsPaletteListingPalette_headerLabel' })
					),
					createPalette
				)
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(
					_baUiCarbon.Accordion,
					null,
					sections
				)
			)
		);
	};

	PaletteListing.prototype._registerPaletteServiceEvents = function _registerPaletteServiceEvents() {
		if (!this._registered) {
			this.props.paletteService.on('palette:created', this._onPaletteCreated.bind(this), this);
			this.props.paletteService.on('palette:updated', this._onPaletteUpdate.bind(this), this);
			this.props.paletteService.on('palette:deleted', this._onPaletteDelete.bind(this), this);
			this._registered = true;
		}
	};

	PaletteListing.prototype._unregisterPaletteServiceEvents = function _unregisterPaletteServiceEvents() {
		if (this._registered) {
			this.props.paletteService.off('palette:created', this._onPaletteCreated, this);
			this.props.paletteService.off('palette:updated', this._onPaletteUpdate, this);
			this.props.paletteService.off('palette:deleted', this._onPaletteDelete, this);
		}
	};

	PaletteListing.prototype._selectPalette = function _selectPalette(palette) {
		this.props.onChange(palette);
	};

	PaletteListing.prototype._onPaletteUpdate = function _onPaletteUpdate() {
		var _this4 = this;

		var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var selectedId = this.state.selectedId;

		if (this.paletteHelper.isSamePaletteId(options.paletteId, selectedId)) {
			var onUpdatePalette = this.props.onUpdatePalette;

			var palette = this.paletteHelper.getPalette(selectedId);
			onUpdatePalette(palette);
		}
		this.paletteHelper.getPaletteGroupBySections().then(function (palettes) {
			_this4.setState({
				palettes: palettes
			});
		});
	};

	PaletteListing.prototype._onPaletteDelete = function _onPaletteDelete(options) {
		// @Brad not sure what is the goal here no not changing code
		var palettes = _extends({}, this.state.palettes);
		var matchedSection = null;

		var _loop = function _loop(sectionName) {
			var sectionPalettes = palettes[sectionName];
			var matchedPalette = sectionPalettes.find(function (candidatePalette) {
				if (_PaletteHelper2.default.isCustomPalette(candidatePalette.id)) {
					return candidatePalette.id == _PaletteHelper2.default.getCustomPaletteId(options.paletteId);
				}
				return candidatePalette.id == options.paletteId;
			});

			if (matchedPalette) {
				palettes[sectionName] = sectionPalettes.filter(function (p) {
					return p != matchedPalette;
				});
				matchedSection = sectionName;
				return 'break';
			}
		};

		for (var sectionName in palettes) {
			var _ret = _loop(sectionName);

			if (_ret === 'break') break;
		}
		if (options.paletteId != this.state.selectedId) {
			this.setState({ palettes: palettes });
		} else {
			var section = matchedSection || 'system';
			var palette = palettes[section].length ? palettes[section][0] : palettes['system'][0];
			this.setState({ palettes: palettes, selectedId: palette.id });
		}
		this.props.onDeletePalette(options.paletteId);
	};

	PaletteListing.prototype._onPaletteCreated = function _onPaletteCreated() {
		var _this5 = this;

		var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		return this.paletteHelper.refreshPalette().then(function (newPaletteList) {
			var newCMPaletteId = _PaletteHelper2.default.getCustomPaletteId(options.paletteId);
			var newPalette = _this5.paletteHelper.getPalette(newCMPaletteId);
			_this5.setState({
				palettes: newPaletteList,
				selectedId: newCMPaletteId
			});
			var onCreatePalette = _this5.props.onCreatePalette;

			onCreatePalette(newCMPaletteId, newPalette);
		});
	};

	PaletteListing.prototype._performPaletteAction = function _performPaletteAction(_event, palette, action) {
		_event.stopPropagation();
		switch (action) {
			case 'edit':
				_DialogWrapper2.default.show(_CustomPalette2.default, {
					paletteService: this.props.paletteService,
					paletteDef: palette.content,
					paletteId: palette.id,
					isDialogOpen: true,
					type: this.props.createGlobalPalettes ? 'global' : '',
					userClass: this.props.createGlobalPalettes ? 'admin' : '',
					paletteType: palette.content.type === 'continuous' ? 'continuous' : 'standard'
				});
				break;
			case 'delete':
				this.props.paletteService.deletePalette(palette.id);
				break;
			case 'duplicate':
				_DialogWrapper2.default.show(_CustomPalette2.default, {
					paletteService: this.props.paletteService,
					paletteDef: palette.content,
					isDialogOpen: true,
					type: this.props.createGlobalPalettes ? 'global' : '',
					userClass: this.props.createGlobalPalettes ? 'admin' : '',
					paletteType: palette.content.type === 'continuous' ? 'continuous' : 'standard'
				});
				break;
			default:
				break;
		}
	};

	return PaletteListing;
}(_react.Component);

PaletteListing.propTypes = {
	paletteService: _propTypes2.default.object.isRequired, // was glass context
	getPalettes: _propTypes2.default.func.isRequired,
	createPalette: _propTypes2.default.func,
	headerText: _propTypes2.default.string,
	onChange: _propTypes2.default.func.isRequired,
	/** callback function to call when a palette get updated */
	onUpdatePalette: _propTypes2.default.func.isRequired,
	/** callback function to call when a new custom palette get created */
	onCreatePalette: _propTypes2.default.func.isRequired,
	/** callback function to call when a palette get deleted */
	onDeletePalette: _propTypes2.default.func.isRequired,
	onClose: _propTypes2.default.func,
	mruComponentIdentifier: _propTypes2.default.string.isRequired, // was component
	selectedId: _propTypes2.default.string,
	createPaletteType: _propTypes2.default.string,
	showRecentlyUsed: _propTypes2.default.bool,
	createGlobalPalettes: _propTypes2.default.bool, // was isAdminUI
	sectionMenuItems: _propTypes2.default.object // was menuItems
};
PaletteListing.defaultProps = {
	sectionMenuItems: {
		'custom': ['edit', 'duplicate', 'delete'],
		'local': ['duplicate'],
		'global': ['duplicate'],
		'system': ['duplicate'],
		'legacy': []
	},
	headerText: _StringResources2.default.get('manageColorPalettes'),
	onUpdatePalette: function onUpdatePalette() {},
	onCreatePalette: function onCreatePalette() {},
	onDeletePalette: function onDeletePalette() {}
};
exports.default = (0, _mobxReact.observer)(PaletteListing);

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getColorStyle = getColorStyle;
/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

// This code is taking from vis-conditional-formatting Git Repo src/js/utils/ColorUtil.ts
function getColorStyle(color, backgroundColor, pattern) {
	var style = {};
	var backgroundStyle = [];

	if (color) {
		style.color = color;
	}
	if (backgroundColor) {
		backgroundStyle.push(backgroundColor);
	}
	if (pattern) {
		backgroundStyle.push('url(\'dashboard-core/images/patterns/' + pattern + '.svg\')');
		style.backgroundRepeat = 'repeat';
		var textShadows = [[2, 2, 2], [2, -2, 2], [2, 0, 2], [-2, 2, 2], [-2, -2, 2], [-2, 0, 2], [0, 2, 2], [0, -2, 2], [0, 0, 2]];
		style['text-shadow'] = textShadows.map(function (shadow) {
			return shadow.join('px ') + 'px #ffffff';
		}).join(',');
	}
	if (backgroundStyle.length > 0) {
		if (pattern) {
			style.background = backgroundStyle.join(' ');
		} else {
			style.backgroundColor = backgroundStyle[0];
		}
	}

	return style;
}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getColorStyle = exports.ColorConversion = exports.QuickPaletteSelection = exports.PaletteListingView = exports.PalettePicker = exports.PaletteListing = exports.ColorPicker = exports.DialogWrapper = exports.SchematicEditor = exports.ChangePaletteView = exports.CustomPalette = exports.CustomColorDialog = undefined;

var _CustomColorDialog = __webpack_require__(24);

var _CustomColorDialog2 = _interopRequireDefault(_CustomColorDialog);

var _CustomPalette = __webpack_require__(8);

var _CustomPalette2 = _interopRequireDefault(_CustomPalette);

var _ChangePaletteView = __webpack_require__(54);

var _ChangePaletteView2 = _interopRequireDefault(_ChangePaletteView);

var _SchematicEditor = __webpack_require__(64);

var _SchematicEditor2 = _interopRequireDefault(_SchematicEditor);

var _DialogWrapper = __webpack_require__(35);

var _DialogWrapper2 = _interopRequireDefault(_DialogWrapper);

var _ColorPicker = __webpack_require__(83);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

var _PaletteListing = __webpack_require__(37);

var _PaletteListing2 = _interopRequireDefault(_PaletteListing);

var _PalettePicker = __webpack_require__(87);

var _PalettePicker2 = _interopRequireDefault(_PalettePicker);

var _PaletteListingView = __webpack_require__(88);

var _PaletteListingView2 = _interopRequireDefault(_PaletteListingView);

var _QuickPaletteSelection = __webpack_require__(90);

var _QuickPaletteSelection2 = _interopRequireDefault(_QuickPaletteSelection);

var _ColorConversion = __webpack_require__(11);

var _ColorConversion2 = _interopRequireDefault(_ColorConversion);

var _ColorUtil = __webpack_require__(38);

__webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.CustomColorDialog = _CustomColorDialog2.default;
exports.CustomPalette = _CustomPalette2.default;
exports.ChangePaletteView = _ChangePaletteView2.default;
exports.SchematicEditor = _SchematicEditor2.default;
exports.DialogWrapper = _DialogWrapper2.default;
exports.ColorPicker = _ColorPicker2.default;
exports.PaletteListing = _PaletteListing2.default;
exports.PalettePicker = _PalettePicker2.default;
exports.PaletteListingView = _PaletteListingView2.default;
exports.QuickPaletteSelection = _QuickPaletteSelection2.default;
exports.ColorConversion = _ColorConversion2.default;
exports.getColorStyle = _ColorUtil.getColorStyle; /*
                                                   *+------------------------------------------------------------------------+
                                                   *| Licensed Materials - Property of IBM
                                                   *| IBM Cognos Products: BI
                                                   *| (C) Copyright IBM Corp. 2018, 2021
                                                   *|
                                                   *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                   *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                   *+------------------------------------------------------------------------+
                                                   */

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(15);
var invariant = __webpack_require__(16);
var warning = __webpack_require__(25);
var assign = __webpack_require__(41);

var ReactPropTypesSecret = __webpack_require__(17);
var checkPropTypes = __webpack_require__(42);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== 'production') {
  var invariant = __webpack_require__(16);
  var warning = __webpack_require__(25);
  var ReactPropTypesSecret = __webpack_require__(17);
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(15);
var invariant = __webpack_require__(16);
var ReactPropTypesSecret = __webpack_require__(17);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _baUiCarbonToolkit = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var RgbSlider = function (_PureComponent) {
	_inherits(RgbSlider, _PureComponent);

	function RgbSlider() {
		_classCallCheck(this, RgbSlider);

		return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	}

	RgbSlider.prototype.render = function render() {
		var _this2 = this;

		var sliderId = 'id' + (this.props.color.charAt(0).toUpperCase() + this.props.color.slice(1)) + 'Range';
		var max = this.props.selectedColorType == 'RGB' ? 255 : this.props.color == 'Hue' ? 360 : 100;

		return _react2.default.createElement(
			'div',
			{ className: 'clsRgbWrapper' },
			_react2.default.createElement(_baUiCarbonToolkit.Slider, {
				light: true,
				id: sliderId,
				showBoundaryLabels: true,
				value: this.props.value,
				labelText: _StringResources2.default.get('code'.concat(this.props.color)),
				onChange: function onChange(value) {
					return _this2.props.onChange(parseInt(value), _this2.props.color);
				},
				min: 0,
				max: max,
				hideTextInput: false,
				className: 'clsRgbSlider'
			})
		);
	};

	return RgbSlider;
}(_react.PureComponent);

RgbSlider.propTypes = {
	color: _propTypes2.default.string,
	onChange: _propTypes2.default.func,
	selectedColorType: _propTypes2.default.string,
	value: _propTypes2.default.int
};
exports.default = RgbSlider;

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = {"Red 100":"2d0709","Red 90":"520408","Red 80":"750e13","Red 70":"a2191f","Red 60":"da1e28","Red 50":"fa4d56","Red 40":"ff8389","Red 30":"ffb3b8","Red 20":"ffd7d9","Red 10":"fff1f1","Magenta 100":"2a0a18","Magenta 90":"510224","Magenta 80":"740937","Magenta 70":"9f1853","Magenta 60":"d12771","Magenta 50":"ee5396","Magenta 40":"ff7eb6","Magenta 30":"ffafd2","Magenta 20":"ffd6e8","Magenta 10":"fff0f7","Purple 100":"1c0f30","Purple 90":"31135e","Purple 80":"491d8b","Purple 70":"6929c4","Purple 60":"8a3ffc","Purple 50":"a56eff","Purple 40":"be95ff","Purple 30":"d4bbff","Purple 20":"e8Daff","Purple 10":"f6f2ff","Blue 100":"001141","Blue 90":"001d6c","Blue 80":"002d9c","Blue 70":"0043ce","Blue 60":"0f62fe","Blue 50":"4589ff","Blue 40":"78a9ff","Blue 30":"a6c8ff","Blue 20":"d0e2ff","Blue 10":"edf5ff","Cyan 100":"061727","Cyan 90":"012749","Cyan 80":"003a6d","Cyan 70":"00539a","Cyan 60":"0072c3","Cyan 50":"1192e8","Cyan 40":"33b1ff","Cyan 30":"82cfff","Cyan 20":"bae6ff","Cyan 10":"e5f6ff","Teal 100":"081a1c","Teal 90":"022b30","Teal 80":"004144","Teal 70":"005d5d","Teal 60":"007d79","Teal 50":"009d9a","Teal 40":"08bdba","Teal 30":"3ddbd9","Teal 20":"9ef0f0","Teal 10":"d9fbfb","Green 100":"071908","Green 90":"022d0d","Green 80":"044317","Green 70":"0e6027","Green 60":"198038","Green 50":"24a148","Green 40":"42be65","Green 30":"6fdc8c","Green 20":"a7F0ba","Green 10":"defbe6","Cool Gray 100":"121619","Cool Gray 90":"21272a","Cool Gray 80":"343a3f","Cool Gray 70":"4d5358","Cool Gray 60":"697077","Cool Gray 50":"878d96","Cool Gray 40":"a2a9b0","Cool Gray 30":"c1c7cd","Cool Gray 20":"dde1E6","Cool Gray 10":"f2f4f8","Gray 100":"161616","Gray 90":"262626","Gray 80":"393939","Gray 70":"525252","Gray 60":"6f6f6f","Gray 50":"8d8d8d","Gray 40":"a8a8a8","Gray 30":"c6c6c6","Gray 20":"e0e0e0","Gray 10":"f4f4f4","Warm Gray 100":"171414","Warm Gray 90":"272525","Warm Gray 80":"3c3838","Warm Gray 70":"565151","Warm Gray 60":"736f6f","Warm Gray 50":"8f8b8b","Warm Gray 40":"ada8a8","Warm Gray 30":"cac5c4","Warm Gray 20":"e5e0df","Warm Gray 10":"f7f3f2","Yellow 100":"1c1500","Yellow 90":"302400","Yellow 80":"483700","Yellow 70":"684e00","Yellow 60":"8e6a00","Yellow 50":"b28600","Yellow 40":"d2a106","Yellow 30":"f1c21b","Yellow 20":"fddc69","Yellow 10":"fcf4d6","Orange 100":"231000","Orange 90":"3e1a00","Orange 80":"5e2900","Orange 70":"8a3800","Orange 60":"ba4e00","Orange 50":"eb6200","Orange 40":"ff832b","Orange 30":"ffb784","Orange 20":"ffd9Be","Orange 10":"fff2e8"}

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(7);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _baUiCarbonToolkit = __webpack_require__(3);

__webpack_require__(4);

var _delete_ = __webpack_require__(31);

var _delete_2 = _interopRequireDefault(_delete_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var DEFAULT_FAVORITES = 12;

var Favorites = function (_Component) {
	_inherits(Favorites, _Component);

	function Favorites(props) {
		_classCallCheck(this, Favorites);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.numberOfFavorites = props.numberOfFavorites ? props.numberOfFavorites : DEFAULT_FAVORITES;
		_this.currentFavorite = null;
		_this.state = {
			favoriteColors: props.favoriteColors
		};
		return _this;
	}

	/**
 	 * Create a view that will show the user his favorite colors, and allow him to choose and delete
 	 * @param {array} options.updateColor - {Optional} callback when a favorite color is selected.
 	 * @param {array} options.favoriteColors - {REQUIRED} Favorite colors previously saved
 	 * @param {integer} options.numberOfFavorites - {Optional} Max number of favorites possible, by default 12.
 */

	Favorites.prototype.onDeleteFavorite = function onDeleteFavorite() {
		//last one
		var index = this.state.favoriteColors.length - 1;
		if (this.currentFavorite) {
			index = this.currentFavorite.getAttribute('favoriteIndex');
			this.deselectCurrentFavorite();
		}
		var colors = this.state.favoriteColors;
		colors.splice(index, 1);
		this.setState({
			favoriteColors: colors
		});
	};

	Favorites.prototype.handleKeyDown = function handleKeyDown(e, handler) {
		if (e.which === 13 || e.which === 32) {
			handler(e);
		}
	};

	Favorites.prototype.deselectCurrentFavorite = function deselectCurrentFavorite() {
		if (this.isFavoriteSelected()) {
			this.currentFavorite.classList.remove('selected');
			this.currentFavorite = null;
		}
	};

	Favorites.prototype.isFavoriteSelected = function isFavoriteSelected() {
		return !!this.currentFavorite;
	};

	Favorites.prototype.updateSelectedColor = function updateSelectedColor(color) {
		var colors = this.state.favoriteColors;
		colors[this.getSelectedIndex()] = color;
		this.setState({
			favoriteColors: colors
		});
	};

	Favorites.prototype.getSelectedIndex = function getSelectedIndex() {
		if (this.isFavoriteSelected()) {
			return this.currentFavorite.getAttribute('favoriteIndex');
		}
	};

	Favorites.prototype.getSelectedColor = function getSelectedColor() {
		if (this.isFavoriteSelected()) {
			return this.currentFavorite.getAttribute('value');
		}
	};

	Favorites.prototype.selectFavorite = function selectFavorite(element) {
		if (element.target.classList.contains('selected')) {
			this.currentFavorite = null;
		} else {
			this.deselectCurrentFavorite();
			this.currentFavorite = element.target;
		}
		element.target.classList.toggle('selected');
		if (this.props.updateColor) {
			this.props.updateColor(this.getSelectedColor());
		}
	};

	Favorites.prototype.getFavoriteColors = function getFavoriteColors() {
		return this.state.favoriteColors;
	};

	Favorites.prototype.getFavorite = function getFavorite(i, color) {
		var _this2 = this;

		if (color) {
			return _react2.default.createElement('div', { className: 'favoriteBox filled', key: i, tabIndex: '0', favoriteIndex: i, value: color, onKeyDown: function onKeyDown(e) {
					return _this2.handleKeyDown(e, _this2.selectFavorite.bind(_this2));
				}, onClick: function onClick(e) {
					return _this2.selectFavorite(e);
				}, style: { backgroundColor: color } });
		} else {
			return _react2.default.createElement('div', { className: 'favoriteBox', key: i, favoriteIndex: i });
		}
	};

	Favorites.prototype.generateFavorites = function generateFavorites() {
		//TODO Get CM colors
		var favorites = [];
		for (var i = 0; i < this.numberOfFavorites; i++) {
			var color = i < this.state.favoriteColors.length ? this.state.favoriteColors[i] : undefined;
			favorites.push(this.getFavorite(i, color));
		}
		return favorites;
	};

	Favorites.prototype.render = function render() {
		var _this3 = this;

		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexLayout,
			{ className: 'favoriteColors', direction: 'column' },
			_react2.default.createElement(_baUiCarbonToolkit.Label, { className: 'favoritesLabel', label: _StringResources2.default.get('favoritesLabel') }),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexLayout,
				{ className: 'favoritesPicker', inline: true, direction: 'row' },
				this.generateFavorites(),
				_react2.default.createElement(_baUiCarbonToolkit.SVGIcon, { className: 'deleteFavorite', size: 'small', iconId: _delete_2.default.id, tabIndex: '0', onKeyDown: function onKeyDown(e) {
						return _this3.handleKeyDown(e, _this3.onDeleteFavorite.bind(_this3));
					}, onClick: this.onDeleteFavorite.bind(this) })
			)
		);
	};

	return Favorites;
}(_react.Component);

Favorites.propTypes = {
	updateColor: _propTypes2.default.func,
	favoriteColors: _propTypes2.default.array.isRequired,
	numberOfFavorites: _propTypes2.default.number
};
exports.default = Favorites;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(48)(false);
// imports


// module
exports.push([module.i, "/**\n * Licensed Materials - Property of IBM\n * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2021\n * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.\n */\n\n/**\n * Licensed Materials - Property of IBM\n * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018\n * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.\n */\n\n#dummyId {\n  background-color: white;\n}\n\n/**\n * Licensed Materials - Property of IBM\n * IBM Cognos Products: BI\n * (C) Copyright IBM Corp. 2018\n * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.\n */\n\n.clsSteppedSwatchContainer {\n  overflow: auto;\n  margin-top: 8px;\n  height: 32px;\n}\n\n.clsSwatchContainer {\n  overflow: auto;\n  margin-top: 8px;\n  width: 450px;\n  height: 40px;\n}\n\n.clsSwatchStyle,\n.clsSwatchStyle_empty,\n.clsSwatchStyle_filled,\n.clsSwatchStyle_filled_light,\n.clsSwatchStyle_empty_selected,\n.clsSwatchStyle_filled_selected,\n.clsVisualItem_empty {\n  height: 24px;\n  padding: 0;\n  width: 24px;\n  margin: 4px 5px;\n}\n\n.clsSwatchStyle_empty,\n.clsSwatchStyle_filled,\n.clsSwatchStyle_filled_light {\n  border: 1px dashed;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.clsSwatchStyle_empty:hover,\n.clsSwatchStyle_filled:hover,\n.clsSwatchStyle_filled_light:hover {\n  box-shadow: 0 0 0 2px hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1), 0 0 0 3px hsla(var(--hover-secondary-h, 0), var(--hover-secondary-s, 0%), var(--hover-secondary-l, 29.80392%), 1);\n}\n\n.clsSwatchStyle_empty_selected {\n  border: 2px solid;\n  border-color: #393939;\n  border-color: hsla(var(--interactive-02-h, 0), var(--interactive-02-s, 0%), var(--interactive-02-l, 22.35294%), 1);\n}\n\n.clsSwatchStyle_filled {\n  border: none;\n}\n\n.clsSwatchStyle_filled_light {\n  border: 1px solid;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.clsSwatchStyle_filled_selected {\n  border: 2px solid;\n  box-shadow: inset 0 0 0 2px hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n  border-color: #393939;\n  border-color: hsla(var(--interactive-02-h, 0), var(--interactive-02-s, 0%), var(--interactive-02-l, 22.35294%), 1);\n}\n\n.clsSwatchOutline_continuous_stepped {\n  border: 1px solid;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.clsSwatchStyle_continuous,\n.clsSwatchStyle_continuous_unselected,\n.clsSwatchStyle_continuous_unselected_light,\n.clsSwatchStyle_continuous_selected {\n  height: 24px;\n  padding: 0;\n  width: 40px;\n}\n\n.clsSwatchStyle_continuous_unselected:hover:before,\n.clsSwatchStyle_continuous_unselected_light:hover:before {\n  content: '';\n  position: absolute;\n  border: 1px solid;\n  height: 28px;\n  width: 40px;\n  box-shadow: inset 0 0 0 2px hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 50%), 1);\n  margin-top: -2px;\n}\n\n.clsSwatchStyle_continuous_unselected_light {\n  border: 1px solid;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.clsSwatchStyle_continuous_selected {\n  border: 2px solid;\n  box-shadow: inset 0 0 0 2px hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n  border-color: #393939;\n  border-color: hsla(var(--interactive-02-h, 0), var(--interactive-02-s, 0%), var(--interactive-02-l, 22.35294%), 1);\n}\n\n.clsColorBoxStyle,\n.clsColorBoxStyle_white {\n  margin-right: 7px;\n  margin-bottom: 7px;\n  width: 25px;\n  height: 25px;\n}\n\n.clsColorBoxStyle_white {\n  border: 1px solid;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.clsPaletteIcons_wrapper,\n.clsPaletteIcons_wrapper_selected {\n  padding-bottom: 3px;\n  margin: 0 8px;\n}\n\n.clsPaletteIcons_wrapper_selected {\n  box-shadow: 0 2px hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n}\n\n.clsPaletteIcons,\n.clsPaletteStandard,\n.clsPaletteGradient {\n  margin-top: 10px;\n  box-sizing: border-box;\n  width: 22px;\n  height: 22px;\n  border: 2px solid;\n  border-color: #8d8d8d;\n  border-color: hsla(var(--ui-04-h, 0), var(--ui-04-s, 0%), var(--ui-04-l, 55.29412%), 1);\n}\n\n.clsPaletteStandard {\n  background-color: #e0e0e0;\n  background-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.clsPaletteGradient {\n  background: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, black 100%);\n}\n\n.clsWheelContainer {\n  cursor: pointer;\n}\n\n.clsPickerWrapper {\n  height: 24px;\n  width: 24px;\n  top: 0;\n  left: 0;\n  position: relative;\n}\n\n.clsWheelSelector {\n  border: 2px solid;\n  border-color: #393939;\n  border-color: hsla(var(--interactive-02-h, 0), var(--interactive-02-s, 0%), var(--interactive-02-l, 22.35294%), 1);\n  border-radius: 50%;\n  box-shadow: inset 0 0 0 2px hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n  background-color: transparent;\n}\n\n.clsPreviewBox {\n  margin-left: 8px;\n  height: 40px;\n  width: 40px;\n  position: relative;\n  border: 1px solid;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.clsSelector {\n  border: 2px solid;\n  border-color: #393939;\n  border-color: hsla(var(--interactive-02-h, 0), var(--interactive-02-s, 0%), var(--interactive-02-l, 22.35294%), 1);\n  height: 24px;\n  width: 24px;\n  border-radius: 50%;\n  box-shadow: inset 0 0 0 2px hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n  transition: 150ms;\n}\n\n.clsContinuousIndicatorContainer {\n  width: 32px;\n  height: 32px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n\n.clsContinuousIndicator {\n  border: 2px solid;\n  border-color: #8d8d8d;\n  border-color: hsla(var(--ui-04-h, 0), var(--ui-04-s, 0%), var(--ui-04-l, 55.29412%), 1);\n  border-radius: 50%;\n  height: 16px;\n  width: 16px;\n  box-shadow: inset 0 0 0 1px hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1), inset 0 0 0 2px hsla(var(--hover-secondary-h, 0), var(--hover-secondary-s, 0%), var(--hover-secondary-l, 29.80392%), 1);\n}\n\n.clsContinuousIndicator:hover {\n  height: 24px;\n  width: 24px;\n  transition: 150ms;\n}\n\n.clsContinuousPreview {\n  width: 97%;\n  height: 32px;\n  border: 1px solid;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n\n.clsContinuousPreviewRoundLeft {\n  border-radius: 16px 0px 0px 16px;\n}\n\n.clsContinuousPreviewRoundRight {\n  border-radius: 0px 16px 16px 0px;\n}\n\n.clsRgbWrapper {\n  margin-top: 16px;\n}\n\n.clsRgbWrapper .clsRgbSlider {\n  width: 71px;\n  min-width: 71px;\n  margin: 12px;\n}\n\n.clsErrorMessage {\n  color: red;\n  font-size: 0.75rem;\n}\n\n.clsButtonSeparator {\n  color: #161616;\n  color: hsla(var(--ui-05-h, 0), var(--ui-05-s, 0%), var(--ui-05-l, 8.62745%), 1);\n}\n\n/**\n * Licensed Materials - Property of IBM\n * IBM Cognos Products: BI\n * (C) Copyright IBM Corp. 2018\n * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.\n */\n\n.favoriteColors .favoritesLabel {\n  margin: 0px 0px 8px 8px;\n}\n\n.favoriteColors .deleteFavorite {\n  margin-left: 16px;\n  -ms-flex-item-align: center;\n      -ms-grid-row-align: center;\n      align-self: center;\n}\n\n.favoriteColors .favoriteBox {\n  border: 2px dashed;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n  height: 24px;\n  padding: 0;\n  width: 24px;\n  float: left;\n  margin-left: 8px;\n}\n\n.favoriteColors .favoriteBox.filled {\n  border-style: solid;\n}\n\n.favoriteColors .favoriteBox.selected {\n  border-color: #161616;\n  border-color: hsla(var(--ui-05-h, 0), var(--ui-05-s, 0%), var(--ui-05-l, 8.62745%), 1);\n}\n\n.addFavorite {\n  margin-right: 8px;\n}\n\n/**\n * Licensed Materials - Property of IBM\n * IBM Cognos Products: BI\n * (C) Copyright IBM Corp. 2019\n * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.\n */\n\n#schematicEditorToastTargetId .ba-common-globaltoast {\n  position: absolute;\n  width: 56%;\n  left: 22%;\n}\n\n.clsSVGEditorTabs .ba-common-tabList__item.is-label {\n  min-width: 120px;\n}\n\n.clsSVGSearch .ba-common-baseInput {\n  width: 288px;\n}\n\n.clsSVGTileStyle,\n.clsSVGTileStyle_selected {\n  background-color: white;\n  background-color: hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n}\n\n.clsSVGTileStyle:hover,\n.clsSVGTileStyle_selected:hover {\n  background-color: #e5e5e5;\n  background-color: hsla(var(--hover-ui-h, 0), var(--hover-ui-s, 0%), var(--hover-ui-l, 89.80392%), 1);\n}\n\n.clsSVGTileStyleContainer {\n  margin-left: 16px;\n  margin-top: 16px;\n}\n\n.clsSVGTileStyle_selected {\n  outline: 1px solid;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--selected-ui-h, 0), var(--selected-ui-s, 0%), var(--selected-ui-l, 87.84314%), 1);\n}\n\n.clsSVGTilesStyle {\n  overflow: auto;\n  height: 491px;\n  width: 100%;\n  background-color: #f4f4f4;\n  background-color: hsla(var(--ui-02-h, 0), var(--ui-02-s, 0%), var(--ui-02-l, 95.68627%), 1);\n  text-align: center;\n}\n\n.clsSVGTileStyleBase,\n.clsSVGTileStyle .clsSVGCheckmarkSelected,\n.clsSVGTileStyle_selected .clsSVGCheckmarkSelected {\n  transition: 110ms cubic-bezier(0.2, 0, 0.38, 0.9);\n}\n\n.clsSVGTileStyle .clsSVGCheckmarkSelected,\n.clsSVGTileStyle_selected .clsSVGCheckmarkSelected {\n  opacity: 0;\n}\n\n.clsSVGTileStyle_selected .clsSVGCheckmarkSelected {\n  opacity: 1;\n}\n\n.clsSVGTileCheckmark {\n  padding-top: 16px;\n  padding-right: 16px;\n}\n\n.clsSVGTabsStyle {\n  padding-top: 16px;\n  height: 594px;\n  box-sizing: border-box;\n}\n\n.clsSVGDetailContainer {\n  background-color: #f4f4f4;\n  background-color: hsla(var(--ui-02-h, 0), var(--ui-02-s, 0%), var(--ui-02-l, 95.68627%), 1);\n  padding: 16px;\n}\n\n.clsSVGPackageEdit .ba-common-baseInput,\n.clsSVGPackageEdit .ba-common-textArea > textarea {\n  width: 420px;\n}\n\n.clsSVGDetailEdit,\n.clsSVGDetailEdit .ba-common-baseInput,\n.clsSVGPackageEdit .ba-common-baseInput {\n  width: 100%;\n}\n\n.clsSVGFileTypeLabel {\n  color: #525252;\n  color: hsla(var(--text-02-h, 0), var(--text-02-s, 0%), var(--text-02-l, 32.15686%), 1);\n}\n\n.clsSVGFileSizeLabel {\n  color: #525252;\n  color: hsla(var(--text-02-h, 0), var(--text-02-s, 0%), var(--text-02-l, 32.15686%), 1);\n}\n\n.clsSVGDetailsPanel [for=\"packageNameEdit\"] {\n  color: #525252;\n  color: hsla(var(--text-02-h, 0), var(--text-02-s, 0%), var(--text-02-l, 32.15686%), 1);\n}\n\n.clsSVGPackageEdit [for=\"packageDescriptionEdit\"] {\n  font-size: 0.875rem;\n}\n\n.clsSVGDetailEdit input,\n.clsSVGPackageEdit input,\n.clsSVGPackageEdit .ba-common-textArea > textarea {\n  box-sizing: border-box;\n}\n\n.clsSVGDetailStyle {\n  height: 216px;\n  width: 237px;\n  background-color: white;\n  background-color: hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n}\n\n.clsSVGTileStyleMenu {\n  height: 16px;\n}\n\n.clsSVGTileStyleMenu .svgIcon {\n  color: #a8a8a8;\n  color: hsla(var(--text-03-h, 0), var(--text-03-s, 0%), var(--text-03-l, 65.88235%), 1);\n}\n\n.clsSVGTileStyleMenu .clsSVGTileStyleMenuAnchor {\n  padding-right: 4px;\n}\n\n.clsSVGTileStyleMenu:hover .svgIcon {\n  color: #e0e0e0;\n  color: hsla(var(--selected-ui-h, 0), var(--selected-ui-s, 0%), var(--selected-ui-l, 87.84314%), 1);\n}\n\n.clsVisualItem_empty {\n  border: 1px dashed;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.clsVisualItem_empty:hover {\n  box-shadow: 0 0 0 2px hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1), 0 0 0 4px hsla(var(--hover-secondary-h, 0), var(--hover-secondary-s, 0%), var(--hover-secondary-l, 29.80392%), 1);\n}\n\n.clsSVGIconPanel,\n.clsSVGDropZone {\n  width: 300px;\n}\n\n.clsSVGDetailsPanel {\n  width: 420px;\n  box-sizing: border-box;\n}\n\n.clsSVGIconRow {\n  height: 48px;\n  width: 410px;\n  background-color: #f4f4f4;\n  background-color: hsla(var(--ui-background-h, 0), var(--ui-background-s, 0%), var(--ui-background-l, 95.68627%), 1);\n}\n\n#svgIconFL {\n  width: 48px;\n  height: 48px;\n}\n\n#svgIconFI {\n  margin: 4px;\n  width: 40px;\n  height: 40px;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.clsSVGDropZone {\n  height: 100%;\n  border: 1px dashed;\n  border-color: #8d8d8d;\n  border-color: hsla(var(--ui-04-h, 0), var(--ui-04-s, 0%), var(--ui-04-l, 55.29412%), 1);\n}\n\n.clsSVGDropZone.dragging {\n  outline: 2px solid;\n  outline-offset: -1px;\n  outline-color: #0f62fe;\n  outline-color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n}\n\n.clsSVGDropZone.dragging a {\n  text-decoration: underline;\n}\n\n.clsSVGDndOverlay {\n  position: absolute;\n  width: 300px;\n  height: 100%;\n  z-index: 1;\n  display: none;\n}\n\n#schematicEditorFooterId {\n  margin-top: 24px;\n}\n\n.clsSVGPackageIcon {\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n  font-weight: bold;\n}\n\n.clsColorPicker {\n  position: relative;\n}\n\n.clsColorPicker_button {\n  border: 1px solid;\n  border-color: #8d8d8d;\n  border-color: hsla(var(--ui-04-h, 0), var(--ui-04-s, 0%), var(--ui-04-l, 55.29412%), 1);\n  min-width: 16px;\n  width: 16px;\n  min-height: 16px;\n  height: 16px;\n  padding: 0;\n}\n\n.clsColorPicker_flyout {\n  background-color: #f4f4f4;\n  background-color: hsla(var(--ui-02-h, 0), var(--ui-02-s, 0%), var(--ui-02-l, 95.68627%), 1);\n  width: 234px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-pack: start;\n      justify-content: flex-start;\n  padding: 24px;\n  -ms-high-contrast-adjust: none;\n}\n\n.clsColorPicker_flyoutContent > div:not(:last-child) {\n  padding-bottom: 8px;\n}\n\n.clsColorPicker_cell {\n  width: 16px;\n  height: 16px;\n  margin: 2px;\n  border: 1px solid;\n  border-color: #8d8d8d;\n  border-color: hsla(var(--ui-04-h, 0), var(--ui-04-s, 0%), var(--ui-04-l, 55.29412%), 1);\n}\n\n.clsColorPicker_cell:hover {\n  cursor: pointer;\n}\n\n.clsColorPicker_paletteHeader {\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n\n.clsColorPicker_paletteContent {\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n\n.clsColorPicker_selected_indicator {\n  margin: 2px;\n  border: 2px solid;\n  border-color: #393939;\n  border-color: hsla(var(--interactive-02-h, 0), var(--interactive-02-s, 0%), var(--interactive-02-l, 22.35294%), 1);\n  height: 16px;\n  width: 16px;\n  border-radius: 50%;\n  box-shadow: inset 0 0 0 2px hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n  transition: 150ms;\n}\n\n.clsColorPicker_restoreDefault {\n  -ms-flex-item-align: center;\n      -ms-grid-row-align: center;\n      align-self: center;\n  margin-right: 6px;\n  color: #0353e9;\n  color: hsla(var(--hover-primary-h, 219.13043), var(--hover-primary-s, 97.45763%), var(--hover-primary-l, 46.27451%), 1);\n}\n\n.clsPaletteListingAccordianItem > div {\n  padding: 0px;\n}\n\n.clsPaletteListingBoxStyle {\n  margin-right: 4px;\n  margin-bottom: 4px;\n  width: 16px;\n  height: 16px;\n}\n\n.clsPaletteListingPalette {\n  border-left: 4px solid;\n  padding-left: 15.5px;\n  border-color: white;\n  border-color: hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n}\n\n.clsPaletteListingPalette:hover {\n  border-color: #e0e0e0;\n  border-color: hsla(var(--selected-ui-h, 0), var(--selected-ui-s, 0%), var(--selected-ui-l, 87.84314%), 1);\n  background-color: #e0e0e0;\n  background-color: hsla(var(--selected-ui-h, 0), var(--selected-ui-s, 0%), var(--selected-ui-l, 87.84314%), 1);\n}\n\n.clsPaletteListingPalette_selected {\n  border-left: 4px solid;\n  padding-left: 15.5px;\n  border-color: #0f62fe;\n  border-color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n  background-color: #e0e0e0;\n  background-color: hsla(var(--selected-ui-h, 0), var(--selected-ui-s, 0%), var(--selected-ui-l, 87.84314%), 1);\n}\n\n.clsPaletteListingPalette_headerLabel {\n  padding-left: 16px;\n  margin-bottom: 16px;\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n  font-size: 1.25rem;\n  font-weight: 400;\n  line-height: 1.4;\n  letter-spacing: 0;\n}\n\n.clsPaletteListingPalette_paletteLabel {\n  min-height: 32px;\n  padding-top: 6px;\n}\n\n.clsPaletteListing_buttonSvg {\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n}\n\n/**\n * Licensed Materials - Property of IBM\n * IBM Cognos Products: BI Dashboard\n * (C) Copyright IBM Corp. 2021\n * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.\n */\n\n.authoring-quick-palette-container {\n  color: #525252;\n  color: hsla(var(--icon-02-h, 0), var(--icon-02-s, 0%), var(--icon-02-l, 32.15686%), 1);\n}\n\n.authoring-quick-palette-container .authoring-quick-palette-label {\n  -ms-flex: 1;\n      flex: 1;\n  color: #525252;\n  color: hsla(var(--icon-02-h, 0), var(--icon-02-s, 0%), var(--icon-02-l, 32.15686%), 1);\n}\n\n/**\n * Licensed Materials - Property of IBM\n * IBM Cognos Products: BI Dashboard\n * (C) Copyright IBM Corp. 2021\n * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.\n */\n\n.authoring-palette-dropdown {\n  cursor: default;\n}\n\n.authoring-palette-dropdown .authoring-palette-dropdown-palette {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n\n.authoring-palette-dropdown .authoring-palette-dropdown-palette .authoring-palette-dropdown-palette-color {\n  box-sizing: border-box;\n  width: 17px;\n  height: 17px;\n  border: 1px solid #DCDCDC;\n  position: relative;\n  margin-right: 2px;\n  margin-bottom: 2px;\n}\n\n.authoring-palette-dropdown .bx--list-box__menu .bx--list-box__menu-item .authoring-palette-dropdown-option-label {\n  color: #525252;\n  color: hsla(var(--icon-02-h, 0), var(--icon-02-s, 0%), var(--icon-02-l, 32.15686%), 1);\n  margin-bottom: 4px;\n}\n\n.authoring-palette-dropdown .bx--list-box__menu .bx--list-box__menu-item .authoring-palette-dropdown-manage-color-palette {\n  color: #0f62fe;\n  color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n}\n\n.authoring-palette-dropdown .bx--list-box__menu .bx--list-box__menu-item .authoring-palette-dropdown-option-label,\n.authoring-palette-dropdown .bx--list-box__menu .bx--list-box__menu-item .authoring-palette-dropdown-manage-color-palette {\n  font-size: 0.75rem;\n  line-height: 1rem;\n  letter-spacing: 0.02rem;\n}\n\n.authoring-palette-dropdown .bx--list-box__menu .bx--list-box__menu-item.authoring-palette-menu-item-label {\n  background: inherit;\n  pointer-events: none;\n}\n\n.authoring-palette-dropdown .bx--list-box__menu .bx--list-box__menu-item:not(.authoring-palette-menu-item-label) {\n  cursor: pointer;\n}", ""]);

// exports


/***/ }),
/* 48 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(50);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 50 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
var PaletteAlgorithms = function () {
	function PaletteAlgorithms() {
		_classCallCheck(this, PaletteAlgorithms);
	}

	PaletteAlgorithms.createPaletteViaHue = function createPaletteViaHue(numSwatches, hslColor) {

		var colors = [];
		var incrementAngle = 360 / numSwatches;
		var startAngle = hslColor.hue;

		for (var i = 0; i < numSwatches; i++) {
			var currAngle = startAngle + incrementAngle * i;
			if (currAngle < 0) {
				currAngle = 360 - currAngle;
			} else if (currAngle > 360) {
				currAngle = currAngle - 360;
			}
			colors.push({
				hue: currAngle,
				sat: hslColor.sat,
				light: hslColor.light
			});
		}
		return colors;
	};

	PaletteAlgorithms.createPaletteViaLight = function createPaletteViaLight(numSwatches, hslColor) {
		var colors = [];
		var startLight = hslColor.light;
		// interval is only needed if there is more than 1
		var interval = numSwatches > 1 ? startLight / (numSwatches - 1) : 0;
		for (var i = 0; i < numSwatches; i++) {
			colors.push({
				hue: hslColor.hue,
				sat: hslColor.sat,
				light: startLight - i * interval
			});
		}
		return colors;
	};

	return PaletteAlgorithms;
}();

exports.default = PaletteAlgorithms;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,s){if(true)module.exports=s(__webpack_require__(5));else if("function"==typeof define&&define.amd)define(["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"],s);else{var a=s("object"==typeof exports?require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"):e["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for(var o in a)("object"==typeof exports?exports:e)[o]=a[o]}}("undefined"!=typeof self?self:this,function(e){return webpackJsonPBaGraphics([2068],{"6873601dfe1d9459c1a9":function(s,a){s.exports=e},c88a074faeb5fe768940:function(e,s,a){"use strict";Object.defineProperty(s,"__esModule",{value:!0});var o=a("6873601dfe1d9459c1a9"),i=(a.n(o),a("d725e5b1813de9af78e7"));s.default=i.a},d725e5b1813de9af78e7:function(e,s,a){"use strict";var o=a("9689a9c94ae38b47fa2c"),i=a.n(o),c=a("9ce58a7deea14f49ef01"),n=a.n(c),t=new i.a({id:"add-new_32_v7",use:"add-new_32_v7-usage",viewBox:"0 0 32 32",content:'<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="add-new_32_v7"><path d="M17 9L15 9 15 15 9 15 9 17 15 17 15 23 17 23 17 17 23 17 23 15 17 15z" /><path d="M16,2C8.269,2,2,8.269,2,16s6.269,14,14,14s14-6.269,14-14S23.731,2,16,2z M16,28C9.383,28,4,22.617,4,16S9.383,4,16,4 s12,5.383,12,12S22.617,28,16,28z" /></symbol>'});n.a.add(t);s.a=t}},["c88a074faeb5fe768940"])});

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){if(true)module.exports=a(__webpack_require__(5));else if("function"==typeof define&&define.amd)define(["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"],a);else{var s=a("object"==typeof exports?require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"):e["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for(var o in s)("object"==typeof exports?exports:e)[o]=s[o]}}("undefined"!=typeof self?self:this,function(e){return webpackJsonPBaGraphics([556],{"10eed102fbc488d5f846":function(e,a,s){"use strict";Object.defineProperty(a,"__esModule",{value:!0});var o=s("6873601dfe1d9459c1a9"),c=(s.n(o),s("33c7892ad4967aa3ba24"));a.default=c.a},"33c7892ad4967aa3ba24":function(e,a,s){"use strict";var o=s("9689a9c94ae38b47fa2c"),c=s.n(o),i=s("9ce58a7deea14f49ef01"),t=s.n(i),n=new c.a({id:"repeat_32_v7",use:"repeat_32_v7-usage",viewBox:"0 0 32 32",content:'<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="repeat_32_v7"><path d="M26 6H5.83L9.41 2.41 8 1 2 7l6 6 1.41-1.41L5.83 8H26v7h2V8A2 2 0 0026 6zM22.59 20.41L26.17 24H6V17H4v7a2 2 0 002 2H26.17l-3.58 3.59L24 31l6-6-6-6z" /></symbol>'});t.a.add(n);a.a=n},"6873601dfe1d9459c1a9":function(a,s){a.exports=e}},["10eed102fbc488d5f846"])});

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _CustomPalette = __webpack_require__(8);

var _CustomPalette2 = _interopRequireDefault(_CustomPalette);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _underscore = __webpack_require__(12);

var _underscore2 = _interopRequireDefault(_underscore);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(7);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _jquery = __webpack_require__(9);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2018, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

var View = __webpack_require__(32);

/**
	Class that will take the palettes, generate a property spec spec and renders it
**/

var DEFAULT_MENUITEMS = {
	'my': ['edit', 'duplicate', 'delete'],
	'local': ['duplicate'],
	'public': ['duplicate'],
	'system': ['duplicate'],
	'legacy': []
};

var PALETTE_SECTION_ORDER = ['mru', 'local', 'my', 'public', 'legacy', 'system'];

var ChangePaletteView = View.extend({

	/**
 	 * Creates a slideout view that renders a list of palettes
 	 * @param {node} options.el - parent element
 	 * @param {String} options.name - property name
 	 * @param {Object} options.isAdminUI - {boolean} boolean to duplicate items in global instead
 	 * @param {Object} options.glassContext - Glass context
 	 * @param {Object} options.menuItems - Object that represents the menu items shown for each type of palettes (my, public, system). By default : DEFAULT_MENUITEMS
 	 * @param {Function} options.getPalettes - function to call to get the list of palettes. Must return a promise that resolved with the palettes
 		 * @param {String} options.selectedId - Palette that is currently selected
 	 * @param {Function} [options.onCreatePalette]- callback called after creating a palette
 	 * @param {Function} options.onCloseCb - callback before closing the view
 	 * @param {Function} options.onChange - callback when we change palette
 	 * @param {Boolean} [options.showHeader] - Should the header be show?  Default is true
 	 * @param {String} options.createPaletteType - Type of palette to create when launching the palette dialog
 	 * @param {String} options.name - property name
 	 * @param {Boolean} [options.useSections] - Should the palettes be rendered inside of collapsible sections?  Default is true.
 	 * @param {String} [options.component] - Used for MRU logic, currently supports 'dashboard' and 'reporting'
 	 * @param {Boolean} [options.showRecentlyUsed] - Should the list of recently used palettes be displayed
 */

	init: function init(options) {
		ChangePaletteView.inherited('init', this, arguments);
		this._sectionOpenState = {}; // Use to track which section are open/closed for when we need to refresh the view
		this._initialSelectedId = options.selectedId;

		_underscore2.default.extend(this, options);
	},

	_createBannerSpec: function _createBannerSpec() {
		var _this = this;

		return {
			'type': 'Banner',
			'value': _StringResources2.default.get('changePaletteLabel'),
			'name': 'changePaletteBanner',
			'id': 'changePaletteBanner',
			'centerLabel': true,
			'onClose': function onClose() {
				_this._handleUpdatingMRU();

				if (_this.onCloseCb) {
					_this.onCloseCb();
				} else if (_this.slideout) {
					_this.slideout.hide();
				}
			},
			'clickables': [{
				'type': 'icon',
				'name': 'addNewPalette',
				'svgIcon': 'common-add-new',
				'iconTooltip': _StringResources2.default.get('createPalette'),
				'clickCallback': this._openPaletteCreator.bind(this)
			}],
			'backButton': true
		};
	},

	_openPaletteCreator: function _openPaletteCreator() {
		var _this2 = this;

		var paletteComponent = _react2.default.createElement(_CustomPalette2.default, {
			key: 'addNewPalette',
			glassContext: this.glassContext,
			onPaletteCreated: this.onPaletteCreated.bind(this),
			paletteType: this.createPaletteType,
			removeDialog: function removeDialog() {
				(0, _jquery2.default)(document.body).find('.paletteDialogContainer').remove();
			},
			ref: function ref(instance) {
				_this2.palleteDialog = instance;
			} });
		var paletteContainer = (0, _jquery2.default)(document.body).find('.paletteDialogContainer');
		if (paletteContainer.length === 0) {
			paletteContainer = (0, _jquery2.default)('<div class="paletteDialogContainer">');
			(0, _jquery2.default)(document.body).append(paletteContainer);
		}
		_reactDom2.default.render(paletteComponent, paletteContainer.get(0));
		this.palleteDialog.openDialog();
	},

	_createSectionSpec: function _createSectionSpec(paletteCategory) {
		var _this3 = this;

		var label = paletteCategory;
		if (paletteCategory === 'my') {
			label = 'custom';
		} else if (paletteCategory === 'public') {
			label = 'global';
		}
		var ret = {
			type: 'CollapsibleSection',
			label: _StringResources2.default.get(label + 'PaletteLabel'),
			id: 'sectionLabel' + paletteCategory,
			name: paletteCategory,
			styleAsSimpleRow: true,
			hideSectionTitle: this.hideSectionTitle ? this.hideSectionTitle : false,
			items: [],
			onOpenChange: function onOpenChange(name, isOpen) {
				// Need to keep track which section is opened/closed for when we refresh the view
				_this3._sectionOpenState[name] = isOpen;
			}
		};
		if (paletteCategory === 'legacy') {
			ret['sectionExtraMessage'] = _StringResources2.default.get('legacySectionExtraMessage');
		}
		return ret;
	},

	_createPaletteSpec: function _createPaletteSpec(palettes, properties) {
		var _this4 = this;

		PALETTE_SECTION_ORDER.forEach(function (sectionName) {
			if (palettes[sectionName] && palettes[sectionName].length > 0) {
				var collapsibleSpec = null;
				if (_this4.useSections !== false) {
					collapsibleSpec = _this4._createSectionSpec(sectionName);
					properties.push(collapsibleSpec);
				}
				var containerProperty = collapsibleSpec ? collapsibleSpec : properties;
				palettes[sectionName].forEach(function (palette) {
					var isSelected = _this4.selectedId === palette.id;
					var propertySpec = {
						type: 'NewPalette',
						id: palette.id,
						name: _this4.name,
						reverse: _this4.reverse,
						selected: isSelected,
						palette: palette,
						createPaletteType: _this4.createPaletteType,
						isAdminUI: _this4.isAdminUI,
						onChange: _this4.onPaletteChange.bind(_this4),
						readOnly: false
					};

					if (_this4.menuItems && _this4.menuItems[palette.section]) {
						propertySpec.menuItems = _this4.menuItems[palette.section];
					} else {
						propertySpec.menuItems = DEFAULT_MENUITEMS[palette.section];
					}

					if (_this4.useSections !== false) {
						if (isSelected && typeof _this4._sectionOpenState[sectionName] === 'undefined') {
							_this4._sectionOpenState[sectionName] = true;
						}

						if (_this4._sectionOpenState[sectionName]) {
							containerProperty.open = true;
						}
						containerProperty.items.push(propertySpec);
					} else {
						containerProperty.push(propertySpec);
					}
				});
			}
		});
	},

	_getPropertySpec: function _getPropertySpec() {
		var _this5 = this;

		var properties = [];

		if (this.showHeader !== false) {
			properties.push(this._createBannerSpec());
		}

		return this.getPalettes().then(function (palettes) {
			_this5._augmentPalettes(palettes);
			_this5.palettes = palettes;
			_this5._trimCustomPalettes(palettes);
			return _this5._getMRUPalettes().then(function (mruPalettes) {
				palettes.mru = mruPalettes || [];

				_this5._createPaletteSpec(palettes, properties);

				if (properties.length === 0) {
					return null;
				}

				return {
					el: _this5.$el,
					glassContext: _this5.glassContext,
					items: properties,
					ariaLabel: properties[0].value,
					primaryUIControl: true
				};
			});
		});
	},


	/**
  * We need to augement the palette information with which section the palette is being shown in
  * @param {Array} palettes
  */
	_augmentPalettes: function _augmentPalettes(palettes) {
		if (!palettes) {
			return;
		}

		var _loop = function _loop(section) {
			if (palettes[section] && palettes[section].length > 0) {
				palettes[section].forEach(function (palette) {
					palette.section = section;
				});
			}
		};

		for (var section in palettes) {
			_loop(section);
		}
	},
	_getMRUPalettes: function _getMRUPalettes() {
		var _this6 = this;

		var mruPalettes = [];
		if (this.showRecentlyUsed === false || !this._paletteService) {
			return Promise.resolve(mruPalettes);
		}

		return this._paletteService.getRecentlyUsedPaletteInfo(this._getFillType()).then(function (mruInfo) {
			mruInfo.forEach(function (info) {
				// Cap the MRU list of palettes to 3
				if (mruPalettes.length < 3) {
					// Only add palettes to the MRU if there already somewhere else in the view (custom, global, system)
					var palette = _this6._findPaletteFromId(info.id);
					if (palette) {
						mruPalettes.push(palette);
					}
				}
			});

			return mruPalettes;
		});
	},


	/**
  * Gets the fill type of the palettes being displayed.  Assumes there's only one fillType at a time, so either all
  * simple or all continuous
  */
	_getFillType: function _getFillType() {
		if (this._fillType) {
			return this._fillType;
		}

		for (var key in this.palettes) {
			if (this.palettes[key] && this.palettes[key].length > 0) {
				var palettes = this.palettes[key];
				for (var i = 0; i < palettes.length; i++) {
					if (palettes[i].content && palettes[i].content.fillType) {
						this._fillType = palettes[i].content.fillType;
						return this._fillType;
					}
				}
			}
		}
	},


	/**
  * Given an ID, search all the sections (custom, local, global, system) for a matching ID
  */
	_findPaletteFromId: function _findPaletteFromId(id) {
		var _this7 = this;

		if (!this.palettes) {
			return null;
		}

		// Make sure we compare the base CM ID without any prefixes
		var safeId = this._getRealPaletteId(id);
		for (var key in this.palettes) {
			if (this.palettes[key]) {
				var match = _underscore2.default.find(this.palettes[key], function (palette) {
					return _this7._getRealPaletteId(palette.id) === safeId;
				});
				if (match) {
					return match;
				}
			}
		}

		return null;
	},


	/**
  * Make sure the same palette doesn't show up in the custom AND global sections
  * @param {Array} palettes
  */
	_trimCustomPalettes: function _trimCustomPalettes() {
		var palettes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		var myPalettes = palettes.my;
		var globalPalettes = palettes.public;

		var findMatch = function findMatch(id) {
			return _underscore2.default.find(globalPalettes, function (palette) {
				return palette.id === id;
			});
		};

		if (myPalettes && globalPalettes) {
			for (var i = 0; i < myPalettes.length; i++) {
				var id = myPalettes[i].id;
				if (findMatch(id)) {
					myPalettes.splice(i, 1);
					i--;
				}
			}
		}
	},


	onPaletteCreated: function onPaletteCreated(paletteId) {
		if (this.onCreatePalette) {
			this.selectedId = this.onCreatePalette(paletteId);
		}
	},

	_registerPaletteServiceEvents: function _registerPaletteServiceEvents() {
		if (this._paletteService && !this._regisered) {
			this._regisered = true;
			this._paletteService.on('palette:created', this.render, this);
			this._paletteService.on('palette:updated', this._onPaletteUpdate, this);
			this._paletteService.on('palette:deleted', this._onPaletteDelete, this);
		}
	},
	_unregisterPaletteServiceEvents: function _unregisterPaletteServiceEvents() {
		if (this._paletteService) {
			this._paletteService.off('palette:created', this.render, this);
			this._paletteService.off('palette:updated', this._onPaletteUpdate, this);
			this._paletteService.off('palette:deleted', this._onPaletteDelete, this);
		}
	},


	/**
  * Update the internal selectedId and call the onChange callback
  */
	onPaletteChange: function onPaletteChange(propertyName, paletteItem) {
		this.selectedId = paletteItem.id;
		if (this.onChange) {
			this.onChange(propertyName, paletteItem);
		}
	},
	_handleUpdatingMRU: function _handleUpdatingMRU() {
		// If the user changed the palette, then update the recently used list
		if (this.selectedId !== this._initialSelectedId) {
			var palette = this._findPaletteFromId(this.selectedId);

			// Don't add local palettes to the MRU list
			if (palette && palette.section !== 'local') {
				var propName = this.name || '';

				// Dashboard has a different list of system palettes for heat and conditional.  Make sure
				// we keep 3 palettes in the MRU for both sets
				var trimSystemByPropName = propName === 'condColorPalette' || propName.indexOf('contColorPalette') === 0 ? true : false;

				this._paletteService.addRecentlyUsedPalette({
					palette: palette,
					isSystem: palette.section === 'system',
					component: this.component,
					propName: propName,
					trimSystemByPropName: trimSystemByPropName
				});
			}
		}
	},


	/**
  * Palette IDs sometime have a prefix to let us know it's a CM palette.  This will
  * remove any prefix
  */
	_getRealPaletteId: function _getRealPaletteId(id) {
		return this._paletteService.getCMSafePaletteId(id);
	},
	_onPaletteUpdate: function _onPaletteUpdate(_ref) {
		var paletteId = _ref.paletteId;

		this._updatePaletteProperties({
			properties: this._propertyUIControl.getProperties(),
			paletteIdToUpdate: paletteId,
			action: 'update'
		});
	},


	/**
  * Method to update properties inline without having to refresh the entire pane.  Only works
  * for updates and if deleting a palette that you currently don't have selected.
  */
	_updatePaletteProperties: function _updatePaletteProperties(_ref2) {
		var _this8 = this;

		var properties = _ref2.properties,
		    paletteIdToUpdate = _ref2.paletteIdToUpdate,
		    action = _ref2.action,
		    parentProperty = _ref2.parentProperty;

		var _loop2 = function _loop2(_i) {
			var property = properties[_i];
			if (property.type === 'CollapsibleSection') {
				_this8._updatePaletteProperties({
					properties: property._oPropertyUIControl.getProperties(),
					paletteIdToUpdate: paletteIdToUpdate,
					action: action,
					parentProperty: property
				});
			} else if (property.type === 'NewPalette' && property.palette && _this8._getRealPaletteId(property.palette.id) === paletteIdToUpdate) {
				var propertyNode = property.$el.find('.property_' + property.id);
				if (action === 'update') {
					propertyNode.remove();
					_this8._paletteService.getPalette(paletteIdToUpdate).then(function (palette) {
						property.palette.content = palette.content;
						property.doRender();
					});
				} else if (action === 'delete') {
					properties.splice(_i, 1);
					_i--;
					if (properties.length === 0 && parentProperty) {
						parentProperty.$el.find('.collapsibleSectionToggle' + parentProperty.id).remove();
						parentProperty.$el.find('.property_' + parentProperty.id).remove();
					} else {
						propertyNode.remove();
					}
				}
			}
			i = _i;
		};

		for (var i = 0; i < properties.length; i++) {
			_loop2(i);
		}
	},


	/**
  * When a palette gets deleted we need to correctly default to something else if the one being
  * deleted is the currently selected palette
  */
	_onPaletteDelete: function _onPaletteDelete(_ref3) {
		var paletteId = _ref3.paletteId;

		if (this._getRealPaletteId(paletteId) === this._getRealPaletteId(this.selectedId)) {
			var newSelectedPalette = null;
			var palette = this._findPaletteFromId(paletteId);

			// We should still have the deleted palette since we have re-renderd.
			if (palette) {
				var section = palette.section;

				// Check the section where the palette was deleted from to see if there are more available
				// palettes in the same section. If so, use that as the selected palette
				for (var _i2 = 0; _i2 < this.palettes[section].length; _i2++) {
					if (this._getRealPaletteId(this.palettes[section][_i2].id) !== this._getRealPaletteId(paletteId)) {
						newSelectedPalette = this.palettes[section][_i2];
						this._sectionOpenState[section] = true;
						break;
					}
				}
			}

			// All else fails defaulkt to the first system palette
			if (!newSelectedPalette && this.palettes.system) {
				newSelectedPalette = this.palettes.system[0];
				this._sectionOpenState['system'] = true;
			}

			if (newSelectedPalette) {
				this.onPaletteChange(this.name, {
					id: newSelectedPalette.id,
					reverse: this.reverse
				});
			}

			this.render();
		} else {
			this._updatePaletteProperties({
				properties: this._propertyUIControl.getProperties(),
				paletteIdToUpdate: paletteId,
				action: 'delete'
			});
		}
	},


	/**
  * Shifts the selection highlight on to the new palette
  */
	updateSelection: function updateSelection() {
		if (this.getPaletteId) {
			var paletteId = this.getPaletteId();
			if (paletteId && paletteId !== this.selectedId) {
				this.selectedId = paletteId;
				// Deselect previous palette, then select the current one
				this.$el && this.$el.find('.paletteColors.selected').removeClass('selected').attr('aria-pressed', 'false');
				this.$el && this.$el.find('.property_' + paletteId).addClass('selected').attr('aria-pressed', 'true');
			}
		}
	},

	remove: function remove() {
		this._unregisterPaletteServiceEvents();
		if (this.onRemove) {
			this.onRemove();
		}
	},

	render: function render() {
		var _this9 = this;

		this.$el.parent().addClass('changePalettePane');

		if (this._propertyUIControl) {
			this._propertyUIControl.remove();
			this.$el.empty();
		}

		return this.glassContext.getSvc('.Palette').then(function (paletteService) {
			_this9._paletteService = paletteService;

			return _this9._getPropertySpec().then(function (propertySpec) {
				if (!propertySpec || !propertySpec.items || !propertySpec.items.length) {
					_this9._registerPaletteServiceEvents();
					return;
				}

				return new Promise(function (resolve) {
					new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(63)]; ((function (PropertyUIControl) {
						_this9._propertyUIControl = new PropertyUIControl(propertySpec);

						return _this9._propertyUIControl.render().then(function () {
							_this9._propertyUIControl.focus();
							_this9._registerPaletteServiceEvents();

							resolve(_this9._propertyUIControl);
						});
					}).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);
				});
			});
		});
	},

	getPropertyUIControl: function getPropertyUIControl() {
		return this._propertyUIControl;
	}
});

exports.default = ChangePaletteView;

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_56__;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2014, 2016
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(9), __webpack_require__(58), __webpack_require__(59), __webpack_require__(20), __webpack_require__(61), __webpack_require__(62)], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, BidiUtil, DnDManager, _, hammer) {

	// Setup jquery to create a hammer instance when we use hammer events.
	var hammerGestures = [];
	for (var name in hammer.gestures) {
		if (Object.prototype.hasOwnProperty.call(hammer.gestures, name)) {
			hammerGestures.push(hammer.gestures[name].name);
		}
	}
	var hammerDefaultOptions = {
		'prevent_mouseevents': true,
		'stop_browser_behavior': false
	};
	$.each(hammerGestures, function (index, name) {
		$.event.special[name] = {
			setup: function setup() {
				var $el = $(this);
				var inst = $el.data('hammer');
				if (!inst) {
					// create hammer instance with default values
					$el.hammer(hammerDefaultOptions);
				}
			}
		};
	});

	/**
  * A jQuery function that can be used to attach the onClick event handler. This function will also attach the touch events required for touch devices to avoid the delay caused by simulated mouse
  * events
  */
	$.fn.onClick = function (handler) {
		this.on('click', function (e) {
			handler(e);
		}).on('tap', function (e) {
			handler(e);
			// prevent the simulated clicks on touch devices
			e.gesture.preventDefault();
		});
		return this;
	};

	// Get the box style to be applied to the inline editor
	var getInlineEditBoxStyles = function getInlineEditBoxStyles($text, options) {

		var cssProps = ['padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'margin-top', 'margin-right', 'margin-bottom', 'margin-left', 'border-bottom-color', 'border-bottom-style', 'border-bottom-width', 'border-top-color', 'border-top-style', 'border-top-width', 'border-right-color', 'border-right-style', 'border-right-width', 'border-left-color', 'border-left-style', 'border-left-width', 'position', 'top', 'right', 'left', 'bottom', 'height', 'width', 'min-height', 'min-width', 'max-height', 'max-width'];

		var cssValues = $text.css(cssProps);

		// We don't want to set a zero height and width
		if (cssValues.height === '0px') {
			delete cssValues.height;
		}
		if (cssValues.width === '0px') {
			delete cssValues.width;
		}

		// Set the maximum width to strech with the parent
		if (options && options.maxSizeNode) {
			var $node = $(options.maxSizeNode);
			var width = options.maxSizeNode.style.width;
			if (width) {
				cssValues['max-width'] = '100%';
				delete cssValues.width;
			} else {
				cssValues['max-width'] = $node.width() + 'px';
			}
		}

		return cssValues;
	};

	// Get the css styles to be applied to the inline editor input element
	var getInlineEditStyles = function getInlineEditStyles($text) {

		var textCss = {
			width: '0px',
			'min-width': $text.css('fontSize')
		};

		// Get the text alignment and apply it to the text input
		var textAlignment = $text.css('text-align');
		if (textAlignment === 'center') {
			textCss['margin'] = '0px auto';
		} else if (textAlignment === 'right') {
			textCss['margin'] = '0px 0px 0px auto';
		}

		return textCss;
	};

	// Get the text css style to be applied to the inline editor
	var getInlineEditTextStyles = function getInlineEditTextStyles($text) {
		return $text.css(['fontSize', 'fontFamily', 'fontWeight', 'letterSpacing', 'color']);
	};

	var _addInlineEditHandlers = function _addInlineEditHandlers($text, fCallback, options) {

		var $inlineEdit = $text._$inlineEdit;

		$text._updateWidth = function () {
			if ($inlineEdit) {
				var value = $inlineEdit.val() || '';
				if (value !== $inlineEdit._hidden.text()) {
					$inlineEdit._hidden.text(value);
					$inlineEdit.width($inlineEdit._hidden.width() + 2);
				}
			}
		};

		$text._inlineEditChangedFn = function () {
			var sText = $inlineEdit.val().trim();

			if (sText.length === 0 && options.noEmptyText) {
				sText = $text._previousInlineText;
			}

			$inlineEdit.removeClass('inlineText').off('keypress').off('keydown').off('blur');
			var invokeCallback = false;
			if ($text._previousInlineText !== sText) {
				invokeCallback = true;
			}
			$text._previousInlineText = null;
			$inlineEdit._hidden.remove();
			$inlineEdit._hidden = null;
			$inlineEdit.off();
			$inlineEdit.hide();
			$inlineEdit.parent().remove();
			$inlineEdit = null;
			$text._$inlineEdit = null;

			$text.text(sText);
			$text.removeClass('inEditMode');
			$text.show().focus();

			if (invokeCallback) {
				fCallback(sText);
			}

			var onEditEnd = options && options.onEditEnd;
			if (onEditEnd) {
				onEditEnd();
			}
		}.bind($text);

		var sText = $text.text();
		$text._previousInlineText = sText; // keep a back up of the current string

		if (!$inlineEdit) {

			$text.addClass('inEditMode');

			// Create a container node that will inherit the text container properties
			// like margin, padding, border and position
			var $inlineEditContainer = $('<div>', {
				'class': 'inlineEditContainer'
			});
			$inlineEditContainer.css(getInlineEditBoxStyles($text, options));
			$text.after($inlineEditContainer);

			$inlineEdit = $('<input>', {
				'class': 'inlineText'
			});

			$inlineEdit.css('max-width', '100%');
			$inlineEdit.css(getInlineEditStyles($text));
			var cssValues = getInlineEditTextStyles($text);
			$inlineEdit.css(cssValues);

			$inlineEditContainer.append($inlineEdit);

			$text._$inlineEdit = $inlineEdit;
			$inlineEdit.val(sText);

			$inlineEdit._hidden = $('<div style="white-space:pre; top:-999px; left:-999px; position:absolute;"></div>');
			$inlineEdit._hidden.css(cssValues);

			$text.hide();
			$text.after($inlineEdit._hidden);
			$inlineEdit.on('keyup keydown input propertychange change', function () {
				$text._updateWidth();
			});

			if (options && options.style) {
				$inlineEdit.css(options.style);
			}

			$text._updateWidth();

			$inlineEdit.on('blur', $text._inlineEditChangedFn).on('keypress', function (e) {
				if (e.keyCode === 13) {
					$text._inlineEditChangedFn();
				}
			}).on('keyup', function (e) {
				//stop propagation for delete key
				if (e.keyCode === 46 || e.keyCode === 8) {
					e.stopPropagation();
				}
			}).on('keydown', function (e) {
				// stop the arrow keys from bubbling when in edit mode. Fix for when editing the name of a tab.
				if (e.keyCode === 37 || e.keyCode === 39) {
					e.stopPropagation();
				}
			}).on('mousedown mouseup dblclick', function (e) {
				// cancel the mouse down, up and double click to allow the user to interact with the text
				e.stopPropagation();
			});
			BidiUtil.initElementForBidi($inlineEdit[0]);
			$inlineEdit.show();
		} else {
			$inlineEdit.val(sText);
		}

		$inlineEdit.focus();
		$inlineEdit[0].setSelectionRange(0, 9999); //needed for selecting on ios

		return false;
	};

	/**
  * Turns an div element into an inline edit control
  */
	$.fn.inlineEditor = function (action, options) {
		if (action === 'remove') {
			if (this._$inlineEdit) {
				this._inlineEditChangedFn();
			}

			this.off('dblclick', this._inlineEditFn);
			this.off('hold', this._inlineEditFn);
			delete this._inlineEditFn;
			delete this._previousInlineText;
			delete this._inlineEditChangedFn;
			delete this._updateWidth;
		} else if (action === 'blur') {

			if (this._$inlineEdit) {
				this._inlineEditChangedFn();
			}
		} else if (action === 'isEditing') {
			return this._$inlineEdit ? true : false;
		} else if (action === 'edit') {
			if (this._inlineEditFn) {
				this._inlineEditFn();
			}
		} else {
			var onEditStart = options && options.onEditStart;
			this._inlineEditFn = function (e) {

				DnDManager.resetDragging();

				if (onEditStart) {
					onEditStart();
				}
				_addInlineEditHandlers(this, action, options);

				if (e) {
					e.stopPropagation();
				}
			}.bind(this);
			this.hammer({
				stop_browser_behavior: false,
				prevent_mouseevents: true
			});
			this.on('dblclick', this._inlineEditFn);
			this.on('hold', this._inlineEditFn);
			this.on('keypress', function (e) {
				var keyCode = e.keyCode || e.charCode;
				if (keyCode === 13 || keyCode === 32) {
					this._inlineEditFn(e);
				}
			}.bind(this));
		}
	};
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
//# sourceMappingURL=EventHelper.js.map

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2012, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 * borrowed from cclcore.
 * Common bidi javascript library - BidiUtils.
 * Singleton containing useable bidi methods.
 */

/**
 * This module contains a subset of BidiUtils from cclcore with some
 * modifications to meet gemini's requirements for BiDi text. Elements passed
 * in to the methods of this module is expected to contain only a single text
 * node such as <div contenteditable> or <input> elements
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
	'use strict';

	var AUTO = 'auto',
	    arabicLocales = {
		'General Info': {
			'Generated from': 'CLDR Version: 30.0.3',
			'Generated by': 'BDL CLDR Reader Tool',
			'Date': '16-03-17 12:40:12'
		},
		'Arabic Default Numbering Systems': {
			'ar': 'arab',
			'ar_AE': 'arab',
			'ar_BH': 'arab',
			'ar_DJ': 'arab',
			'ar_DZ': 'latn',
			'ar_EG': 'arab',
			'ar_EH': 'latn',
			'ar_ER': 'arab',
			'ar_IL': 'arab',
			'ar_IQ': 'arab',
			'ar_JO': 'arab',
			'ar_KM': 'arab',
			'ar_KW': 'arab',
			'ar_LB': 'arab',
			'ar_LY': 'latn',
			'ar_MA': 'latn',
			'ar_MR': 'arab',
			'ar_OM': 'arab',
			'ar_PS': 'arab',
			'ar_QA': 'arab',
			'ar_SA': 'arab',
			'ar_SD': 'arab',
			'ar_SO': 'arab',
			'ar_SS': 'arab',
			'ar_SY': 'arab',
			'ar_TD': 'arab',
			'ar_TN': 'latn',
			'ar_YE': 'arab'
		}
	},
	    cldrData = arabicLocales['Arabic Default Numbering Systems'];

	var BidiUtil = function BidiUtil() {
		this._isIE = this._detectIE(navigator.userAgent);
		this.userPreferredTextDir = this._getUserPreferredTextDir() || AUTO;
		this.LRE = '\u202A';
		this.RLE = '\u202B';
		this.PDF = '\u202C';
		this.LRM = '\u200E';
	};

	BidiUtil.prototype._detectIE = function (useragent) {
		return (/\b(MSIE|Trident|Edge)\b/.test(useragent)
		);
	};

	// Private Methods
	// Should not need to call these methods outside this module. Although real
	// encapsulation is possible, defining as part of BidiUtil's prototype allows
	// unit testing and faster scope chain access from public methods

	/**
  * Gets the user's preferred text direction from <html> attribute passed in
  * from server-side and stores it as member of this singleton as userPreferredTextDir
  * @return {string} User's preferred text direction (i.e. ltr, rtl, auto)
  */
	BidiUtil.prototype._getUserPreferredTextDir = function () {
		if (!this.userPreferredTextDir) {
			this.userPreferredTextDir = document.documentElement.getAttribute('data-pref-text-dir');
		}
		return this.userPreferredTextDir;
	};

	/**
  * Normalizes the process of retrieving the value from <input> or <div contenteditable>
  * HTML elements
  * @param  {Element|HTMLInputElement} element - DOM element receiving text input
  * @return {string} String value of the DOM element
  */
	BidiUtil.prototype._getNodeValue = function (element) {
		return element.value || element.tagName === 'INPUT' ? element.value : element.textContent;
	};

	/**
  * Normalizes the process of setting the value to <input> or <div contenteditable>
  * HTML elements
  * @param {Element|HTMLInputElement} element - DOM element receiving text input
  * @param {string} value - String value to be set to element
  */
	BidiUtil.prototype._setNodeValue = function (element, value) {
		if (element.value || element.tagName === 'INPUT') {
			element.value = value;
		} else {
			// setting the textContent removes any text of its child nodes
			element.textContent = value;
		}
	};

	/**
  * Checks if the character passed in is an Arabic character.
  * @param {string} charCode - Character code
  * @return {boolean} True, if character is an Arabic character
  */
	BidiUtil.prototype._isArabicChar = function (charCode) {
		if (charCode >= 0x0620 && charCode <= 0x0669 || charCode >= 0x06fa && charCode <= 0x07ff || charCode >= 0xfb50 && charCode <= 0xfdff || charCode >= 0xfe70 && charCode <= 0xfefc) {
			return true;
		}
		return false;
	};

	/**
  * Checks if the character passed in is a Hebrew character.
  * @param {string} charCode - Character code
  * @return {boolean} True, if character is a Hebrew character
  */
	BidiUtil.prototype._isHebrewChar = function (charCode) {
		if (charCode >= 0x05d0 && charCode <= 0x05ff) {
			return true;
		}
		return false;
	};

	/**
  * Checks if the character passed in is a BiDi character.
  * @param  {number}  charCode - Chracter code
  * @return {boolean} True, if the character is a BiDi (Arabic or Hebrew) character
  */
	BidiUtil.prototype._isBidiChar = function (charCode) {
		return this._isArabicChar(charCode) || this._isHebrewChar(charCode);
	};

	/**
  * Checks if the character passed in is a Latin character (Only treats
  * capital and lower case alphabets as latin characters)
  * @param  {number}  charCode - Character code
  * @return {boolean} True, if the character is a Latin character
  */
	BidiUtil.prototype._isLatinChar = function (charCode) {
		if (charCode > 64 && charCode < 91 || charCode > 96 && charCode < 123) {
			return true;
		}
		return false;
	};

	/**
  * Checks if the character passed in is an Asian character
  * The ranges of Unicode characters which are routinely used for Chinese and Japanese text are:
  * U+3040 - U+30FF: hiragana and katakana (Japanese only)
  * U+3400 - U+4DBF: CJK unified ideographs extension A (Chinese, Japanese, and Korean)
  * U+4E00 - U+9FFF: CJK unified ideographs (Chinese, Japanese, and Korean)
  * U+F900 - U+FAFF: CJK compatibility ideographs (Chinese, Japanese, and Korean)
  * U+FF66 - U+FF9F: half-width katakana (Japanese only)	
  * @param  {char}  char- Character
  * @return {boolean} True, if the character is an Asian character
  */
	BidiUtil.prototype._isAsianChar = function (char) {
		return (/[\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff66-\uff9f]/.test(char)
		);
	};

	/**
  * Event handler for 'input' event (events causing the value of the target
  * element to change)
  * Resolves the base text direction and sets the dir attribute
  * @param {Event} event - DOM Event object
  */
	BidiUtil.prototype._handleInputEvent = function (event) {
		// NOTE: 'this' has been binded to be BidiUtil in _addBidiEventListeners function
		this._resolveDirAttr(event.target);
	};

	/**
  * Adds event listeners for events changing the value of the element being passed in
  * @param {Element|HTMLInputElement} element - DOM element receiving text input
  */
	BidiUtil.prototype._addBidiEventListeners = function (element) {
		if (!element._hasBidiEventListeners) {
			element._hasBidiEventListeners = true;

			var eventTypes = ['keyup', 'cut', 'paste'];
			for (var i = 0; i < eventTypes.length; ++i) {
				element.addEventListener(eventTypes[i], this._handleInputEvent.bind(this), false);
			}
		}
	};

	/**
  * Sets dir attribute of the DOM element passed in as parameter according to
  * the direction of the first strong character in the text content of the element
  * @param {Element|HTMLInputElement} element - DOM element receiving text input
  */
	BidiUtil.prototype._resolveDirAttr = function (element) {
		if (this._isIE && (this.userPreferredTextDir === AUTO || !this.userPreferredTextDir)) {
			// IE doesn't support dir="auto" HTML attribute
			var text = this._getNodeValue(element);
			element.dir = this.resolveBaseTextDir(text);
		} else {
			// Chrome, Safari, and Firefox supports dir="auto" HTML attribute
			// IE will only receive "ltr" or "rtl" in this block
			element.dir = this.userPreferredTextDir || AUTO;
		}
	};

	/**
 * This function determines the positions where we should insert the LRM marker for correct display
 * of Structured Text Value
 * @param str
 * @param isLocation
 * @returns array
 */
	BidiUtil.prototype._parseSTT = function (str, isLocation) {
		var delimiter = isLocation ? '>' : ':/@=[]\'<>';
		var segmentsPointers = [];
		var sp_len = 0,
		    i;

		for (i = 0; i < str.length; i++) {
			if (delimiter.indexOf(str.charAt(i)) >= 0) {
				segmentsPointers[sp_len] = i;
				sp_len++;
			}
		}
		return segmentsPointers;
	};

	// Public Methods
	/**
  * Simply resolves the dir attribute of the HTML element and adds BiDi specific
  * event handlers if necessary
  * @param  {Element|HTMLInputElement} element - DOM element receiving text input
  */
	BidiUtil.prototype.initElementForBidi = function (element) {
		if (element) {
			this._resolveDirAttr(element); // resolve dir attribute of the element

			if (this._isIE) {
				this._addBidiEventListeners(element);
			}
		}
	};

	/**
  * Enforces text direction by adding UCC (Unicode Control Characters)
  * @param  {String} text - The text for which we should enforce text direction.
  * @returns string
  */
	BidiUtil.prototype.enforceTextDirection = function (text) {
		if (text) {
			var finalDir = this.resolveBaseTextDir(text);
			var finalValue = text;

			if (finalDir === 'ltr') {
				finalValue = this.LRE + finalValue + this.PDF;
			} else if (finalDir === 'rtl') {
				finalValue = this.RLE + finalValue + this.PDF;
			}
			return finalValue;
		}
		return text;
	};

	/**
  * Traverses the string passed in as parameter from the beginning and
  * determines the direction of the text based on the first strong character
  * @param  {string} text - A bi-directional text
  * @param  {bool} isTextArea - Does the text belong to a textarea
  * @return {string} Direction of the text
  */
	BidiUtil.prototype.resolveBaseTextDir = function (text, isTextArea) {

		var textDir = this.userPreferredTextDir;
		if (!textDir) {
			textDir = AUTO;
		}
		if (textDir === AUTO && (!isTextArea || this._isIE)) {
			for (var i = 0; text && i < text.length; i++) {
				var character = text.charCodeAt(i);
				if (this._isBidiChar(character)) {
					textDir = 'rtl';
					break;
				} else if (this._isLatinChar(character)) {
					textDir = 'ltr';
					break;
				} else if (this._isAsianChar(text[i])) {
					textDir = 'ltr';
					break;
				}
			}
			if (this._isIE && textDir === AUTO) {
				textDir = '';
			}
		}

		return textDir;
	};

	/**
  * Enforces text direction for Structured Text value by adding UCC (Unicode Control Characters)
  * We should add an LRM before each segment and also we should enforce text direction of each segment
  * @param  {String} text - The text for which we should enforce text direction.
  * @returns string
  */
	BidiUtil.prototype.enforceTextDirectionForSTT = function (text) {
		if (text) {
			text = this.removeMarkers(text);
			var isLocation = (text.match(/ > /g) || []).length > 0;
			var segmentsPointers = this._parseSTT(text, isLocation);
			var result = '';
			var n;
			var marker = this.LRM;
			var offset = isLocation ? 1 : 0;
			if (segmentsPointers.length === 0) {
				result = this.enforceTextDirection(text);
			} else {
				result = this.enforceTextDirection(text.substring(0, segmentsPointers[0] - offset));
			}
			for (var i = 0; i < segmentsPointers.length; i++) {
				n = segmentsPointers[i];
				if (n) {
					var endIndex = i < segmentsPointers.length - 1 ? segmentsPointers[i + 1] - offset : text.length;
					var segment = text.substring(n + 1 + offset, endIndex);
					result = result + marker + text.substring(n - offset, n + offset + 1) + this.enforceTextDirection(segment);
				}
			}
			return result;
		}
		return text;
	};

	/**
  * Enforces text direction for Structured Text value by adding UCC (Unicode Control Characters)
  * We should add an LRM before each segment and also we should enforce text direction of each segment
  * @param  {String} text - The text for which we should enforce text direction.
  * @returns string
  */
	BidiUtil.prototype.enforceTextDirectionForLocation = function (text) {
		return this.enforceTextDirectionForSTT(text);
	};

	/**
  * Removes all the markers from the text
  * @param  {String} text - The text
  * @returns string
  */
	BidiUtil.prototype.removeMarkers = function (text) {
		return text.replace(/[\u202A\u202B\u202C\u200E]/g, '');
	};

	BidiUtil.prototype._isArabicLocale = function (locale) {
		return locale.match(/^ar[-_].*$/i);
	};

	BidiUtil.prototype._useLatinNums = function (locale) {
		if (!this._isArabicLocale(locale)) {
			return true;
		}
		return cldrData[locale] && cldrData[locale] === 'latn';
	};

	/**
  * Enforces numeric shaping for the given string
  * @param {Object} text to be wrapped. Can be number or string object.
  * @param {bool} isContextual. Should enforce contextual numeric shaping.
  * @returns {string}
  */
	BidiUtil.prototype.enforceNumericShaping = function (text, isContextual) {
		if (this.bidiSupport && this.userPreferredContentLocale.startsWith('ar') && (typeof text === 'number' || typeof text === 'string')) {
			var segmentDir = this.userPreferredTextDir;
			if (this.userPreferredTextDir === AUTO) {
				segmentDir = this.resolveBaseTextDir(text);
			}
			var locale = typeof navigator === 'undefined' ? '' : navigator.language || navigator.userLanguage || '';
			locale = locale.replace('-', '_');
			var finalText = text;
			if (typeof text === 'number') {
				finalText = text.toString();
			}
			// eslint-disable-next-line no-misleading-character-class
			var pattern = /([0-9])|([\u0660-\u0669])|([\u0590-\u05FF\u0608\u060B\u060D\u061B-\u064A\u066D-\u066F\u0671-\u06D5\u06E5-\u06E6\u06EE-\u06EF\u06FA-\u06FF\u0750-\u077F\u08A0-\u08E3\u200F\u202B\u202E\u2067\uFB50-\uFD3D\uFD40-\uFDCF\uFDF0-\uFDFC\uFDFE-\uFDFF\uFE70-\uFEFE]+)|([^0-9\u0590-\u05FF\u0660-\u0669\u0608\u060B\u060D\u061B-\u064A\u066D-\u066F\u0671-\u06D5\u06E5-\u06E6\u06EE-\u06EF\u06FA-\u06FF\u0750-\u077F\u08A0-\u08E3\u200F\u202B\u202E\u2067\uFB50-\uFD3D\uFD40-\uFDCF\uFDF0-\uFDFC\uFDFE-\uFDFF\uFE70-\uFEFE\u0600-\u0607\u0609-\u060A\u060C\u060E-\u061A\u064B-\u066C\u0670\u06D6-\u06E4\u06E7-\u06ED\u06F0-\u06F9\u08E4-\u08FF\uFD3E-\uFD3F\uFDD0-\uFDEF\uFDFD\uFEFF\u0000-\u0040\u005B-\u0060\u007B-\u007F\u0080-\u00A9\u00AB-\u00B4\u00B6-\u00B9\u00BB-\u00BF\u00D7\u00F7\u02B9-\u02BA\u02C2-\u02CF\u02D2-\u02DF\u02E5-\u02ED\u02EF-\u02FF\u2070\u2074-\u207E\u2080-\u208E\u2100-\u2101\u2103-\u2106\u2108-\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A-\u213B\u2140-\u2144\u214A-\u214D\u2150-\u215F\u2189\uA720-\uA721\uA788\uFF01-\uFF20\uFF3B-\uFF40\uFF5B-\uFF65\uFFE0-\uFFE6\uFFE8-\uFFEE]+)/g; // eslint-disable-line no-control-regex
			var self = this;
			return finalText.replace(pattern, function (curChs, latNum, araNum, rtlChs, ltrChs) {
				if (araNum) {
					if (isContextual && segmentDir === 'ltr' || !isContextual && self._useLatinNums(locale)) {
						return araNum.charCodeAt(0) - 1632;
					} else {
						return araNum;
					}
				} else if (latNum) {
					if (isContextual && segmentDir === 'rtl' || !isContextual && !self._useLatinNums(locale)) {
						return String.fromCharCode(parseInt(latNum) + 1632);
					} else {
						return latNum;
					}
				} else if (rtlChs) {
					segmentDir = 'rtl';
				} else if (ltrChs) {
					segmentDir = 'ltr';
				}
				return curChs;
			});
		}
		return text;
	};

	/**
  * Sets the text dir user preference
  * @param  {String} textDir - The text direction user preference.
  * @param  {String} bidiSupport - Is Bidi support enabled ?
  */
	BidiUtil.prototype.setUserPreferredTextDir = function (textDir, bidiSupport) {
		this.userPreferredTextDir = '';
		this.bidiSupport = false;
		if (bidiSupport === 'true') {
			this.userPreferredTextDir = textDir.toLowerCase();
			this.bidiSupport = true;
		}
	};

	/**
  * Sets the content locale user preference
  * @param  {String} contentLocale - The content locale user preference.
  */
	BidiUtil.prototype.setUserPreferredContentLocale = function (contentLocale) {
		this.userPreferredContentLocale = contentLocale;
	};

	return new BidiUtil();
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
//# sourceMappingURL=BidiUtil.js.map
//# sourceMappingURL=BidiUtil.js.map

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2014, 2016
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 * Drag-and-Drop Manager
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(9), __webpack_require__(20), __webpack_require__(13), __webpack_require__(60)], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, _, Class, utils) {
	'use strict';

	var DnDManager = null;

	DnDManager = Class.extend({

		dropTargets: null,
		currentDropTarget: null,
		init: function init() {
			this.dropTargets = [];
			this.currentDropTarget = {};

			// Add the dialog blocker as a default drop zone to swallow and ignore any drop that happens on the backdrop
			this.addDropTarget($('body')[0], '.dialogBlocker', {
				accepts: function accepts() {
					return true;
				}
			});
		},

		// Utility method that subscribes to the specified jQuery event
		// and returns removable object, that can be inserted into the 'owned' collections
		// of subscriptions
		//
		on: function on($el, types, selector, data, fn) {
			$el.on(types, selector, data, fn);
			return {
				remove: function remove() {
					$el.off(types, selector, fn);
				}
			};
		},

		/**
   * Register a drop Zone with the drag and drop manage
   *
   *
   * @param el - The drop zone element.
   * @param selector - Selector to identify the drop zone sub regions. If not specified, there will only be one region which is the drop zone element.
   * @param callbacks
   *		callbacks.accepts(dragObject)  - Called to check if the dropzone accepts the payload.
   *		callbacks.onDragStart() - Called when a drag starts
   *		callbacks.onDragEnd() - Called when a drag ends
   *		callbacks.onDragEnter(dragObject, dropNode) - Called when we enter a drop zone
   *		callbacks.onDragMove(dragObject, dropNode) - Called when we move inside a drop zone
   *		callbacks.onDragLeave(dragObject, dropNode) - Called when we leave a drop zone
   *		callbacks.onDrop(dragObject, dropNode) - Called when a drop occurs.
   * @returns {___anonymous1282_1365}
   */
		addDropTarget: function addDropTarget(el, selector, callbacks) {
			if (typeof selector !== 'string') {
				callbacks = selector;
				selector = null;
			}

			this.removeDropTarget(el);
			this.dropTargets.push({
				el: el,
				selector: selector,
				callbacks: callbacks
			});

			return {
				remove: function () {
					this.removeDropTarget(el);
				}.bind(this)
			};
		},

		/**
   * Remove a registered drop target
   * @param el
   */
		removeDropTarget: function removeDropTarget(el) {
			var target = _.find(this.dropTargets, function (t) {
				return t.el === el;
			});
			if (target) {
				this.dropTargets.splice(_.indexOf(this.dropTargets, target), 1);
			}
		},

		_isScrollDropSupported: function _isScrollDropSupported() {
			return this.currentDropTarget.target && this.currentDropTarget.target.callbacks.isScrollDropSupported ? true : false;
		},

		/**
   *
   * Check if the intention is scrolling and return the proper scrolling enabled drop zone.
   * If we are dragging outside of the view port, the intention is to auto scroll. In this case we do the following:
   * 		- if we have a drop zone, find the closest scrollable drop zone in the ancestors.
   *      - if there is no drop zone, select the last scrollable drop zone that was used.
   *
   * If we are dragging within the view and we have no drop zone, find the closest scrolling drop zone using the last drop target that was used.
   *  @param target
   * @param isScrollDropSupported
   * @param pos - current mouse position
   *
   * @returns the target or empty object.
   */
		_validateDropTarget: function _validateDropTarget(target, isScrollDropSupported, pos) {
			var foundTarget = target;
			if (isScrollDropSupported) {
				if (pos.x + 1 >= $(window).innerWidth() || pos.y + 1 >= $(window).height() || pos.x <= 1 || pos.y <= 1) {
					// dragging outside of the viewport.. most likely the intent is to auto scroll a drop zone
					if (foundTarget) {
						foundTarget = this._getClosestTargetWithScrollSupport(foundTarget.node);
					} else {
						foundTarget = this.lastActiveScrollableTarget;
					}
				}

				if (!foundTarget && this.currentDropTarget) {
					foundTarget = this._getClosestTargetWithScrollSupport(this.currentDropTarget.node);
				}
			}

			return foundTarget || {};
		},

		/**
   * Scan the list containing the ancestors + self and return the first drop zone that suppports scrolling.
   *
   * @param dropTargetNode - the node of the drop target where to start the search
   *
   */
		_getClosestTargetWithScrollSupport: function _getClosestTargetWithScrollSupport(dropTargetNode) {
			var parentsAndSelf = $(dropTargetNode).parents();
			parentsAndSelf.splice(0, 0, dropTargetNode);
			var target = null;
			for (var i = 0; i < parentsAndSelf.length; i++) {
				target = this._getDropTargetWithScrollSupport(parentsAndSelf[i]);
				if (target) {
					this.lastActiveScrollableTarget = target;
					break;
				}
			}

			return target;
		},

		/**
   * Find the drop zone that support scrolling where the node match the given node parameter
   *
   * @param targetNode - node to match with the drop zone node.
   *
   */
		_getDropTargetWithScrollSupport: function _getDropTargetWithScrollSupport(targetNode) {
			var foundTarget = null;

			var dropTarget = _.find(this.dropTargets, function (target) {
				var $elements = $(target.el);
				if (target.selector) {
					$elements = $elements.find(target.selector);
				}

				return _.find($elements, function (node) {
					return node === targetNode && target.callbacks.isScrollDropSupported && (!target.callbacks.accepts || target.callbacks.accepts(this.dragObject));
				}.bind(this));
			}.bind(this));

			if (dropTarget) {
				foundTarget = {
					target: dropTarget,
					node: targetNode
				};
			}
			return foundTarget;
		},

		/**
   * Helper method that gets the current drop target from a position
   * @param pos
   * @param options -- options passed by the called when the startDrag method is called
   * @returns {Object} - drop target
   */
		getDropTargetFromPos: function getDropTargetFromPos(pos, options) {
			var isScrollDropSupported = options && !options.disableScrollableDropZoneSupport;

			var foundTarget = null;
			var foundTargetArea = 0;
			var foundTargetPriority = 0;

			var nonActiveDropZones = [];

			_.each(this.dropTargets, function (target) {
				var $elements = $(target.el);
				if (target.selector) {
					$elements = $elements.find(target.selector);
				}

				_.each($elements, function (node) {

					var info = this.getTargetMatchInformation(pos, node, target, foundTarget, foundTargetArea, foundTargetPriority);
					if (info.isMatch) {
						if (!target.callbacks.accepts || target.callbacks.accepts(this.dragObject)) {
							foundTarget = {
								target: target,
								node: node
							};
							foundTargetArea = info.area;
							foundTargetPriority = info.priority;
						} else if (target.callbacks.receiveEventsWhenNotAccepting) {
							nonActiveDropZones.push({
								target: target,
								node: node
							});
						}
					}
				}.bind(this));
			}.bind(this));

			foundTarget = this._validateDropTarget(foundTarget, isScrollDropSupported, pos);

			if (foundTarget) {
				foundTarget.nonActiveDropZones = nonActiveDropZones;
			}

			return foundTarget || {};
		},

		/**
   * Return true if val is between lowerBound and (lowerBound + rangeSize).
   */
		_isInRange: function _isInRange(val, lowerBound, rangeSize) {
			return val >= lowerBound && val < lowerBound + rangeSize;
		},

		/**
   * return the priority set for target or 0.
   */
		_getPriority: function _getPriority(target) {
			var priority = target.callbacks.priority;
			if (typeof priority === 'function') {
				priority = priority();
			}
			return priority || 0;
		},

		/**
   * Helper function used by getDropTargetFromPos to decide if a drop target is found or not using the current mouse position
   */
		getTargetMatchInformation: function getTargetMatchInformation(pos, node, target, foundTarget, foundTargetArea, foundTargetPriority) {
			var matchInformation = {};
			var $el = $(node);
			var bounds = node.getBoundingClientRect();
			var isVisible = $el.is(':visible');
			if (isVisible) {
				var xInRange = this._isInRange(pos.x, bounds.left, bounds.width);
				var yInRange = this._isInRange(pos.y, bounds.top, bounds.height);

				if (xInRange && yInRange) {
					matchInformation = {
						area: bounds.width * bounds.height,
						priority: this._getPriority(target)
					};
					matchInformation.isMatch = !foundTarget || matchInformation.priority > foundTargetPriority || foundTargetArea > matchInformation.area && matchInformation.priority >= foundTargetPriority;
				}
			}

			return matchInformation;
		},

		/**
   * Helper method that gets the current drop target from a node
   * @param pos
   * @returns {Object} - drop target
   */
		getDropTargetFromNode: function getDropTargetFromNode(node) {

			var target = null;
			for (var i = 0; i < this.dropTargets.length; i++) {
				if (node === this.dropTargets[i].el) {
					target = this.dropTargets[i];
					break;
				}
			}

			return target;
		},

		dragObject: null,
		/**
   * Called to start dragging
   * @param options
   *		options.event ev - the event used to start the drag. e.g. mousedown, touchstart
   *		options.type - The type of the data being dropped.
   *		options.data - The data being dropped.
   *		options.avatar - the avatar node associated with the drag and drop operation
   *		options.avatarXOffset - the number of pixel added to the avatar left position
   *		options.avatarYOffset - the number of pixel added to the avatar top position
   *		options.restrictToXAxis - restrict moving on the x axis
   *		options.restrictToYAxis - restrict moving on the y axis
   *
   *		options.callerCallbacks
   *			callerCallback.onDragStart(event, {dragObject}) - Called when the drag is started.
   *			callerCallback.onMove(event, {dragObject, dropNode}) - Called on every move event.
   *			callerCallback.onDragDone(event, {dragObject, dropNode, isDropped}) - Called when the drag is complete, whether we droppped or not.
   *
   *		options.moveXThreshold - the number of pixel to move on the X axis before we allow the drag to start. A good example to use this is
   *			when want to enable a drag horizontally and still allow vertical scrolling/panning. In this case, we would set the moveXThreshold to something like 30.
   *			This will allow vertical scroll as long as we don't drag horizontally more that 30 pixels.
   *
   *		options.moveYThreshold - the number of pixel to move on the Y axis before we allow the drag to start.
   *
   * @param moveThreshold - distance in pixel that will activate the move and the avatar
   */
		startDrag: function startDrag(options) {
			if (this.dragObject) {
				// cannot start another drag operation until the previous one is finished
				return;
			}
			$('body').addClass('preventSelection');
			this.isDragStartCalled = false;

			this.targetMap = {};

			var isTouch = utils.isTouchEvent(options.event);
			this.dragObject = {
				type: options.type,
				data: options.data,
				avatar: options.avatar,
				isTouch: isTouch || options.event.gesture !== undefined
			};

			var eventPos = utils.getEventPos(options.event);
			this.dragObject.startPosition = {
				x: eventPos.pageX,
				y: eventPos.pageY
			};

			this.setAvatar(options.avatar, options);

			this.callerCallbacks = options.callerCallbacks ? options.callerCallbacks : {};

			var $target = $(window);
			if (isTouch) {
				$target = $(utils.getEventTarget(options.event));
			}
			this.attachedMoveHandler = this.on($target, 'mousemove touchmove', this.moveHandler.bind(this, options));
			this.attachedUpHandler = this.on($target, 'mouseup touchend touchcancel', this.upHandler.bind(this));
			if (options.event.type === 'mousedown') {
				this.attachedScrollHandler = this.on($(options.event.target), 'scroll', this.scrollHandler.bind(this));
			}

			if (options.currentDropZoneNode) {
				var target = this.getDropTargetFromNode(options.currentDropZoneNode);
				if (target) {
					this.currentDropTarget = {
						target: target,
						node: options.currentDropZoneNode
					};
				}
			}
		},

		scrollHandler: function scrollHandler() /* event */{
			// we are scrolling, do not track movement
			// cancel drag
			// IE does not fire mouseUp on scrollbar so drag move continues after releasing the mouse when it should not
			this.resetDragging();
		},

		_setAvatarPosition: function _setAvatarPosition(options) {
			if (this.avatar && this.dragObject.position) {
				if (!this.avatar.parentNode) {
					$('body').append(this.avatar);
				}

				var xOffset = options && options.avatarXOffset ? options.avatarXOffset : 1;
				var yOffset = options && options.avatarYOffset ? options.avatarYOffset : 1;
				$(this.avatar).css({
					left: this.dragObject.position.x + xOffset + 'px',
					top: this.dragObject.position.y + yOffset + 'px'
				});
			}
		},

		setAvatar: function setAvatar(avatar, options) {
			this.avatar = avatar;
			this._setAvatarPosition(options);
		},

		/**
   * Move event main handler
   * @param options - drag options
   * @param ev
   */
		moveHandler: function moveHandler(options, ev) {

			//Always prevent the default behavior on drag move to prevent chrome auto scrolling
			ev.preventDefault();

			var eventPos = utils.getEventPos(ev);
			var dx = eventPos.pageX;
			var dy = eventPos.pageY;

			this.dragObject.position = {
				x: dx,
				y: dy
			};

			if (options.restrictToXAxis) {
				this.dragObject.position.y = this.dragObject.startPosition.y;
			}

			if (options.restrictToYAxis) {
				this.dragObject.position.x = this.dragObject.startPosition.x;
			}

			if (!this.isDragStartCalled && this._isThresholdNotMet(options)) {
				return;
			}

			this._setAvatarPosition(options);
			var dropTarget = this.getDropTargetFromPos(this.dragObject.position, options);

			this._callStartDrag(ev);

			this._callMove(dropTarget, ev);

			this._processCallbacks(dropTarget);

			// Don't stop the propagation. This will interfere with hammer gestures like tap and hold.
			// If there is an active tap/hold handlers, hammer needs to know when there is a move.
		},

		_processCallbacks: function _processCallbacks(dropTarget) {

			var currentNonActiveDropZones = this.currentDropTarget.nonActiveDropZones;

			// Process the callback for the active drop zone that accepted the drop
			if (dropTarget.target !== this.currentDropTarget.target || dropTarget.node !== this.currentDropTarget.node) {
				this._dropTargetCallback(this.currentDropTarget, 'onDragLeave');
				this.currentDropTarget = dropTarget;
				this._dropTargetCallback(this.currentDropTarget, 'onDragEnter');
			} else {
				this._dropTargetCallback(this.currentDropTarget, 'onDragMove');
			}

			// Process callback for drop zone that didn't accept but chose to receive the event anyway
			this._processCallbacksForNonActiveDropzones(dropTarget.nonActiveDropZones, currentNonActiveDropZones);
		},

		_processCallbacksForNonActiveDropzones: function _processCallbacksForNonActiveDropzones(newDropZones, oldDropZones) {

			_.each(newDropZones, function (dropZone) {
				if (this._isDropZoneInArray(dropZone, oldDropZones)) {
					this._dropTargetCallback(dropZone, 'onDragMove');
				} else {
					this._dropTargetCallback(dropZone, 'onDragEnter');
				}
			}.bind(this));

			if (oldDropZones) {
				_.each(oldDropZones, function (dropZone) {
					if (!this._isDropZoneInArray(dropZone, newDropZones)) {
						this._dropTargetCallback(dropZone, 'onDragLeave');
					}
				}.bind(this));
			}

			this.currentDropTarget.nonActiveDropZones = newDropZones;
		},

		_dropTargetCallback: function _dropTargetCallback(dropTarget, callbackName) {
			if (dropTarget.target && dropTarget.target.callbacks[callbackName]) {
				dropTarget.target.callbacks[callbackName](this.dragObject, dropTarget.node);
				return true;
			}
			return false;
		},
		_isDropZoneInArray: function _isDropZoneInArray(dropZone, dropZoneArray) {
			var found = false;
			if (dropZoneArray) {
				for (var i = 0; i < dropZoneArray.length; i++) {
					if (dropZone.target === dropZoneArray[i].target) {
						found = true;
						break;
					}
				}
			}

			return found;
		},

		_isThresholdNotMet: function _isThresholdNotMet(options) {
			var hasThreshold = options.moveXThreshold || options.moveYThreshold;
			var isXThresholdNotMet = !options.moveXThreshold || options.moveXThreshold > Math.abs(this.dragObject.position.x - this.dragObject.startPosition.x);
			var isYThresholdNotMet = !options.moveYThreshold || options.moveYThreshold > Math.abs(this.dragObject.position.y - this.dragObject.startPosition.y);

			return hasThreshold && isXThresholdNotMet && isYThresholdNotMet;
		},

		_callMove: function _callMove(dropTarget, ev) {
			if (this.callerCallbacks.onMove) {
				this.callerCallbacks.onMove(ev, {
					dragObject: this.dragObject,
					dropTargetNode: dropTarget.node
				});
			}
		},

		_callStartDrag: function _callStartDrag(ev) {
			if (this.callerCallbacks.onDragStart && !this.isDragStartCalled) {
				this.callerCallbacks.onDragStart(ev, { dragObject: this.dragObject });

				_.each(this.dropTargets, function (target) {
					if (target.callbacks.onDragStart) {
						target.callbacks.onDragStart(this.dragObject);
					}
				}.bind(this));
			}
			$('body').addClass('dragging');
			this.isDragStartCalled = true;
		},

		/**
   *  mouseup/touchend main handler
   *
   * @param ev
   */
		upHandler: function upHandler(ev) {
			if (this.isDragStartCalled) {
				var isDropped = false;
				$('body').removeClass('dragging');

				var dropTarget = this.currentDropTarget;
				if (this._dropTargetCallback(dropTarget, 'onDrop')) {
					isDropped = true;
				}

				if (this.callerCallbacks.onDragDone) {
					this.callerCallbacks.onDragDone(ev, {
						dragObject: this.dragObject,
						dropTargetNode: isDropped ? dropTarget.node : null,
						isDropped: isDropped
					});
				}

				if (dropTarget.nonActiveDropZones) {
					_.each(dropTarget.nonActiveDropZones, function (dropZone) {
						this._dropTargetCallback(dropZone, 'onDrop');
					}.bind(this));
				}

				_.each(this.dropTargets, function (target) {
					if (target.callbacks.onDragEnd) {
						target.callbacks.onDragEnd(this.dragObject);
					}
				}.bind(this));
			}

			this.resetDragging();

			// Don't stop the propagation. This will interfere with hammer gestures like tap and hold.
			// If there is an active tap/hold handlers, hammer needs to know when the touch ends.
		},
		resetDragging: function resetDragging() {

			// Release the capture that we set in the mouse down.
			// This is used to allow IE to keep firing the mouse event when the mouse leaves the window or iframe
			if (document.releaseCapture) {
				document.releaseCapture();
			}

			if (this.attachedMoveHandler) {
				this.attachedMoveHandler.remove();
			}
			if (this.attachedUpHandler) {
				this.attachedUpHandler.remove();
			}

			if (this.attachedScrollHandler) {
				this.attachedScrollHandler.remove();
			}

			$('body').removeClass('preventSelection');
			this.currentDropTarget = {};
			this.dragObject = null;
			this.isDragStartCalled = false;
			this.targetMap = null;
			this.lastActiveScrollableTarget = null;

			$(this.avatar).remove();
		}
	});

	return new DnDManager();
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
//# sourceMappingURL=DnDManager.js.map

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2014, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
	'use strict';

	return {
		getAncestorOfClass: function getAncestorOfClass(node, className) {
			var doc = document;
			while (node && node !== doc) {
				if (node.className.split(' ').indexOf(className) >= 0) {
					return node;
				}
				node = node.parentNode;
			}

			return null;
		},

		isTouchEvent: function isTouchEvent(ev) {
			return ev.type.indexOf('touch') === 0;
		},

		isPointerTouch: function isPointerTouch(ev) {
			return ev.gesture && ev.gesture.pointerType === 'touch';
		},

		isMultiTouchEvent: function isMultiTouchEvent(ev) {
			var oev = ev.originalEvent || ev;
			if (oev && oev.touches && oev.touches.length > 1) {
				return true;
			}
			return false;
		},

		isGesture: function isGesture(ev) {
			if (ev.gesture && ev.gesture.touches && ev.gesture.touches.length > 0) {
				return true;
			}
			return false;
		},

		getEventPos: function getEventPos(ev) {
			var pageValuesValid = function pageValuesValid(event) {
				return event && (event.pageX || event.pageX === 0) && (event.pageY || event.pageY === 0);
			};

			var pos;
			if (this.isGesture(ev)) {
				var touches = ev.gesture.touches[0];
				if (pageValuesValid(touches)) {
					pos = {
						pageX: touches.pageX,
						pageY: touches.pageY
					};
				}
			}
			if (!pos && this.isTouchEvent(ev)) {
				var oev = ev.originalEvent || ev;
				if (oev && oev.touches.length > 0 && pageValuesValid(oev.touches[0])) {
					pos = { pageX: oev.touches[0].pageX, pageY: oev.touches[0].pageY };
				}
			}
			if (!pos && pageValuesValid(ev)) {
				pos = { pageX: ev.pageX, pageY: ev.pageY };
			}
			if (!pos && pageValuesValid(ev.originalEvent)) {
				pos = { pageX: ev.originalEvent.pageX, pageY: ev.originalEvent.pageY };
			}
			if (!pos) {
				// could not find any valid numbers so return zero.  Returning undefined values breaks some other code.
				pos = { pageX: 0, pageY: 0 };
			}
			return pos;
		},

		getEventTarget: function getEventTarget(ev) {
			if (this.isTouchEvent(ev)) {
				var oev = ev.originalEvent || ev;
				if (oev && oev.touches.length > 0) {
					return oev.touches[0].target;
				}
			}
			return ev.target;
		},

		withinElementBoundaries: function withinElementBoundaries(event, node) {
			var pos = this.getEventPos(event);
			var boundingRect = node.getBoundingClientRect();
			var inXRange = pos.pageX >= boundingRect.left && pos.pageX <= boundingRect.right;
			var inYRange = pos.pageY >= boundingRect.top && pos.pageY <= boundingRect.bottom;

			return inXRange && inYRange;
		}

	};
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
//# sourceMappingURL=dom-utils.js.map

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_61__;

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_62__;

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_63__;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _ContentPanel = __webpack_require__(65);

var _ContentPanel2 = _interopRequireDefault(_ContentPanel);

var _PackagePanel = __webpack_require__(81);

var _PackagePanel2 = _interopRequireDefault(_PackagePanel);

var _ToastEnum = __webpack_require__(33);

var _ToastEnum2 = _interopRequireDefault(_ToastEnum);

var _baUiCarbonToolkit = __webpack_require__(3);

__webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

// Schematic Editor class
var SchematicEditor = function (_Component) {
	_inherits(SchematicEditor, _Component);

	// Constructor
	// State consists of property to define whether or not the dialog is open or closed,
	// the selectedTab for the tab panel and the selected item in the select drop down list
	function SchematicEditor(props) {
		_classCallCheck(this, SchematicEditor);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.componentDidMount = function () {};

		_this.openDialog = function () {
			_this.setState({ isDialogOpen: true });
		};

		_this.applyDialog = function () {
			// normally just call the OK callback - but wrap in a function for any housekeeping
			_this.props.okCallbackFn(_this.state.definition);
			_this.closeDialog();
		};

		_this.closeDialog = function () {
			var onCloseDialog = _this.props.onCloseDialog;

			_this.setState({ isDialogOpen: false }, function () {
				if (onCloseDialog) {
					onCloseDialog();
				}
			});
		};

		_this._cloneJsonObject = function (_object) {
			return JSON.parse(JSON.stringify(_object));
		};

		_this._renderGlobalToast = function () {
			var toastMsg = _this.state.toastMsg;

			return toastMsg && toastMsg.type && toastMsg.info && _react2.default.createElement(_baUiCarbonToolkit.GlobalToast, {
				statusType: toastMsg.type,
				timedDismiss: true,
				contentString: toastMsg.info,
				targetId: 'schematicEditorToastTargetId',
				onClose: function onClose() {
					_this.setState({ toastMsg: null });
				} });
		};

		_this._updatePackageInfo = function (_result) {
			var newDefinition = _this._cloneJsonObject(_this.state.definition);
			newDefinition.meta[_result.name] = _result.value;
			_this.setState({
				definition: newDefinition
			});
		};

		_this._handleContentChange = function (_result) {
			_this.setState(_result);
		};

		_this._iconLoadFailed = function (_error) {
			_this.setState({
				toastMsg: {
					type: _ToastEnum2.default.ERROR,
					info: _error.message
				}
			});
		};

		_this._handleIconLoad = function (_fileName, _blobUrl) {
			var newDefinition = _this._cloneJsonObject(_this.state.definition);
			newDefinition.meta.icon = _fileName;
			newDefinition.iconUrl = _blobUrl;

			var msg = _fileName ? _StringResources2.default.get('schematicsIconAdded', { file: _fileName }) : _StringResources2.default.get('schematicsIconRemove');
			_this.setState({
				toastMsg: {
					type: _ToastEnum2.default.SUCCESS,
					info: msg
				},
				definition: newDefinition
			});
		};

		_this.addSvgFilesButtonRef = null;

		// need to clone the definition from input props
		var stateDefinition = _this._cloneJsonObject(_this.props.definition);

		_this.state = {
			isDialogOpen: false,
			definition: stateDefinition,
			selectedIndices: [],
			search: '',
			searchMatches: null,
			toastMsg: null,
			svgFiles: null,
			selectedTab: 'schematicEditorContentTab',
			tabs: null
		};
		return _this;
	}

	/**
 * componentDidMount - Lifecycle method. Executes before first render. Executes when the element is inserted into the virtual DOM but before the HTML node itself can be manipulated.
 * Use this point to configure the element as required based on properties passed upon creation
 **/


	// Update the state when the package details(name or description) have changed


	// Function used to render the CustomPalette element (dialog)
	SchematicEditor.prototype.render = function render() {
		var _this2 = this;

		var dialogTitle = _StringResources2.default.get('editSchematic');
		var contentTabTitle = _StringResources2.default.get('schematicsContentTab');
		var packageTabTitle = _StringResources2.default.get('schematicsPackageTab');

		var _props = this.props,
		    zipMaxSize = _props.zipMaxSize,
		    imgMaxSize = _props.imgMaxSize;
		var _state = this.state,
		    isDialogOpen = _state.isDialogOpen,
		    selectedTab = _state.selectedTab,
		    tabs = _state.tabs,
		    definition = _state.definition,
		    svgFiles = _state.svgFiles,
		    selectedIndices = _state.selectedIndices,
		    search = _state.search,
		    searchMatches = _state.searchMatches;


		return isDialogOpen && _react2.default.createElement(
			'div',
			null,
			this._renderGlobalToast(),
			_react2.default.createElement(
				_baUiCarbonToolkit.Dialog,
				{ width: '920px', onClose: this.closeDialog, startingFocusIndex: 0 },
				_react2.default.createElement(
					_baUiCarbonToolkit.Dialog.Header,
					{ id: 'schematicEditorToastTargetId' },
					dialogTitle
				),
				_react2.default.createElement(
					_baUiCarbonToolkit.Dialog.Body,
					null,
					_react2.default.createElement(
						_baUiCarbonToolkit.Tabs,
						{
							draggable: false,
							selected: selectedTab,
							onChange: function onChange(tabId) {
								return _this2.setState({ selectedTab: tabId });
							},
							stateTabs: tabs,
							className: 'clsSVGEditorTabs'
						},
						_react2.default.createElement(
							_baUiCarbonToolkit.TabPanel,
							{ id: 'schematicEditorPackageTab', label: packageTabTitle },
							_react2.default.createElement(_PackagePanel2.default, {
								packageName: definition.meta.name,
								packageDescription: definition.meta.description,
								iconName: definition.meta.icon,
								iconURL: definition.iconUrl,
								zipMaxSize: zipMaxSize,
								imgMaxSize: imgMaxSize,
								onChange: this._updatePackageInfo,
								onIconChanged: this._handleIconLoad,
								onIconError: this._iconLoadFailed
							})
						),
						_react2.default.createElement(
							_baUiCarbonToolkit.TabPanel,
							{ id: 'schematicEditorContentTab', label: contentTabTitle },
							_react2.default.createElement(_ContentPanel2.default, {
								definition: definition,
								svgFiles: svgFiles,
								selectedIndices: selectedIndices,
								search: search,
								searchMatches: searchMatches,
								zipMaxSize: zipMaxSize,
								imgMaxSize: imgMaxSize,
								onChange: this._handleContentChange
							})
						)
					)
				),
				_react2.default.createElement(
					_baUiCarbonToolkit.Dialog.Footer,
					{ id: 'schematicEditorFooterId' },
					_react2.default.createElement(_baUiCarbonToolkit.Dialog.Button, { id: 'idCancelBtn', label: _StringResources2.default.get('cancelDialog'), onClick: this.closeDialog, tabIndex: 0 }),
					_react2.default.createElement(_baUiCarbonToolkit.Dialog.Button, { id: 'idOkBtn', autofocus: true, label: _StringResources2.default.get('saveDialog'), onClick: this.applyDialog, tabIndex: 0, primary: true })
				)
			)
		);
	};

	return SchematicEditor;
}(_react.Component);

SchematicEditor.propTypes = {
	definition: _propTypes2.default.object.isRequired,
	okCallbackFn: _propTypes2.default.func.isRequired,
	onCloseDialog: _propTypes2.default.func,
	zipMaxSize: _propTypes2.default.number,
	imgMaxSize: _propTypes2.default.number };
exports.default = SchematicEditor;


SchematicEditor.defaultProps = {
	zipMaxSize: 500,
	imgMaxSize: 500
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _ConfirmReplaceDialog = __webpack_require__(66);

var _ConfirmReplaceDialog2 = _interopRequireDefault(_ConfirmReplaceDialog);

var _ItemDetail = __webpack_require__(67);

var _ItemDetail2 = _interopRequireDefault(_ItemDetail);

var _ToastEnum = __webpack_require__(33);

var _ToastEnum2 = _interopRequireDefault(_ToastEnum);

var _VisualItems = __webpack_require__(68);

var _VisualItems2 = _interopRequireDefault(_VisualItems);

var _SVGFileInput = __webpack_require__(72);

var _SVGFileInput2 = _interopRequireDefault(_SVGFileInput);

var _baUiCarbonToolkit = __webpack_require__(3);

var _baUiCarbon = __webpack_require__(14);

var _upload_ = __webpack_require__(80);

var _upload_2 = _interopRequireDefault(_upload_);

__webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var ContentPanel = function (_Component) {
	_inherits(ContentPanel, _Component);

	function ContentPanel(props) {
		_classCallCheck(this, ContentPanel);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this._cloneJsonObject = function (_object) {
			return JSON.parse(JSON.stringify(_object));
		};

		_this._findSearchMatches = function (value) {
			var _this$props = _this.props,
			    definition = _this$props.definition,
			    onChange = _this$props.onChange;

			var matchIndices = null;
			// if the value is empty - there's nothing being searched
			if (value) {
				matchIndices = [];
				definition.meta.content.forEach(function (item, j) {
					if (item.caption.toLowerCase().indexOf(value.toLowerCase()) !== -1) matchIndices.push(j);
				});
			}

			onChange({
				search: value,
				searchMatches: matchIndices
			});
		};

		_this._updateItem = function (property, value, index) {
			var _this$props2 = _this.props,
			    definition = _this$props2.definition,
			    onChange = _this$props2.onChange;

			var newDefinition = _this._cloneJsonObject(definition);
			newDefinition.meta.content = newDefinition.meta.content.map(function (item, j) {
				if (j === index) {
					item[property] = value;
				}
				return item;
			});

			onChange({
				definition: newDefinition
			});
		};

		_this._updateSVGFiles = function (sourceNames, blobUrls, action, applyToAll, replaceIdx) {
			var _this$props3 = _this.props,
			    definition = _this$props3.definition,
			    onChange = _this$props3.onChange;

			var newDefinition = _this._cloneJsonObject(definition);
			var count = 0;
			while (sourceNames.length > 0) {
				var sourceName = sourceNames[0];
				var blobUrl = blobUrls[0];
				var existIdx = -1;
				for (var idx = 0; idx < newDefinition.meta.content.length; ++idx) {
					if (newDefinition.meta.content[idx].source === sourceName) {
						existIdx = idx;
						break;
					}
				}

				if (replaceIdx >= 0 && replaceIdx < newDefinition.meta.content.length) {
					newDefinition.files[replaceIdx] = blobUrl;
					count = 1;
				} else if (existIdx >= 0) {
					if (action === 'confirm') break;

					if (action === 'replace') {
						newDefinition.files[existIdx] = blobUrl;
						count++;
					}
				} else {
					newDefinition.meta.content.push({
						'key': sourceName,
						'caption': sourceName,
						'source': sourceName
					});
					newDefinition.files.push(blobUrl);
					count++;
				}

				sourceNames.shift();
				blobUrls.shift();

				if (!applyToAll) action = 'confirm';
			}

			var toastMsg = count ? { type: _ToastEnum2.default.SUCCESS } : null;
			if (count === 1) toastMsg.info = _StringResources2.default.get('schematicsSingleAddSuccessed');else if (count > 1) toastMsg.info = _StringResources2.default.get('schematicsMultipleAddSuccessed', { 'count': count });

			onChange({
				definition: newDefinition,
				svgFiles: sourceNames.length > 0 ? { 'sourceNames': sourceNames, 'blobUrls': blobUrls } : null,
				search: '',
				searchMatches: null,
				toastMsg: toastMsg
			});
		};

		_this._newSvgFiles = function (sourceNames, blobUrls, replaceIdx) {
			_this._updateSVGFiles(sourceNames, blobUrls, 'confirm', false, replaceIdx);
		};

		_this._toastSchematicsAddFailed = function (_error) {
			_this.props.onChange({
				toastMsg: {
					type: _ToastEnum2.default.ERROR,
					info: _error && _error.message || _StringResources2.default.get('schematicsAddFailed')
				}
			});
		};

		_this._toggleSelection = function (idx, multiSelect) {
			var _this$props4 = _this.props,
			    selectedIndices = _this$props4.selectedIndices,
			    onChange = _this$props4.onChange;


			var newSelectedIndices = _this._cloneJsonObject(selectedIndices);

			var index = newSelectedIndices.indexOf(idx);
			if (index !== -1 && multiSelect) {
				newSelectedIndices.splice(index, 1);
			} else {
				if (multiSelect) newSelectedIndices.push(idx);else newSelectedIndices = newSelectedIndices.find(function (item) {
					return item === idx;
				}) !== undefined ? [] : [idx];
			}

			onChange({
				selectedIndices: newSelectedIndices
			});
		};

		_this._replaceSelected = function () {
			if (_this.replaceSvgFilesInputRef) {
				var selectedIndices = _this.props.selectedIndices;

				_this.replaceSvgFilesInputRef.openFileSelector(false, selectedIndices[0]);
			}
		};

		_this._deleteSelected = function () {
			var selectedIndices = _this.props.selectedIndices;

			_this._handleDeletions(selectedIndices);
		};

		_this._handleDeletions = function (itemIdxArray) {
			var _this$props5 = _this.props,
			    definition = _this$props5.definition,
			    searchMatches = _this$props5.searchMatches,
			    selectedIndices = _this$props5.selectedIndices,
			    onChange = _this$props5.onChange;

			if (itemIdxArray.length > 0) {
				var deletedCount = 0;

				var newDefinition = {
					meta: function (_ref) {
						var clone = _objectWithoutProperties(_ref, []);

						return clone;
					}(definition.meta),
					files: []
				};

				// Add the icon if defined
				if (definition.iconUrl) {
					newDefinition.iconUrl = definition.iconUrl;
				}

				newDefinition.meta.content = [];

				var newSelectedIndices = [];
				var newSearchMatches = searchMatches ? [] : null;
				for (var idx = 0; idx < definition.files.length; ++idx) {
					if (!(itemIdxArray.indexOf(idx) !== -1)) {
						newDefinition.meta.content.push(definition.meta.content[idx]);
						newDefinition.files.push(definition.files[idx]);
						var newIdx = newDefinition.files.length - 1;
						if (selectedIndices.indexOf(idx) !== -1) {
							newSelectedIndices.push(newIdx);
						}
						if (searchMatches && searchMatches.indexOf(idx) !== -1) {
							newSearchMatches.push(newIdx);
						}
					} else {
						deletedCount += 1;
					}
				}

				if (deletedCount > 0) {
					var toastInfo = deletedCount === 1 ? _StringResources2.default.get('schematicsSingleDeletionSuccessed') : _StringResources2.default.get('schematicsMultipleDeletionSuccessed', { count: deletedCount });

					onChange({
						selectedIndices: newSelectedIndices,
						searchMatches: newSearchMatches,
						definition: newDefinition,
						toastMsg: {
							type: _ToastEnum2.default.SUCCESS,
							info: toastInfo
						}
					});
				}
			}
		};

		_this._replaceAddSVGFiles = function (applyToAll) {
			var newSvgFiles = _this._cloneJsonObject(_this.props.svgFiles);
			_this._updateSVGFiles(newSvgFiles.sourceNames, newSvgFiles.blobUrls, 'replace', applyToAll);
		};

		_this._cancelAddSVGFiles = function (applyToAll) {
			var newSvgFiles = _this._cloneJsonObject(_this.props.svgFiles);
			_this._updateSVGFiles(newSvgFiles.sourceNames, newSvgFiles.blobUrls, 'cancel', applyToAll);
		};

		_this._renderHeader = function (selectedCount) {
			if (selectedCount > 0) return _this._renderBatchActions(selectedCount);

			var searchTitle = _StringResources2.default.get('searchSchematic');
			var _this$props6 = _this.props,
			    search = _this$props6.search,
			    definition = _this$props6.definition,
			    onChange = _this$props6.onChange,
			    zipMaxSize = _this$props6.zipMaxSize,
			    imgMaxSize = _this$props6.imgMaxSize;

			return _react2.default.createElement(
				'div',
				{ style: { display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', flexGrow: 1 } },
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_baUiCarbonToolkit.SearchInput, {
						light: true,
						tabIndex: 0,
						placeholder: searchTitle,
						className: 'clsSVGSearch',
						value: search,
						disabled: definition.meta.content.length === 0,
						onChange: _this._findSearchMatches,
						onClear: function onClear() {
							return onChange({ search: '', searchMatches: null });
						}
					})
				),
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_SVGFileInput2.default, {
						ref: function ref(_ref2) {
							_this.addSvgFilesInputRef = _ref2;
						},
						successCallback: _this._newSvgFiles,
						failCallback: _this._toastSchematicsAddFailed,
						zipMaxSize: zipMaxSize,
						imgMaxSize: imgMaxSize
					}),
					_react2.default.createElement(
						_baUiCarbonToolkit.Button,
						{
							icon: _upload_2.default.id,
							kind: 'ghost',
							onClick: function onClick() {
								return _this.addSvgFilesInputRef ? _this.addSvgFilesInputRef.openFileSelector(true) : {};
							},
							title: _StringResources2.default.get('addSchematic')
						},
						' ',
						_StringResources2.default.get('addSchematic'),
						' '
					)
				)
			);
		};

		_this._renderBatchActions = function (selectedCount) {
			var _this$props7 = _this.props,
			    zipMaxSize = _this$props7.zipMaxSize,
			    imgMaxSize = _this$props7.imgMaxSize;

			return _react2.default.createElement(
				_baUiCarbon.TableToolbar,
				null,
				_react2.default.createElement(
					_baUiCarbon.TableBatchActions,
					{
						style: { justifyContent: 'space-between' },
						totalSelected: selectedCount,
						shouldShowBatchActions: true,
						onCancel: function onCancel() {
							_this.props.onChange({ selectedIndices: [] });
						} },
					selectedCount === 1 ? _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_baUiCarbon.TableBatchAction,
							{
								isVisible: selectedCount === 1,
								tabIndex: selectedCount === 1 ? 0 : -1,
								onClick: function onClick() {
									_this._replaceSelected();
								},
								renderIcon: function renderIcon() {
									return null;
								} },
							_StringResources2.default.get('schematicsContextMenuReplace')
						),
						_react2.default.createElement(_SVGFileInput2.default, {
							ref: function ref(_ref3) {
								_this.replaceSvgFilesInputRef = _ref3;
							},
							successCallback: _this._newSvgFiles,
							failCallback: _this._toastSchematicsAddFailed,
							zipMaxSize: zipMaxSize,
							imgMaxSize: imgMaxSize
						})
					) : null,
					_react2.default.createElement(
						_baUiCarbon.TableBatchAction,
						{
							tabIndex: 0,
							onClick: function onClick() {
								_this._deleteSelected();
							},
							renderIcon: function renderIcon() {
								return null;
							} },
						_StringResources2.default.get('schematicsContextMenuDelete')
					)
				)
			);
		};

		return _this;
	}

	// update the state when a property value is changed


	// add button parameters: action, applyToAll
	// contextMenu replace parameters: replaceIdx


	//
	// Main render function
	//
	ContentPanel.prototype.render = function render() {
		var _props = this.props,
		    selectedIndices = _props.selectedIndices,
		    searchMatches = _props.searchMatches,
		    definition = _props.definition,
		    onChange = _props.onChange,
		    svgFiles = _props.svgFiles;
		// calculate the values which drive the detail panel. Have to take into account the searchMatches - which
		// reduces the set of items to see

		var filteredItems = !searchMatches ? selectedIndices : selectedIndices.filter(function (value) {
			return searchMatches.indexOf(value) !== -1;
		});
		var selectedCount = filteredItems.length;
		var selectedItem = selectedCount === 1 ? definition.meta.content[filteredItems[0]] : {};
		var selectedFileRef = selectedCount === 1 ? definition.files[filteredItems[0]] : '';
		var selectedIndex = selectedCount === 1 ? filteredItems[0] : -1;

		return _react2.default.createElement(
			'div',
			{ className: 'clsSVGTabsStyle' },
			_react2.default.createElement(_baUiCarbonToolkit.VSpacer, { size: 2 }),
			this._renderHeader(selectedCount),
			_react2.default.createElement(_baUiCarbonToolkit.VSpacer, { size: 2 }),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexLayout,
				{
					direction: 'row',
					justifyContent: 'space-between',
					alignItems: 'stretch',
					style: { width: '100%' }
				},
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					{
						style: { width: '593px' }
					},
					_react2.default.createElement(_VisualItems2.default, {
						items: definition.meta.content,
						files: definition.files,
						selections: selectedIndices,
						searchMatches: searchMatches,
						selectVisualItemCallback: this._toggleSelection,
						deSelectAllCallback: function deSelectAllCallback() {
							onChange({
								selectedIndices: []
							});
						}
					})
				),
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					null,
					_react2.default.createElement(_baUiCarbonToolkit.HSpacer, { size: 1 })
				),
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					{
						style: { width: '271px' }
					},
					_react2.default.createElement(_ItemDetail2.default, {
						item: selectedItem,
						fileRef: selectedFileRef,
						index: selectedIndex,
						selectionCount: selectedCount,
						updateItemCallback: this._updateItem
					})
				)
			),
			!!svgFiles && _react2.default.createElement(_ConfirmReplaceDialog2.default, {
				sourceName: svgFiles ? svgFiles.sourceNames[0] : '',
				isApplyToAll: false,
				okCallback: this._replaceAddSVGFiles,
				cancelCallback: this._cancelAddSVGFiles
			})
		);
	};

	return ContentPanel;
}(_react.Component);

ContentPanel.propTypes = {
	definition: _propTypes2.default.object.isRequired,
	svgFiles: _propTypes2.default.object,
	selectedIndices: _propTypes2.default.array.isRequired,
	search: _propTypes2.default.string.isRequired,
	searchMatches: _propTypes2.default.array,
	zipMaxSize: _propTypes2.default.number,
	imgMaxSize: _propTypes2.default.number,
	onChange: _propTypes2.default.func.isRequired
};
exports.default = ContentPanel;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _baUiCarbonToolkit = __webpack_require__(3);

__webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var ConfirmReplaceDialog = function (_Component) {
	_inherits(ConfirmReplaceDialog, _Component);

	function ConfirmReplaceDialog(props) {
		_classCallCheck(this, ConfirmReplaceDialog);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this._replace = function () {
			_this.props.okCallback(_this.state.isApplyToAll);
		};

		_this._cancel = function () {
			_this.props.cancelCallback(_this.state.isApplyToAll);
		};

		_this.state = {
			isApplyToAll: _this.props.isApplyToAll
		};
		return _this;
	}

	ConfirmReplaceDialog.prototype.render = function render() {
		var _this2 = this;

		return _react2.default.createElement(
			_baUiCarbonToolkit.Dialog,
			{ width: '500px', onClose: this._cancel, startingFocusIndex: 0 },
			_react2.default.createElement(
				_baUiCarbonToolkit.Dialog.Header,
				null,
				_StringResources2.default.get('schematicsReplaceDlgTitle')
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.Dialog.Body,
				null,
				_react2.default.createElement(
					'div',
					{ style: { marginTop: '8px' } },
					_StringResources2.default.get('schematicsReplaceDlgContent', { 'sourceName': this.props.sourceName })
				),
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexLayout,
					{
						direction: 'column',
						width: '100%',
						height: '100%',
						alignItems: 'flex-start',
						justifyContent: 'center',
						style: { marginTop: '8px' }
					},
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						null,
						_react2.default.createElement(_baUiCarbonToolkit.Checkbox, {
							label: _StringResources2.default.get('schematicsReplaceDlgApplyToAllFiles'),
							checked: this.state.isApplyToAll,
							onChange: function onChange() {
								return _this2.setState({ isApplyToAll: !_this2.state.isApplyToAll });
							}
						})
					)
				)
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.Dialog.Footer,
				null,
				_react2.default.createElement(_baUiCarbonToolkit.Dialog.Button, { id: 'idCancelBtn', label: _StringResources2.default.get('cancelDialog'), onClick: this._cancel, tabIndex: 0 }),
				_react2.default.createElement(_baUiCarbonToolkit.Dialog.Button, { id: 'idOkBtn', label: _StringResources2.default.get('okDialog'), onClick: this._replace, tabIndex: 0, primary: true })
			)
		);
	};

	return ConfirmReplaceDialog;
}(_react.Component);

ConfirmReplaceDialog.propTypes = {
	sourceName: _propTypes2.default.string.isRequired,
	isApplyToAll: _propTypes2.default.bool.isRequired,
	okCallback: _propTypes2.default.func.isRequired,
	cancelCallback: _propTypes2.default.func.isRequired
};
exports.default = ConfirmReplaceDialog;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _baUiCarbonToolkit = __webpack_require__(3);

__webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var ItemDetail = function (_Component) {
	_inherits(ItemDetail, _Component);

	function ItemDetail(props) {
		_classCallCheck(this, ItemDetail);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	/* componentWillReceiveProps(nextProps) {
 } */

	ItemDetail.prototype.renderCountSelection = function renderCountSelection() {
		var selectionCount = this.props.selectionCount;


		var label = selectionCount === 0 ? _StringResources2.default.get('schematicsNoSelection') : _StringResources2.default.get('schematicsMultipleSelection', { count: selectionCount });
		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexLayout,
			{
				direction: 'column',
				width: '100%',
				height: '100%',
				alignItems: 'center',
				justifyContent: 'center',
				className: 'clsSVGDetailContainer'
			},
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(_baUiCarbonToolkit.Label, { type: 'caption', label: label })
			)
		);
	};

	ItemDetail.prototype.renderSingleSelection = function renderSingleSelection() {
		var _this2 = this;

		var _props = this.props,
		    item = _props.item,
		    index = _props.index,
		    fileRef = _props.fileRef;


		var nameLabel = _StringResources2.default.get('nameLabelSchematic');
		var captionLabel = _StringResources2.default.get('captionLabelSchematic');
		var keyLabel = _StringResources2.default.get('keyLabelSchematic');

		var sourceUrl = fileRef;
		var source = item.source;
		var caption = item.caption;
		var key = item.key;

		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexLayout,
			{
				direction: 'column',
				width: '100%',
				height: '100%',
				alignItems: 'center',
				className: 'clsSVGDetailContainer'
			},
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexLayout,
					{
						direction: 'column',
						alignItems: 'center',
						justifyContent: 'center',
						className: 'clsSVGDetailStyle'
					},
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						{ style: { width: '100%' } },
						_react2.default.createElement(
							_baUiCarbonToolkit.FlexItem,
							null,
							item && _react2.default.createElement('img', { style: { width: '100%', height: 'auto', maxWidth: '237px', maxHeight: '216px' }, src: sourceUrl })
						)
					)
				)
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(_baUiCarbonToolkit.VSpacer, { size: 2 })
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				{ style: { width: '100%', height: '24px' } },
				_react2.default.createElement(_baUiCarbonToolkit.Label, { type: 'caption', htmlFor: 'nameEdit', label: nameLabel })
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				{ className: 'clsSVGDetailEdit' },
				_react2.default.createElement(_baUiCarbonToolkit.TextInput, {
					id: 'nameEdit',
					value: source,
					disabled: true })
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(_baUiCarbonToolkit.VSpacer, { size: 2 })
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				{ style: { width: '100%', height: '24px' } },
				_react2.default.createElement(_baUiCarbonToolkit.Label, { type: 'caption', htmlFor: 'captionEdit', label: captionLabel })
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				{ className: 'clsSVGDetailEdit' },
				_react2.default.createElement(_baUiCarbonToolkit.TextInput, {
					id: 'captionEdit',
					value: caption,
					onValueChange: function onValueChange(v) {
						_this2.props.updateItemCallback('caption', v, index);
					}
				})
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(_baUiCarbonToolkit.VSpacer, { size: 2 })
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				{ style: { width: '100%', height: '24px' } },
				_react2.default.createElement(_baUiCarbonToolkit.Label, { type: 'caption', htmlFor: 'keyEdit', label: keyLabel })
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				{ className: 'clsSVGDetailEdit' },
				_react2.default.createElement(_baUiCarbonToolkit.TextInput, {
					id: 'keyEdit',
					value: key,
					onValueChange: function onValueChange(v) {
						_this2.props.updateItemCallback('key', v, index);
					}
				})
			)
		);
	};

	ItemDetail.prototype.render = function render() {
		var selectionCount = this.props.selectionCount;


		if (selectionCount === 1) return this.renderSingleSelection();
		return this.renderCountSelection();
	};

	return ItemDetail;
}(_react.Component);

ItemDetail.propTypes = {
	item: _propTypes2.default.object.isRequired,
	fileRef: _propTypes2.default.string.isRequired,
	updateItemCallback: _propTypes2.default.func.isRequired,
	index: _propTypes2.default.number.isRequired,
	selectionCount: _propTypes2.default.number.isRequired
};
exports.default = ItemDetail;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _VisualItem = __webpack_require__(69);

var _VisualItem2 = _interopRequireDefault(_VisualItem);

var _baUiCarbonToolkit = __webpack_require__(3);

__webpack_require__(4);

var _search_ = __webpack_require__(71);

var _search_2 = _interopRequireDefault(_search_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

// search_16 is placeHolder.


//import emptySearchResults from '@ba/ba-graphics/dist/illustrations-js/search-results_128.js';

var VisualItems = function (_Component) {
	_inherits(VisualItems, _Component);

	function VisualItems(props) {
		_classCallCheck(this, VisualItems);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this._renderEmptySearchResults = function () {
			var searchMatches = _this.props.searchMatches;

			if (searchMatches && searchMatches.length === 0) return _react2.default.createElement(
				_baUiCarbonToolkit.FlexLayout,
				{
					direction: 'column',
					width: '100%',
					height: '100%',
					alignItems: 'center',
					justifyContent: 'center'
				},
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					null,
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						null,
						_react2.default.createElement(_baUiCarbonToolkit.SVGIcon, {
							width: 150,
							height: 150,
							focusable: false,
							intent: 'info',
							className: 'svgIcon',
							verticalAlign: 'middle',
							iconId: _search_2.default.id
						})
					),
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						null,
						_react2.default.createElement(_baUiCarbonToolkit.VSpacer, { size: 2 })
					),
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						null,
						_react2.default.createElement(_baUiCarbonToolkit.Label, { label: _StringResources2.default.get('schematicsEmptySearchResults') })
					)
				)
			);
		};

		return _this;
	}

	/* componentWillReceiveProps(nextProps) {
 } */

	VisualItems.prototype.renderVisualizationItem = function renderVisualizationItem(item, fileRef, selected, idx) {
		// remove the props we don't want to pass to each child
		return _react2.default.createElement(_VisualItem2.default, _extends({}, this.props, { key: item.source, item: item, fileRef: fileRef, selected: selected, idx: idx }));
	};

	VisualItems.prototype.render = function render() {
		var _this2 = this;

		var _props = this.props,
		    items = _props.items,
		    files = _props.files,
		    selections = _props.selections,
		    searchMatches = _props.searchMatches;

		var contentItems = [];
		items.forEach(function (item, idx) {
			var selected = selections.indexOf(idx) !== -1;
			if (searchMatches && searchMatches.indexOf(idx) !== -1 || !searchMatches) contentItems.push(_this2.renderVisualizationItem(item, files[idx], selected, idx));
		});

		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexLayout,
			{
				direction: 'row',
				wrap: 'wrap',
				alignItems: 'flex-start',
				justifyContent: 'flex-start',
				style: { alignContent: 'flex-start' },
				className: 'clsSVGTilesStyle',
				onClick: function onClick(e) {
					e.stopPropagation();
					_this2.props.deSelectAllCallback();
				}
			},
			this._renderEmptySearchResults(),
			contentItems
		);
	};

	return VisualItems;
}(_react.Component);

VisualItems.propTypes = {
	items: _propTypes2.default.array.isRequired,
	files: _propTypes2.default.array.isRequired,
	selections: _propTypes2.default.array.isRequired,
	searchMatches: _propTypes2.default.array, // can be null means no search at all, show all items.
	selectVisualItemCallback: _propTypes2.default.func.isRequired,
	deSelectAllCallback: _propTypes2.default.func.isRequired
};
exports.default = VisualItems;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _baUiCarbonToolkit = __webpack_require__(3);

var _checkmarkFilled_ = __webpack_require__(70);

var _checkmarkFilled_2 = _interopRequireDefault(_checkmarkFilled_);

__webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var VisualItem = function (_Component) {
	_inherits(VisualItem, _Component);

	function VisualItem(props) {
		_classCallCheck(this, VisualItem);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this._onClickHandler = function (e) {
			e.stopPropagation();
			_this.props.selectVisualItemCallback(_this.props.idx, e.ctrlKey || e.metaKey);
		};

		_this._onKeyDownHandler = function (e) {
			// implement
			if (e.keyCode === 32 || e.keyCode === 13) {
				// TODO - we should cancel the event
				// but this is react event so outside normal event processing
				// see https://medium.com/@ericclemmons/react-event-preventdefault-78c28c950e46
				// use native event to stop this
				_this.props.selectVisualItemCallback(_this.props.idx, e.ctrlKey || e.metaKey);
			}
		};

		_this._showVisualItemContextMenu = function (idx) {
			_this.props.selectVisualItemCallback(idx);
			_this.props.handleVisualItemContextMenuCallback();
			_this.setState({ isContextMenuOpen: !_this.state.isContextMenuOpen });
		};

		_this._closeVisualItemContextMenu = function () {
			_this.setState({ isContextMenuOpen: false });
		};

		_this._renderItem = function (fileRef) {
			return _react2.default.createElement(
				_baUiCarbonToolkit.FlexLayout,
				{
					direction: 'column',
					role: 'button',
					onClick: _this._onClickHandler,
					onKeyDown: _this._onKeyDownHandler },
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					{ style: { width: '128px', height: '128px' } },
					_this._renderContent(fileRef)
				)
			);
		};

		_this._renderContent = function (fileRef) {
			// all urls are represented as blobs in our files data
			// (implies that any integrator would extract and supply as blobs)
			return _react2.default.createElement(
				_baUiCarbonToolkit.FlexLayout,
				{
					direction: 'column',
					width: '100%',
					height: '100%',
					alignItems: 'center',
					justifyContent: 'center'
				},
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					{ style: { width: '100%' } },
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						null,
						_react2.default.createElement('img', { style: { width: '100%', height: 'auto', maxWidth: '108px', maxHeight: '108px' },
							src: fileRef
						})
					)
				)
			);
		};

		_this._renderItemLabel = function (item) {
			return _react2.default.createElement(_baUiCarbonToolkit.Label, { label: item.caption, ellipsis: true });
		};

		_this.state = {
			isContextMenuOpen: false
		};
		return _this;
	}

	//
	// Main render function
	//
	VisualItem.prototype.render = function render() {
		var className = 'clsSVGTileStyle' + (this.props.selected ? '_selected' : '');

		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexItem,
			{ className: 'clsSVGTileStyleContainer' },
			_react2.default.createElement(
				'div',
				{ ref: this._rootRef, style: { width: '128px' } },
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexLayout,
					{
						fullHeight: true,
						direction: 'column',
						alignItems: 'flex-start',
						className: className,
						onClick: this._onClickHandler,
						onKeyDown: this._onKeyDownHandler,
						tabIndex: 0
					},
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						{ alignSelf: 'flex-end', className: 'clsSVGTileCheckmark' },
						_react2.default.createElement(_baUiCarbonToolkit.SVGIcon, {
							size: 'small',
							className: 'svgIcon clsSVGCheckmarkSelected',
							verticalAlign: 'initial',
							iconId: _checkmarkFilled_2.default.id,
							tabIndex: -1
						})
					),
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						null,
						this._renderItem(this.props.fileRef, this.props.selected, this.props.idx)
					),
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						{ alignSelf: 'center'
						},
						this._renderItemLabel(this.props.item)
					)
				)
			)
		);
	};

	return VisualItem;
}(_react.Component);

VisualItem.propTypes = {
	item: _propTypes2.default.object.isRequired,
	fileRef: _propTypes2.default.string.isRequired,
	selected: _propTypes2.default.bool.isRequired,
	idx: _propTypes2.default.number.isRequired,
	items: _propTypes2.default.array.isRequired,
	files: _propTypes2.default.array.isRequired,
	selections: _propTypes2.default.array.isRequired,
	selectVisualItemCallback: _propTypes2.default.func.isRequired,
	handleVisualItemContextMenuCallback: _propTypes2.default.func.isRequired
};
exports.default = VisualItem;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,s){if(true)module.exports=s(__webpack_require__(5));else if("function"==typeof define&&define.amd)define(["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"],s);else{var c=s("object"==typeof exports?require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"):e["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for(var a in c)("object"==typeof exports?exports:e)[a]=c[a]}}("undefined"!=typeof self?self:this,function(e){return webpackJsonPBaGraphics([1691],{"6873601dfe1d9459c1a9":function(s,c){s.exports=e},"719d2200b9ef2c0c6681":function(e,s,c){"use strict";Object.defineProperty(s,"__esModule",{value:!0});var a=c("6873601dfe1d9459c1a9"),o=(c.n(a),c("c8afa3f4f2def0c0f92f"));s.default=o.a},c8afa3f4f2def0c0f92f:function(e,s,c){"use strict";var a=c("9689a9c94ae38b47fa2c"),o=c.n(a),i=c("9ce58a7deea14f49ef01"),f=c.n(i),n=new o.a({id:"checkmark--filled_16_v7",use:"checkmark--filled_16_v7-usage",viewBox:"0 0 16 16",content:'<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="checkmark--filled_16_v7"><path d="M8,1C4.1,1,1,4.1,1,8c0,3.9,3.1,7,7,7s7-3.1,7-7C15,4.1,11.9,1,8,1z M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z" /></symbol>'});f.a.add(n);s.a=n}},["719d2200b9ef2c0c6681"])});

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,s){if(true)module.exports=s(__webpack_require__(5));else if("function"==typeof define&&define.amd)define(["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"],s);else{var a=s("object"==typeof exports?require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"):e["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for(var c in a)("object"==typeof exports?exports:e)[c]=a[c]}}("undefined"!=typeof self?self:this,function(e){return webpackJsonPBaGraphics([456],{"2faa256623dda8fa3df1":function(e,s,a){"use strict";var c=a("9689a9c94ae38b47fa2c"),o=a.n(c),i=a("9ce58a7deea14f49ef01"),t=a.n(i),n=new o.a({id:"search_16_v7",use:"search_16_v7-usage",viewBox:"0 0 16 16",content:'<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="search_16_v7"><path d="M15,14.3L10.7,10c1.9-2.3,1.6-5.8-0.7-7.7S4.2,0.7,2.3,3S0.7,8.8,3,10.7c2,1.7,5,1.7,7,0l4.3,4.3L15,14.3z M2,6.5\tC2,4,4,2,6.5,2S11,4,11,6.5S9,11,6.5,11S2,9,2,6.5z" /></symbol>'});t.a.add(n);s.a=n},"6873601dfe1d9459c1a9":function(s,a){s.exports=e},"7417e443bcec9c766abb":function(e,s,a){"use strict";Object.defineProperty(s,"__esModule",{value:!0});var c=a("6873601dfe1d9459c1a9"),o=(a.n(c),a("2faa256623dda8fa3df1"));s.default=o.a}},["7417e443bcec9c766abb"])});

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FileLoader = __webpack_require__(34);

var _FileLoader2 = _interopRequireDefault(_FileLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

// This is a bit of an odd component, it renders a hidden file input and relies on the parent component to invoke openFileSelector using a ref
var SVGFileInput = function (_Component) {
	_inherits(SVGFileInput, _Component);

	function SVGFileInput(props) {
		_classCallCheck(this, SVGFileInput);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this._findSourceName = function (name) {
			return name.split('/').pop();
		};

		_this._onFileChange = function (e) {
			var loader = new _FileLoader2.default(null, _this.props.zipMaxSize, _this.props.imgMaxSize);
			loader.load(e.target.files, function (_fileList) {
				if (_fileList.length > 0) {
					var sourceNames = [];
					var blobUrls = [];
					var loadBlobPromises = [];

					_fileList.forEach(function (item) {
						sourceNames.push(_this._findSourceName(item));
						blobUrls.push('');
						loadBlobPromises.push(loader.getFileAsBlob(item));
					});

					var urlCreator = window.URL || window.webkitURL;
					Promise.all(loadBlobPromises).then(function (loadedBlobUrls) {
						loadedBlobUrls.forEach(function (item, i) {
							// item is returned as blob - but it won't have a type
							// so we need to slice it to set the type
							var sliceBlob = item.slice(0, item.size, 'image/svg+xml');
							// want to keep the source URL - we need to release it later
							blobUrls[i] = urlCreator.createObjectURL(sliceBlob);
						});
						_this.props.successCallback(sourceNames, blobUrls, _this.replaceIdx);
					}).catch(_this.props.failCallback);
				}
			}, _this.props.failCallback);
		};

		_this.fileInputRef = null;
		_this.replaceIdx = null;
		return _this;
	}

	SVGFileInput.prototype.openFileSelector = function openFileSelector(isMultiple, replaceIdx) {
		this.replaceIdx = replaceIdx;
		if (this.fileInputRef) {
			this.fileInputRef.multiple = isMultiple;
			this.fileInputRef.click();
		}
	};

	// some utility methods - need to find the name of the image - without path


	SVGFileInput.prototype.render = function render() {
		var _this2 = this;

		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement('input', {
				id: 'myInput',
				accept: '.svg',
				multiple: true,
				value: '',
				type: 'file',
				style: { display: 'none' },
				ref: function ref(_ref) {
					_this2.fileInputRef = _ref;
				},
				onChange: this._onFileChange
			})
		);
	};

	return SVGFileInput;
}(_react.Component);

SVGFileInput.propTypes = {
	successCallback: _propTypes2.default.func.isRequired,
	failCallback: _propTypes2.default.func.isRequired,
	zipMaxSize: _propTypes2.default.number.isRequired,
	imgMaxSize: _propTypes2.default.number.isRequired
};
exports.default = SVGFileInput;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer, setImmediate, global, process) {var require;var require;/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/

!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{("undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this).JSZip=e()}}(function(){return function s(a,o,h){function u(r,e){if(!o[r]){if(!a[r]){var t="function"==typeof require&&require;if(!e&&t)return require(r,!0);if(l)return l(r,!0);var n=new Error("Cannot find module '"+r+"'");throw n.code="MODULE_NOT_FOUND",n}var i=o[r]={exports:{}};a[r][0].call(i.exports,function(e){var t=a[r][1][e];return u(t||e)},i,i.exports,s,a,o,h)}return o[r].exports}for(var l="function"==typeof require&&require,e=0;e<h.length;e++)u(h[e]);return u}({1:[function(e,t,r){"use strict";var d=e("./utils"),c=e("./support"),p="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";r.encode=function(e){for(var t,r,n,i,s,a,o,h=[],u=0,l=e.length,f=l,c="string"!==d.getTypeOf(e);u<e.length;)f=l-u,n=c?(t=e[u++],r=u<l?e[u++]:0,u<l?e[u++]:0):(t=e.charCodeAt(u++),r=u<l?e.charCodeAt(u++):0,u<l?e.charCodeAt(u++):0),i=t>>2,s=(3&t)<<4|r>>4,a=1<f?(15&r)<<2|n>>6:64,o=2<f?63&n:64,h.push(p.charAt(i)+p.charAt(s)+p.charAt(a)+p.charAt(o));return h.join("")},r.decode=function(e){var t,r,n,i,s,a,o=0,h=0,u="data:";if(e.substr(0,u.length)===u)throw new Error("Invalid base64 input, it looks like a data url.");var l,f=3*(e=e.replace(/[^A-Za-z0-9+/=]/g,"")).length/4;if(e.charAt(e.length-1)===p.charAt(64)&&f--,e.charAt(e.length-2)===p.charAt(64)&&f--,f%1!=0)throw new Error("Invalid base64 input, bad content length.");for(l=c.uint8array?new Uint8Array(0|f):new Array(0|f);o<e.length;)t=p.indexOf(e.charAt(o++))<<2|(i=p.indexOf(e.charAt(o++)))>>4,r=(15&i)<<4|(s=p.indexOf(e.charAt(o++)))>>2,n=(3&s)<<6|(a=p.indexOf(e.charAt(o++))),l[h++]=t,64!==s&&(l[h++]=r),64!==a&&(l[h++]=n);return l}},{"./support":30,"./utils":32}],2:[function(e,t,r){"use strict";var n=e("./external"),i=e("./stream/DataWorker"),s=e("./stream/Crc32Probe"),a=e("./stream/DataLengthProbe");function o(e,t,r,n,i){this.compressedSize=e,this.uncompressedSize=t,this.crc32=r,this.compression=n,this.compressedContent=i}o.prototype={getContentWorker:function(){var e=new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")),t=this;return e.on("end",function(){if(this.streamInfo.data_length!==t.uncompressedSize)throw new Error("Bug : uncompressed data size mismatch")}),e},getCompressedWorker:function(){return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize",this.compressedSize).withStreamInfo("uncompressedSize",this.uncompressedSize).withStreamInfo("crc32",this.crc32).withStreamInfo("compression",this.compression)}},o.createWorkerFrom=function(e,t,r){return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression",t)},t.exports=o},{"./external":6,"./stream/Crc32Probe":25,"./stream/DataLengthProbe":26,"./stream/DataWorker":27}],3:[function(e,t,r){"use strict";var n=e("./stream/GenericWorker");r.STORE={magic:"\0\0",compressWorker:function(){return new n("STORE compression")},uncompressWorker:function(){return new n("STORE decompression")}},r.DEFLATE=e("./flate")},{"./flate":7,"./stream/GenericWorker":28}],4:[function(e,t,r){"use strict";var n=e("./utils");var o=function(){for(var e,t=[],r=0;r<256;r++){e=r;for(var n=0;n<8;n++)e=1&e?3988292384^e>>>1:e>>>1;t[r]=e}return t}();t.exports=function(e,t){return void 0!==e&&e.length?"string"!==n.getTypeOf(e)?function(e,t,r,n){var i=o,s=n+r;e^=-1;for(var a=n;a<s;a++)e=e>>>8^i[255&(e^t[a])];return-1^e}(0|t,e,e.length,0):function(e,t,r,n){var i=o,s=n+r;e^=-1;for(var a=n;a<s;a++)e=e>>>8^i[255&(e^t.charCodeAt(a))];return-1^e}(0|t,e,e.length,0):0}},{"./utils":32}],5:[function(e,t,r){"use strict";r.base64=!1,r.binary=!1,r.dir=!1,r.createFolders=!0,r.date=null,r.compression=null,r.compressionOptions=null,r.comment=null,r.unixPermissions=null,r.dosPermissions=null},{}],6:[function(e,t,r){"use strict";var n=null;n="undefined"!=typeof Promise?Promise:e("lie"),t.exports={Promise:n}},{lie:37}],7:[function(e,t,r){"use strict";var n="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Uint32Array,i=e("pako"),s=e("./utils"),a=e("./stream/GenericWorker"),o=n?"uint8array":"array";function h(e,t){a.call(this,"FlateWorker/"+e),this._pako=null,this._pakoAction=e,this._pakoOptions=t,this.meta={}}r.magic="\b\0",s.inherits(h,a),h.prototype.processChunk=function(e){this.meta=e.meta,null===this._pako&&this._createPako(),this._pako.push(s.transformTo(o,e.data),!1)},h.prototype.flush=function(){a.prototype.flush.call(this),null===this._pako&&this._createPako(),this._pako.push([],!0)},h.prototype.cleanUp=function(){a.prototype.cleanUp.call(this),this._pako=null},h.prototype._createPako=function(){this._pako=new i[this._pakoAction]({raw:!0,level:this._pakoOptions.level||-1});var t=this;this._pako.onData=function(e){t.push({data:e,meta:t.meta})}},r.compressWorker=function(e){return new h("Deflate",e)},r.uncompressWorker=function(){return new h("Inflate",{})}},{"./stream/GenericWorker":28,"./utils":32,pako:38}],8:[function(e,t,r){"use strict";function A(e,t){var r,n="";for(r=0;r<t;r++)n+=String.fromCharCode(255&e),e>>>=8;return n}function n(e,t,r,n,i,s){var a,o,h=e.file,u=e.compression,l=s!==O.utf8encode,f=I.transformTo("string",s(h.name)),c=I.transformTo("string",O.utf8encode(h.name)),d=h.comment,p=I.transformTo("string",s(d)),m=I.transformTo("string",O.utf8encode(d)),_=c.length!==h.name.length,g=m.length!==d.length,b="",v="",y="",w=h.dir,k=h.date,x={crc32:0,compressedSize:0,uncompressedSize:0};t&&!r||(x.crc32=e.crc32,x.compressedSize=e.compressedSize,x.uncompressedSize=e.uncompressedSize);var S=0;t&&(S|=8),l||!_&&!g||(S|=2048);var z=0,C=0;w&&(z|=16),"UNIX"===i?(C=798,z|=function(e,t){var r=e;return e||(r=t?16893:33204),(65535&r)<<16}(h.unixPermissions,w)):(C=20,z|=function(e){return 63&(e||0)}(h.dosPermissions)),a=k.getUTCHours(),a<<=6,a|=k.getUTCMinutes(),a<<=5,a|=k.getUTCSeconds()/2,o=k.getUTCFullYear()-1980,o<<=4,o|=k.getUTCMonth()+1,o<<=5,o|=k.getUTCDate(),_&&(v=A(1,1)+A(B(f),4)+c,b+="up"+A(v.length,2)+v),g&&(y=A(1,1)+A(B(p),4)+m,b+="uc"+A(y.length,2)+y);var E="";return E+="\n\0",E+=A(S,2),E+=u.magic,E+=A(a,2),E+=A(o,2),E+=A(x.crc32,4),E+=A(x.compressedSize,4),E+=A(x.uncompressedSize,4),E+=A(f.length,2),E+=A(b.length,2),{fileRecord:R.LOCAL_FILE_HEADER+E+f+b,dirRecord:R.CENTRAL_FILE_HEADER+A(C,2)+E+A(p.length,2)+"\0\0\0\0"+A(z,4)+A(n,4)+f+b+p}}var I=e("../utils"),i=e("../stream/GenericWorker"),O=e("../utf8"),B=e("../crc32"),R=e("../signature");function s(e,t,r,n){i.call(this,"ZipFileWorker"),this.bytesWritten=0,this.zipComment=t,this.zipPlatform=r,this.encodeFileName=n,this.streamFiles=e,this.accumulate=!1,this.contentBuffer=[],this.dirRecords=[],this.currentSourceOffset=0,this.entriesCount=0,this.currentFile=null,this._sources=[]}I.inherits(s,i),s.prototype.push=function(e){var t=e.meta.percent||0,r=this.entriesCount,n=this._sources.length;this.accumulate?this.contentBuffer.push(e):(this.bytesWritten+=e.data.length,i.prototype.push.call(this,{data:e.data,meta:{currentFile:this.currentFile,percent:r?(t+100*(r-n-1))/r:100}}))},s.prototype.openedSource=function(e){this.currentSourceOffset=this.bytesWritten,this.currentFile=e.file.name;var t=this.streamFiles&&!e.file.dir;if(t){var r=n(e,t,!1,this.currentSourceOffset,this.zipPlatform,this.encodeFileName);this.push({data:r.fileRecord,meta:{percent:0}})}else this.accumulate=!0},s.prototype.closedSource=function(e){this.accumulate=!1;var t=this.streamFiles&&!e.file.dir,r=n(e,t,!0,this.currentSourceOffset,this.zipPlatform,this.encodeFileName);if(this.dirRecords.push(r.dirRecord),t)this.push({data:function(e){return R.DATA_DESCRIPTOR+A(e.crc32,4)+A(e.compressedSize,4)+A(e.uncompressedSize,4)}(e),meta:{percent:100}});else for(this.push({data:r.fileRecord,meta:{percent:0}});this.contentBuffer.length;)this.push(this.contentBuffer.shift());this.currentFile=null},s.prototype.flush=function(){for(var e=this.bytesWritten,t=0;t<this.dirRecords.length;t++)this.push({data:this.dirRecords[t],meta:{percent:100}});var r=this.bytesWritten-e,n=function(e,t,r,n,i){var s=I.transformTo("string",i(n));return R.CENTRAL_DIRECTORY_END+"\0\0\0\0"+A(e,2)+A(e,2)+A(t,4)+A(r,4)+A(s.length,2)+s}(this.dirRecords.length,r,e,this.zipComment,this.encodeFileName);this.push({data:n,meta:{percent:100}})},s.prototype.prepareNextSource=function(){this.previous=this._sources.shift(),this.openedSource(this.previous.streamInfo),this.isPaused?this.previous.pause():this.previous.resume()},s.prototype.registerPrevious=function(e){this._sources.push(e);var t=this;return e.on("data",function(e){t.processChunk(e)}),e.on("end",function(){t.closedSource(t.previous.streamInfo),t._sources.length?t.prepareNextSource():t.end()}),e.on("error",function(e){t.error(e)}),this},s.prototype.resume=function(){return!!i.prototype.resume.call(this)&&(!this.previous&&this._sources.length?(this.prepareNextSource(),!0):this.previous||this._sources.length||this.generatedError?void 0:(this.end(),!0))},s.prototype.error=function(e){var t=this._sources;if(!i.prototype.error.call(this,e))return!1;for(var r=0;r<t.length;r++)try{t[r].error(e)}catch(e){}return!0},s.prototype.lock=function(){i.prototype.lock.call(this);for(var e=this._sources,t=0;t<e.length;t++)e[t].lock()},t.exports=s},{"../crc32":4,"../signature":23,"../stream/GenericWorker":28,"../utf8":31,"../utils":32}],9:[function(e,t,r){"use strict";var u=e("../compressions"),n=e("./ZipFileWorker");r.generateWorker=function(e,a,t){var o=new n(a.streamFiles,t,a.platform,a.encodeFileName),h=0;try{e.forEach(function(e,t){h++;var r=function(e,t){var r=e||t,n=u[r];if(!n)throw new Error(r+" is not a valid compression method !");return n}(t.options.compression,a.compression),n=t.options.compressionOptions||a.compressionOptions||{},i=t.dir,s=t.date;t._compressWorker(r,n).withStreamInfo("file",{name:e,dir:i,date:s,comment:t.comment||"",unixPermissions:t.unixPermissions,dosPermissions:t.dosPermissions}).pipe(o)}),o.entriesCount=h}catch(e){o.error(e)}return o}},{"../compressions":3,"./ZipFileWorker":8}],10:[function(e,t,r){"use strict";function n(){if(!(this instanceof n))return new n;if(arguments.length)throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");this.files=Object.create(null),this.comment=null,this.root="",this.clone=function(){var e=new n;for(var t in this)"function"!=typeof this[t]&&(e[t]=this[t]);return e}}(n.prototype=e("./object")).loadAsync=e("./load"),n.support=e("./support"),n.defaults=e("./defaults"),n.version="3.10.1",n.loadAsync=function(e,t){return(new n).loadAsync(e,t)},n.external=e("./external"),t.exports=n},{"./defaults":5,"./external":6,"./load":11,"./object":15,"./support":30}],11:[function(e,t,r){"use strict";var u=e("./utils"),i=e("./external"),n=e("./utf8"),s=e("./zipEntries"),a=e("./stream/Crc32Probe"),l=e("./nodejsUtils");function f(n){return new i.Promise(function(e,t){var r=n.decompressed.getContentWorker().pipe(new a);r.on("error",function(e){t(e)}).on("end",function(){r.streamInfo.crc32!==n.decompressed.crc32?t(new Error("Corrupted zip : CRC32 mismatch")):e()}).resume()})}t.exports=function(e,o){var h=this;return o=u.extend(o||{},{base64:!1,checkCRC32:!1,optimizedBinaryString:!1,createFolders:!1,decodeFileName:n.utf8decode}),l.isNode&&l.isStream(e)?i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")):u.prepareContent("the loaded zip file",e,!0,o.optimizedBinaryString,o.base64).then(function(e){var t=new s(o);return t.load(e),t}).then(function(e){var t=[i.Promise.resolve(e)],r=e.files;if(o.checkCRC32)for(var n=0;n<r.length;n++)t.push(f(r[n]));return i.Promise.all(t)}).then(function(e){for(var t=e.shift(),r=t.files,n=0;n<r.length;n++){var i=r[n],s=i.fileNameStr,a=u.resolve(i.fileNameStr);h.file(a,i.decompressed,{binary:!0,optimizedBinaryString:!0,date:i.date,dir:i.dir,comment:i.fileCommentStr.length?i.fileCommentStr:null,unixPermissions:i.unixPermissions,dosPermissions:i.dosPermissions,createFolders:o.createFolders}),i.dir||(h.file(a).unsafeOriginalName=s)}return t.zipComment.length&&(h.comment=t.zipComment),h})}},{"./external":6,"./nodejsUtils":14,"./stream/Crc32Probe":25,"./utf8":31,"./utils":32,"./zipEntries":33}],12:[function(e,t,r){"use strict";var n=e("../utils"),i=e("../stream/GenericWorker");function s(e,t){i.call(this,"Nodejs stream input adapter for "+e),this._upstreamEnded=!1,this._bindStream(t)}n.inherits(s,i),s.prototype._bindStream=function(e){var t=this;(this._stream=e).pause(),e.on("data",function(e){t.push({data:e,meta:{percent:0}})}).on("error",function(e){t.isPaused?this.generatedError=e:t.error(e)}).on("end",function(){t.isPaused?t._upstreamEnded=!0:t.end()})},s.prototype.pause=function(){return!!i.prototype.pause.call(this)&&(this._stream.pause(),!0)},s.prototype.resume=function(){return!!i.prototype.resume.call(this)&&(this._upstreamEnded?this.end():this._stream.resume(),!0)},t.exports=s},{"../stream/GenericWorker":28,"../utils":32}],13:[function(e,t,r){"use strict";var i=e("readable-stream").Readable;function n(e,t,r){i.call(this,t),this._helper=e;var n=this;e.on("data",function(e,t){n.push(e)||n._helper.pause(),r&&r(t)}).on("error",function(e){n.emit("error",e)}).on("end",function(){n.push(null)})}e("../utils").inherits(n,i),n.prototype._read=function(){this._helper.resume()},t.exports=n},{"../utils":32,"readable-stream":16}],14:[function(e,t,r){"use strict";t.exports={isNode:"undefined"!=typeof Buffer,newBufferFrom:function(e,t){if(Buffer.from&&Buffer.from!==Uint8Array.from)return Buffer.from(e,t);if("number"==typeof e)throw new Error('The "data" argument must not be a number');return new Buffer(e,t)},allocBuffer:function(e){if(Buffer.alloc)return Buffer.alloc(e);var t=new Buffer(e);return t.fill(0),t},isBuffer:function(e){return Buffer.isBuffer(e)},isStream:function(e){return e&&"function"==typeof e.on&&"function"==typeof e.pause&&"function"==typeof e.resume}}},{}],15:[function(e,t,r){"use strict";function s(e,t,r){var n,i=u.getTypeOf(t),s=u.extend(r||{},f);s.date=s.date||new Date,null!==s.compression&&(s.compression=s.compression.toUpperCase()),"string"==typeof s.unixPermissions&&(s.unixPermissions=parseInt(s.unixPermissions,8)),s.unixPermissions&&16384&s.unixPermissions&&(s.dir=!0),s.dosPermissions&&16&s.dosPermissions&&(s.dir=!0),s.dir&&(e=g(e)),s.createFolders&&(n=_(e))&&b.call(this,n,!0);var a="string"===i&&!1===s.binary&&!1===s.base64;r&&void 0!==r.binary||(s.binary=!a),(t instanceof c&&0===t.uncompressedSize||s.dir||!t||0===t.length)&&(s.base64=!1,s.binary=!0,t="",s.compression="STORE",i="string");var o=null;o=t instanceof c||t instanceof l?t:p.isNode&&p.isStream(t)?new m(e,t):u.prepareContent(e,t,s.binary,s.optimizedBinaryString,s.base64);var h=new d(e,o,s);this.files[e]=h}var i=e("./utf8"),u=e("./utils"),l=e("./stream/GenericWorker"),a=e("./stream/StreamHelper"),f=e("./defaults"),c=e("./compressedObject"),d=e("./zipObject"),o=e("./generate"),p=e("./nodejsUtils"),m=e("./nodejs/NodejsStreamInputAdapter"),_=function(e){"/"===e.slice(-1)&&(e=e.substring(0,e.length-1));var t=e.lastIndexOf("/");return 0<t?e.substring(0,t):""},g=function(e){return"/"!==e.slice(-1)&&(e+="/"),e},b=function(e,t){return t=void 0!==t?t:f.createFolders,e=g(e),this.files[e]||s.call(this,e,null,{dir:!0,createFolders:t}),this.files[e]};function h(e){return"[object RegExp]"===Object.prototype.toString.call(e)}var n={load:function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},forEach:function(e){var t,r,n;for(t in this.files)n=this.files[t],(r=t.slice(this.root.length,t.length))&&t.slice(0,this.root.length)===this.root&&e(r,n)},filter:function(r){var n=[];return this.forEach(function(e,t){r(e,t)&&n.push(t)}),n},file:function(e,t,r){if(1!==arguments.length)return e=this.root+e,s.call(this,e,t,r),this;if(h(e)){var n=e;return this.filter(function(e,t){return!t.dir&&n.test(e)})}var i=this.files[this.root+e];return i&&!i.dir?i:null},folder:function(r){if(!r)return this;if(h(r))return this.filter(function(e,t){return t.dir&&r.test(e)});var e=this.root+r,t=b.call(this,e),n=this.clone();return n.root=t.name,n},remove:function(r){r=this.root+r;var e=this.files[r];if(e||("/"!==r.slice(-1)&&(r+="/"),e=this.files[r]),e&&!e.dir)delete this.files[r];else for(var t=this.filter(function(e,t){return t.name.slice(0,r.length)===r}),n=0;n<t.length;n++)delete this.files[t[n].name];return this},generate:function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},generateInternalStream:function(e){var t,r={};try{if((r=u.extend(e||{},{streamFiles:!1,compression:"STORE",compressionOptions:null,type:"",platform:"DOS",comment:null,mimeType:"application/zip",encodeFileName:i.utf8encode})).type=r.type.toLowerCase(),r.compression=r.compression.toUpperCase(),"binarystring"===r.type&&(r.type="string"),!r.type)throw new Error("No output type specified.");u.checkSupport(r.type),"darwin"!==r.platform&&"freebsd"!==r.platform&&"linux"!==r.platform&&"sunos"!==r.platform||(r.platform="UNIX"),"win32"===r.platform&&(r.platform="DOS");var n=r.comment||this.comment||"";t=o.generateWorker(this,r,n)}catch(e){(t=new l("error")).error(e)}return new a(t,r.type||"string",r.mimeType)},generateAsync:function(e,t){return this.generateInternalStream(e).accumulate(t)},generateNodeStream:function(e,t){return(e=e||{}).type||(e.type="nodebuffer"),this.generateInternalStream(e).toNodejsStream(t)}};t.exports=n},{"./compressedObject":2,"./defaults":5,"./generate":9,"./nodejs/NodejsStreamInputAdapter":12,"./nodejsUtils":14,"./stream/GenericWorker":28,"./stream/StreamHelper":29,"./utf8":31,"./utils":32,"./zipObject":35}],16:[function(e,t,r){"use strict";t.exports=e("stream")},{stream:void 0}],17:[function(e,t,r){"use strict";var n=e("./DataReader");function i(e){n.call(this,e);for(var t=0;t<this.data.length;t++)e[t]=255&e[t]}e("../utils").inherits(i,n),i.prototype.byteAt=function(e){return this.data[this.zero+e]},i.prototype.lastIndexOfSignature=function(e){for(var t=e.charCodeAt(0),r=e.charCodeAt(1),n=e.charCodeAt(2),i=e.charCodeAt(3),s=this.length-4;0<=s;--s)if(this.data[s]===t&&this.data[s+1]===r&&this.data[s+2]===n&&this.data[s+3]===i)return s-this.zero;return-1},i.prototype.readAndCheckSignature=function(e){var t=e.charCodeAt(0),r=e.charCodeAt(1),n=e.charCodeAt(2),i=e.charCodeAt(3),s=this.readData(4);return t===s[0]&&r===s[1]&&n===s[2]&&i===s[3]},i.prototype.readData=function(e){if(this.checkOffset(e),0===e)return[];var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./DataReader":18}],18:[function(e,t,r){"use strict";var n=e("../utils");function i(e){this.data=e,this.length=e.length,this.index=0,this.zero=0}i.prototype={checkOffset:function(e){this.checkIndex(this.index+e)},checkIndex:function(e){if(this.length<this.zero+e||e<0)throw new Error("End of data reached (data length = "+this.length+", asked index = "+e+"). Corrupted zip ?")},setIndex:function(e){this.checkIndex(e),this.index=e},skip:function(e){this.setIndex(this.index+e)},byteAt:function(){},readInt:function(e){var t,r=0;for(this.checkOffset(e),t=this.index+e-1;t>=this.index;t--)r=(r<<8)+this.byteAt(t);return this.index+=e,r},readString:function(e){return n.transformTo("string",this.readData(e))},readData:function(){},lastIndexOfSignature:function(){},readAndCheckSignature:function(){},readDate:function(){var e=this.readInt(4);return new Date(Date.UTC(1980+(e>>25&127),(e>>21&15)-1,e>>16&31,e>>11&31,e>>5&63,(31&e)<<1))}},t.exports=i},{"../utils":32}],19:[function(e,t,r){"use strict";var n=e("./Uint8ArrayReader");function i(e){n.call(this,e)}e("../utils").inherits(i,n),i.prototype.readData=function(e){this.checkOffset(e);var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./Uint8ArrayReader":21}],20:[function(e,t,r){"use strict";var n=e("./DataReader");function i(e){n.call(this,e)}e("../utils").inherits(i,n),i.prototype.byteAt=function(e){return this.data.charCodeAt(this.zero+e)},i.prototype.lastIndexOfSignature=function(e){return this.data.lastIndexOf(e)-this.zero},i.prototype.readAndCheckSignature=function(e){return e===this.readData(4)},i.prototype.readData=function(e){this.checkOffset(e);var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./DataReader":18}],21:[function(e,t,r){"use strict";var n=e("./ArrayReader");function i(e){n.call(this,e)}e("../utils").inherits(i,n),i.prototype.readData=function(e){if(this.checkOffset(e),0===e)return new Uint8Array(0);var t=this.data.subarray(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./ArrayReader":17}],22:[function(e,t,r){"use strict";var n=e("../utils"),i=e("../support"),s=e("./ArrayReader"),a=e("./StringReader"),o=e("./NodeBufferReader"),h=e("./Uint8ArrayReader");t.exports=function(e){var t=n.getTypeOf(e);return n.checkSupport(t),"string"!==t||i.uint8array?"nodebuffer"===t?new o(e):i.uint8array?new h(n.transformTo("uint8array",e)):new s(n.transformTo("array",e)):new a(e)}},{"../support":30,"../utils":32,"./ArrayReader":17,"./NodeBufferReader":19,"./StringReader":20,"./Uint8ArrayReader":21}],23:[function(e,t,r){"use strict";r.LOCAL_FILE_HEADER="PK",r.CENTRAL_FILE_HEADER="PK",r.CENTRAL_DIRECTORY_END="PK",r.ZIP64_CENTRAL_DIRECTORY_LOCATOR="PK",r.ZIP64_CENTRAL_DIRECTORY_END="PK",r.DATA_DESCRIPTOR="PK\b"},{}],24:[function(e,t,r){"use strict";var n=e("./GenericWorker"),i=e("../utils");function s(e){n.call(this,"ConvertWorker to "+e),this.destType=e}i.inherits(s,n),s.prototype.processChunk=function(e){this.push({data:i.transformTo(this.destType,e.data),meta:e.meta})},t.exports=s},{"../utils":32,"./GenericWorker":28}],25:[function(e,t,r){"use strict";var n=e("./GenericWorker"),i=e("../crc32");function s(){n.call(this,"Crc32Probe"),this.withStreamInfo("crc32",0)}e("../utils").inherits(s,n),s.prototype.processChunk=function(e){this.streamInfo.crc32=i(e.data,this.streamInfo.crc32||0),this.push(e)},t.exports=s},{"../crc32":4,"../utils":32,"./GenericWorker":28}],26:[function(e,t,r){"use strict";var n=e("../utils"),i=e("./GenericWorker");function s(e){i.call(this,"DataLengthProbe for "+e),this.propName=e,this.withStreamInfo(e,0)}n.inherits(s,i),s.prototype.processChunk=function(e){if(e){var t=this.streamInfo[this.propName]||0;this.streamInfo[this.propName]=t+e.data.length}i.prototype.processChunk.call(this,e)},t.exports=s},{"../utils":32,"./GenericWorker":28}],27:[function(e,t,r){"use strict";var n=e("../utils"),i=e("./GenericWorker");function s(e){i.call(this,"DataWorker");var t=this;this.dataIsReady=!1,this.index=0,this.max=0,this.data=null,this.type="",this._tickScheduled=!1,e.then(function(e){t.dataIsReady=!0,t.data=e,t.max=e&&e.length||0,t.type=n.getTypeOf(e),t.isPaused||t._tickAndRepeat()},function(e){t.error(e)})}n.inherits(s,i),s.prototype.cleanUp=function(){i.prototype.cleanUp.call(this),this.data=null},s.prototype.resume=function(){return!!i.prototype.resume.call(this)&&(!this._tickScheduled&&this.dataIsReady&&(this._tickScheduled=!0,n.delay(this._tickAndRepeat,[],this)),!0)},s.prototype._tickAndRepeat=function(){this._tickScheduled=!1,this.isPaused||this.isFinished||(this._tick(),this.isFinished||(n.delay(this._tickAndRepeat,[],this),this._tickScheduled=!0))},s.prototype._tick=function(){if(this.isPaused||this.isFinished)return!1;var e=null,t=Math.min(this.max,this.index+16384);if(this.index>=this.max)return this.end();switch(this.type){case"string":e=this.data.substring(this.index,t);break;case"uint8array":e=this.data.subarray(this.index,t);break;case"array":case"nodebuffer":e=this.data.slice(this.index,t)}return this.index=t,this.push({data:e,meta:{percent:this.max?this.index/this.max*100:0}})},t.exports=s},{"../utils":32,"./GenericWorker":28}],28:[function(e,t,r){"use strict";function n(e){this.name=e||"default",this.streamInfo={},this.generatedError=null,this.extraStreamInfo={},this.isPaused=!0,this.isFinished=!1,this.isLocked=!1,this._listeners={data:[],end:[],error:[]},this.previous=null}n.prototype={push:function(e){this.emit("data",e)},end:function(){if(this.isFinished)return!1;this.flush();try{this.emit("end"),this.cleanUp(),this.isFinished=!0}catch(e){this.emit("error",e)}return!0},error:function(e){return!this.isFinished&&(this.isPaused?this.generatedError=e:(this.isFinished=!0,this.emit("error",e),this.previous&&this.previous.error(e),this.cleanUp()),!0)},on:function(e,t){return this._listeners[e].push(t),this},cleanUp:function(){this.streamInfo=this.generatedError=this.extraStreamInfo=null,this._listeners=[]},emit:function(e,t){if(this._listeners[e])for(var r=0;r<this._listeners[e].length;r++)this._listeners[e][r].call(this,t)},pipe:function(e){return e.registerPrevious(this)},registerPrevious:function(e){if(this.isLocked)throw new Error("The stream '"+this+"' has already been used.");this.streamInfo=e.streamInfo,this.mergeStreamInfo(),this.previous=e;var t=this;return e.on("data",function(e){t.processChunk(e)}),e.on("end",function(){t.end()}),e.on("error",function(e){t.error(e)}),this},pause:function(){return!this.isPaused&&!this.isFinished&&(this.isPaused=!0,this.previous&&this.previous.pause(),!0)},resume:function(){if(!this.isPaused||this.isFinished)return!1;var e=this.isPaused=!1;return this.generatedError&&(this.error(this.generatedError),e=!0),this.previous&&this.previous.resume(),!e},flush:function(){},processChunk:function(e){this.push(e)},withStreamInfo:function(e,t){return this.extraStreamInfo[e]=t,this.mergeStreamInfo(),this},mergeStreamInfo:function(){for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo,e)&&(this.streamInfo[e]=this.extraStreamInfo[e])},lock:function(){if(this.isLocked)throw new Error("The stream '"+this+"' has already been used.");this.isLocked=!0,this.previous&&this.previous.lock()},toString:function(){var e="Worker "+this.name;return this.previous?this.previous+" -> "+e:e}},t.exports=n},{}],29:[function(e,t,r){"use strict";var h=e("../utils"),i=e("./ConvertWorker"),s=e("./GenericWorker"),u=e("../base64"),n=e("../support"),a=e("../external"),o=null;if(n.nodestream)try{o=e("../nodejs/NodejsStreamOutputAdapter")}catch(e){}function l(e,o){return new a.Promise(function(t,r){var n=[],i=e._internalType,s=e._outputType,a=e._mimeType;e.on("data",function(e,t){n.push(e),o&&o(t)}).on("error",function(e){n=[],r(e)}).on("end",function(){try{var e=function(e,t,r){switch(e){case"blob":return h.newBlob(h.transformTo("arraybuffer",t),r);case"base64":return u.encode(t);default:return h.transformTo(e,t)}}(s,function(e,t){var r,n=0,i=null,s=0;for(r=0;r<t.length;r++)s+=t[r].length;switch(e){case"string":return t.join("");case"array":return Array.prototype.concat.apply([],t);case"uint8array":for(i=new Uint8Array(s),r=0;r<t.length;r++)i.set(t[r],n),n+=t[r].length;return i;case"nodebuffer":return Buffer.concat(t);default:throw new Error("concat : unsupported type '"+e+"'")}}(i,n),a);t(e)}catch(e){r(e)}n=[]}).resume()})}function f(e,t,r){var n=t;switch(t){case"blob":case"arraybuffer":n="uint8array";break;case"base64":n="string"}try{this._internalType=n,this._outputType=t,this._mimeType=r,h.checkSupport(n),this._worker=e.pipe(new i(n)),e.lock()}catch(e){this._worker=new s("error"),this._worker.error(e)}}f.prototype={accumulate:function(e){return l(this,e)},on:function(e,t){var r=this;return"data"===e?this._worker.on(e,function(e){t.call(r,e.data,e.meta)}):this._worker.on(e,function(){h.delay(t,arguments,r)}),this},resume:function(){return h.delay(this._worker.resume,[],this._worker),this},pause:function(){return this._worker.pause(),this},toNodejsStream:function(e){if(h.checkSupport("nodestream"),"nodebuffer"!==this._outputType)throw new Error(this._outputType+" is not supported by this method");return new o(this,{objectMode:"nodebuffer"!==this._outputType},e)}},t.exports=f},{"../base64":1,"../external":6,"../nodejs/NodejsStreamOutputAdapter":13,"../support":30,"../utils":32,"./ConvertWorker":24,"./GenericWorker":28}],30:[function(e,t,r){"use strict";if(r.base64=!0,r.array=!0,r.string=!0,r.arraybuffer="undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array,r.nodebuffer="undefined"!=typeof Buffer,r.uint8array="undefined"!=typeof Uint8Array,"undefined"==typeof ArrayBuffer)r.blob=!1;else{var n=new ArrayBuffer(0);try{r.blob=0===new Blob([n],{type:"application/zip"}).size}catch(e){try{var i=new(self.BlobBuilder||self.WebKitBlobBuilder||self.MozBlobBuilder||self.MSBlobBuilder);i.append(n),r.blob=0===i.getBlob("application/zip").size}catch(e){r.blob=!1}}}try{r.nodestream=!!e("readable-stream").Readable}catch(e){r.nodestream=!1}},{"readable-stream":16}],31:[function(e,t,s){"use strict";for(var o=e("./utils"),h=e("./support"),r=e("./nodejsUtils"),n=e("./stream/GenericWorker"),u=new Array(256),i=0;i<256;i++)u[i]=252<=i?6:248<=i?5:240<=i?4:224<=i?3:192<=i?2:1;u[254]=u[254]=1;function a(){n.call(this,"utf-8 decode"),this.leftOver=null}function l(){n.call(this,"utf-8 encode")}s.utf8encode=function(e){return h.nodebuffer?r.newBufferFrom(e,"utf-8"):function(e){var t,r,n,i,s,a=e.length,o=0;for(i=0;i<a;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),o+=r<128?1:r<2048?2:r<65536?3:4;for(t=h.uint8array?new Uint8Array(o):new Array(o),i=s=0;s<o;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),r<128?t[s++]=r:(r<2048?t[s++]=192|r>>>6:(r<65536?t[s++]=224|r>>>12:(t[s++]=240|r>>>18,t[s++]=128|r>>>12&63),t[s++]=128|r>>>6&63),t[s++]=128|63&r);return t}(e)},s.utf8decode=function(e){return h.nodebuffer?o.transformTo("nodebuffer",e).toString("utf-8"):function(e){var t,r,n,i,s=e.length,a=new Array(2*s);for(t=r=0;t<s;)if((n=e[t++])<128)a[r++]=n;else if(4<(i=u[n]))a[r++]=65533,t+=i-1;else{for(n&=2===i?31:3===i?15:7;1<i&&t<s;)n=n<<6|63&e[t++],i--;1<i?a[r++]=65533:n<65536?a[r++]=n:(n-=65536,a[r++]=55296|n>>10&1023,a[r++]=56320|1023&n)}return a.length!==r&&(a.subarray?a=a.subarray(0,r):a.length=r),o.applyFromCharCode(a)}(e=o.transformTo(h.uint8array?"uint8array":"array",e))},o.inherits(a,n),a.prototype.processChunk=function(e){var t=o.transformTo(h.uint8array?"uint8array":"array",e.data);if(this.leftOver&&this.leftOver.length){if(h.uint8array){var r=t;(t=new Uint8Array(r.length+this.leftOver.length)).set(this.leftOver,0),t.set(r,this.leftOver.length)}else t=this.leftOver.concat(t);this.leftOver=null}var n=function(e,t){var r;for((t=t||e.length)>e.length&&(t=e.length),r=t-1;0<=r&&128==(192&e[r]);)r--;return r<0?t:0===r?t:r+u[e[r]]>t?r:t}(t),i=t;n!==t.length&&(h.uint8array?(i=t.subarray(0,n),this.leftOver=t.subarray(n,t.length)):(i=t.slice(0,n),this.leftOver=t.slice(n,t.length))),this.push({data:s.utf8decode(i),meta:e.meta})},a.prototype.flush=function(){this.leftOver&&this.leftOver.length&&(this.push({data:s.utf8decode(this.leftOver),meta:{}}),this.leftOver=null)},s.Utf8DecodeWorker=a,o.inherits(l,n),l.prototype.processChunk=function(e){this.push({data:s.utf8encode(e.data),meta:e.meta})},s.Utf8EncodeWorker=l},{"./nodejsUtils":14,"./stream/GenericWorker":28,"./support":30,"./utils":32}],32:[function(e,t,a){"use strict";var o=e("./support"),h=e("./base64"),r=e("./nodejsUtils"),u=e("./external");function n(e){return e}function l(e,t){for(var r=0;r<e.length;++r)t[r]=255&e.charCodeAt(r);return t}e("setimmediate"),a.newBlob=function(t,r){a.checkSupport("blob");try{return new Blob([t],{type:r})}catch(e){try{var n=new(self.BlobBuilder||self.WebKitBlobBuilder||self.MozBlobBuilder||self.MSBlobBuilder);return n.append(t),n.getBlob(r)}catch(e){throw new Error("Bug : can't construct the Blob.")}}};var i={stringifyByChunk:function(e,t,r){var n=[],i=0,s=e.length;if(s<=r)return String.fromCharCode.apply(null,e);for(;i<s;)"array"===t||"nodebuffer"===t?n.push(String.fromCharCode.apply(null,e.slice(i,Math.min(i+r,s)))):n.push(String.fromCharCode.apply(null,e.subarray(i,Math.min(i+r,s)))),i+=r;return n.join("")},stringifyByChar:function(e){for(var t="",r=0;r<e.length;r++)t+=String.fromCharCode(e[r]);return t},applyCanBeUsed:{uint8array:function(){try{return o.uint8array&&1===String.fromCharCode.apply(null,new Uint8Array(1)).length}catch(e){return!1}}(),nodebuffer:function(){try{return o.nodebuffer&&1===String.fromCharCode.apply(null,r.allocBuffer(1)).length}catch(e){return!1}}()}};function s(e){var t=65536,r=a.getTypeOf(e),n=!0;if("uint8array"===r?n=i.applyCanBeUsed.uint8array:"nodebuffer"===r&&(n=i.applyCanBeUsed.nodebuffer),n)for(;1<t;)try{return i.stringifyByChunk(e,r,t)}catch(e){t=Math.floor(t/2)}return i.stringifyByChar(e)}function f(e,t){for(var r=0;r<e.length;r++)t[r]=e[r];return t}a.applyFromCharCode=s;var c={};c.string={string:n,array:function(e){return l(e,new Array(e.length))},arraybuffer:function(e){return c.string.uint8array(e).buffer},uint8array:function(e){return l(e,new Uint8Array(e.length))},nodebuffer:function(e){return l(e,r.allocBuffer(e.length))}},c.array={string:s,array:n,arraybuffer:function(e){return new Uint8Array(e).buffer},uint8array:function(e){return new Uint8Array(e)},nodebuffer:function(e){return r.newBufferFrom(e)}},c.arraybuffer={string:function(e){return s(new Uint8Array(e))},array:function(e){return f(new Uint8Array(e),new Array(e.byteLength))},arraybuffer:n,uint8array:function(e){return new Uint8Array(e)},nodebuffer:function(e){return r.newBufferFrom(new Uint8Array(e))}},c.uint8array={string:s,array:function(e){return f(e,new Array(e.length))},arraybuffer:function(e){return e.buffer},uint8array:n,nodebuffer:function(e){return r.newBufferFrom(e)}},c.nodebuffer={string:s,array:function(e){return f(e,new Array(e.length))},arraybuffer:function(e){return c.nodebuffer.uint8array(e).buffer},uint8array:function(e){return f(e,new Uint8Array(e.length))},nodebuffer:n},a.transformTo=function(e,t){if(t=t||"",!e)return t;a.checkSupport(e);var r=a.getTypeOf(t);return c[r][e](t)},a.resolve=function(e){for(var t=e.split("/"),r=[],n=0;n<t.length;n++){var i=t[n];"."===i||""===i&&0!==n&&n!==t.length-1||(".."===i?r.pop():r.push(i))}return r.join("/")},a.getTypeOf=function(e){return"string"==typeof e?"string":"[object Array]"===Object.prototype.toString.call(e)?"array":o.nodebuffer&&r.isBuffer(e)?"nodebuffer":o.uint8array&&e instanceof Uint8Array?"uint8array":o.arraybuffer&&e instanceof ArrayBuffer?"arraybuffer":void 0},a.checkSupport=function(e){if(!o[e.toLowerCase()])throw new Error(e+" is not supported by this platform")},a.MAX_VALUE_16BITS=65535,a.MAX_VALUE_32BITS=-1,a.pretty=function(e){var t,r,n="";for(r=0;r<(e||"").length;r++)n+="\\x"+((t=e.charCodeAt(r))<16?"0":"")+t.toString(16).toUpperCase();return n},a.delay=function(e,t,r){setImmediate(function(){e.apply(r||null,t||[])})},a.inherits=function(e,t){function r(){}r.prototype=t.prototype,e.prototype=new r},a.extend=function(){var e,t,r={};for(e=0;e<arguments.length;e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e],t)&&void 0===r[t]&&(r[t]=arguments[e][t]);return r},a.prepareContent=function(r,e,n,i,s){return u.Promise.resolve(e).then(function(n){return o.blob&&(n instanceof Blob||-1!==["[object File]","[object Blob]"].indexOf(Object.prototype.toString.call(n)))&&"undefined"!=typeof FileReader?new u.Promise(function(t,r){var e=new FileReader;e.onload=function(e){t(e.target.result)},e.onerror=function(e){r(e.target.error)},e.readAsArrayBuffer(n)}):n}).then(function(e){var t=a.getTypeOf(e);return t?("arraybuffer"===t?e=a.transformTo("uint8array",e):"string"===t&&(s?e=h.decode(e):n&&!0!==i&&(e=function(e){return l(e,o.uint8array?new Uint8Array(e.length):new Array(e.length))}(e))),e):u.Promise.reject(new Error("Can't read the data of '"+r+"'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"))})}},{"./base64":1,"./external":6,"./nodejsUtils":14,"./support":30,setimmediate:54}],33:[function(e,t,r){"use strict";var n=e("./reader/readerFor"),i=e("./utils"),s=e("./signature"),a=e("./zipEntry"),o=e("./support");function h(e){this.files=[],this.loadOptions=e}h.prototype={checkSignature:function(e){if(!this.reader.readAndCheckSignature(e)){this.reader.index-=4;var t=this.reader.readString(4);throw new Error("Corrupted zip or bug: unexpected signature ("+i.pretty(t)+", expected "+i.pretty(e)+")")}},isSignature:function(e,t){var r=this.reader.index;this.reader.setIndex(e);var n=this.reader.readString(4)===t;return this.reader.setIndex(r),n},readBlockEndOfCentral:function(){this.diskNumber=this.reader.readInt(2),this.diskWithCentralDirStart=this.reader.readInt(2),this.centralDirRecordsOnThisDisk=this.reader.readInt(2),this.centralDirRecords=this.reader.readInt(2),this.centralDirSize=this.reader.readInt(4),this.centralDirOffset=this.reader.readInt(4),this.zipCommentLength=this.reader.readInt(2);var e=this.reader.readData(this.zipCommentLength),t=o.uint8array?"uint8array":"array",r=i.transformTo(t,e);this.zipComment=this.loadOptions.decodeFileName(r)},readBlockZip64EndOfCentral:function(){this.zip64EndOfCentralSize=this.reader.readInt(8),this.reader.skip(4),this.diskNumber=this.reader.readInt(4),this.diskWithCentralDirStart=this.reader.readInt(4),this.centralDirRecordsOnThisDisk=this.reader.readInt(8),this.centralDirRecords=this.reader.readInt(8),this.centralDirSize=this.reader.readInt(8),this.centralDirOffset=this.reader.readInt(8),this.zip64ExtensibleData={};for(var e,t,r,n=this.zip64EndOfCentralSize-44;0<n;)e=this.reader.readInt(2),t=this.reader.readInt(4),r=this.reader.readData(t),this.zip64ExtensibleData[e]={id:e,length:t,value:r}},readBlockZip64EndOfCentralLocator:function(){if(this.diskWithZip64CentralDirStart=this.reader.readInt(4),this.relativeOffsetEndOfZip64CentralDir=this.reader.readInt(8),this.disksCount=this.reader.readInt(4),1<this.disksCount)throw new Error("Multi-volumes zip are not supported")},readLocalFiles:function(){var e,t;for(e=0;e<this.files.length;e++)t=this.files[e],this.reader.setIndex(t.localHeaderOffset),this.checkSignature(s.LOCAL_FILE_HEADER),t.readLocalPart(this.reader),t.handleUTF8(),t.processAttributes()},readCentralDir:function(){var e;for(this.reader.setIndex(this.centralDirOffset);this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e=new a({zip64:this.zip64},this.loadOptions)).readCentralPart(this.reader),this.files.push(e);if(this.centralDirRecords!==this.files.length&&0!==this.centralDirRecords&&0===this.files.length)throw new Error("Corrupted zip or bug: expected "+this.centralDirRecords+" records in central dir, got "+this.files.length)},readEndOfCentral:function(){var e=this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);if(e<0)throw!this.isSignature(0,s.LOCAL_FILE_HEADER)?new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html"):new Error("Corrupted zip: can't find end of central directory");this.reader.setIndex(e);var t=e;if(this.checkSignature(s.CENTRAL_DIRECTORY_END),this.readBlockEndOfCentral(),this.diskNumber===i.MAX_VALUE_16BITS||this.diskWithCentralDirStart===i.MAX_VALUE_16BITS||this.centralDirRecordsOnThisDisk===i.MAX_VALUE_16BITS||this.centralDirRecords===i.MAX_VALUE_16BITS||this.centralDirSize===i.MAX_VALUE_32BITS||this.centralDirOffset===i.MAX_VALUE_32BITS){if(this.zip64=!0,(e=this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR))<0)throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");if(this.reader.setIndex(e),this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR),this.readBlockZip64EndOfCentralLocator(),!this.isSignature(this.relativeOffsetEndOfZip64CentralDir,s.ZIP64_CENTRAL_DIRECTORY_END)&&(this.relativeOffsetEndOfZip64CentralDir=this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END),this.relativeOffsetEndOfZip64CentralDir<0))throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir),this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END),this.readBlockZip64EndOfCentral()}var r=this.centralDirOffset+this.centralDirSize;this.zip64&&(r+=20,r+=12+this.zip64EndOfCentralSize);var n=t-r;if(0<n)this.isSignature(t,s.CENTRAL_FILE_HEADER)||(this.reader.zero=n);else if(n<0)throw new Error("Corrupted zip: missing "+Math.abs(n)+" bytes.")},prepareReader:function(e){this.reader=n(e)},load:function(e){this.prepareReader(e),this.readEndOfCentral(),this.readCentralDir(),this.readLocalFiles()}},t.exports=h},{"./reader/readerFor":22,"./signature":23,"./support":30,"./utils":32,"./zipEntry":34}],34:[function(e,t,r){"use strict";var n=e("./reader/readerFor"),s=e("./utils"),i=e("./compressedObject"),a=e("./crc32"),o=e("./utf8"),h=e("./compressions"),u=e("./support");function l(e,t){this.options=e,this.loadOptions=t}l.prototype={isEncrypted:function(){return 1==(1&this.bitFlag)},useUTF8:function(){return 2048==(2048&this.bitFlag)},readLocalPart:function(e){var t,r;if(e.skip(22),this.fileNameLength=e.readInt(2),r=e.readInt(2),this.fileName=e.readData(this.fileNameLength),e.skip(r),-1===this.compressedSize||-1===this.uncompressedSize)throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");if(null===(t=function(e){for(var t in h)if(Object.prototype.hasOwnProperty.call(h,t)&&h[t].magic===e)return h[t];return null}(this.compressionMethod)))throw new Error("Corrupted zip : compression "+s.pretty(this.compressionMethod)+" unknown (inner file : "+s.transformTo("string",this.fileName)+")");this.decompressed=new i(this.compressedSize,this.uncompressedSize,this.crc32,t,e.readData(this.compressedSize))},readCentralPart:function(e){this.versionMadeBy=e.readInt(2),e.skip(2),this.bitFlag=e.readInt(2),this.compressionMethod=e.readString(2),this.date=e.readDate(),this.crc32=e.readInt(4),this.compressedSize=e.readInt(4),this.uncompressedSize=e.readInt(4);var t=e.readInt(2);if(this.extraFieldsLength=e.readInt(2),this.fileCommentLength=e.readInt(2),this.diskNumberStart=e.readInt(2),this.internalFileAttributes=e.readInt(2),this.externalFileAttributes=e.readInt(4),this.localHeaderOffset=e.readInt(4),this.isEncrypted())throw new Error("Encrypted zip are not supported");e.skip(t),this.readExtraFields(e),this.parseZIP64ExtraField(e),this.fileComment=e.readData(this.fileCommentLength)},processAttributes:function(){this.unixPermissions=null,this.dosPermissions=null;var e=this.versionMadeBy>>8;this.dir=!!(16&this.externalFileAttributes),0==e&&(this.dosPermissions=63&this.externalFileAttributes),3==e&&(this.unixPermissions=this.externalFileAttributes>>16&65535),this.dir||"/"!==this.fileNameStr.slice(-1)||(this.dir=!0)},parseZIP64ExtraField:function(){if(this.extraFields[1]){var e=n(this.extraFields[1].value);this.uncompressedSize===s.MAX_VALUE_32BITS&&(this.uncompressedSize=e.readInt(8)),this.compressedSize===s.MAX_VALUE_32BITS&&(this.compressedSize=e.readInt(8)),this.localHeaderOffset===s.MAX_VALUE_32BITS&&(this.localHeaderOffset=e.readInt(8)),this.diskNumberStart===s.MAX_VALUE_32BITS&&(this.diskNumberStart=e.readInt(4))}},readExtraFields:function(e){var t,r,n,i=e.index+this.extraFieldsLength;for(this.extraFields||(this.extraFields={});e.index+4<i;)t=e.readInt(2),r=e.readInt(2),n=e.readData(r),this.extraFields[t]={id:t,length:r,value:n};e.setIndex(i)},handleUTF8:function(){var e=u.uint8array?"uint8array":"array";if(this.useUTF8())this.fileNameStr=o.utf8decode(this.fileName),this.fileCommentStr=o.utf8decode(this.fileComment);else{var t=this.findExtraFieldUnicodePath();if(null!==t)this.fileNameStr=t;else{var r=s.transformTo(e,this.fileName);this.fileNameStr=this.loadOptions.decodeFileName(r)}var n=this.findExtraFieldUnicodeComment();if(null!==n)this.fileCommentStr=n;else{var i=s.transformTo(e,this.fileComment);this.fileCommentStr=this.loadOptions.decodeFileName(i)}}},findExtraFieldUnicodePath:function(){var e=this.extraFields[28789];if(e){var t=n(e.value);return 1!==t.readInt(1)?null:a(this.fileName)!==t.readInt(4)?null:o.utf8decode(t.readData(e.length-5))}return null},findExtraFieldUnicodeComment:function(){var e=this.extraFields[25461];if(e){var t=n(e.value);return 1!==t.readInt(1)?null:a(this.fileComment)!==t.readInt(4)?null:o.utf8decode(t.readData(e.length-5))}return null}},t.exports=l},{"./compressedObject":2,"./compressions":3,"./crc32":4,"./reader/readerFor":22,"./support":30,"./utf8":31,"./utils":32}],35:[function(e,t,r){"use strict";function n(e,t,r){this.name=e,this.dir=r.dir,this.date=r.date,this.comment=r.comment,this.unixPermissions=r.unixPermissions,this.dosPermissions=r.dosPermissions,this._data=t,this._dataBinary=r.binary,this.options={compression:r.compression,compressionOptions:r.compressionOptions}}var s=e("./stream/StreamHelper"),i=e("./stream/DataWorker"),a=e("./utf8"),o=e("./compressedObject"),h=e("./stream/GenericWorker");n.prototype={internalStream:function(e){var t=null,r="string";try{if(!e)throw new Error("No output type specified.");var n="string"===(r=e.toLowerCase())||"text"===r;"binarystring"!==r&&"text"!==r||(r="string"),t=this._decompressWorker();var i=!this._dataBinary;i&&!n&&(t=t.pipe(new a.Utf8EncodeWorker)),!i&&n&&(t=t.pipe(new a.Utf8DecodeWorker))}catch(e){(t=new h("error")).error(e)}return new s(t,r,"")},async:function(e,t){return this.internalStream(e).accumulate(t)},nodeStream:function(e,t){return this.internalStream(e||"nodebuffer").toNodejsStream(t)},_compressWorker:function(e,t){if(this._data instanceof o&&this._data.compression.magic===e.magic)return this._data.getCompressedWorker();var r=this._decompressWorker();return this._dataBinary||(r=r.pipe(new a.Utf8EncodeWorker)),o.createWorkerFrom(r,e,t)},_decompressWorker:function(){return this._data instanceof o?this._data.getContentWorker():this._data instanceof h?this._data:new i(this._data)}};for(var u=["asText","asBinary","asNodeBuffer","asUint8Array","asArrayBuffer"],l=function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},f=0;f<u.length;f++)n.prototype[u[f]]=l;t.exports=n},{"./compressedObject":2,"./stream/DataWorker":27,"./stream/GenericWorker":28,"./stream/StreamHelper":29,"./utf8":31}],36:[function(e,l,t){(function(t){"use strict";var r,n,e=t.MutationObserver||t.WebKitMutationObserver;if(e){var i=0,s=new e(u),a=t.document.createTextNode("");s.observe(a,{characterData:!0}),r=function(){a.data=i=++i%2}}else if(t.setImmediate||void 0===t.MessageChannel)r="document"in t&&"onreadystatechange"in t.document.createElement("script")?function(){var e=t.document.createElement("script");e.onreadystatechange=function(){u(),e.onreadystatechange=null,e.parentNode.removeChild(e),e=null},t.document.documentElement.appendChild(e)}:function(){setTimeout(u,0)};else{var o=new t.MessageChannel;o.port1.onmessage=u,r=function(){o.port2.postMessage(0)}}var h=[];function u(){var e,t;n=!0;for(var r=h.length;r;){for(t=h,h=[],e=-1;++e<r;)t[e]();r=h.length}n=!1}l.exports=function(e){1!==h.push(e)||n||r()}}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],37:[function(e,t,r){"use strict";var i=e("immediate");function u(){}var l={},s=["REJECTED"],a=["FULFILLED"],n=["PENDING"];function o(e){if("function"!=typeof e)throw new TypeError("resolver must be a function");this.state=n,this.queue=[],this.outcome=void 0,e!==u&&d(this,e)}function h(e,t,r){this.promise=e,"function"==typeof t&&(this.onFulfilled=t,this.callFulfilled=this.otherCallFulfilled),"function"==typeof r&&(this.onRejected=r,this.callRejected=this.otherCallRejected)}function f(t,r,n){i(function(){var e;try{e=r(n)}catch(e){return l.reject(t,e)}e===t?l.reject(t,new TypeError("Cannot resolve promise with itself")):l.resolve(t,e)})}function c(e){var t=e&&e.then;if(e&&("object"==typeof e||"function"==typeof e)&&"function"==typeof t)return function(){t.apply(e,arguments)}}function d(t,e){var r=!1;function n(e){r||(r=!0,l.reject(t,e))}function i(e){r||(r=!0,l.resolve(t,e))}var s=p(function(){e(i,n)});"error"===s.status&&n(s.value)}function p(e,t){var r={};try{r.value=e(t),r.status="success"}catch(e){r.status="error",r.value=e}return r}(t.exports=o).prototype.finally=function(t){if("function"!=typeof t)return this;var r=this.constructor;return this.then(function(e){return r.resolve(t()).then(function(){return e})},function(e){return r.resolve(t()).then(function(){throw e})})},o.prototype.catch=function(e){return this.then(null,e)},o.prototype.then=function(e,t){if("function"!=typeof e&&this.state===a||"function"!=typeof t&&this.state===s)return this;var r=new this.constructor(u);this.state!==n?f(r,this.state===a?e:t,this.outcome):this.queue.push(new h(r,e,t));return r},h.prototype.callFulfilled=function(e){l.resolve(this.promise,e)},h.prototype.otherCallFulfilled=function(e){f(this.promise,this.onFulfilled,e)},h.prototype.callRejected=function(e){l.reject(this.promise,e)},h.prototype.otherCallRejected=function(e){f(this.promise,this.onRejected,e)},l.resolve=function(e,t){var r=p(c,t);if("error"===r.status)return l.reject(e,r.value);var n=r.value;if(n)d(e,n);else{e.state=a,e.outcome=t;for(var i=-1,s=e.queue.length;++i<s;)e.queue[i].callFulfilled(t)}return e},l.reject=function(e,t){e.state=s,e.outcome=t;for(var r=-1,n=e.queue.length;++r<n;)e.queue[r].callRejected(t);return e},o.resolve=function(e){if(e instanceof this)return e;return l.resolve(new this(u),e)},o.reject=function(e){var t=new this(u);return l.reject(t,e)},o.all=function(e){var r=this;if("[object Array]"!==Object.prototype.toString.call(e))return this.reject(new TypeError("must be an array"));var n=e.length,i=!1;if(!n)return this.resolve([]);var s=new Array(n),a=0,t=-1,o=new this(u);for(;++t<n;)h(e[t],t);return o;function h(e,t){r.resolve(e).then(function(e){s[t]=e,++a!==n||i||(i=!0,l.resolve(o,s))},function(e){i||(i=!0,l.reject(o,e))})}},o.race=function(e){var t=this;if("[object Array]"!==Object.prototype.toString.call(e))return this.reject(new TypeError("must be an array"));var r=e.length,n=!1;if(!r)return this.resolve([]);var i=-1,s=new this(u);for(;++i<r;)a=e[i],t.resolve(a).then(function(e){n||(n=!0,l.resolve(s,e))},function(e){n||(n=!0,l.reject(s,e))});var a;return s}},{immediate:36}],38:[function(e,t,r){"use strict";var n={};(0,e("./lib/utils/common").assign)(n,e("./lib/deflate"),e("./lib/inflate"),e("./lib/zlib/constants")),t.exports=n},{"./lib/deflate":39,"./lib/inflate":40,"./lib/utils/common":41,"./lib/zlib/constants":44}],39:[function(e,t,r){"use strict";var a=e("./zlib/deflate"),o=e("./utils/common"),h=e("./utils/strings"),i=e("./zlib/messages"),s=e("./zlib/zstream"),u=Object.prototype.toString,l=0,f=-1,c=0,d=8;function p(e){if(!(this instanceof p))return new p(e);this.options=o.assign({level:f,method:d,chunkSize:16384,windowBits:15,memLevel:8,strategy:c,to:""},e||{});var t=this.options;t.raw&&0<t.windowBits?t.windowBits=-t.windowBits:t.gzip&&0<t.windowBits&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new s,this.strm.avail_out=0;var r=a.deflateInit2(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(r!==l)throw new Error(i[r]);if(t.header&&a.deflateSetHeader(this.strm,t.header),t.dictionary){var n;if(n="string"==typeof t.dictionary?h.string2buf(t.dictionary):"[object ArrayBuffer]"===u.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,(r=a.deflateSetDictionary(this.strm,n))!==l)throw new Error(i[r]);this._dict_set=!0}}function n(e,t){var r=new p(t);if(r.push(e,!0),r.err)throw r.msg||i[r.err];return r.result}p.prototype.push=function(e,t){var r,n,i=this.strm,s=this.options.chunkSize;if(this.ended)return!1;n=t===~~t?t:!0===t?4:0,"string"==typeof e?i.input=h.string2buf(e):"[object ArrayBuffer]"===u.call(e)?i.input=new Uint8Array(e):i.input=e,i.next_in=0,i.avail_in=i.input.length;do{if(0===i.avail_out&&(i.output=new o.Buf8(s),i.next_out=0,i.avail_out=s),1!==(r=a.deflate(i,n))&&r!==l)return this.onEnd(r),!(this.ended=!0);0!==i.avail_out&&(0!==i.avail_in||4!==n&&2!==n)||("string"===this.options.to?this.onData(h.buf2binstring(o.shrinkBuf(i.output,i.next_out))):this.onData(o.shrinkBuf(i.output,i.next_out)))}while((0<i.avail_in||0===i.avail_out)&&1!==r);return 4===n?(r=a.deflateEnd(this.strm),this.onEnd(r),this.ended=!0,r===l):2!==n||(this.onEnd(l),!(i.avail_out=0))},p.prototype.onData=function(e){this.chunks.push(e)},p.prototype.onEnd=function(e){e===l&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=o.flattenChunks(this.chunks)),this.chunks=[],this.err=e,this.msg=this.strm.msg},r.Deflate=p,r.deflate=n,r.deflateRaw=function(e,t){return(t=t||{}).raw=!0,n(e,t)},r.gzip=function(e,t){return(t=t||{}).gzip=!0,n(e,t)}},{"./utils/common":41,"./utils/strings":42,"./zlib/deflate":46,"./zlib/messages":51,"./zlib/zstream":53}],40:[function(e,t,r){"use strict";var c=e("./zlib/inflate"),d=e("./utils/common"),p=e("./utils/strings"),m=e("./zlib/constants"),n=e("./zlib/messages"),i=e("./zlib/zstream"),s=e("./zlib/gzheader"),_=Object.prototype.toString;function a(e){if(!(this instanceof a))return new a(e);this.options=d.assign({chunkSize:16384,windowBits:0,to:""},e||{});var t=this.options;t.raw&&0<=t.windowBits&&t.windowBits<16&&(t.windowBits=-t.windowBits,0===t.windowBits&&(t.windowBits=-15)),!(0<=t.windowBits&&t.windowBits<16)||e&&e.windowBits||(t.windowBits+=32),15<t.windowBits&&t.windowBits<48&&0==(15&t.windowBits)&&(t.windowBits|=15),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new i,this.strm.avail_out=0;var r=c.inflateInit2(this.strm,t.windowBits);if(r!==m.Z_OK)throw new Error(n[r]);this.header=new s,c.inflateGetHeader(this.strm,this.header)}function o(e,t){var r=new a(t);if(r.push(e,!0),r.err)throw r.msg||n[r.err];return r.result}a.prototype.push=function(e,t){var r,n,i,s,a,o,h=this.strm,u=this.options.chunkSize,l=this.options.dictionary,f=!1;if(this.ended)return!1;n=t===~~t?t:!0===t?m.Z_FINISH:m.Z_NO_FLUSH,"string"==typeof e?h.input=p.binstring2buf(e):"[object ArrayBuffer]"===_.call(e)?h.input=new Uint8Array(e):h.input=e,h.next_in=0,h.avail_in=h.input.length;do{if(0===h.avail_out&&(h.output=new d.Buf8(u),h.next_out=0,h.avail_out=u),(r=c.inflate(h,m.Z_NO_FLUSH))===m.Z_NEED_DICT&&l&&(o="string"==typeof l?p.string2buf(l):"[object ArrayBuffer]"===_.call(l)?new Uint8Array(l):l,r=c.inflateSetDictionary(this.strm,o)),r===m.Z_BUF_ERROR&&!0===f&&(r=m.Z_OK,f=!1),r!==m.Z_STREAM_END&&r!==m.Z_OK)return this.onEnd(r),!(this.ended=!0);h.next_out&&(0!==h.avail_out&&r!==m.Z_STREAM_END&&(0!==h.avail_in||n!==m.Z_FINISH&&n!==m.Z_SYNC_FLUSH)||("string"===this.options.to?(i=p.utf8border(h.output,h.next_out),s=h.next_out-i,a=p.buf2string(h.output,i),h.next_out=s,h.avail_out=u-s,s&&d.arraySet(h.output,h.output,i,s,0),this.onData(a)):this.onData(d.shrinkBuf(h.output,h.next_out)))),0===h.avail_in&&0===h.avail_out&&(f=!0)}while((0<h.avail_in||0===h.avail_out)&&r!==m.Z_STREAM_END);return r===m.Z_STREAM_END&&(n=m.Z_FINISH),n===m.Z_FINISH?(r=c.inflateEnd(this.strm),this.onEnd(r),this.ended=!0,r===m.Z_OK):n!==m.Z_SYNC_FLUSH||(this.onEnd(m.Z_OK),!(h.avail_out=0))},a.prototype.onData=function(e){this.chunks.push(e)},a.prototype.onEnd=function(e){e===m.Z_OK&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=d.flattenChunks(this.chunks)),this.chunks=[],this.err=e,this.msg=this.strm.msg},r.Inflate=a,r.inflate=o,r.inflateRaw=function(e,t){return(t=t||{}).raw=!0,o(e,t)},r.ungzip=o},{"./utils/common":41,"./utils/strings":42,"./zlib/constants":44,"./zlib/gzheader":47,"./zlib/inflate":49,"./zlib/messages":51,"./zlib/zstream":53}],41:[function(e,t,r){"use strict";var n="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Int32Array;r.assign=function(e){for(var t=Array.prototype.slice.call(arguments,1);t.length;){var r=t.shift();if(r){if("object"!=typeof r)throw new TypeError(r+"must be non-object");for(var n in r)r.hasOwnProperty(n)&&(e[n]=r[n])}}return e},r.shrinkBuf=function(e,t){return e.length===t?e:e.subarray?e.subarray(0,t):(e.length=t,e)};var i={arraySet:function(e,t,r,n,i){if(t.subarray&&e.subarray)e.set(t.subarray(r,r+n),i);else for(var s=0;s<n;s++)e[i+s]=t[r+s]},flattenChunks:function(e){var t,r,n,i,s,a;for(t=n=0,r=e.length;t<r;t++)n+=e[t].length;for(a=new Uint8Array(n),t=i=0,r=e.length;t<r;t++)s=e[t],a.set(s,i),i+=s.length;return a}},s={arraySet:function(e,t,r,n,i){for(var s=0;s<n;s++)e[i+s]=t[r+s]},flattenChunks:function(e){return[].concat.apply([],e)}};r.setTyped=function(e){e?(r.Buf8=Uint8Array,r.Buf16=Uint16Array,r.Buf32=Int32Array,r.assign(r,i)):(r.Buf8=Array,r.Buf16=Array,r.Buf32=Array,r.assign(r,s))},r.setTyped(n)},{}],42:[function(e,t,r){"use strict";var h=e("./common"),i=!0,s=!0;try{String.fromCharCode.apply(null,[0])}catch(e){i=!1}try{String.fromCharCode.apply(null,new Uint8Array(1))}catch(e){s=!1}for(var u=new h.Buf8(256),n=0;n<256;n++)u[n]=252<=n?6:248<=n?5:240<=n?4:224<=n?3:192<=n?2:1;function l(e,t){if(t<65537&&(e.subarray&&s||!e.subarray&&i))return String.fromCharCode.apply(null,h.shrinkBuf(e,t));for(var r="",n=0;n<t;n++)r+=String.fromCharCode(e[n]);return r}u[254]=u[254]=1,r.string2buf=function(e){var t,r,n,i,s,a=e.length,o=0;for(i=0;i<a;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),o+=r<128?1:r<2048?2:r<65536?3:4;for(t=new h.Buf8(o),i=s=0;s<o;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),r<128?t[s++]=r:(r<2048?t[s++]=192|r>>>6:(r<65536?t[s++]=224|r>>>12:(t[s++]=240|r>>>18,t[s++]=128|r>>>12&63),t[s++]=128|r>>>6&63),t[s++]=128|63&r);return t},r.buf2binstring=function(e){return l(e,e.length)},r.binstring2buf=function(e){for(var t=new h.Buf8(e.length),r=0,n=t.length;r<n;r++)t[r]=e.charCodeAt(r);return t},r.buf2string=function(e,t){var r,n,i,s,a=t||e.length,o=new Array(2*a);for(r=n=0;r<a;)if((i=e[r++])<128)o[n++]=i;else if(4<(s=u[i]))o[n++]=65533,r+=s-1;else{for(i&=2===s?31:3===s?15:7;1<s&&r<a;)i=i<<6|63&e[r++],s--;1<s?o[n++]=65533:i<65536?o[n++]=i:(i-=65536,o[n++]=55296|i>>10&1023,o[n++]=56320|1023&i)}return l(o,n)},r.utf8border=function(e,t){var r;for((t=t||e.length)>e.length&&(t=e.length),r=t-1;0<=r&&128==(192&e[r]);)r--;return r<0?t:0===r?t:r+u[e[r]]>t?r:t}},{"./common":41}],43:[function(e,t,r){"use strict";t.exports=function(e,t,r,n){for(var i=65535&e|0,s=e>>>16&65535|0,a=0;0!==r;){for(r-=a=2e3<r?2e3:r;s=s+(i=i+t[n++]|0)|0,--a;);i%=65521,s%=65521}return i|s<<16|0}},{}],44:[function(e,t,r){"use strict";t.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8}},{}],45:[function(e,t,r){"use strict";var o=function(){for(var e,t=[],r=0;r<256;r++){e=r;for(var n=0;n<8;n++)e=1&e?3988292384^e>>>1:e>>>1;t[r]=e}return t}();t.exports=function(e,t,r,n){var i=o,s=n+r;e^=-1;for(var a=n;a<s;a++)e=e>>>8^i[255&(e^t[a])];return-1^e}},{}],46:[function(e,t,r){"use strict";var h,c=e("../utils/common"),u=e("./trees"),d=e("./adler32"),p=e("./crc32"),n=e("./messages"),l=0,f=4,m=0,_=-2,g=-1,b=4,i=2,v=8,y=9,s=286,a=30,o=19,w=2*s+1,k=15,x=3,S=258,z=S+x+1,C=42,E=113,A=1,I=2,O=3,B=4;function R(e,t){return e.msg=n[t],t}function T(e){return(e<<1)-(4<e?9:0)}function D(e){for(var t=e.length;0<=--t;)e[t]=0}function F(e){var t=e.state,r=t.pending;r>e.avail_out&&(r=e.avail_out),0!==r&&(c.arraySet(e.output,t.pending_buf,t.pending_out,r,e.next_out),e.next_out+=r,t.pending_out+=r,e.total_out+=r,e.avail_out-=r,t.pending-=r,0===t.pending&&(t.pending_out=0))}function N(e,t){u._tr_flush_block(e,0<=e.block_start?e.block_start:-1,e.strstart-e.block_start,t),e.block_start=e.strstart,F(e.strm)}function U(e,t){e.pending_buf[e.pending++]=t}function P(e,t){e.pending_buf[e.pending++]=t>>>8&255,e.pending_buf[e.pending++]=255&t}function L(e,t){var r,n,i=e.max_chain_length,s=e.strstart,a=e.prev_length,o=e.nice_match,h=e.strstart>e.w_size-z?e.strstart-(e.w_size-z):0,u=e.window,l=e.w_mask,f=e.prev,c=e.strstart+S,d=u[s+a-1],p=u[s+a];e.prev_length>=e.good_match&&(i>>=2),o>e.lookahead&&(o=e.lookahead);do{if(u[(r=t)+a]===p&&u[r+a-1]===d&&u[r]===u[s]&&u[++r]===u[s+1]){s+=2,r++;do{}while(u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&s<c);if(n=S-(c-s),s=c-S,a<n){if(e.match_start=t,o<=(a=n))break;d=u[s+a-1],p=u[s+a]}}}while((t=f[t&l])>h&&0!=--i);return a<=e.lookahead?a:e.lookahead}function j(e){var t,r,n,i,s,a,o,h,u,l,f=e.w_size;do{if(i=e.window_size-e.lookahead-e.strstart,e.strstart>=f+(f-z)){for(c.arraySet(e.window,e.window,f,f,0),e.match_start-=f,e.strstart-=f,e.block_start-=f,t=r=e.hash_size;n=e.head[--t],e.head[t]=f<=n?n-f:0,--r;);for(t=r=f;n=e.prev[--t],e.prev[t]=f<=n?n-f:0,--r;);i+=f}if(0===e.strm.avail_in)break;if(a=e.strm,o=e.window,h=e.strstart+e.lookahead,u=i,l=void 0,l=a.avail_in,u<l&&(l=u),r=0===l?0:(a.avail_in-=l,c.arraySet(o,a.input,a.next_in,l,h),1===a.state.wrap?a.adler=d(a.adler,o,l,h):2===a.state.wrap&&(a.adler=p(a.adler,o,l,h)),a.next_in+=l,a.total_in+=l,l),e.lookahead+=r,e.lookahead+e.insert>=x)for(s=e.strstart-e.insert,e.ins_h=e.window[s],e.ins_h=(e.ins_h<<e.hash_shift^e.window[s+1])&e.hash_mask;e.insert&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[s+x-1])&e.hash_mask,e.prev[s&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=s,s++,e.insert--,!(e.lookahead+e.insert<x)););}while(e.lookahead<z&&0!==e.strm.avail_in)}function Z(e,t){for(var r,n;;){if(e.lookahead<z){if(j(e),e.lookahead<z&&t===l)return A;if(0===e.lookahead)break}if(r=0,e.lookahead>=x&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),0!==r&&e.strstart-r<=e.w_size-z&&(e.match_length=L(e,r)),e.match_length>=x)if(n=u._tr_tally(e,e.strstart-e.match_start,e.match_length-x),e.lookahead-=e.match_length,e.match_length<=e.max_lazy_match&&e.lookahead>=x){for(e.match_length--;e.strstart++,e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart,0!=--e.match_length;);e.strstart++}else e.strstart+=e.match_length,e.match_length=0,e.ins_h=e.window[e.strstart],e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+1])&e.hash_mask;else n=u._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++;if(n&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=e.strstart<x-1?e.strstart:x-1,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}function W(e,t){for(var r,n,i;;){if(e.lookahead<z){if(j(e),e.lookahead<z&&t===l)return A;if(0===e.lookahead)break}if(r=0,e.lookahead>=x&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),e.prev_length=e.match_length,e.prev_match=e.match_start,e.match_length=x-1,0!==r&&e.prev_length<e.max_lazy_match&&e.strstart-r<=e.w_size-z&&(e.match_length=L(e,r),e.match_length<=5&&(1===e.strategy||e.match_length===x&&4096<e.strstart-e.match_start)&&(e.match_length=x-1)),e.prev_length>=x&&e.match_length<=e.prev_length){for(i=e.strstart+e.lookahead-x,n=u._tr_tally(e,e.strstart-1-e.prev_match,e.prev_length-x),e.lookahead-=e.prev_length-1,e.prev_length-=2;++e.strstart<=i&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),0!=--e.prev_length;);if(e.match_available=0,e.match_length=x-1,e.strstart++,n&&(N(e,!1),0===e.strm.avail_out))return A}else if(e.match_available){if((n=u._tr_tally(e,0,e.window[e.strstart-1]))&&N(e,!1),e.strstart++,e.lookahead--,0===e.strm.avail_out)return A}else e.match_available=1,e.strstart++,e.lookahead--}return e.match_available&&(n=u._tr_tally(e,0,e.window[e.strstart-1]),e.match_available=0),e.insert=e.strstart<x-1?e.strstart:x-1,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}function M(e,t,r,n,i){this.good_length=e,this.max_lazy=t,this.nice_length=r,this.max_chain=n,this.func=i}function H(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=v,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new c.Buf16(2*w),this.dyn_dtree=new c.Buf16(2*(2*a+1)),this.bl_tree=new c.Buf16(2*(2*o+1)),D(this.dyn_ltree),D(this.dyn_dtree),D(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new c.Buf16(k+1),this.heap=new c.Buf16(2*s+1),D(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new c.Buf16(2*s+1),D(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}function G(e){var t;return e&&e.state?(e.total_in=e.total_out=0,e.data_type=i,(t=e.state).pending=0,t.pending_out=0,t.wrap<0&&(t.wrap=-t.wrap),t.status=t.wrap?C:E,e.adler=2===t.wrap?0:1,t.last_flush=l,u._tr_init(t),m):R(e,_)}function K(e){var t=G(e);return t===m&&function(e){e.window_size=2*e.w_size,D(e.head),e.max_lazy_match=h[e.level].max_lazy,e.good_match=h[e.level].good_length,e.nice_match=h[e.level].nice_length,e.max_chain_length=h[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=x-1,e.match_available=0,e.ins_h=0}(e.state),t}function Y(e,t,r,n,i,s){if(!e)return _;var a=1;if(t===g&&(t=6),n<0?(a=0,n=-n):15<n&&(a=2,n-=16),i<1||y<i||r!==v||n<8||15<n||t<0||9<t||s<0||b<s)return R(e,_);8===n&&(n=9);var o=new H;return(e.state=o).strm=e,o.wrap=a,o.gzhead=null,o.w_bits=n,o.w_size=1<<o.w_bits,o.w_mask=o.w_size-1,o.hash_bits=i+7,o.hash_size=1<<o.hash_bits,o.hash_mask=o.hash_size-1,o.hash_shift=~~((o.hash_bits+x-1)/x),o.window=new c.Buf8(2*o.w_size),o.head=new c.Buf16(o.hash_size),o.prev=new c.Buf16(o.w_size),o.lit_bufsize=1<<i+6,o.pending_buf_size=4*o.lit_bufsize,o.pending_buf=new c.Buf8(o.pending_buf_size),o.d_buf=1*o.lit_bufsize,o.l_buf=3*o.lit_bufsize,o.level=t,o.strategy=s,o.method=r,K(e)}h=[new M(0,0,0,0,function(e,t){var r=65535;for(r>e.pending_buf_size-5&&(r=e.pending_buf_size-5);;){if(e.lookahead<=1){if(j(e),0===e.lookahead&&t===l)return A;if(0===e.lookahead)break}e.strstart+=e.lookahead,e.lookahead=0;var n=e.block_start+r;if((0===e.strstart||e.strstart>=n)&&(e.lookahead=e.strstart-n,e.strstart=n,N(e,!1),0===e.strm.avail_out))return A;if(e.strstart-e.block_start>=e.w_size-z&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=0,t===f?(N(e,!0),0===e.strm.avail_out?O:B):(e.strstart>e.block_start&&(N(e,!1),e.strm.avail_out),A)}),new M(4,4,8,4,Z),new M(4,5,16,8,Z),new M(4,6,32,32,Z),new M(4,4,16,16,W),new M(8,16,32,32,W),new M(8,16,128,128,W),new M(8,32,128,256,W),new M(32,128,258,1024,W),new M(32,258,258,4096,W)],r.deflateInit=function(e,t){return Y(e,t,v,15,8,0)},r.deflateInit2=Y,r.deflateReset=K,r.deflateResetKeep=G,r.deflateSetHeader=function(e,t){return e&&e.state?2!==e.state.wrap?_:(e.state.gzhead=t,m):_},r.deflate=function(e,t){var r,n,i,s;if(!e||!e.state||5<t||t<0)return e?R(e,_):_;if(n=e.state,!e.output||!e.input&&0!==e.avail_in||666===n.status&&t!==f)return R(e,0===e.avail_out?-5:_);if(n.strm=e,r=n.last_flush,n.last_flush=t,n.status===C)if(2===n.wrap)e.adler=0,U(n,31),U(n,139),U(n,8),n.gzhead?(U(n,(n.gzhead.text?1:0)+(n.gzhead.hcrc?2:0)+(n.gzhead.extra?4:0)+(n.gzhead.name?8:0)+(n.gzhead.comment?16:0)),U(n,255&n.gzhead.time),U(n,n.gzhead.time>>8&255),U(n,n.gzhead.time>>16&255),U(n,n.gzhead.time>>24&255),U(n,9===n.level?2:2<=n.strategy||n.level<2?4:0),U(n,255&n.gzhead.os),n.gzhead.extra&&n.gzhead.extra.length&&(U(n,255&n.gzhead.extra.length),U(n,n.gzhead.extra.length>>8&255)),n.gzhead.hcrc&&(e.adler=p(e.adler,n.pending_buf,n.pending,0)),n.gzindex=0,n.status=69):(U(n,0),U(n,0),U(n,0),U(n,0),U(n,0),U(n,9===n.level?2:2<=n.strategy||n.level<2?4:0),U(n,3),n.status=E);else{var a=v+(n.w_bits-8<<4)<<8;a|=(2<=n.strategy||n.level<2?0:n.level<6?1:6===n.level?2:3)<<6,0!==n.strstart&&(a|=32),a+=31-a%31,n.status=E,P(n,a),0!==n.strstart&&(P(n,e.adler>>>16),P(n,65535&e.adler)),e.adler=1}if(69===n.status)if(n.gzhead.extra){for(i=n.pending;n.gzindex<(65535&n.gzhead.extra.length)&&(n.pending!==n.pending_buf_size||(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),F(e),i=n.pending,n.pending!==n.pending_buf_size));)U(n,255&n.gzhead.extra[n.gzindex]),n.gzindex++;n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),n.gzindex===n.gzhead.extra.length&&(n.gzindex=0,n.status=73)}else n.status=73;if(73===n.status)if(n.gzhead.name){i=n.pending;do{if(n.pending===n.pending_buf_size&&(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),F(e),i=n.pending,n.pending===n.pending_buf_size)){s=1;break}s=n.gzindex<n.gzhead.name.length?255&n.gzhead.name.charCodeAt(n.gzindex++):0,U(n,s)}while(0!==s);n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),0===s&&(n.gzindex=0,n.status=91)}else n.status=91;if(91===n.status)if(n.gzhead.comment){i=n.pending;do{if(n.pending===n.pending_buf_size&&(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),F(e),i=n.pending,n.pending===n.pending_buf_size)){s=1;break}s=n.gzindex<n.gzhead.comment.length?255&n.gzhead.comment.charCodeAt(n.gzindex++):0,U(n,s)}while(0!==s);n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),0===s&&(n.status=103)}else n.status=103;if(103===n.status&&(n.gzhead.hcrc?(n.pending+2>n.pending_buf_size&&F(e),n.pending+2<=n.pending_buf_size&&(U(n,255&e.adler),U(n,e.adler>>8&255),e.adler=0,n.status=E)):n.status=E),0!==n.pending){if(F(e),0===e.avail_out)return n.last_flush=-1,m}else if(0===e.avail_in&&T(t)<=T(r)&&t!==f)return R(e,-5);if(666===n.status&&0!==e.avail_in)return R(e,-5);if(0!==e.avail_in||0!==n.lookahead||t!==l&&666!==n.status){var o=2===n.strategy?function(e,t){for(var r;;){if(0===e.lookahead&&(j(e),0===e.lookahead)){if(t===l)return A;break}if(e.match_length=0,r=u._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++,r&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=0,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}(n,t):3===n.strategy?function(e,t){for(var r,n,i,s,a=e.window;;){if(e.lookahead<=S){if(j(e),e.lookahead<=S&&t===l)return A;if(0===e.lookahead)break}if(e.match_length=0,e.lookahead>=x&&0<e.strstart&&(n=a[i=e.strstart-1])===a[++i]&&n===a[++i]&&n===a[++i]){s=e.strstart+S;do{}while(n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&i<s);e.match_length=S-(s-i),e.match_length>e.lookahead&&(e.match_length=e.lookahead)}if(e.match_length>=x?(r=u._tr_tally(e,1,e.match_length-x),e.lookahead-=e.match_length,e.strstart+=e.match_length,e.match_length=0):(r=u._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++),r&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=0,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}(n,t):h[n.level].func(n,t);if(o!==O&&o!==B||(n.status=666),o===A||o===O)return 0===e.avail_out&&(n.last_flush=-1),m;if(o===I&&(1===t?u._tr_align(n):5!==t&&(u._tr_stored_block(n,0,0,!1),3===t&&(D(n.head),0===n.lookahead&&(n.strstart=0,n.block_start=0,n.insert=0))),F(e),0===e.avail_out))return n.last_flush=-1,m}return t!==f?m:n.wrap<=0?1:(2===n.wrap?(U(n,255&e.adler),U(n,e.adler>>8&255),U(n,e.adler>>16&255),U(n,e.adler>>24&255),U(n,255&e.total_in),U(n,e.total_in>>8&255),U(n,e.total_in>>16&255),U(n,e.total_in>>24&255)):(P(n,e.adler>>>16),P(n,65535&e.adler)),F(e),0<n.wrap&&(n.wrap=-n.wrap),0!==n.pending?m:1)},r.deflateEnd=function(e){var t;return e&&e.state?(t=e.state.status)!==C&&69!==t&&73!==t&&91!==t&&103!==t&&t!==E&&666!==t?R(e,_):(e.state=null,t===E?R(e,-3):m):_},r.deflateSetDictionary=function(e,t){var r,n,i,s,a,o,h,u,l=t.length;if(!e||!e.state)return _;if(2===(s=(r=e.state).wrap)||1===s&&r.status!==C||r.lookahead)return _;for(1===s&&(e.adler=d(e.adler,t,l,0)),r.wrap=0,l>=r.w_size&&(0===s&&(D(r.head),r.strstart=0,r.block_start=0,r.insert=0),u=new c.Buf8(r.w_size),c.arraySet(u,t,l-r.w_size,r.w_size,0),t=u,l=r.w_size),a=e.avail_in,o=e.next_in,h=e.input,e.avail_in=l,e.next_in=0,e.input=t,j(r);r.lookahead>=x;){for(n=r.strstart,i=r.lookahead-(x-1);r.ins_h=(r.ins_h<<r.hash_shift^r.window[n+x-1])&r.hash_mask,r.prev[n&r.w_mask]=r.head[r.ins_h],r.head[r.ins_h]=n,n++,--i;);r.strstart=n,r.lookahead=x-1,j(r)}return r.strstart+=r.lookahead,r.block_start=r.strstart,r.insert=r.lookahead,r.lookahead=0,r.match_length=r.prev_length=x-1,r.match_available=0,e.next_in=o,e.input=h,e.avail_in=a,r.wrap=s,m},r.deflateInfo="pako deflate (from Nodeca project)"},{"../utils/common":41,"./adler32":43,"./crc32":45,"./messages":51,"./trees":52}],47:[function(e,t,r){"use strict";t.exports=function(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1}},{}],48:[function(e,t,r){"use strict";t.exports=function(e,t){var r,n,i,s,a,o,h,u,l,f,c,d,p,m,_,g,b,v,y,w,k,x,S,z,C;r=e.state,n=e.next_in,z=e.input,i=n+(e.avail_in-5),s=e.next_out,C=e.output,a=s-(t-e.avail_out),o=s+(e.avail_out-257),h=r.dmax,u=r.wsize,l=r.whave,f=r.wnext,c=r.window,d=r.hold,p=r.bits,m=r.lencode,_=r.distcode,g=(1<<r.lenbits)-1,b=(1<<r.distbits)-1;e:do{p<15&&(d+=z[n++]<<p,p+=8,d+=z[n++]<<p,p+=8),v=m[d&g];t:for(;;){if(d>>>=y=v>>>24,p-=y,0===(y=v>>>16&255))C[s++]=65535&v;else{if(!(16&y)){if(0==(64&y)){v=m[(65535&v)+(d&(1<<y)-1)];continue t}if(32&y){r.mode=12;break e}e.msg="invalid literal/length code",r.mode=30;break e}w=65535&v,(y&=15)&&(p<y&&(d+=z[n++]<<p,p+=8),w+=d&(1<<y)-1,d>>>=y,p-=y),p<15&&(d+=z[n++]<<p,p+=8,d+=z[n++]<<p,p+=8),v=_[d&b];r:for(;;){if(d>>>=y=v>>>24,p-=y,!(16&(y=v>>>16&255))){if(0==(64&y)){v=_[(65535&v)+(d&(1<<y)-1)];continue r}e.msg="invalid distance code",r.mode=30;break e}if(k=65535&v,p<(y&=15)&&(d+=z[n++]<<p,(p+=8)<y&&(d+=z[n++]<<p,p+=8)),h<(k+=d&(1<<y)-1)){e.msg="invalid distance too far back",r.mode=30;break e}if(d>>>=y,p-=y,(y=s-a)<k){if(l<(y=k-y)&&r.sane){e.msg="invalid distance too far back",r.mode=30;break e}if(S=c,(x=0)===f){if(x+=u-y,y<w){for(w-=y;C[s++]=c[x++],--y;);x=s-k,S=C}}else if(f<y){if(x+=u+f-y,(y-=f)<w){for(w-=y;C[s++]=c[x++],--y;);if(x=0,f<w){for(w-=y=f;C[s++]=c[x++],--y;);x=s-k,S=C}}}else if(x+=f-y,y<w){for(w-=y;C[s++]=c[x++],--y;);x=s-k,S=C}for(;2<w;)C[s++]=S[x++],C[s++]=S[x++],C[s++]=S[x++],w-=3;w&&(C[s++]=S[x++],1<w&&(C[s++]=S[x++]))}else{for(x=s-k;C[s++]=C[x++],C[s++]=C[x++],C[s++]=C[x++],2<(w-=3););w&&(C[s++]=C[x++],1<w&&(C[s++]=C[x++]))}break}}break}}while(n<i&&s<o);n-=w=p>>3,d&=(1<<(p-=w<<3))-1,e.next_in=n,e.next_out=s,e.avail_in=n<i?i-n+5:5-(n-i),e.avail_out=s<o?o-s+257:257-(s-o),r.hold=d,r.bits=p}},{}],49:[function(e,t,r){"use strict";var I=e("../utils/common"),O=e("./adler32"),B=e("./crc32"),R=e("./inffast"),T=e("./inftrees"),D=1,F=2,N=0,U=-2,P=1,n=852,i=592;function L(e){return(e>>>24&255)+(e>>>8&65280)+((65280&e)<<8)+((255&e)<<24)}function s(){this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new I.Buf16(320),this.work=new I.Buf16(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0}function a(e){var t;return e&&e.state?(t=e.state,e.total_in=e.total_out=t.total=0,e.msg="",t.wrap&&(e.adler=1&t.wrap),t.mode=P,t.last=0,t.havedict=0,t.dmax=32768,t.head=null,t.hold=0,t.bits=0,t.lencode=t.lendyn=new I.Buf32(n),t.distcode=t.distdyn=new I.Buf32(i),t.sane=1,t.back=-1,N):U}function o(e){var t;return e&&e.state?((t=e.state).wsize=0,t.whave=0,t.wnext=0,a(e)):U}function h(e,t){var r,n;return e&&e.state?(n=e.state,t<0?(r=0,t=-t):(r=1+(t>>4),t<48&&(t&=15)),t&&(t<8||15<t)?U:(null!==n.window&&n.wbits!==t&&(n.window=null),n.wrap=r,n.wbits=t,o(e))):U}function u(e,t){var r,n;return e?(n=new s,(e.state=n).window=null,(r=h(e,t))!==N&&(e.state=null),r):U}var l,f,c=!0;function j(e){if(c){var t;for(l=new I.Buf32(512),f=new I.Buf32(32),t=0;t<144;)e.lens[t++]=8;for(;t<256;)e.lens[t++]=9;for(;t<280;)e.lens[t++]=7;for(;t<288;)e.lens[t++]=8;for(T(D,e.lens,0,288,l,0,e.work,{bits:9}),t=0;t<32;)e.lens[t++]=5;T(F,e.lens,0,32,f,0,e.work,{bits:5}),c=!1}e.lencode=l,e.lenbits=9,e.distcode=f,e.distbits=5}function Z(e,t,r,n){var i,s=e.state;return null===s.window&&(s.wsize=1<<s.wbits,s.wnext=0,s.whave=0,s.window=new I.Buf8(s.wsize)),n>=s.wsize?(I.arraySet(s.window,t,r-s.wsize,s.wsize,0),s.wnext=0,s.whave=s.wsize):(n<(i=s.wsize-s.wnext)&&(i=n),I.arraySet(s.window,t,r-n,i,s.wnext),(n-=i)?(I.arraySet(s.window,t,r-n,n,0),s.wnext=n,s.whave=s.wsize):(s.wnext+=i,s.wnext===s.wsize&&(s.wnext=0),s.whave<s.wsize&&(s.whave+=i))),0}r.inflateReset=o,r.inflateReset2=h,r.inflateResetKeep=a,r.inflateInit=function(e){return u(e,15)},r.inflateInit2=u,r.inflate=function(e,t){var r,n,i,s,a,o,h,u,l,f,c,d,p,m,_,g,b,v,y,w,k,x,S,z,C=0,E=new I.Buf8(4),A=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!e||!e.state||!e.output||!e.input&&0!==e.avail_in)return U;12===(r=e.state).mode&&(r.mode=13),a=e.next_out,i=e.output,h=e.avail_out,s=e.next_in,n=e.input,o=e.avail_in,u=r.hold,l=r.bits,f=o,c=h,x=N;e:for(;;)switch(r.mode){case P:if(0===r.wrap){r.mode=13;break}for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(2&r.wrap&&35615===u){E[r.check=0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0),l=u=0,r.mode=2;break}if(r.flags=0,r.head&&(r.head.done=!1),!(1&r.wrap)||(((255&u)<<8)+(u>>8))%31){e.msg="incorrect header check",r.mode=30;break}if(8!=(15&u)){e.msg="unknown compression method",r.mode=30;break}if(l-=4,k=8+(15&(u>>>=4)),0===r.wbits)r.wbits=k;else if(k>r.wbits){e.msg="invalid window size",r.mode=30;break}r.dmax=1<<k,e.adler=r.check=1,r.mode=512&u?10:12,l=u=0;break;case 2:for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(r.flags=u,8!=(255&r.flags)){e.msg="unknown compression method",r.mode=30;break}if(57344&r.flags){e.msg="unknown header flags set",r.mode=30;break}r.head&&(r.head.text=u>>8&1),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0)),l=u=0,r.mode=3;case 3:for(;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.head&&(r.head.time=u),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,E[2]=u>>>16&255,E[3]=u>>>24&255,r.check=B(r.check,E,4,0)),l=u=0,r.mode=4;case 4:for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.head&&(r.head.xflags=255&u,r.head.os=u>>8),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0)),l=u=0,r.mode=5;case 5:if(1024&r.flags){for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.length=u,r.head&&(r.head.extra_len=u),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0)),l=u=0}else r.head&&(r.head.extra=null);r.mode=6;case 6:if(1024&r.flags&&(o<(d=r.length)&&(d=o),d&&(r.head&&(k=r.head.extra_len-r.length,r.head.extra||(r.head.extra=new Array(r.head.extra_len)),I.arraySet(r.head.extra,n,s,d,k)),512&r.flags&&(r.check=B(r.check,n,d,s)),o-=d,s+=d,r.length-=d),r.length))break e;r.length=0,r.mode=7;case 7:if(2048&r.flags){if(0===o)break e;for(d=0;k=n[s+d++],r.head&&k&&r.length<65536&&(r.head.name+=String.fromCharCode(k)),k&&d<o;);if(512&r.flags&&(r.check=B(r.check,n,d,s)),o-=d,s+=d,k)break e}else r.head&&(r.head.name=null);r.length=0,r.mode=8;case 8:if(4096&r.flags){if(0===o)break e;for(d=0;k=n[s+d++],r.head&&k&&r.length<65536&&(r.head.comment+=String.fromCharCode(k)),k&&d<o;);if(512&r.flags&&(r.check=B(r.check,n,d,s)),o-=d,s+=d,k)break e}else r.head&&(r.head.comment=null);r.mode=9;case 9:if(512&r.flags){for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(u!==(65535&r.check)){e.msg="header crc mismatch",r.mode=30;break}l=u=0}r.head&&(r.head.hcrc=r.flags>>9&1,r.head.done=!0),e.adler=r.check=0,r.mode=12;break;case 10:for(;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}e.adler=r.check=L(u),l=u=0,r.mode=11;case 11:if(0===r.havedict)return e.next_out=a,e.avail_out=h,e.next_in=s,e.avail_in=o,r.hold=u,r.bits=l,2;e.adler=r.check=1,r.mode=12;case 12:if(5===t||6===t)break e;case 13:if(r.last){u>>>=7&l,l-=7&l,r.mode=27;break}for(;l<3;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}switch(r.last=1&u,l-=1,3&(u>>>=1)){case 0:r.mode=14;break;case 1:if(j(r),r.mode=20,6!==t)break;u>>>=2,l-=2;break e;case 2:r.mode=17;break;case 3:e.msg="invalid block type",r.mode=30}u>>>=2,l-=2;break;case 14:for(u>>>=7&l,l-=7&l;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if((65535&u)!=(u>>>16^65535)){e.msg="invalid stored block lengths",r.mode=30;break}if(r.length=65535&u,l=u=0,r.mode=15,6===t)break e;case 15:r.mode=16;case 16:if(d=r.length){if(o<d&&(d=o),h<d&&(d=h),0===d)break e;I.arraySet(i,n,s,d,a),o-=d,s+=d,h-=d,a+=d,r.length-=d;break}r.mode=12;break;case 17:for(;l<14;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(r.nlen=257+(31&u),u>>>=5,l-=5,r.ndist=1+(31&u),u>>>=5,l-=5,r.ncode=4+(15&u),u>>>=4,l-=4,286<r.nlen||30<r.ndist){e.msg="too many length or distance symbols",r.mode=30;break}r.have=0,r.mode=18;case 18:for(;r.have<r.ncode;){for(;l<3;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.lens[A[r.have++]]=7&u,u>>>=3,l-=3}for(;r.have<19;)r.lens[A[r.have++]]=0;if(r.lencode=r.lendyn,r.lenbits=7,S={bits:r.lenbits},x=T(0,r.lens,0,19,r.lencode,0,r.work,S),r.lenbits=S.bits,x){e.msg="invalid code lengths set",r.mode=30;break}r.have=0,r.mode=19;case 19:for(;r.have<r.nlen+r.ndist;){for(;g=(C=r.lencode[u&(1<<r.lenbits)-1])>>>16&255,b=65535&C,!((_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(b<16)u>>>=_,l-=_,r.lens[r.have++]=b;else{if(16===b){for(z=_+2;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(u>>>=_,l-=_,0===r.have){e.msg="invalid bit length repeat",r.mode=30;break}k=r.lens[r.have-1],d=3+(3&u),u>>>=2,l-=2}else if(17===b){for(z=_+3;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}l-=_,k=0,d=3+(7&(u>>>=_)),u>>>=3,l-=3}else{for(z=_+7;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}l-=_,k=0,d=11+(127&(u>>>=_)),u>>>=7,l-=7}if(r.have+d>r.nlen+r.ndist){e.msg="invalid bit length repeat",r.mode=30;break}for(;d--;)r.lens[r.have++]=k}}if(30===r.mode)break;if(0===r.lens[256]){e.msg="invalid code -- missing end-of-block",r.mode=30;break}if(r.lenbits=9,S={bits:r.lenbits},x=T(D,r.lens,0,r.nlen,r.lencode,0,r.work,S),r.lenbits=S.bits,x){e.msg="invalid literal/lengths set",r.mode=30;break}if(r.distbits=6,r.distcode=r.distdyn,S={bits:r.distbits},x=T(F,r.lens,r.nlen,r.ndist,r.distcode,0,r.work,S),r.distbits=S.bits,x){e.msg="invalid distances set",r.mode=30;break}if(r.mode=20,6===t)break e;case 20:r.mode=21;case 21:if(6<=o&&258<=h){e.next_out=a,e.avail_out=h,e.next_in=s,e.avail_in=o,r.hold=u,r.bits=l,R(e,c),a=e.next_out,i=e.output,h=e.avail_out,s=e.next_in,n=e.input,o=e.avail_in,u=r.hold,l=r.bits,12===r.mode&&(r.back=-1);break}for(r.back=0;g=(C=r.lencode[u&(1<<r.lenbits)-1])>>>16&255,b=65535&C,!((_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(g&&0==(240&g)){for(v=_,y=g,w=b;g=(C=r.lencode[w+((u&(1<<v+y)-1)>>v)])>>>16&255,b=65535&C,!(v+(_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}u>>>=v,l-=v,r.back+=v}if(u>>>=_,l-=_,r.back+=_,r.length=b,0===g){r.mode=26;break}if(32&g){r.back=-1,r.mode=12;break}if(64&g){e.msg="invalid literal/length code",r.mode=30;break}r.extra=15&g,r.mode=22;case 22:if(r.extra){for(z=r.extra;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.length+=u&(1<<r.extra)-1,u>>>=r.extra,l-=r.extra,r.back+=r.extra}r.was=r.length,r.mode=23;case 23:for(;g=(C=r.distcode[u&(1<<r.distbits)-1])>>>16&255,b=65535&C,!((_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(0==(240&g)){for(v=_,y=g,w=b;g=(C=r.distcode[w+((u&(1<<v+y)-1)>>v)])>>>16&255,b=65535&C,!(v+(_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}u>>>=v,l-=v,r.back+=v}if(u>>>=_,l-=_,r.back+=_,64&g){e.msg="invalid distance code",r.mode=30;break}r.offset=b,r.extra=15&g,r.mode=24;case 24:if(r.extra){for(z=r.extra;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.offset+=u&(1<<r.extra)-1,u>>>=r.extra,l-=r.extra,r.back+=r.extra}if(r.offset>r.dmax){e.msg="invalid distance too far back",r.mode=30;break}r.mode=25;case 25:if(0===h)break e;if(d=c-h,r.offset>d){if((d=r.offset-d)>r.whave&&r.sane){e.msg="invalid distance too far back",r.mode=30;break}p=d>r.wnext?(d-=r.wnext,r.wsize-d):r.wnext-d,d>r.length&&(d=r.length),m=r.window}else m=i,p=a-r.offset,d=r.length;for(h<d&&(d=h),h-=d,r.length-=d;i[a++]=m[p++],--d;);0===r.length&&(r.mode=21);break;case 26:if(0===h)break e;i[a++]=r.length,h--,r.mode=21;break;case 27:if(r.wrap){for(;l<32;){if(0===o)break e;o--,u|=n[s++]<<l,l+=8}if(c-=h,e.total_out+=c,r.total+=c,c&&(e.adler=r.check=r.flags?B(r.check,i,c,a-c):O(r.check,i,c,a-c)),c=h,(r.flags?u:L(u))!==r.check){e.msg="incorrect data check",r.mode=30;break}l=u=0}r.mode=28;case 28:if(r.wrap&&r.flags){for(;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(u!==(4294967295&r.total)){e.msg="incorrect length check",r.mode=30;break}l=u=0}r.mode=29;case 29:x=1;break e;case 30:x=-3;break e;case 31:return-4;case 32:default:return U}return e.next_out=a,e.avail_out=h,e.next_in=s,e.avail_in=o,r.hold=u,r.bits=l,(r.wsize||c!==e.avail_out&&r.mode<30&&(r.mode<27||4!==t))&&Z(e,e.output,e.next_out,c-e.avail_out)?(r.mode=31,-4):(f-=e.avail_in,c-=e.avail_out,e.total_in+=f,e.total_out+=c,r.total+=c,r.wrap&&c&&(e.adler=r.check=r.flags?B(r.check,i,c,e.next_out-c):O(r.check,i,c,e.next_out-c)),e.data_type=r.bits+(r.last?64:0)+(12===r.mode?128:0)+(20===r.mode||15===r.mode?256:0),(0==f&&0===c||4===t)&&x===N&&(x=-5),x)},r.inflateEnd=function(e){if(!e||!e.state)return U;var t=e.state;return t.window&&(t.window=null),e.state=null,N},r.inflateGetHeader=function(e,t){var r;return e&&e.state?0==(2&(r=e.state).wrap)?U:((r.head=t).done=!1,N):U},r.inflateSetDictionary=function(e,t){var r,n=t.length;return e&&e.state?0!==(r=e.state).wrap&&11!==r.mode?U:11===r.mode&&O(1,t,n,0)!==r.check?-3:Z(e,t,n,n)?(r.mode=31,-4):(r.havedict=1,N):U},r.inflateInfo="pako inflate (from Nodeca project)"},{"../utils/common":41,"./adler32":43,"./crc32":45,"./inffast":48,"./inftrees":50}],50:[function(e,t,r){"use strict";var D=e("../utils/common"),F=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0],N=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78],U=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0],P=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];t.exports=function(e,t,r,n,i,s,a,o){var h,u,l,f,c,d,p,m,_,g=o.bits,b=0,v=0,y=0,w=0,k=0,x=0,S=0,z=0,C=0,E=0,A=null,I=0,O=new D.Buf16(16),B=new D.Buf16(16),R=null,T=0;for(b=0;b<=15;b++)O[b]=0;for(v=0;v<n;v++)O[t[r+v]]++;for(k=g,w=15;1<=w&&0===O[w];w--);if(w<k&&(k=w),0===w)return i[s++]=20971520,i[s++]=20971520,o.bits=1,0;for(y=1;y<w&&0===O[y];y++);for(k<y&&(k=y),b=z=1;b<=15;b++)if(z<<=1,(z-=O[b])<0)return-1;if(0<z&&(0===e||1!==w))return-1;for(B[1]=0,b=1;b<15;b++)B[b+1]=B[b]+O[b];for(v=0;v<n;v++)0!==t[r+v]&&(a[B[t[r+v]]++]=v);if(d=0===e?(A=R=a,19):1===e?(A=F,I-=257,R=N,T-=257,256):(A=U,R=P,-1),b=y,c=s,S=v=E=0,l=-1,f=(C=1<<(x=k))-1,1===e&&852<C||2===e&&592<C)return 1;for(;;){for(p=b-S,_=a[v]<d?(m=0,a[v]):a[v]>d?(m=R[T+a[v]],A[I+a[v]]):(m=96,0),h=1<<b-S,y=u=1<<x;i[c+(E>>S)+(u-=h)]=p<<24|m<<16|_|0,0!==u;);for(h=1<<b-1;E&h;)h>>=1;if(0!==h?(E&=h-1,E+=h):E=0,v++,0==--O[b]){if(b===w)break;b=t[r+a[v]]}if(k<b&&(E&f)!==l){for(0===S&&(S=k),c+=y,z=1<<(x=b-S);x+S<w&&!((z-=O[x+S])<=0);)x++,z<<=1;if(C+=1<<x,1===e&&852<C||2===e&&592<C)return 1;i[l=E&f]=k<<24|x<<16|c-s|0}}return 0!==E&&(i[c+E]=b-S<<24|64<<16|0),o.bits=k,0}},{"../utils/common":41}],51:[function(e,t,r){"use strict";t.exports={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"}},{}],52:[function(e,t,r){"use strict";var i=e("../utils/common"),o=0,h=1;function n(e){for(var t=e.length;0<=--t;)e[t]=0}var s=0,a=29,u=256,l=u+1+a,f=30,c=19,_=2*l+1,g=15,d=16,p=7,m=256,b=16,v=17,y=18,w=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],k=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],x=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],S=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],z=new Array(2*(l+2));n(z);var C=new Array(2*f);n(C);var E=new Array(512);n(E);var A=new Array(256);n(A);var I=new Array(a);n(I);var O,B,R,T=new Array(f);function D(e,t,r,n,i){this.static_tree=e,this.extra_bits=t,this.extra_base=r,this.elems=n,this.max_length=i,this.has_stree=e&&e.length}function F(e,t){this.dyn_tree=e,this.max_code=0,this.stat_desc=t}function N(e){return e<256?E[e]:E[256+(e>>>7)]}function U(e,t){e.pending_buf[e.pending++]=255&t,e.pending_buf[e.pending++]=t>>>8&255}function P(e,t,r){e.bi_valid>d-r?(e.bi_buf|=t<<e.bi_valid&65535,U(e,e.bi_buf),e.bi_buf=t>>d-e.bi_valid,e.bi_valid+=r-d):(e.bi_buf|=t<<e.bi_valid&65535,e.bi_valid+=r)}function L(e,t,r){P(e,r[2*t],r[2*t+1])}function j(e,t){for(var r=0;r|=1&e,e>>>=1,r<<=1,0<--t;);return r>>>1}function Z(e,t,r){var n,i,s=new Array(g+1),a=0;for(n=1;n<=g;n++)s[n]=a=a+r[n-1]<<1;for(i=0;i<=t;i++){var o=e[2*i+1];0!==o&&(e[2*i]=j(s[o]++,o))}}function W(e){var t;for(t=0;t<l;t++)e.dyn_ltree[2*t]=0;for(t=0;t<f;t++)e.dyn_dtree[2*t]=0;for(t=0;t<c;t++)e.bl_tree[2*t]=0;e.dyn_ltree[2*m]=1,e.opt_len=e.static_len=0,e.last_lit=e.matches=0}function M(e){8<e.bi_valid?U(e,e.bi_buf):0<e.bi_valid&&(e.pending_buf[e.pending++]=e.bi_buf),e.bi_buf=0,e.bi_valid=0}function H(e,t,r,n){var i=2*t,s=2*r;return e[i]<e[s]||e[i]===e[s]&&n[t]<=n[r]}function G(e,t,r){for(var n=e.heap[r],i=r<<1;i<=e.heap_len&&(i<e.heap_len&&H(t,e.heap[i+1],e.heap[i],e.depth)&&i++,!H(t,n,e.heap[i],e.depth));)e.heap[r]=e.heap[i],r=i,i<<=1;e.heap[r]=n}function K(e,t,r){var n,i,s,a,o=0;if(0!==e.last_lit)for(;n=e.pending_buf[e.d_buf+2*o]<<8|e.pending_buf[e.d_buf+2*o+1],i=e.pending_buf[e.l_buf+o],o++,0===n?L(e,i,t):(L(e,(s=A[i])+u+1,t),0!==(a=w[s])&&P(e,i-=I[s],a),L(e,s=N(--n),r),0!==(a=k[s])&&P(e,n-=T[s],a)),o<e.last_lit;);L(e,m,t)}function Y(e,t){var r,n,i,s=t.dyn_tree,a=t.stat_desc.static_tree,o=t.stat_desc.has_stree,h=t.stat_desc.elems,u=-1;for(e.heap_len=0,e.heap_max=_,r=0;r<h;r++)0!==s[2*r]?(e.heap[++e.heap_len]=u=r,e.depth[r]=0):s[2*r+1]=0;for(;e.heap_len<2;)s[2*(i=e.heap[++e.heap_len]=u<2?++u:0)]=1,e.depth[i]=0,e.opt_len--,o&&(e.static_len-=a[2*i+1]);for(t.max_code=u,r=e.heap_len>>1;1<=r;r--)G(e,s,r);for(i=h;r=e.heap[1],e.heap[1]=e.heap[e.heap_len--],G(e,s,1),n=e.heap[1],e.heap[--e.heap_max]=r,e.heap[--e.heap_max]=n,s[2*i]=s[2*r]+s[2*n],e.depth[i]=(e.depth[r]>=e.depth[n]?e.depth[r]:e.depth[n])+1,s[2*r+1]=s[2*n+1]=i,e.heap[1]=i++,G(e,s,1),2<=e.heap_len;);e.heap[--e.heap_max]=e.heap[1],function(e,t){var r,n,i,s,a,o,h=t.dyn_tree,u=t.max_code,l=t.stat_desc.static_tree,f=t.stat_desc.has_stree,c=t.stat_desc.extra_bits,d=t.stat_desc.extra_base,p=t.stat_desc.max_length,m=0;for(s=0;s<=g;s++)e.bl_count[s]=0;for(h[2*e.heap[e.heap_max]+1]=0,r=e.heap_max+1;r<_;r++)p<(s=h[2*h[2*(n=e.heap[r])+1]+1]+1)&&(s=p,m++),h[2*n+1]=s,u<n||(e.bl_count[s]++,a=0,d<=n&&(a=c[n-d]),o=h[2*n],e.opt_len+=o*(s+a),f&&(e.static_len+=o*(l[2*n+1]+a)));if(0!==m){do{for(s=p-1;0===e.bl_count[s];)s--;e.bl_count[s]--,e.bl_count[s+1]+=2,e.bl_count[p]--,m-=2}while(0<m);for(s=p;0!==s;s--)for(n=e.bl_count[s];0!==n;)u<(i=e.heap[--r])||(h[2*i+1]!==s&&(e.opt_len+=(s-h[2*i+1])*h[2*i],h[2*i+1]=s),n--)}}(e,t),Z(s,u,e.bl_count)}function X(e,t,r){var n,i,s=-1,a=t[1],o=0,h=7,u=4;for(0===a&&(h=138,u=3),t[2*(r+1)+1]=65535,n=0;n<=r;n++)i=a,a=t[2*(n+1)+1],++o<h&&i===a||(o<u?e.bl_tree[2*i]+=o:0!==i?(i!==s&&e.bl_tree[2*i]++,e.bl_tree[2*b]++):o<=10?e.bl_tree[2*v]++:e.bl_tree[2*y]++,s=i,u=(o=0)===a?(h=138,3):i===a?(h=6,3):(h=7,4))}function V(e,t,r){var n,i,s=-1,a=t[1],o=0,h=7,u=4;for(0===a&&(h=138,u=3),n=0;n<=r;n++)if(i=a,a=t[2*(n+1)+1],!(++o<h&&i===a)){if(o<u)for(;L(e,i,e.bl_tree),0!=--o;);else 0!==i?(i!==s&&(L(e,i,e.bl_tree),o--),L(e,b,e.bl_tree),P(e,o-3,2)):o<=10?(L(e,v,e.bl_tree),P(e,o-3,3)):(L(e,y,e.bl_tree),P(e,o-11,7));s=i,u=(o=0)===a?(h=138,3):i===a?(h=6,3):(h=7,4)}}n(T);var q=!1;function J(e,t,r,n){P(e,(s<<1)+(n?1:0),3),function(e,t,r,n){M(e),n&&(U(e,r),U(e,~r)),i.arraySet(e.pending_buf,e.window,t,r,e.pending),e.pending+=r}(e,t,r,!0)}r._tr_init=function(e){q||(function(){var e,t,r,n,i,s=new Array(g+1);for(n=r=0;n<a-1;n++)for(I[n]=r,e=0;e<1<<w[n];e++)A[r++]=n;for(A[r-1]=n,n=i=0;n<16;n++)for(T[n]=i,e=0;e<1<<k[n];e++)E[i++]=n;for(i>>=7;n<f;n++)for(T[n]=i<<7,e=0;e<1<<k[n]-7;e++)E[256+i++]=n;for(t=0;t<=g;t++)s[t]=0;for(e=0;e<=143;)z[2*e+1]=8,e++,s[8]++;for(;e<=255;)z[2*e+1]=9,e++,s[9]++;for(;e<=279;)z[2*e+1]=7,e++,s[7]++;for(;e<=287;)z[2*e+1]=8,e++,s[8]++;for(Z(z,l+1,s),e=0;e<f;e++)C[2*e+1]=5,C[2*e]=j(e,5);O=new D(z,w,u+1,l,g),B=new D(C,k,0,f,g),R=new D(new Array(0),x,0,c,p)}(),q=!0),e.l_desc=new F(e.dyn_ltree,O),e.d_desc=new F(e.dyn_dtree,B),e.bl_desc=new F(e.bl_tree,R),e.bi_buf=0,e.bi_valid=0,W(e)},r._tr_stored_block=J,r._tr_flush_block=function(e,t,r,n){var i,s,a=0;0<e.level?(2===e.strm.data_type&&(e.strm.data_type=function(e){var t,r=4093624447;for(t=0;t<=31;t++,r>>>=1)if(1&r&&0!==e.dyn_ltree[2*t])return o;if(0!==e.dyn_ltree[18]||0!==e.dyn_ltree[20]||0!==e.dyn_ltree[26])return h;for(t=32;t<u;t++)if(0!==e.dyn_ltree[2*t])return h;return o}(e)),Y(e,e.l_desc),Y(e,e.d_desc),a=function(e){var t;for(X(e,e.dyn_ltree,e.l_desc.max_code),X(e,e.dyn_dtree,e.d_desc.max_code),Y(e,e.bl_desc),t=c-1;3<=t&&0===e.bl_tree[2*S[t]+1];t--);return e.opt_len+=3*(t+1)+5+5+4,t}(e),i=e.opt_len+3+7>>>3,(s=e.static_len+3+7>>>3)<=i&&(i=s)):i=s=r+5,r+4<=i&&-1!==t?J(e,t,r,n):4===e.strategy||s===i?(P(e,2+(n?1:0),3),K(e,z,C)):(P(e,4+(n?1:0),3),function(e,t,r,n){var i;for(P(e,t-257,5),P(e,r-1,5),P(e,n-4,4),i=0;i<n;i++)P(e,e.bl_tree[2*S[i]+1],3);V(e,e.dyn_ltree,t-1),V(e,e.dyn_dtree,r-1)}(e,e.l_desc.max_code+1,e.d_desc.max_code+1,a+1),K(e,e.dyn_ltree,e.dyn_dtree)),W(e),n&&M(e)},r._tr_tally=function(e,t,r){return e.pending_buf[e.d_buf+2*e.last_lit]=t>>>8&255,e.pending_buf[e.d_buf+2*e.last_lit+1]=255&t,e.pending_buf[e.l_buf+e.last_lit]=255&r,e.last_lit++,0===t?e.dyn_ltree[2*r]++:(e.matches++,t--,e.dyn_ltree[2*(A[r]+u+1)]++,e.dyn_dtree[2*N(t)]++),e.last_lit===e.lit_bufsize-1},r._tr_align=function(e){P(e,2,3),L(e,m,z),function(e){16===e.bi_valid?(U(e,e.bi_buf),e.bi_buf=0,e.bi_valid=0):8<=e.bi_valid&&(e.pending_buf[e.pending++]=255&e.bi_buf,e.bi_buf>>=8,e.bi_valid-=8)}(e)}},{"../utils/common":41}],53:[function(e,t,r){"use strict";t.exports=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0}},{}],54:[function(e,t,r){(function(e){!function(r,n){"use strict";if(!r.setImmediate){var i,s,t,a,o=1,h={},u=!1,l=r.document,e=Object.getPrototypeOf&&Object.getPrototypeOf(r);e=e&&e.setTimeout?e:r,i="[object process]"==={}.toString.call(r.process)?function(e){process.nextTick(function(){c(e)})}:function(){if(r.postMessage&&!r.importScripts){var e=!0,t=r.onmessage;return r.onmessage=function(){e=!1},r.postMessage("","*"),r.onmessage=t,e}}()?(a="setImmediate$"+Math.random()+"$",r.addEventListener?r.addEventListener("message",d,!1):r.attachEvent("onmessage",d),function(e){r.postMessage(a+e,"*")}):r.MessageChannel?((t=new MessageChannel).port1.onmessage=function(e){c(e.data)},function(e){t.port2.postMessage(e)}):l&&"onreadystatechange"in l.createElement("script")?(s=l.documentElement,function(e){var t=l.createElement("script");t.onreadystatechange=function(){c(e),t.onreadystatechange=null,s.removeChild(t),t=null},s.appendChild(t)}):function(e){setTimeout(c,0,e)},e.setImmediate=function(e){"function"!=typeof e&&(e=new Function(""+e));for(var t=new Array(arguments.length-1),r=0;r<t.length;r++)t[r]=arguments[r+1];var n={callback:e,args:t};return h[o]=n,i(o),o++},e.clearImmediate=f}function f(e){delete h[e]}function c(e){if(u)setTimeout(c,0,e);else{var t=h[e];if(t){u=!0;try{!function(e){var t=e.callback,r=e.args;switch(r.length){case 0:t();break;case 1:t(r[0]);break;case 2:t(r[0],r[1]);break;case 3:t(r[0],r[1],r[2]);break;default:t.apply(n,r)}}(t)}finally{f(e),u=!1}}}}function d(e){e.source===r&&"string"==typeof e.data&&0===e.data.indexOf(a)&&c(+e.data.slice(a.length))}}("undefined"==typeof self?void 0===e?this:e:self)}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}]},{},[10])(10)});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(74).Buffer, __webpack_require__(78).setImmediate, __webpack_require__(10), __webpack_require__(6)))

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(75)
var ieee754 = __webpack_require__(76)
var isArray = __webpack_require__(77)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 76 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 77 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(79);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(6)))

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,s){if(true)module.exports=s(__webpack_require__(5));else if("function"==typeof define&&define.amd)define(["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"],s);else{var o=s("object"==typeof exports?require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"):e["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for(var a in o)("object"==typeof exports?exports:e)[a]=o[a]}}("undefined"!=typeof self?self:this,function(e){return webpackJsonPBaGraphics([115],{"0768325c7d55ee3d0425":function(e,s,o){"use strict";var a=o("9689a9c94ae38b47fa2c"),c=o.n(a),i=o("9ce58a7deea14f49ef01"),n=o.n(i),t=new c.a({id:"upload_16_v7",use:"upload_16_v7-usage",viewBox:"0 0 16 16",content:'<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="upload_16_v7"><path d="M3 9L3.7 9.7 7.5 5.9 7.5 15 8.5 15 8.5 5.9 12.3 9.7 13 9 8 4zM3 4V2h10v2h1V2c0-.6-.4-1-1-1H3C2.4 1 2 1.4 2 2v2H3z" /></symbol>'});n.a.add(t);s.a=t},"105375219d726d2ad9eb":function(e,s,o){"use strict";Object.defineProperty(s,"__esModule",{value:!0});var a=o("6873601dfe1d9459c1a9"),c=(o.n(a),o("0768325c7d55ee3d0425"));s.default=c.a},"6873601dfe1d9459c1a9":function(s,o){s.exports=e}},["105375219d726d2ad9eb"])});

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _baUiCarbonToolkit = __webpack_require__(3);

var _baUiCarbon = __webpack_require__(14);

__webpack_require__(4);

var _FileLoader = __webpack_require__(34);

var _FileLoader2 = _interopRequireDefault(_FileLoader);

var _dismiss_ = __webpack_require__(82);

var _dismiss_2 = _interopRequireDefault(_dismiss_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var ICON_ADD = 'add';
var ICON_REMOVE = 'remove';
var ICON_FILE_TYPES = '.svg .jpg .png';

var PackagePanel = function (_Component) {
	_inherits(PackagePanel, _Component);

	function PackagePanel(props) {
		_classCallCheck(this, PackagePanel);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this._showOverlay = function () {
			_this.setState({ isDragging: true });
		};

		_this._hideOverlay = function () {
			_this.setState({ isDragging: false });
		};

		_this._findSourceName = function (_name) {
			return _name.split('/').pop();
		};

		_this._getUrlCreator = function () {
			return window.URL || window.webkitURL;
		};

		_this._handlePackageNameChange = function (_value) {
			_this.props.onChange({ 'name': 'name', 'value': _value });
		};

		_this._handlePackageDescriptionChange = function (synthEvent) {
			_this.props.onChange({ 'name': 'description', 'value': synthEvent.target.value });
		};

		_this._handleDragEnter = function () {
			_this._showOverlay();
		};

		_this._handleDragOver = function (_event) {
			_event.dataTransfer.dropEffect = 'copy';
			_event.preventDefault();
			_event.stopPropagation();
		};

		_this._handleDragEnd = function () {
			_this._hideOverlay();
		};

		_this._handleDragLeave = function (_event) {
			_this._hideOverlay();
			_event.preventDefault();
		};

		_this._handleDrop = function (_event) {
			_this._hideOverlay();
			var failed = false;
			// Check that the file type is '.svg'
			for (var i = 0; i < _event.dataTransfer.files.length; i++) {
				var file = _event.dataTransfer.files[i];
				if (ICON_FILE_TYPES.indexOf(file.name.toLowerCase().substr(-4)) < 0) {
					_this.props.onIconError(new Error(_StringResources2.default.get('schematicsInvalidType', { type: file.name })));
					failed = true;
					break;
				}
			}

			if (!failed) _this._handleIconChange(ICON_ADD, _event.dataTransfer.files);
			_event.preventDefault();
		};

		_this._handleIconChange = function (_action, _files) {
			var _this$props = _this.props,
			    zipMaxSize = _this$props.zipMaxSize,
			    imgMaxSize = _this$props.imgMaxSize,
			    onIconError = _this$props.onIconError,
			    onIconChanged = _this$props.onIconChanged;

			if (_action === 'add') {
				var loader = new _FileLoader2.default(null, zipMaxSize, imgMaxSize, ICON_FILE_TYPES);
				loader.load(_files, function (_fileList) {
					if (_fileList.length > 0) {
						var item = _fileList[0];
						var blobUrl = null;
						var sourceName = _this._findSourceName(item);
						var loadPromise = loader.getFileAsBlob(item);

						loadPromise.then(function (loadedBlobUrl) {
							blobUrl = _this._getUrlCreator().createObjectURL(loadedBlobUrl);
							onIconChanged(sourceName, blobUrl);
						}).catch(onIconError);
					}
				}, onIconError);
			} else if (_action === 'remove') {
				onIconChanged('', '');
			}
		};

		_this.state = {
			isDragging: false
		};

		_this.inputRef = null;
		_this.dndOverlay = null;
		return _this;
	}

	//
	// Utility functions
	//


	//
	// Event handlers
	//

	// The package name has changed


	// The package description has changed


	PackagePanel.prototype._renderIconRow = function _renderIconRow() {
		var _this2 = this;

		var _props = this.props,
		    iconURL = _props.iconURL,
		    iconName = _props.iconName;

		if (iconURL) {
			return _react2.default.createElement(
				_baUiCarbonToolkit.FlexLayout,
				{
					className: 'clsSVGIconRow',
					direction: 'row',
					justifyContent: 'flex-start',
					alignItems: 'center'
				},
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					null,
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexLayout,
						{ id: 'svgIconFL' },
						_react2.default.createElement(_baUiCarbonToolkit.FlexItem, { id: 'svgIconFI', style: { backgroundImage: 'url(' + iconURL + ')' } })
					)
				),
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					{ grow: true },
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexLayout,
						{ direction: 'row', justifyContent: 'flex-start' },
						_react2.default.createElement(
							_baUiCarbonToolkit.FlexItem,
							{ style: { height: '18px' } },
							_react2.default.createElement(_baUiCarbonToolkit.Label, { id: 'idSchematicIconLabel', type: 'caption', htmlFor: 'idSchematicIcon', label: iconName, ellipsis: true })
						)
					)
				),
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					null,
					_react2.default.createElement(_baUiCarbonToolkit.Button, {
						intent: 'primary',
						icon: _dismiss_2.default.id,
						iconSize: 'small',
						variant: 'icon',
						onClick: function onClick() {
							return _this2._handleIconChange(ICON_REMOVE, null);
						},
						title: _StringResources2.default.get('schematicsDeleteIcon'),
						tabIndex: 0
					})
				)
			);
		} else return;
	};

	PackagePanel.prototype._renderDropZone = function _renderDropZone() {
		var _this3 = this;

		var dropLabel = _StringResources2.default.get('schematicsIconDropFiles');

		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexLayout,
			{
				fullHeight: true,
				direction: 'column'
			},
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				{ style: { margin: '16px' } },
				_react2.default.createElement(
					_baUiCarbon.Link,
					{ href: 'javascript:void()', onClick: function onClick() {
							return _this3.inputRef.click();
						} },
					dropLabel
				)
			)
		);
	};

	PackagePanel.prototype._renderIconContents = function _renderIconContents() {
		var _this4 = this;

		if (this.props.iconURL) return this._renderIconRow();
		// This component keeps a simple state of whether we are dragging on not.
		var overlayDisplayStyle = this.state.isDragging ? 'block' : 'none';
		var fileTypesLabel = _StringResources2.default.get('schematicsIconFileTypes');
		var imgMaxSize = this.props.imgMaxSize;

		var fileSizeLabel = _StringResources2.default.get('schematicsIconFileSize', { size: imgMaxSize });
		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexLayout,
			{ direction: 'column', fullHeight: true },
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(_baUiCarbonToolkit.Label, { className: 'clsSVGFileTypeLabel', label: fileTypesLabel })
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(_baUiCarbonToolkit.Label, { className: 'clsSVGFileSizeLabel', label: fileSizeLabel })
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(_baUiCarbonToolkit.VSpacer, { size: 2 })
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				{ grow: 1, className: 'clsSVGIconPanel' },
				_react2.default.createElement(
					_baUiCarbonToolkit.Container,
					{
						onDragEnter: function onDragEnter(e) {
							return _this4._handleDragEnter(e);
						},
						className: this.state.isDragging ? 'clsSVGDropZone dragging' : 'clsSVGDropZone',
						droppable: 'true'
					},
					_react2.default.createElement(_baUiCarbonToolkit.Container, {
						className: 'clsSVGDndOverlay',
						onDragOver: function onDragOver(e) {
							return _this4._handleDragOver(e);
						},
						onDragEnd: function onDragEnd(e) {
							return _this4._handleDragEnd(e);
						},
						onDragLeave: function onDragLeave(e) {
							return _this4._handleDragLeave(e);
						},
						onDrop: function onDrop(e) {
							return _this4._handleDrop(e);
						},
						style: { display: overlayDisplayStyle },
						ref: function ref(_ref) {
							_this4.dndOverlay = _ref;
						}
					}),
					this._renderDropZone()
				)
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(_baUiCarbonToolkit.VSpacer, { size: 2 })
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement('input', {
					ref: function ref(_ref2) {
						_this4.inputRef = _ref2;
					},
					id: 'idChooseFile_Input',
					accept: '.svg, .jpg, .png',
					type: 'file',
					onChange: function onChange() {
						return _this4._handleIconChange(ICON_ADD, _this4.inputRef.files);
					},
					style: { display: 'none' }
				}),
				_react2.default.createElement(_baUiCarbonToolkit.Button, {
					id: 'idChooseFile_Button',
					intent: 'primary',
					onClick: function onClick() {
						return _this4.inputRef.click();
					},
					label: _StringResources2.default.get('schematicsChooseFile'),
					tabIndex: 0
				})
			)
		);
	};

	//
	// Main render function
	//


	PackagePanel.prototype.render = function render() {
		var _props2 = this.props,
		    packageName = _props2.packageName,
		    packageDescription = _props2.packageDescription;
		// Get the i18n strings

		var packageNameLabel = _StringResources2.default.get('nameLabelSchematic');
		var packageDescriptionLabel = _StringResources2.default.get('schematicsDescriptionLabel');
		var iconLabel = _StringResources2.default.get('schematicsIconLabel');

		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexLayout,
			{
				className: 'clsSVGTabsStyle',
				direction: 'row',
				style: { width: '100%' }
			},
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexLayout,
					{ direction: 'row' },
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						null,
						_react2.default.createElement(
							_baUiCarbonToolkit.FlexLayout,
							{ className: 'clsSVGDetailsPanel',
								direction: 'column'
							},
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								null,
								_react2.default.createElement(_baUiCarbonToolkit.VSpacer, { size: 2 })
							),
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								null,
								_react2.default.createElement(_baUiCarbonToolkit.Label, { type: 'caption', htmlFor: 'packageNameEdit', label: packageNameLabel })
							),
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								{ className: 'clsSVGPackageEdit' },
								_react2.default.createElement(_baUiCarbonToolkit.TextInput, {
									id: 'packageNameEdit',
									placeholder: packageNameLabel,
									value: packageName,
									onValueChange: this._handlePackageNameChange,
									light: true
								})
							),
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								null,
								_react2.default.createElement(_baUiCarbonToolkit.VSpacer, { size: 3 })
							),
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								{ className: 'clsSVGPackageEdit' },
								_react2.default.createElement(_baUiCarbon.TextArea, { style: { resize: 'none' },
									id: 'packageDescriptionEdit',
									placeholder: packageDescriptionLabel,
									rows: 6,
									maxLength: 100,
									value: packageDescription,
									labelText: packageDescriptionLabel,
									onChange: this._handlePackageDescriptionChange,
									light: true
								})
							)
						)
					),
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						null,
						_react2.default.createElement(_baUiCarbonToolkit.HSpacer, { size: 4 })
					),
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						{ grow: 1 },
						_react2.default.createElement(
							_baUiCarbonToolkit.FlexLayout,
							{ direction: 'column', fullHeight: true },
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								null,
								_react2.default.createElement(_baUiCarbonToolkit.VSpacer, { size: 2 })
							),
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								null,
								_react2.default.createElement(_baUiCarbonToolkit.Label, { type: 'caption', htmlFor: 'iconDropZone', label: iconLabel, className: 'clsSVGPackageIcon' })
							),
							this._renderIconContents()
						)
					)
				)
			)
		);
	};

	return PackagePanel;
}(_react.Component);

PackagePanel.defaultProps = {
	iconName: '',
	iconURL: '',
	packageDescription: ''
};
PackagePanel.propTypes = {
	packageName: _propTypes2.default.string.isRequired,
	packageDescription: _propTypes2.default.string.isRequired,
	iconURL: _propTypes2.default.string,
	iconName: _propTypes2.default.string,
	zipMaxSize: _propTypes2.default.number,
	imgMaxSize: _propTypes2.default.number,
	onChange: _propTypes2.default.func.isRequired,
	onIconChanged: _propTypes2.default.func.isRequired,
	onIconError: _propTypes2.default.func.isRequired
};
exports.default = PackagePanel;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,s){if(true)module.exports=s(__webpack_require__(5));else if("function"==typeof define&&define.amd)define(["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"],s);else{var c=s("object"==typeof exports?require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"):e["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for(var i in c)("object"==typeof exports?exports:e)[i]=c[i]}}("undefined"!=typeof self?self:this,function(e){return webpackJsonPBaGraphics([1346],{"6873601dfe1d9459c1a9":function(s,c){s.exports=e},"8d4ccaf2baec1d5ec793":function(e,s,c){"use strict";var i=c("9689a9c94ae38b47fa2c"),o=c.n(i),a=c("9ce58a7deea14f49ef01"),n=c.n(a),t=new o.a({id:"dismiss_16_v7",use:"dismiss_16_v7-usage",viewBox:"0 0 16 16",content:'<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="dismiss_16_v7"><path d="M14 3.5L12.5 2 8 6.5 3.5 2 2 3.5 6.5 8 2 12.5 3.5 14 8 9.5 12.5 14 14 12.5 9.5 8 14 3.5z" /></symbol>'});n.a.add(t);s.a=t},"97c51f33b6d3e5f2ee40":function(e,s,c){"use strict";Object.defineProperty(s,"__esModule",{value:!0});var i=c("6873601dfe1d9459c1a9"),o=(c.n(i),c("8d4ccaf2baec1d5ec793"));s.default=o.a}},["97c51f33b6d3e5f2ee40"])});

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _baUiCarbonToolkit = __webpack_require__(3);

var _reset_ = __webpack_require__(84);

var _reset_2 = _interopRequireDefault(_reset_);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _CustomColorDialog = __webpack_require__(24);

var _CustomColorDialog2 = _interopRequireDefault(_CustomColorDialog);

__webpack_require__(4);

var _KeyCodes = __webpack_require__(36);

var _KeyCodes2 = _interopRequireDefault(_KeyCodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* IBM Confidential
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OCO Source Materials
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: authoring-common
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2020, 2021
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * The source code for this program is not published or otherwise
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * divested of its trade secrets, irrespective of what has been
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * deposited with the U.S. Copyright Office.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * NLS_ENCODING=UTF-8
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * NLS_MESSAGEFORMAT_NONE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var colorPickerName = 'colorPicker';

/**
 * Description:
 * The client is responsible for supplying at least the required properties. The client is also responsible for
 * supplying the favorite colors from the paletteService if there is one as well. The selected color is returned
 * in the callback and the client must set the selectedColor property with it and presist the selected color.
 * This is needed for the Color Picker to show which color is current selected from palette and/or favorites.
 *
 * This ColorPicker has 5 required properties:
 *   colors - An array of colors (strings of hex values that start with #)
 *   colorsLabel - The label of the set of colours that are shown in the flyout
 *   onColorSelected - A callback prototype which has one parameter, which is the selected color that is returns back.
 *   paletteService - the paletteService object which is needed by the Custom Color dialog for selecting favorite/custom colors
 *   resetColor - A callback funciton that is called when the "restor to default" action is executed. The implementer is responsible for
 *      keeping track of the default colour and how to restore it.
 *
 * */

var ColorPicker = function (_Component) {
	_inherits(ColorPicker, _Component);

	function ColorPicker(props) {
		_classCallCheck(this, ColorPicker);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.classPrefix = 'clsColorPicker';

		_this.state = _extends({}, ColorPicker.defaultProps);
		_this._handleOpen = _this._handleOpen.bind(_this);
		_this.triggerButton = _react2.default.createRef();
		_this.attachRef = _react2.default.createRef();
		return _this;
	}

	ColorPicker.prototype.render = function render() {
		var _state = this.state,
		    colorFlyoutOpen = _state.colorFlyoutOpen,
		    customColorDialogOpen = _state.customColorDialogOpen;
		var _props = this.props,
		    selectedColor = _props.selectedColor,
		    title = _props.title,
		    disabled = _props.disabled,
		    className = _props.className,
		    style = _props.style;


		var orientation = this.props.orientation;
		if (!this.props.orientation) {
			orientation = document.body.dir === 'rtl' ? 'bottomLeftStart' : 'bottomRightStart';
		}

		return _react2.default.createElement(
			'div',
			{ className: this.classPrefix + ' ' + className, style: style },
			customColorDialogOpen && this._renderCustomColor(),
			_react2.default.createElement(_baUiCarbonToolkit.Button, {
				'aria-controls': colorPickerName + '_button',
				'data-tid': colorPickerName + '_button',
				title: title,
				disabled: disabled,
				tabIndex: 0,
				ref: this.triggerButton,
				'data-name': this._selectedDataName(),
				'data-value': selectedColor,
				kind: 'ghost',
				onClick: this._handleOpen,
				style: this._getColorStyle(selectedColor),
				className: this.classPrefix + '_button'
			}),
			colorFlyoutOpen && _react2.default.createElement(
				_baUiCarbonToolkit.Flyout,
				{
					'data-tid': colorPickerName + '_flyout',
					placement: orientation,
					domNodeToAttachTo: this.attachRef.current,
					hideArrow: true,
					offset: 2,
					onClose: this._handleClose.bind(this),
					className: this.classPrefix + '_flyout'
				},
				this._displayFlyout()
			)
		);
	};

	ColorPicker.prototype._selectedDataName = function _selectedDataName() {
		var _props2 = this.props,
		    selectedColor = _props2.selectedColor,
		    favoriteColors = _props2.favoriteColors,
		    colorTitles = _props2.colorTitles,
		    colors = _props2.colors;

		if (colorTitles && colors.indexOf(selectedColor) !== -1) {
			return colorTitles[colors.findIndex(function (e) {
				return e === selectedColor;
			})];
		} else if (favoriteColors && favoriteColors.indexOf(selectedColor) !== -1) {
			return 'favColor' + favoriteColors.findIndex(function (e) {
				return e === selectedColor;
			});
		} else {
			return 'customColor';
		}
	};

	ColorPicker.prototype._displayFlyout = function _displayFlyout() {
		var _this2 = this;

		var _props3 = this.props,
		    colors = _props3.colors,
		    colorsLabel = _props3.colorsLabel,
		    favoriteColors = _props3.favoriteColors,
		    colorTitles = _props3.colorTitles;

		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexLayout,
			{ direction: 'column', className: this.classPrefix + '_flyoutContent' },
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexLayout,
				{ className: this.classPrefix + '_paletteHeader' },
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					null,
					_react2.default.createElement(_baUiCarbonToolkit.Label, { label: colorsLabel })
				),
				_react2.default.createElement(_baUiCarbonToolkit.SVGIcon, {
					className: this.classPrefix + '_restoreDefault',
					size: 'small',
					iconId: _reset_2.default.id,
					tabIndex: '0',
					alt: _StringResources2.default.get('restoreDefault'),
					ariaLabelledby: _StringResources2.default.get('restoreDefault'),
					onClick: this._restoreDefault.bind(this) })
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexLayout,
				{ className: this.classPrefix + '_paletteContent' },
				colors.map(function (color, index) {
					return _this2._displayColors(color, index, colorTitles);
				})
			),
			favoriteColors && favoriteColors.length > 1 && _react2.default.createElement(
				_baUiCarbonToolkit.FlexLayout,
				{ direction: 'column', className: this.classPrefix + '_paletteHeader' },
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					null,
					_react2.default.createElement(_baUiCarbonToolkit.Label, { label: _StringResources2.default.get('favorite') })
				),
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexLayout,
					{ className: this.classPrefix + '_paletteContent' },
					favoriteColors.map(function (color, index) {
						return _this2._displayColors(color, index);
					})
				)
			),
			this.props.showCustomColorButton && _react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(
					_baUiCarbonToolkit.Link,
					{ onClick: this._showCustomColor.bind(this, true) },
					_StringResources2.default.get('modeCustom')
				)
			)
		);
	};

	ColorPicker.prototype._displayColors = function _displayColors(color, index, titles) {
		var _this3 = this;

		var _props4 = this.props,
		    selectedColor = _props4.selectedColor,
		    favoriteColors = _props4.favoriteColors;

		var style = this._getColorStyle(color);
		if (style) {
			style.background = style.backgroundColor;
		}

		var clsName = void 0;
		if (selectedColor === color) {
			clsName = this.classPrefix + '_selected_indicator';
		} else {
			clsName = this.classPrefix + '_cell';
		}
		var title = void 0;
		if (titles) {
			title = titles[index];
		} else if (favoriteColors) {
			title = 'favColor' + index;
		}
		return _react2.default.createElement(_baUiCarbonToolkit.FlexItem, {
			className: clsName,
			style: style,
			key: index,
			tabIndex: 0,
			'data-name': title,
			'data-value': color,
			title: title,
			onClick: this._handleSelect.bind(this, color),
			onKeyDown: function onKeyDown(e) {
				return _this3._handleKey(e, color);
			}
		});
	};

	ColorPicker.prototype._handleOpen = function _handleOpen() {
		this.setState({ colorFlyoutOpen: !this.state.colorFlyoutOpen });
	};

	ColorPicker.prototype._handleClose = function _handleClose() {
		var customColorDialogOpen = this.state.customColorDialogOpen;
		// hide this if the color dialog isn't open

		if (!customColorDialogOpen) {
			this.setState({ colorFlyoutOpen: false });
		}
	};

	ColorPicker.prototype._getColorStyle = function _getColorStyle(color) {
		if (!color) {
			return;
		}

		return {
			color: color,
			backgroundColor: color
		};
	};

	ColorPicker.prototype._handleSelect = function _handleSelect(color) {
		this.props.onColorSelected(color);
		this.setState({ colorFlyoutOpen: false });
	};

	ColorPicker.prototype._showCustomColor = function _showCustomColor(show) {
		this.setState({ customColorDialogOpen: show });
	};

	ColorPicker.prototype._renderCustomColor = function _renderCustomColor() {
		var _props5 = this.props,
		    paletteService = _props5.paletteService,
		    selectedColor = _props5.selectedColor;


		return _react2.default.createElement(_CustomColorDialog2.default, {
			key: 'colorDialog',
			selectedColor: selectedColor,
			paletteService: paletteService,
			isDialogOpen: true,
			onChange: this._handleSelect.bind(this),
			onCloseDialog: this._showCustomColor.bind(this, false)
		});
	};

	ColorPicker.prototype._restoreDefault = function _restoreDefault() {
		this.props.resetColor();
	};

	ColorPicker.prototype._handleKey = function _handleKey(e, color) {
		// if Enter or Space key
		if (e.keyCode === _KeyCodes2.default.ENTER || e.keyCode === _KeyCodes2.default.SPACE) {
			this._handleSelect(color);
			e.preventDefault();
		}
	};

	return ColorPicker;
}(_react.Component);

ColorPicker.propTypes = {
	/* Colors to be selected */
	colors: _propTypes2.default.array.isRequired,
	/* The callback that gets called on click of a color; onColorSelected(colorHexValue) */
	onColorSelected: _propTypes2.default.func.isRequired,
	/* Palette Service needed to create custom color dialog */
	paletteService: _propTypes2.default.object.isRequired,
	/* Colors label. It has a limited size, width of the control */
	colorsLabel: _propTypes2.default.string.isRequired,
	/* The callback that handles restoring the default colour (defined by the implementer) */
	resetColor: _propTypes2.default.func.isRequired,
	/* The title for each color in the colors property */
	colorTitles: _propTypes2.default.array.isRequired,

	/* Custom css class names */
	className: _propTypes2.default.string,
	/* Flag to disable the color picker button */
	disabled: _propTypes2.default.bool,
	/* Favorite colors to be selected. The palette service has a method to retrieve this called getFavoriteColors() */
	favoriteColors: _propTypes2.default.array,
	/* See ba-ui-carbon-toolkit Flyout placement values; we default to "bottomRightStart" or "bottomLeftStart" for rtl languages */
	orientation: _baUiCarbonToolkit.Flyout.propTypes.placement,
	/* Selected color to show on the button. NOTE: Must be set by client when a color is selected. Would be passed to the onColorSelected() */
	selectedColor: _propTypes2.default.string,
	/* Show a button to allow user to add a custom colour */
	showCustomColorButton: _propTypes2.default.bool,
	/* Custom css styles. Applied to the component container div */
	style: _propTypes2.default.object,
	/* Tooltip when you hover on the color picker button */
	title: _propTypes2.default.string
};
ColorPicker.defaultProps = {
	className: '',
	colorFlyoutOpen: false,
	customColorDialogOpen: false,
	disabled: false
};
exports.default = ColorPicker;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,s){if(true)module.exports=s(__webpack_require__(5));else if("function"==typeof define&&define.amd)define(["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"],s);else{var o=s("object"==typeof exports?require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"):e["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for(var a in o)("object"==typeof exports?exports:e)[a]=o[a]}}("undefined"!=typeof self?self:this,function(e){return webpackJsonPBaGraphics([529],{"4d98f53e61fdcfb55d18":function(e,s,o){"use strict";Object.defineProperty(s,"__esModule",{value:!0});var a=o("6873601dfe1d9459c1a9"),c=(o.n(a),o("e0f9fbeeec6e2f0b6a93"));s.default=c.a},"6873601dfe1d9459c1a9":function(s,o){s.exports=e},e0f9fbeeec6e2f0b6a93:function(e,s,o){"use strict";var a=o("9689a9c94ae38b47fa2c"),c=o.n(a),i=o("9ce58a7deea14f49ef01"),t=o.n(i),f=new c.a({id:"reset_32_v7",use:"reset_32_v7-usage",viewBox:"0 0 32 32",content:'<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="reset_32_v7"><path d="M18,28A12,12,0,1,0,6,16v6.2L2.4,18.6,1,20l6,6,6-6-1.4-1.4L8,22.2V16H8A10,10,0,1,1,18,26Z" /></symbol>'});t.a.add(f);s.a=f}},["4d98f53e61fdcfb55d18"])});

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,s){if(true)module.exports=s(__webpack_require__(5));else if("function"==typeof define&&define.amd)define(["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"],s);else{var o=s("object"==typeof exports?require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"):e["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for(var a in o)("object"==typeof exports?exports:e)[a]=o[a]}}("undefined"!=typeof self?self:this,function(e){return webpackJsonPBaGraphics([1970],{"6873601dfe1d9459c1a9":function(s,o){s.exports=e},"7747182150d3b89d9a34":function(e,s,o){"use strict";var a=o("9689a9c94ae38b47fa2c"),i=o.n(a),t=o("9ce58a7deea14f49ef01"),c=o.n(t),n=new i.a({id:"arrow--left_16_v7",use:"arrow--left_16_v7-usage",viewBox:"0 0 16 16",content:'<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="arrow--left_16_v7"><path d="M6.7 12.3L2.9 8.5 15 8.5 15 7.5 2.9 7.5 6.7 3.7 6 3 1 8 6 13z" /></symbol>'});c.a.add(n);s.a=n},"852b68bf0240055d5826":function(e,s,o){"use strict";Object.defineProperty(s,"__esModule",{value:!0});var a=o("6873601dfe1d9459c1a9"),i=(o.n(a),o("7747182150d3b89d9a34"));s.default=i.a}},["852b68bf0240055d5826"])});

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){if(true)module.exports=a(__webpack_require__(5));else if("function"==typeof define&&define.amd)define(["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"],a);else{var s=a("object"==typeof exports?require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"):e["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for(var o in s)("object"==typeof exports?exports:e)[o]=s[o]}}("undefined"!=typeof self?self:this,function(e){return webpackJsonPBaGraphics([2066],{"0cb7e8aeae71aca8482e":function(e,a,s){"use strict";Object.defineProperty(a,"__esModule",{value:!0});var o=s("6873601dfe1d9459c1a9"),c=(s.n(o),s("df23011b6ab348b86eed"));a.default=c.a},"6873601dfe1d9459c1a9":function(a,s){a.exports=e},df23011b6ab348b86eed:function(e,a,s){"use strict";var o=s("9689a9c94ae38b47fa2c"),c=s.n(o),i=s("9ce58a7deea14f49ef01"),n=s.n(i),t=new c.a({id:"add_32_v7",use:"add_32_v7-usage",viewBox:"0 0 32 32",content:'<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="add_32_v7"><path d="M17 15L17 8 15 8 15 15 8 15 8 17 15 17 15 24 17 24 17 17 24 17 24 15z" /></symbol>'});n.a.add(t);a.a=t}},["0cb7e8aeae71aca8482e"])});

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* IBM Confidential
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OCO Source Materials
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: authoring-common
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * The source code for this program is not published or otherwise
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * divested of its trade secrets, irrespective of what has been
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * deposited with the U.S. Copyright Office.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * NLS_ENCODING=UTF-8
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * NLS_MESSAGEFORMAT_NONE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var PalettePicker = function (_Component) {
	_inherits(PalettePicker, _Component);

	function PalettePicker() {
		_classCallCheck(this, PalettePicker);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	PalettePicker.prototype.render = function render() {
		return _react2.default.createElement(
			'div',
			null,
			'Palette Picker Placeholder'
		);
	};

	// just a guesstimate of what it will need for now, based on ChangePaletteView options


	return PalettePicker;
}(_react.Component);

PalettePicker.propTypes = {
	paletteService: _propTypes2.default.object.isRequired, // was glass context
	getPalettes: _propTypes2.default.func.isRequired,
	onCreatePalette: _propTypes2.default.func.isRequired,
	onChange: _propTypes2.default.func.isRequired,
	mruComponentIdentifier: _propTypes2.default.string.isRequired, // was component
	selectedId: _propTypes2.default.string,
	createPaletteType: _propTypes2.default.string
};
exports.default = PalettePicker;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(7);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _PaletteListingWrapper = __webpack_require__(89);

var _PaletteListingWrapper2 = _interopRequireDefault(_PaletteListingWrapper);

var _CustomPalette = __webpack_require__(8);

var _CustomPalette2 = _interopRequireDefault(_CustomPalette);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: authoring-common
 * (C) Copyright IBM Corp. 2020, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var View = __webpack_require__(32);


var PaletteListingView = View.extend({
	init: function init(options, container) {
		PaletteListingView.inherited('init', this, arguments);
		this.container = container;
		this.options = options;
	},
	render: function render() {
		_reactDom2.default.render(_react2.default.createElement(_PaletteListingWrapper2.default, {
			paletteService: this.options.paletteService,
			getPalettes: this.options.getPalettes,
			createPalette: this._openPaletteCreator.bind(this),
			onChange: this.options.onChange,
			mruComponentIdentifier: this.options.mruComponentIdentifier,
			selectedId: this.options.selectedId,
			createPaletteType: this.options.createPaletteType,
			onClose: this.options.slideout.hide.bind(this.options.slideout)
		}), this.container);
	},
	remove: function remove() {
		_reactDom2.default.unmountComponentAtNode(this.container);
	},
	_openPaletteCreator: function _openPaletteCreator() {
		var _this = this;

		var paletteComponent = _react2.default.createElement(_CustomPalette2.default, {
			key: 'addNewPalette',
			paletteService: this.options.paletteService,
			onPaletteCreated: this.options.onCreatePalette.bind(this),
			paletteType: this.options.createPaletteType,
			removeDialog: function removeDialog() {
				var paletteContainer = document.querySelector('.paletteDialogContainer');
				_reactDom2.default.unmountComponentAtNode(paletteContainer);
			},
			ref: function ref(instance) {
				_this.palleteDialog = instance;
			} });
		var paletteContainer = document.querySelector('.paletteDialogContainer');
		if (!paletteContainer) {
			paletteContainer = document.createElement('div');
			paletteContainer.classList.add('paletteDialogContainer');
			document.body.append(paletteContainer);
		}
		_reactDom2.default.render(paletteComponent, paletteContainer);
		this.palleteDialog.openDialog();
	}
});

exports.default = PaletteListingView;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PaletteListing = __webpack_require__(37);

var _PaletteListing2 = _interopRequireDefault(_PaletteListing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaletteListingWrapper = function (_Component) {
	_inherits(PaletteListingWrapper, _Component);

	function PaletteListingWrapper(props) {
		_classCallCheck(this, PaletteListingWrapper);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		var selectedId = _this.props.selectedId;

		_this.state = {
			selectedId: selectedId
		};
		return _this;
	}

	PaletteListingWrapper.prototype.render = function render() {
		var _props = this.props,
		    paletteService = _props.paletteService,
		    getPalettes = _props.getPalettes,
		    createPalette = _props.createPalette,
		    mruComponentIdentifier = _props.mruComponentIdentifier,
		    createPaletteType = _props.createPaletteType,
		    onClose = _props.onClose;
		var selectedId = this.state.selectedId;


		return _react2.default.createElement(_PaletteListing2.default, {
			paletteService: paletteService,
			getPalettes: getPalettes,
			createPalette: createPalette,
			onChange: this._onChange.bind(this),
			mruComponentIdentifier: mruComponentIdentifier,
			selectedId: selectedId,
			createPaletteType: createPaletteType,
			onClose: onClose
		});
	};

	PaletteListingWrapper.prototype._onChange = function _onChange() {
		var palette = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		this.setState({ selectedId: palette.id });
	};

	return PaletteListingWrapper;
}(_react.Component);

PaletteListingWrapper.propTypes = {
	paletteService: _propTypes2.default.object.isRequired, // was glass context
	getPalettes: _propTypes2.default.func.isRequired,
	createPalette: _propTypes2.default.func,
	onChange: _propTypes2.default.func.isRequired,
	onClose: _propTypes2.default.func,
	mruComponentIdentifier: _propTypes2.default.string.isRequired, // was component
	selectedId: _propTypes2.default.string,
	createPaletteType: _propTypes2.default.string
};
exports.default = PaletteListingWrapper;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = __webpack_require__(22);

var _baUiCarbonToolkit = __webpack_require__(3);

var _DropDownPalette = __webpack_require__(91);

var _DropDownPalette2 = _interopRequireDefault(_DropDownPalette);

var _CustomPalette = __webpack_require__(8);

var _CustomPalette2 = _interopRequireDefault(_CustomPalette);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _PaletteHelper = __webpack_require__(23);

var _PaletteHelper2 = _interopRequireDefault(_PaletteHelper);

var _KeyCodes = __webpack_require__(36);

var _KeyCodes2 = _interopRequireDefault(_KeyCodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI Dashboard
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2020, 2021
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

// this may need to change to a prop if QuickPaletteSelection gets picked up by reporting(authoring), no short-term plan for that
var COMPONENT_IDENTIFIER = 'dashboard';

var QuickPaletteSelection = function (_Component) {
	_inherits(QuickPaletteSelection, _Component);

	function QuickPaletteSelection(props) {
		_classCallCheck(this, QuickPaletteSelection);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {
			isOpenCustomDialog: false
		};
		return _this;
	}

	QuickPaletteSelection.prototype.render = function render() {
		var _this2 = this;

		var _props = this.props,
		    defaultSelectedId = _props.defaultSelectedId,
		    dropDownOptions = _props.dropDownOptions,
		    getPalettes = _props.getPalettes,
		    icons = _props.icons,
		    onManageColorPalette = _props.onManageColorPalette,
		    paletteTypeName = _props.paletteTypeName,
		    paletteService = _props.paletteService,
		    selectedId = _props.selectedId;
		var isOpenCustomDialog = this.state.isOpenCustomDialog;

		return _react2.default.createElement(
			_react2.default.Fragment,
			null,
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexLayout,
				{
					className: 'authoring-quick-palette-container',
					direction: 'row',
					alignItems: 'center',
					justifyContent: 'space-between'
				},
				_react2.default.createElement(_baUiCarbonToolkit.Label, {
					className: 'authoring-quick-palette-label',
					label: _StringResources2.default.get('colorPaletteLabel')
				}),
				_react2.default.createElement(
					_baUiCarbonToolkit.Container,
					{
						title: _StringResources2.default.get('createPalette'),
						'aria-label': _StringResources2.default.get('createPalette'),
						tabIndex: 0,
						onKeyDown: function onKeyDown(e) {
							if (e.keyCode === _KeyCodes2.default.ENTER || e.keyCode === _KeyCodes2.default.SPACE) {
								_this2.setState({ isOpenCustomDialog: true });
								// Prevent browser's default action: space does a PageDown
								e.preventDefault();
							}
						}
					},
					_react2.default.createElement(_baUiCarbonToolkit.SVGIcon, {
						iconId: icons.getIcon('add16').id,
						size: 'small',
						onClick: function onClick() {
							_this2.setState({ isOpenCustomDialog: true });
						}
					})
				),
				isOpenCustomDialog && this._renderCustomDialog()
			),
			_react2.default.createElement(_baUiCarbonToolkit.VSpacer, { size: 1 }),
			_react2.default.createElement(_DropDownPalette2.default, _extends({}, dropDownOptions, {
				getPalettes: getPalettes,
				paletteService: paletteService,
				selectedId: selectedId,
				defaultSelectedId: defaultSelectedId,
				onChange: this._onPaletteChanged.bind(this),
				onManageColorPalette: onManageColorPalette,
				paletteTypeName: paletteTypeName
			}))
		);
	};

	QuickPaletteSelection.prototype._renderCustomDialog = function _renderCustomDialog() {
		var _this3 = this;

		var paletteService = this.props.paletteService;

		return _react2.default.createElement(_CustomPalette2.default, {
			key: 'createPalette',
			paletteService: paletteService,
			isDialogOpen: true,
			paletteType: 'standard',
			onPaletteCreated: this._onPaletteCreated.bind(this),
			removeDialog: function removeDialog() {
				_this3.setState({ isOpenCustomDialog: false });
			}
		});
	};

	QuickPaletteSelection.prototype._onPaletteCreated = function _onPaletteCreated(paletteId) {
		var newCMPaletteId = _PaletteHelper2.default.getCustomPaletteId(paletteId);
		var _props2 = this.props,
		    onCreatePalette = _props2.onCreatePalette,
		    paletteService = _props2.paletteService;

		this.setState({ isOpenCustomDialog: false });
		return paletteService.getPalette(paletteId).then(this._addPaletteToMru.bind(this)).then(function () {
			return onCreatePalette(newCMPaletteId);
		});
	};

	QuickPaletteSelection.prototype._onPaletteChanged = function _onPaletteChanged(palette) {
		var _this4 = this;

		return this._addPaletteToMru(palette).then(function () {
			_this4.props.onChange(palette);
		});
	};

	// logic copied from ChangePaletteView._handleUpdatingMRU


	QuickPaletteSelection.prototype._addPaletteToMru = function _addPaletteToMru(palette) {
		// Don't add local palettes to the MRU list
		var isLocal = palette.isMine === false && palette.public === false;
		if (isLocal) {
			return Promise.resolve();
		}
		// Dashboard has a different list of system palettes for heat and conditional.  Make sure
		// we keep 3 palettes in the MRU for both sets
		var trimSystemByPropName = this.props.propertyName === 'condColorPalette' || this.props.propertyName.indexOf('contColorPalette') === 0 ? true : false;
		return this.props.paletteService.addRecentlyUsedPalette({
			palette: palette,
			isSystem: !!palette.system,
			component: COMPONENT_IDENTIFIER,
			propName: this.props.propertyName,
			trimSystemByPropName: trimSystemByPropName
		});
	};

	return QuickPaletteSelection;
}(_react.Component);

QuickPaletteSelection.propTypes = {
	/** Icons Api */
	icons: _propTypes2.default.object.isRequired, // The Icons Feature
	/** Current selected palette id */
	selectedId: _propTypes2.default.string.isRequired,
	/** Default selected palette id if cannot find the palette selected id */
	defaultSelectedId: _propTypes2.default.string.isRequired,
	/** paletteService */
	paletteService: _propTypes2.default.object.isRequired, // was glass context
	/** Palette type name supported. One of  */
	paletteTypeName: _propTypes2.default.oneOf(['ColorPalette', 'HeatPalette', 'ConditionalPalette']),
	/** Property name for the palette property, used by palette service for MRU  */
	propertyName: _propTypes2.default.string.isRequired,
	/** callback function to get palettes */
	getPalettes: _propTypes2.default.func.isRequired,
	/** callback function to call during selection change */
	onChange: _propTypes2.default.func.isRequired,
	/** callback function to call when a new custom palette get created */
	onCreatePalette: _propTypes2.default.func.isRequired,
	/** callback function to call to manage color palette */
	onManageColorPalette: _propTypes2.default.func.isRequired,
	/** Extra options for the svg to pass to Flyout */
	dropDownOptions: _propTypes2.default.shape({
		className: _propTypes2.default.string,
		tabIndex: _propTypes2.default.number
	})
};
QuickPaletteSelection.defaultProps = {
	dropDownOptions: {},
	paletteTypeName: 'ColorPalette'
};
exports.default = (0, _mobxReact.observer)(QuickPaletteSelection);

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = __webpack_require__(22);

var _baUiCarbonToolkit = __webpack_require__(3);

var _baUiCarbon = __webpack_require__(14);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _ColorUtil = __webpack_require__(38);

var _PaletteHelper = __webpack_require__(23);

var _PaletteHelper2 = _interopRequireDefault(_PaletteHelper);

var _jquery = __webpack_require__(9);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI Dashboard
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2021
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var MAX_PALETTE_COLOR_SIZE = 12; // AS per UX Design
var MANAGE_COLOR_PALETTE_LINK_ID = 'manageColorPaletteId';
var MRU_PALETTES_LABEL_ID = 'mruPalettesLabelId';
var All_PALETTES_LABEL_ID = 'allPalettesLabelId';

var observerOptions = {
	attributes: true
};

var DropDownPalette = function (_Component) {
	_inherits(DropDownPalette, _Component);

	function DropDownPalette(props) {
		_classCallCheck(this, DropDownPalette);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		var selectedId = _this.props.selectedId;

		_this.state = {
			selectedPalette: null,
			palettes: null,
			selectedId: selectedId
		};
		var _this$props = _this.props,
		    getPalettes = _this$props.getPalettes,
		    paletteService = _this$props.paletteService,
		    paletteTypeName = _this$props.paletteTypeName;

		_this.paletteHelper = new _PaletteHelper2.default({ paletteService: paletteService, getPalettesFn: getPalettes, paletteName: paletteTypeName });
		_this._optionLabelObservers = {};
		return _this;
	}

	DropDownPalette.prototype.componentDidUpdate = function componentDidUpdate() {
		var _this2 = this;

		var propSelectedId = this.props.selectedId;
		var stateSelectedId = this.state.selectedId;

		var promise = propSelectedId != stateSelectedId ? this._loadPalettes() : Promise.resolve();
		return promise.then(function () {
			if (!_this2._observer && _this2.instanceDomNode) {
				_this2._dropDown$ = (0, _jquery2.default)(_this2.instanceDomNode).find('.bx--dropdown.authoring-palette-dropdown .bx--list-box__menu');
				if (_this2._dropDown$.length) {
					_this2._observer = new window.MutationObserver(_this2._processListBoxMenuMutationObserver.bind(_this2));
					_this2._observer.observe(_this2._dropDown$[0], observerOptions);
				}
			}
		});
	};

	DropDownPalette.prototype.componentDidMount = function componentDidMount() {
		return this._loadPalettes();
	};

	DropDownPalette.prototype.componentWillUnmount = function componentWillUnmount() {
		this._disconnectAllMutationObservers();
		this.instanceDomNode = null;
	};

	DropDownPalette.prototype.render = function render() {
		var _this3 = this;

		var className = this.props.className;
		var _state = this.state,
		    selectedPalette = _state.selectedPalette,
		    palettes = _state.palettes;

		var clsNames = 'authoring-palette-dropdown' + (className ? ' ' + className : '');
		return selectedPalette ? _react2.default.createElement(
			'div',
			{
				ref: function ref(instanceDomNode) {
					// Carbon Dropdown re-render the Component each time a new palette selection is selected
					// In this case it toggles between removing the instance in the DOM and then add it back
					// During the removal of the instance node from the DOM clean up all mutation observers associated with that DOM instance node
					_this3._disconnectAllMutationObservers();
					_this3.instanceDomNode = instanceDomNode;
				}
			},
			_react2.default.createElement(_baUiCarbon.Dropdown, {
				id: 'authoring-palette-dropdownId',
				className: clsNames,
				itemToElement: this._itemToElement.bind(this),
				itemToString: this._itemToString.bind(this),
				items: palettes,
				label: '',
				selectedItem: selectedPalette,
				onChange: this.onChange.bind(this)
			})
		) : _react2.default.createElement(_baUiCarbon.DropdownSkeleton, null);
	};

	DropDownPalette.prototype.onChange = function onChange() {
		var palette = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		var selectedItem = palette.selectedItem;
		var _props = this.props,
		    onManageColorPalette = _props.onManageColorPalette,
		    onChange = _props.onChange;

		if (selectedItem.content.optionLink) {
			onManageColorPalette();
		} else {
			this.setState({ selectedPalette: selectedItem });
			onChange(selectedItem);
		}
	};

	DropDownPalette.prototype._loadPalettes = function _loadPalettes() {
		var _this4 = this;

		if (!this._loadPaletteInProgress) {
			this._loadPaletteInProgress = this.paletteHelper.getPaletteGroupBySections();
		}
		return this._loadPaletteInProgress.then(function (palettesGroupBySection) {
			var _props2 = _this4.props,
			    defaultSelectedId = _props2.defaultSelectedId,
			    selectedId = _props2.selectedId;

			var newSelectedId = void 0;
			var selectedPalette = _this4.paletteHelper.getPalette(selectedId);
			if (selectedPalette) {
				newSelectedId = selectedId;
			} else {
				selectedPalette = _this4.paletteHelper.getPalette(defaultSelectedId);
				newSelectedId = defaultSelectedId;
			}
			if (!selectedPalette) {
				return Promise.reject('Cannot find the selected palettes: ' + selectedId + ' and ' + defaultSelectedId);
			}
			var palettes = [].concat(_this4._getPaletteContent(palettesGroupBySection));
			_this4.setState({
				selectedId: newSelectedId,
				selectedPalette: selectedPalette,
				palettes: palettes
			});
		}).finally(function () {
			delete _this4._loadPaletteInProgress;
		});
	};

	DropDownPalette.prototype._itemToElement = function _itemToElement(palette) {
		if (!palette || !palette.content) {
			return null;
		}
		var optionLink = palette.content.optionLink;
		var sectionLabel = palette.content.sectionLabel;
		if (optionLink) {
			return _react2.default.createElement(_baUiCarbonToolkit.Label, {
				className: 'authoring-palette-dropdown-manage-color-palette',
				label: optionLink,
				tabIndex: 0,
				title: optionLink
			});
		} else if (sectionLabel) {
			return _react2.default.createElement(_baUiCarbonToolkit.Label, {
				className: 'authoring-palette-dropdown-option-label',
				label: sectionLabel,
				tabIndex: -1,
				title: sectionLabel
			});
		}
		return this._renderDropDownPaletteFills(palette);
	};

	DropDownPalette.prototype._itemToString = function _itemToString(palette) {
		if (!palette || !palette.content) {
			return null;
		}
		return this._renderDropDownPaletteFills(palette);
	};

	DropDownPalette.prototype._renderDropDownPaletteFills = function _renderDropDownPaletteFills() {
		var palette = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		var fills = palette.content.fills || [];
		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexLayout,
			{
				className: 'authoring-palette-dropdown-palette',
				'aria-label': palette.content.label,
				title: palette.content.label
			},
			fills.map(function (color, index) {
				return _react2.default.createElement(_baUiCarbonToolkit.FlexItem, {
					className: 'authoring-palette-dropdown-palette-color',
					key: index,
					'data-index': index,
					'data-value': color,
					style: color && (0, _ColorUtil.getColorStyle)(color.color, color.fill || color, color.pattern)
				});
			})
		);
	};

	DropDownPalette.prototype._getPaletteContent = function _getPaletteContent() {
		var palettesGroup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		var palettes = [];
		var sections = this.paletteHelper.getPaletteSectionOrder();
		var hasAllPalettesLabel = palettesGroup.local.length || palettesGroup.custom.length || palettesGroup.global.length || palettesGroup.system.length || palettesGroup.legacy.length;
		sections.forEach(function (section) {
			var palette = palettesGroup[section] || [];
			if (section === 'mru') {
				if (palette.length) {
					palettes.push({
						content: {
							id: MRU_PALETTES_LABEL_ID,
							sectionLabel: _StringResources2.default.get('mruPalettes')
						}
					});
				}
			} else if (hasAllPalettesLabel) {
				palettes.push({
					content: {
						id: All_PALETTES_LABEL_ID,
						sectionLabel: _StringResources2.default.get('allPalettes')
					}
				});
				hasAllPalettesLabel = false;
			}
			palette.forEach(function (item) {
				if (item.content.fills) {
					item.content.fills.length = item.content.fills.length <= MAX_PALETTE_COLOR_SIZE ? item.content.fills.length : MAX_PALETTE_COLOR_SIZE;
				}
			});
			palettes.push.apply(palettes, palette);
		});

		// Now add the 'Manage color palettes' link
		palettes.push({
			id: MANAGE_COLOR_PALETTE_LINK_ID,
			content: {
				id: MANAGE_COLOR_PALETTE_LINK_ID,
				optionLink: _StringResources2.default.get('manageColorPalettes')
			}
		});
		return palettes;
	};

	DropDownPalette.prototype._processListBoxMenuMutationObserver = function _processListBoxMenuMutationObserver(mutations) {
		var _this5 = this;

		var mutation = mutations.find(function (item) {
			return item.attributeName === 'aria-activedescendant';
		});
		if (mutation && mutation.target.getAttribute('aria-activedescendant')) {
			var optionLabelNodes = (0, _jquery2.default)(this._dropDown$[0]).find('.authoring-palette-dropdown-option-label');
			if (optionLabelNodes.length) {
				optionLabelNodes.each(function (index, optionNode) {
					var node$ = (0, _jquery2.default)(optionNode).closest('.bx--list-box__menu-item');
					if (node$.length) {
						if (!_this5._optionLabelObservers[index]) {
							_this5._optionLabelObservers[index] = new window.MutationObserver(_this5._processMutationOptionLabelObserver.bind(_this5));
						}
						_this5._optionLabelObservers[index].observe(node$[0], observerOptions);
						node$.addClass('authoring-palette-menu-item-label');
					}
				});
			}
		} else {
			this._disconnectMutationOptionLabelObserver();
		}
	};

	DropDownPalette.prototype._processMutationOptionLabelObserver = function _processMutationOptionLabelObserver(mutations) {
		mutations.forEach(function (mutation) {
			if (mutation.attributeName === 'class') {
				var $node = (0, _jquery2.default)(mutation.target);
				if (!$node.hasClass('authoring-palette-menu-item-label')) {
					$node.addClass('authoring-palette-menu-item-label');
				}
			}
		});
	};

	DropDownPalette.prototype._disconnectMutationOptionLabelObserver = function _disconnectMutationOptionLabelObserver() {
		var _this6 = this;

		var keys = Object.keys(this._optionLabelObservers);
		keys.forEach(function (key) {
			_this6._optionLabelObservers[key].disconnect();
		});
		this._optionLabelObservers = {};
	};

	DropDownPalette.prototype._disconnectAllMutationObservers = function _disconnectAllMutationObservers() {
		this._disconnectMutationOptionLabelObserver();
		if (this._observer) {
			this._observer.disconnect();
			this._observer = null;
		}
		if (this._dropDown$) {
			this._dropDown$ = null;
		}
	};

	return DropDownPalette;
}(_react.Component);

DropDownPalette.propTypes = {
	className: _propTypes2.default.string,
	/** Current selected palette id */
	selectedId: _propTypes2.default.string.isRequired,
	/** Default selected palette id if cannot find the palette selected id */
	defaultSelectedId: _propTypes2.default.string.isRequired,
	/** paletteService */
	paletteService: _propTypes2.default.object.isRequired, // was glass context
	/** callback function to get palettes */
	getPalettes: _propTypes2.default.func.isRequired,
	/** callback function to call during selection change */
	onChange: _propTypes2.default.func.isRequired,
	/** callback function to call to manage color palette */
	onManageColorPalette: _propTypes2.default.func.isRequired,
	/** Palette type name supported. One of  */
	paletteTypeName: _propTypes2.default.oneOf(['ColorPalette', 'HeatPalette', 'ConditionalPalette'])
};
DropDownPalette.defaultProps = {
	className: ''
};
exports.default = (0, _mobxReact.observer)(DropDownPalette);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// authoring-common.min.js